var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFish = function SvgFish(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 4268,
    height: 2315,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeMiterlimit: 10,
    opacity: 0.07
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__a)",
    stroke: "url(#fish_svg__c)",
    d: "M1878.76 100.199c-.12-9.337 4.55-18.555 12.93-23.942 7.9-5.148 17.47-5.746 25.61-2.514 2.28.958 4.43-1.317 3.47-3.591a29.6 29.6 0 0 0-3.23-5.627c-6.94-9.457-19.15-13.408-30.16-10.415 1.2-9.337-1.2-20.351-7.66-30.407 6.34-2.274 11.97-3.95 17.35-.12 1.56 1.198 3.83-.24 3.48-2.154-.24-1.437-.6-2.874-1.2-4.31-4.67-12.93-18.67-19.633-31.24-14.964a24.2 24.2 0 0 0-6.82 3.95c-2.88-1.317-5.87-2.274-8.98-2.514-6.22-1.316-12.33-.478-17.35 2.754-2.04 1.317-3.83 2.993-5.39 4.908-7.66 10.175-7.06 27.534 2.39 42.618l.36.478c8.98 14.007 23.1 21.908 35.07 20.83-1.67 7.183-.48 14.845 3.71 21.549a24.6 24.6 0 0 0 4.19 5.028c1.32 1.077 3.47.239 3.47-1.557Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__d)",
    stroke: "url(#fish_svg__e)",
    d: "M2036.27 142.817c-.12-9.338 4.55-18.555 12.93-23.943 7.9-5.147 17.47-5.746 25.61-2.513 2.28.957 4.43-1.317 3.47-3.592a29 29 0 0 0-3.23-5.626c-6.94-9.458-19.15-13.408-30.16-10.415 1.2-9.338-1.2-20.351-7.66-30.407 6.34-2.275 11.97-3.95 17.36-.12 1.55 1.197 3.83-.24 3.47-2.155-.24-1.436-.6-2.873-1.2-4.31-4.67-12.928-18.67-19.632-31.24-14.963a24.2 24.2 0 0 0-6.82 3.95c-2.87-1.317-5.87-2.275-8.98-2.514-6.22-1.317-12.33-.479-17.35 2.753-2.04 1.317-3.83 2.993-5.39 4.909-7.66 10.175-7.06 27.533 2.39 42.617l.36.48c8.98 14.005 23.1 21.906 35.07 20.829-1.67 7.183-.48 14.844 3.71 21.548a24.9 24.9 0 0 0 4.19 5.028c1.32 1.078 3.47.24 3.47-1.556Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__f)",
    stroke: "url(#fish_svg__g)",
    d: "M2193.78 185.435c-.12-9.338 4.55-18.556 12.93-23.943 7.9-5.148 17.47-5.746 25.61-2.514 2.28.958 4.43-1.317 3.47-3.591a29 29 0 0 0-3.23-5.627c-6.94-9.457-19.15-13.407-30.16-10.415 1.2-9.337-1.2-20.351-7.66-30.407 6.34-2.274 11.97-3.95 17.36-.119 1.55 1.197 3.83-.24 3.47-2.155-.24-1.437-.6-2.873-1.2-4.31-4.67-12.929-18.67-19.633-31.24-14.964a24.2 24.2 0 0 0-6.82 3.95c-2.87-1.316-5.87-2.274-8.98-2.513-6.22-1.317-12.33-.48-17.35 2.753-2.04 1.317-3.83 2.993-5.39 4.908-7.66 10.176-7.06 27.534 2.39 42.618l.36.479c8.98 14.006 23.1 21.907 35.07 20.83-1.67 7.182-.48 14.844 3.71 21.548a25 25 0 0 0 4.19 5.028c1.32 1.077 3.47.239 3.47-1.556Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__h)",
    stroke: "url(#fish_svg__i)",
    d: "M2351.29 228.052c-.11-9.337 4.55-18.555 12.93-23.942 7.9-5.148 17.48-5.746 25.61-2.514 2.28.958 4.43-1.317 3.48-3.592a29.6 29.6 0 0 0-3.24-5.626c-6.94-9.457-19.15-13.408-30.16-10.415 1.2-9.338-1.19-20.351-7.66-30.407 6.35-2.275 11.97-3.951 17.36-.12 1.55 1.197 3.83-.239 3.47-2.155-.24-1.436-.6-2.873-1.2-4.309-4.67-12.929-18.67-19.633-31.24-14.964a24.2 24.2 0 0 0-6.82 3.95c-2.87-1.317-5.86-2.274-8.98-2.514-6.22-1.317-12.32-.479-17.35 2.754-2.04 1.317-3.83 2.993-5.39 4.908-7.66 10.175-7.06 27.534 2.4 42.618l.36.478c8.97 14.007 23.1 21.908 35.06 20.83-1.67 7.183-.47 14.845 3.71 21.549a25 25 0 0 0 4.19 5.028c1.32.957 3.47.239 3.47-1.557Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__j)",
    stroke: "url(#fish_svg__k)",
    d: "M2508.81 270.67c-.12-9.338 4.54-18.556 12.92-23.943 7.9-5.147 17.48-5.746 25.62-2.514 2.27.958 4.42-1.316 3.47-3.591a30 30 0 0 0-3.23-5.626c-6.95-9.458-19.15-13.408-30.17-10.415 1.2-9.338-1.19-20.352-7.66-30.407 6.35-2.275 11.97-3.951 17.36-.12 1.55 1.197 3.83-.239 3.47-2.155-.24-1.436-.6-2.873-1.2-4.31-4.66-12.928-18.67-19.632-31.24-14.964a24.3 24.3 0 0 0-6.82 3.951c-2.87-1.317-5.86-2.275-8.97-2.514-6.23-1.317-12.33-.479-17.36 2.753-2.03 1.317-3.83 2.993-5.39 4.909-7.66 10.175-7.06 27.533 2.4 42.617l.36.479c8.97 14.006 23.1 21.907 35.07 20.83-1.68 7.183-.48 14.844 3.71 21.548a24.2 24.2 0 0 0 4.19 5.028c1.31.958 3.47.12 3.47-1.556Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__l)",
    stroke: "url(#fish_svg__m)",
    d: "M2666.32 313.288c-.12-9.338 4.55-18.556 12.92-23.943 7.9-5.148 17.48-5.746 25.62-2.514 2.27.958 4.43-1.317 3.47-3.591a30 30 0 0 0-3.23-5.627c-6.94-9.457-19.15-13.408-30.16-10.415 1.19-9.337-1.2-20.351-7.66-30.407 6.34-2.274 11.96-3.95 17.35-.119 1.56 1.197 3.83-.24 3.47-2.155-.24-1.437-.6-2.873-1.2-4.31-4.66-12.929-18.67-19.633-31.23-14.964a24.2 24.2 0 0 0-6.83 3.951c-2.87-1.317-5.86-2.275-8.97-2.514-6.23-1.317-12.33-.479-17.36 2.753-2.03 1.317-3.83 2.993-5.38 4.908-7.66 10.176-7.07 27.534 2.39 42.618l.36.479c8.98 14.006 23.1 21.907 35.07 20.83-1.68 7.182-.48 14.844 3.71 21.548a24.6 24.6 0 0 0 4.19 5.028c1.31.958 3.47.12 3.47-1.556Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__n)",
    stroke: "url(#fish_svg__o)",
    d: "M2823.83 355.905c-.12-9.337 4.55-18.555 12.92-23.942 7.9-5.148 17.48-5.746 25.62-2.514 2.27.957 4.43-1.317 3.47-3.592a30 30 0 0 0-3.23-5.626c-6.94-9.457-19.15-13.408-30.16-10.415 1.19-9.338-1.2-20.351-7.66-30.407 6.34-2.275 11.96-3.951 17.35-.12 1.56 1.197 3.83-.239 3.47-2.155-.24-1.436-.6-2.873-1.2-4.309-4.66-12.929-18.67-19.633-31.23-14.964a24.2 24.2 0 0 0-6.83 3.95c-2.87-1.317-5.86-2.274-8.97-2.514-6.23-1.317-12.33-.479-17.36 2.754-2.03 1.316-3.83 2.992-5.38 4.908-7.66 10.175-7.07 27.534 2.39 42.617l.36.479c8.98 14.007 23.1 21.908 35.07 20.83-1.68 7.183-.48 14.845 3.71 21.549a24.3 24.3 0 0 0 4.19 5.027c1.31.958 3.47.12 3.47-1.556Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__p)",
    stroke: "url(#fish_svg__q)",
    d: "M2981.34 398.523c-.12-9.338 4.55-18.556 12.93-23.943 7.9-5.147 17.47-5.746 25.61-2.514 2.27.958 4.43-1.316 3.47-3.591a29.6 29.6 0 0 0-3.23-5.626c-6.94-9.458-19.15-13.408-30.16-10.415 1.19-9.338-1.2-20.352-7.66-30.407 6.34-2.275 11.97-3.951 17.35-.12 1.56 1.197 3.83-.24 3.47-2.155-.24-1.437-.6-2.873-1.19-4.31-4.67-12.929-18.68-19.632-31.24-14.964a24 24 0 0 0-6.82 3.951c-2.88-1.317-5.87-2.275-8.98-2.514-6.23-1.317-12.33-.479-17.36 2.753-2.03 1.317-3.83 2.993-5.38 4.908-7.66 10.176-7.06 27.534 2.39 42.618l.36.479c8.98 14.006 23.1 21.907 35.07 20.83-1.68 7.183-.48 14.844 3.71 21.548a24.6 24.6 0 0 0 4.19 5.028c1.32.958 3.47.12 3.47-1.556Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__r)",
    stroke: "url(#fish_svg__s)",
    d: "M1782.05 182.202c-.12-9.337 4.55-18.555 12.93-23.942 7.9-5.148 17.47-5.746 25.61-2.514 2.28.958 4.43-1.317 3.47-3.591a29 29 0 0 0-3.23-5.627c-6.94-9.457-19.15-13.408-30.16-10.415 1.2-9.337-1.2-20.351-7.66-30.407 6.34-2.274 11.97-3.95 17.36-.12 1.55 1.198 3.83-.239 3.47-2.154-.24-1.437-.6-2.874-1.2-4.31-4.67-12.929-18.67-19.633-31.24-14.964a24.2 24.2 0 0 0-6.82 3.95c-2.87-1.316-5.87-2.274-8.98-2.514-6.22-1.316-12.33-.478-17.35 2.754-2.04 1.317-3.83 2.993-5.39 4.908-7.66 10.176-7.06 27.534 2.39 42.618l.36.479c8.98 14.006 23.1 21.907 35.07 20.83-1.67 7.182-.48 14.844 3.71 21.548a25 25 0 0 0 4.19 5.028c1.44.957 3.47.239 3.47-1.557Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__t)",
    stroke: "url(#fish_svg__u)",
    d: "M1939.56 224.82c-.12-9.338 4.55-18.555 12.93-23.942 7.9-5.148 17.48-5.747 25.61-2.514 2.28.957 4.43-1.317 3.48-3.592a29.6 29.6 0 0 0-3.24-5.626c-6.94-9.458-19.15-13.408-30.16-10.415 1.2-9.338-1.19-20.351-7.66-30.407 6.35-2.275 11.97-3.951 17.36-.12 1.55 1.197 3.83-.239 3.47-2.155-.24-1.436-.6-2.873-1.2-4.309-4.67-12.929-18.67-19.633-31.24-14.964a24.2 24.2 0 0 0-6.82 3.95c-2.87-1.317-5.87-2.275-8.98-2.514-6.22-1.317-12.32-.479-17.35 2.753-2.04 1.317-3.83 2.993-5.39 4.909-7.66 10.175-7.06 27.534 2.4 42.617l.35.479c8.98 14.007 23.1 21.908 35.07 20.83-1.67 7.183-.47 14.844 3.71 21.548a24.9 24.9 0 0 0 4.19 5.028c1.44.958 3.47.12 3.47-1.556Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__v)",
    stroke: "url(#fish_svg__w)",
    d: "M2097.07 267.438c-.12-9.338 4.55-18.556 12.93-23.943 7.9-5.147 17.48-5.746 25.61-2.514 2.28.958 4.43-1.317 3.48-3.591a29.6 29.6 0 0 0-3.24-5.627c-6.94-9.457-19.15-13.407-30.16-10.415 1.2-9.337-1.2-20.351-7.66-30.407 6.35-2.274 11.97-3.95 17.36-.119 1.55 1.197 3.83-.24 3.47-2.155-.24-1.437-.6-2.873-1.2-4.31-4.67-12.929-18.67-19.633-31.24-14.964a24.2 24.2 0 0 0-6.82 3.951c-2.87-1.317-5.87-2.275-8.98-2.514-6.22-1.317-12.33-.479-17.35 2.753-2.04 1.317-3.83 2.993-5.39 4.908-7.66 10.176-7.06 27.534 2.4 42.618l.35.479c8.98 14.006 23.1 21.907 35.07 20.83-1.67 7.183-.48 14.844 3.71 21.548a25 25 0 0 0 4.19 5.028c1.44.958 3.47.12 3.47-1.556Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__x)",
    stroke: "url(#fish_svg__y)",
    d: "M2254.59 310.055c-.12-9.337 4.54-18.555 12.92-23.942 7.9-5.148 17.48-5.746 25.62-2.514 2.27.958 4.42-1.317 3.47-3.592a30 30 0 0 0-3.23-5.626c-6.95-9.457-19.16-13.408-30.17-10.415 1.2-9.338-1.19-20.351-7.66-30.407 6.35-2.274 11.97-3.95 17.36-.12 1.55 1.197 3.83-.239 3.47-2.154-.24-1.437-.6-2.874-1.2-4.31-4.67-12.929-18.67-19.633-31.24-14.964a24.3 24.3 0 0 0-6.82 3.95c-2.87-1.317-5.86-2.274-8.98-2.514-6.22-1.316-12.32-.478-17.35 2.754-2.04 1.317-3.83 2.993-5.39 4.908-7.66 10.176-7.06 27.534 2.4 42.618l.36.478c8.97 14.007 23.1 21.908 35.07 20.83-1.68 7.183-.48 14.845 3.71 21.549 1.19 1.915 2.63 3.591 4.18 5.028 1.44.957 3.48.119 3.48-1.557Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__z)",
    stroke: "url(#fish_svg__A)",
    d: "M2412.1 352.673c-.12-9.338 4.55-18.555 12.92-23.943 7.9-5.147 17.48-5.746 25.62-2.513 2.27.957 4.43-1.317 3.47-3.592a30 30 0 0 0-3.23-5.626c-6.95-9.458-19.15-13.408-30.16-10.415 1.19-9.338-1.2-20.351-7.66-30.407 6.34-2.275 11.96-3.951 17.35-.12 1.56 1.197 3.83-.239 3.47-2.155-.24-1.436-.6-2.873-1.2-4.309-4.66-12.929-18.67-19.633-31.23-14.965a24.2 24.2 0 0 0-6.83 3.951c-2.87-1.317-5.86-2.275-8.97-2.514-6.23-1.317-12.33-.479-17.36 2.753-2.03 1.317-3.83 2.993-5.38 4.909-7.66 10.175-7.07 27.533 2.39 42.617l.36.479c8.97 14.006 23.1 21.908 35.07 20.83-1.68 7.183-.48 14.844 3.71 21.548a24.2 24.2 0 0 0 4.19 5.028c1.43.958 3.47.12 3.47-1.556Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__B)",
    stroke: "url(#fish_svg__C)",
    d: "M2569.61 395.171c-.12-9.338 4.55-18.556 12.92-23.943 7.9-5.147 17.48-5.746 25.62-2.514 2.27.958 4.43-1.316 3.47-3.591a30 30 0 0 0-3.23-5.626c-6.95-9.458-19.15-13.408-30.16-10.415 1.19-9.338-1.2-20.352-7.67-30.407 6.35-2.275 11.97-3.951 17.36-.12 1.56 1.197 3.83-.24 3.47-2.155-.24-1.436-.6-2.873-1.2-4.31-4.66-12.928-18.67-19.632-31.24-14.964a24.3 24.3 0 0 0-6.82 3.951c-2.87-1.317-5.86-2.275-8.97-2.514-6.23-1.317-12.33-.479-17.36 2.753-2.03 1.317-3.83 2.993-5.38 4.909-7.67 10.175-7.07 27.533 2.39 42.617l.36.479c8.97 14.006 23.1 21.907 35.07 20.83-1.68 7.183-.48 14.844 3.71 21.548a24.2 24.2 0 0 0 4.19 5.028c1.43 1.078 3.47.24 3.47-1.556Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__D)",
    stroke: "url(#fish_svg__E)",
    d: "M2727.12 437.789c-.12-9.338 4.55-18.556 12.93-23.943 7.9-5.148 17.47-5.746 25.61-2.514 2.27.958 4.43-1.317 3.47-3.591a30 30 0 0 0-3.23-5.627c-6.94-9.457-19.15-13.408-30.16-10.415 1.19-9.337-1.2-20.351-7.66-30.407 6.34-2.274 11.97-3.95 17.35-.119 1.56 1.197 3.83-.24 3.47-2.155-.24-1.437-.6-2.873-1.19-4.31-4.67-12.929-18.68-19.633-31.24-14.964a24.2 24.2 0 0 0-6.83 3.951c-2.87-1.317-5.86-2.275-8.97-2.514-6.23-1.317-12.33-.479-17.36 2.753-2.03 1.317-3.83 2.993-5.38 4.908-7.66 10.176-7.06 27.534 2.39 42.618l.36.479c8.98 14.006 23.1 21.907 35.07 20.83-1.68 7.182-.48 14.844 3.71 21.548a24.6 24.6 0 0 0 4.19 5.028c1.43 1.077 3.47.239 3.47-1.556Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__F)",
    stroke: "url(#fish_svg__G)",
    d: "M2884.63 480.406c-.12-9.337 4.55-18.555 12.93-23.942 7.9-5.148 17.47-5.747 25.61-2.514 2.27.957 4.43-1.317 3.47-3.592a29.6 29.6 0 0 0-3.23-5.626c-6.94-9.457-19.15-13.408-30.16-10.415 1.2-9.338-1.2-20.351-7.66-30.407 6.34-2.275 11.97-3.951 17.35-.12 1.56 1.197 3.83-.239 3.47-2.155-.24-1.436-.59-2.873-1.19-4.309-4.67-12.929-18.67-19.633-31.24-14.964a24 24 0 0 0-6.82 3.95c-2.88-1.317-5.87-2.274-8.98-2.514-6.22-1.317-12.33-.479-17.36 2.754-2.03 1.316-3.83 2.992-5.38 4.908-7.66 10.175-7.06 27.534 2.39 42.617l.36.479c8.98 14.007 23.1 21.908 35.07 20.83-1.68 7.183-.48 14.845 3.71 21.548a24.6 24.6 0 0 0 4.19 5.028c1.44 1.078 3.47.24 3.47-1.556Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__H)",
    stroke: "url(#fish_svg__I)",
    d: "M1685.34 264.205c-.12-9.337 4.55-18.555 12.93-23.942 7.9-5.148 17.47-5.746 25.61-2.514 2.28.958 4.43-1.317 3.47-3.591a29 29 0 0 0-3.23-5.627c-6.94-9.457-19.15-13.408-30.16-10.415 1.2-9.337-1.2-20.351-7.66-30.407 6.34-2.274 11.97-3.95 17.36-.12 1.55 1.198 3.83-.239 3.47-2.154-.24-1.437-.6-2.873-1.2-4.31-4.67-12.929-18.67-19.633-31.24-14.964a24.2 24.2 0 0 0-6.82 3.95c-2.87-1.316-5.87-2.274-8.98-2.514-6.22-1.316-12.33-.478-17.35 2.754-2.04 1.317-3.83 2.993-5.39 4.908-7.66 10.176-7.06 27.534 2.4 42.618l.35.479c8.98 14.006 23.1 21.907 35.07 20.83-1.67 7.182-.48 14.844 3.71 21.548a25 25 0 0 0 4.19 5.028c1.44.957 3.59.119 3.47-1.557Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__J)",
    stroke: "url(#fish_svg__K)",
    d: "M1842.86 306.823c-.12-9.338 4.54-18.555 12.92-23.942 7.9-5.148 17.48-5.747 25.62-2.514 2.27.957 4.42-1.317 3.47-3.592a29.6 29.6 0 0 0-3.24-5.626c-6.94-9.458-19.15-13.408-30.16-10.415 1.2-9.338-1.19-20.351-7.66-30.407 6.35-2.275 11.97-3.951 17.36-.12 1.55 1.197 3.83-.239 3.47-2.155-.24-1.436-.6-2.873-1.2-4.309-4.67-12.929-18.67-19.633-31.24-14.964a24.3 24.3 0 0 0-6.82 3.95c-2.87-1.317-5.86-2.274-8.98-2.514-6.22-1.317-12.32-.479-17.35 2.753-2.04 1.317-3.83 2.993-5.39 4.909-7.66 10.175-7.06 27.534 2.4 42.617l.36.479c8.97 14.007 23.1 21.908 35.06 20.83-1.67 7.183-.47 14.845 3.72 21.548 1.19 1.916 2.63 3.592 4.18 5.028 1.44.958 3.6.12 3.48-1.556Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__L)",
    stroke: "url(#fish_svg__M)",
    d: "M2000.37 349.321c-.12-9.338 4.54-18.555 12.92-23.942 7.9-5.148 17.48-5.747 25.62-2.514 2.27.957 4.42-1.317 3.47-3.592a29.6 29.6 0 0 0-3.24-5.626c-6.94-9.458-19.15-13.408-30.16-10.415 1.2-9.338-1.19-20.351-7.66-30.407 6.35-2.275 11.97-3.951 17.36-.12 1.55 1.197 3.83-.239 3.47-2.155-.24-1.436-.6-2.873-1.2-4.309-4.67-12.929-18.67-19.633-31.24-14.965a24.3 24.3 0 0 0-6.82 3.951c-2.87-1.317-5.86-2.275-8.98-2.514-6.22-1.317-12.32-.479-17.35 2.753-2.04 1.317-3.83 2.993-5.39 4.909-7.66 10.175-7.06 27.534 2.4 42.617l.36.479c8.97 14.006 23.1 21.908 35.06 20.83-1.67 7.183-.47 14.844 3.72 21.548 1.19 1.916 2.63 3.592 4.18 5.028 1.44 1.078 3.59.24 3.48-1.556Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__N)",
    stroke: "url(#fish_svg__O)",
    d: "M2157.88 391.939c-.12-9.338 4.54-18.556 12.92-23.943 7.9-5.147 17.48-5.746 25.62-2.514 2.27.958 4.43-1.317 3.47-3.591a30 30 0 0 0-3.23-5.627c-6.95-9.457-19.15-13.407-30.17-10.415 1.2-9.337-1.19-20.351-7.66-30.407 6.35-2.274 11.97-3.95 17.36-.119 1.56 1.197 3.83-.24 3.47-2.155-.24-1.437-.6-2.873-1.2-4.31-4.66-12.929-18.67-19.633-31.24-14.964a24.3 24.3 0 0 0-6.82 3.951c-2.87-1.317-5.86-2.275-8.97-2.514-6.23-1.317-12.33-.479-17.36 2.753-2.03 1.317-3.83 2.993-5.39 4.908-7.66 10.176-7.06 27.534 2.4 42.618l.36.479c8.97 14.006 23.1 21.907 35.07 20.83-1.68 7.183-.48 14.844 3.71 21.548a24.3 24.3 0 0 0 4.19 5.028c1.43 1.077 3.59.239 3.47-1.556Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__P)",
    stroke: "url(#fish_svg__Q)",
    d: "M2315.39 434.556c-.12-9.337 4.55-18.555 12.93-23.942 7.89-5.148 17.47-5.746 25.61-2.514 2.27.958 4.43-1.317 3.47-3.592a30 30 0 0 0-3.23-5.626c-6.94-9.457-19.15-13.408-30.16-10.415 1.19-9.338-1.2-20.351-7.66-30.407 6.34-2.274 11.97-3.95 17.35-.12 1.56 1.197 3.83-.239 3.47-2.154-.24-1.437-.6-2.874-1.19-4.31-4.67-12.929-18.68-19.633-31.24-14.964a24.2 24.2 0 0 0-6.83 3.95c-2.87-1.317-5.86-2.274-8.97-2.514-6.23-1.317-12.33-.479-17.36 2.754-2.03 1.317-3.83 2.993-5.38 4.908-7.66 10.176-7.07 27.534 2.39 42.618l.36.478c8.98 14.007 23.1 21.908 35.07 20.83-1.68 7.183-.48 14.845 3.71 21.549a24.6 24.6 0 0 0 4.19 5.028c1.43 1.077 3.59.239 3.47-1.557Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__R)",
    stroke: "url(#fish_svg__S)",
    d: "M2472.9 477.174c-.12-9.338 4.55-18.555 12.92-23.943 7.9-5.147 17.48-5.746 25.62-2.514 2.27.958 4.43-1.316 3.47-3.591a30 30 0 0 0-3.23-5.626c-6.94-9.458-19.15-13.408-30.16-10.415 1.19-9.338-1.2-20.351-7.66-30.407 6.34-2.275 11.96-3.951 17.35-.12 1.56 1.197 3.83-.239 3.47-2.155-.24-1.436-.6-2.873-1.2-4.31-4.66-12.928-18.67-19.632-31.23-14.964a24.2 24.2 0 0 0-6.83 3.951c-2.87-1.317-5.86-2.275-8.97-2.514-6.23-1.317-12.33-.479-17.36 2.753-2.03 1.317-3.83 2.993-5.38 4.909-7.66 10.175-7.07 27.533 2.39 42.617l.36.479c8.98 14.006 23.1 21.907 35.07 20.83-1.68 7.183-.48 14.844 3.71 21.548a24.6 24.6 0 0 0 4.19 5.028c1.43 1.078 3.59.24 3.47-1.556Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__T)",
    stroke: "url(#fish_svg__U)",
    d: "M2630.41 519.792c-.12-9.338 4.55-18.556 12.93-23.943 7.9-5.148 17.47-5.746 25.61-2.514 2.27.958 4.43-1.317 3.47-3.591a29.6 29.6 0 0 0-3.23-5.627c-6.94-9.457-19.15-13.408-30.16-10.415 1.19-9.337-1.2-20.351-7.66-30.407 6.34-2.274 11.97-3.95 17.35-.119 1.56 1.197 3.83-.24 3.47-2.155-.24-1.437-.6-2.873-1.19-4.31-4.67-12.929-18.67-19.633-31.24-14.964a24 24 0 0 0-6.82 3.951c-2.88-1.317-5.87-2.275-8.98-2.514-6.23-1.317-12.33-.479-17.36 2.753-2.03 1.317-3.83 2.993-5.38 4.908-7.66 10.176-7.06 27.534 2.39 42.618l.36.479c8.98 14.006 23.1 21.907 35.07 20.83-1.68 7.182-.48 14.844 3.71 21.548a24.6 24.6 0 0 0 4.19 5.028c1.44.958 3.59.239 3.47-1.556Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__V)",
    stroke: "url(#fish_svg__W)",
    d: "M2787.92 562.409c-.12-9.337 4.55-18.555 12.93-23.942 7.9-5.148 17.47-5.746 25.61-2.514 2.28.957 4.43-1.317 3.47-3.592a29.6 29.6 0 0 0-3.23-5.626c-6.94-9.457-19.15-13.408-30.16-10.415 1.2-9.338-1.2-20.351-7.66-30.407 6.34-2.275 11.97-3.951 17.35-.12 1.56 1.197 3.83-.239 3.48-2.155-.24-1.436-.6-2.873-1.2-4.309-4.67-12.929-18.67-19.633-31.24-14.964a24.2 24.2 0 0 0-6.82 3.95c-2.88-1.317-5.87-2.274-8.98-2.514-6.22-1.317-12.33-.479-17.35 2.754-2.04 1.316-3.83 2.992-5.39 4.908-7.66 10.175-7.06 27.534 2.39 42.617l.36.479c8.98 14.007 23.1 21.908 35.07 20.83-1.67 7.183-.48 14.845 3.71 21.549a24.6 24.6 0 0 0 4.19 5.027c1.44.958 3.47.12 3.47-1.556Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__X)",
    stroke: "url(#fish_svg__Y)",
    d: "M1588.76 346.089c-.12-9.338 4.54-18.556 12.92-23.943 7.9-5.147 17.48-5.746 25.62-2.514 2.27.958 4.42-1.317 3.47-3.591a30 30 0 0 0-3.23-5.627c-6.95-9.457-19.16-13.407-30.17-10.415 1.2-9.337-1.19-20.351-7.66-30.407 6.35-2.274 11.97-3.95 17.36-.119 1.55 1.197 3.83-.24 3.47-2.155-.24-1.437-.6-2.873-1.2-4.31-4.67-12.929-18.67-19.633-31.24-14.964a24.3 24.3 0 0 0-6.82 3.951c-2.87-1.317-5.86-2.275-8.98-2.514-6.22-1.317-12.32-.479-17.35 2.753-2.04 1.317-3.83 2.993-5.39 4.908-7.66 10.176-7.06 27.534 2.4 42.618l.36.479c8.97 14.006 23.1 21.907 35.07 20.83-1.68 7.183-.48 14.844 3.71 21.548 1.19 1.916 2.63 3.591 4.18 5.028 1.32 1.077 3.48.239 3.48-1.556Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__Z)",
    stroke: "url(#fish_svg__aa)",
    d: "M1746.27 388.706c-.12-9.337 4.55-18.555 12.92-23.942 7.9-5.148 17.48-5.746 25.62-2.514 2.27.958 4.43-1.317 3.47-3.591a30 30 0 0 0-3.23-5.627c-6.95-9.457-19.15-13.408-30.16-10.415 1.19-9.337-1.2-20.351-7.66-30.407 6.34-2.274 11.96-3.95 17.35-.12 1.56 1.198 3.83-.239 3.47-2.154-.24-1.437-.6-2.873-1.2-4.31-4.66-12.929-18.67-19.633-31.23-14.964a24.2 24.2 0 0 0-6.83 3.95c-2.87-1.316-5.86-2.274-8.97-2.514-6.23-1.316-12.33-.478-17.36 2.754-2.03 1.317-3.83 2.993-5.38 4.908-7.66 10.176-7.07 27.534 2.39 42.618l.36.479c8.97 14.006 23.1 21.907 35.07 20.829-1.68 7.183-.48 14.845 3.71 21.549a24.3 24.3 0 0 0 4.19 5.028c1.31 1.077 3.47.239 3.47-1.557Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__ab)",
    stroke: "url(#fish_svg__ac)",
    d: "M1903.78 431.324c-.12-9.338 4.55-18.555 12.92-23.942 7.9-5.148 17.48-5.747 25.62-2.514 2.27.957 4.43-1.317 3.47-3.592a30 30 0 0 0-3.23-5.626c-6.95-9.458-19.15-13.408-30.17-10.415 1.2-9.338-1.19-20.351-7.66-30.407 6.35-2.275 11.97-3.951 17.36-.12 1.56 1.197 3.83-.239 3.47-2.155-.24-1.436-.6-2.873-1.2-4.309-4.66-12.929-18.67-19.633-31.24-14.964a24.3 24.3 0 0 0-6.82 3.95c-2.87-1.317-5.86-2.274-8.97-2.514-6.23-1.317-12.33-.479-17.36 2.753-2.03 1.317-3.83 2.993-5.39 4.909-7.66 10.175-7.06 27.534 2.4 42.617l.36.479c8.97 14.007 23.1 21.908 35.07 20.83-1.68 7.183-.48 14.844 3.71 21.548a24.2 24.2 0 0 0 4.19 5.028c1.31 1.078 3.47.24 3.47-1.556Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__ad)",
    stroke: "url(#fish_svg__ae)",
    d: "M2061.29 473.942c-.12-9.338 4.55-18.556 12.93-23.943 7.89-5.147 17.47-5.746 25.61-2.514 2.27.958 4.43-1.317 3.47-3.591a30 30 0 0 0-3.23-5.627c-6.94-9.457-19.15-13.407-30.16-10.415 1.19-9.337-1.2-20.351-7.66-30.407 6.34-2.274 11.97-3.95 17.35-.119 1.56 1.197 3.83-.24 3.47-2.155-.24-1.437-.6-2.873-1.19-4.31-4.67-12.929-18.68-19.633-31.24-14.964a24.2 24.2 0 0 0-6.83 3.951c-2.87-1.317-5.86-2.275-8.97-2.514-6.23-1.317-12.33-.479-17.36 2.753-2.03 1.317-3.83 2.993-5.38 4.908-7.66 10.176-7.06 27.534 2.39 42.618l.36.479c8.98 14.006 23.1 21.907 35.07 20.83-1.68 7.183-.48 14.844 3.71 21.548a24.6 24.6 0 0 0 4.19 5.028c1.31.958 3.47.239 3.47-1.556Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__af)",
    stroke: "url(#fish_svg__ag)",
    d: "M2218.8 516.559c-.12-9.337 4.55-18.555 12.93-23.942 7.9-5.148 17.47-5.746 25.61-2.514 2.27.958 4.43-1.317 3.47-3.591a29.6 29.6 0 0 0-3.23-5.627c-6.94-9.457-19.15-13.408-30.16-10.415 1.2-9.338-1.2-20.351-7.66-30.407 6.34-2.274 11.97-3.95 17.35-.12 1.56 1.197 3.83-.239 3.47-2.154-.24-1.437-.59-2.874-1.19-4.31-4.67-12.929-18.67-19.633-31.24-14.964a24 24 0 0 0-6.82 3.95c-2.88-1.316-5.87-2.274-8.98-2.514-6.22-1.316-12.33-.478-17.36 2.754-2.03 1.317-3.83 2.993-5.38 4.908-7.66 10.176-7.06 27.534 2.39 42.618l.36.478c8.98 14.007 23.1 21.908 35.07 20.83-1.68 7.183-.48 14.845 3.71 21.549a24.6 24.6 0 0 0 4.19 5.028c1.32.957 3.47.119 3.47-1.557Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__ah)",
    stroke: "url(#fish_svg__ai)",
    d: "M2376.31 559.177c-.12-9.338 4.55-18.555 12.93-23.943 7.9-5.147 17.47-5.746 25.61-2.513 2.27.957 4.43-1.317 3.47-3.592a29.6 29.6 0 0 0-3.23-5.626c-6.94-9.458-19.15-13.408-30.16-10.415 1.19-9.338-1.2-20.351-7.66-30.407 6.34-2.275 11.97-3.951 17.35-.12 1.56 1.197 3.83-.239 3.47-2.155-.24-1.436-.59-2.873-1.19-4.309-4.67-12.929-18.67-19.633-31.24-14.965a24 24 0 0 0-6.82 3.951c-2.88-1.317-5.87-2.275-8.98-2.514-6.22-1.317-12.33-.479-17.36 2.753-2.03 1.317-3.83 2.993-5.38 4.909-7.66 10.175-7.06 27.533 2.39 42.617l.36.479c8.98 14.006 23.1 21.908 35.07 20.83-1.68 7.183-.48 14.844 3.71 21.548a24.6 24.6 0 0 0 4.19 5.028c1.32.958 3.47.12 3.47-1.556Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__aj)",
    stroke: "url(#fish_svg__ak)",
    d: "M2533.82 601.795c-.12-9.338 4.55-18.556 12.93-23.943 7.9-5.147 17.47-5.746 25.61-2.514 2.28.958 4.43-1.317 3.47-3.591a29 29 0 0 0-3.23-5.627c-6.94-9.457-19.15-13.407-30.16-10.415 1.2-9.337-1.2-20.351-7.66-30.407 6.34-2.274 11.97-3.95 17.35-.119 1.56 1.197 3.83-.24 3.48-2.155-.24-1.437-.6-2.873-1.2-4.31-4.67-12.929-18.67-19.633-31.24-14.964a24.2 24.2 0 0 0-6.82 3.951c-2.87-1.317-5.87-2.275-8.98-2.514-6.22-1.317-12.33-.479-17.35 2.753-2.04 1.317-3.83 2.993-5.39 4.908-7.66 10.176-7.06 27.534 2.39 42.618l.36.479c8.98 14.006 23.1 21.907 35.07 20.83-1.67 7.182-.48 14.844 3.71 21.548a25 25 0 0 0 4.19 5.028c1.32.958 3.47.12 3.47-1.556Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__al)",
    stroke: "url(#fish_svg__am)",
    d: "M2691.33 644.412c-.12-9.337 4.55-18.555 12.93-23.942 7.9-5.148 17.48-5.746 25.61-2.514 2.28.958 4.43-1.317 3.47-3.592a29 29 0 0 0-3.23-5.626c-6.94-9.457-19.15-13.408-30.16-10.415 1.2-9.338-1.2-20.351-7.66-30.407 6.34-2.275 11.97-3.951 17.36-.12 1.55 1.197 3.83-.239 3.47-2.155-.24-1.436-.6-2.873-1.2-4.309-4.67-12.929-18.67-19.633-31.24-14.964a24.2 24.2 0 0 0-6.82 3.95c-2.87-1.317-5.87-2.274-8.98-2.514-6.22-1.317-12.33-.479-17.35 2.754-2.04 1.317-3.83 2.992-5.39 4.908-7.66 10.175-7.06 27.534 2.4 42.618l.35.478c8.98 14.007 23.1 21.908 35.07 20.83-1.67 7.183-.48 14.845 3.71 21.549a25 25 0 0 0 4.19 5.027c1.32.958 3.47.12 3.47-1.556Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__an)",
    stroke: "url(#fish_svg__ao)",
    d: "M1492.05 428.092c-.12-9.338 4.55-18.556 12.92-23.943 7.9-5.147 17.48-5.746 25.62-2.514 2.27.958 4.43-1.316 3.47-3.591a30 30 0 0 0-3.23-5.627c-6.95-9.457-19.15-13.407-30.17-10.414 1.2-9.338-1.19-20.352-7.66-30.407 6.35-2.275 11.97-3.951 17.36-.12 1.56 1.197 3.83-.24 3.47-2.155-.24-1.437-.6-2.873-1.2-4.31-4.66-12.929-18.67-19.632-31.24-14.964a24.3 24.3 0 0 0-6.82 3.951c-2.87-1.317-5.86-2.275-8.97-2.514-6.23-1.317-12.33-.479-17.36 2.753-2.03 1.317-3.83 2.993-5.39 4.908-7.66 10.176-7.06 27.534 2.4 42.618l.36.479c8.97 14.006 23.1 21.907 35.07 20.83-1.68 7.183-.48 14.844 3.71 21.548a24.2 24.2 0 0 0 4.19 5.028c1.31.958 3.47.24 3.47-1.556Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__ap)",
    stroke: "url(#fish_svg__aq)",
    d: "M1649.56 470.709c-.12-9.337 4.55-18.555 12.93-23.942 7.89-5.148 17.47-5.746 25.61-2.514 2.27.958 4.43-1.317 3.47-3.591a30 30 0 0 0-3.23-5.627c-6.94-9.457-19.15-13.408-30.16-10.415 1.19-9.337-1.2-20.351-7.66-30.407 6.34-2.274 11.97-3.95 17.35-.12 1.56 1.198 3.83-.239 3.47-2.154-.24-1.437-.6-2.873-1.19-4.31-4.67-12.929-18.68-19.633-31.24-14.964a24.2 24.2 0 0 0-6.83 3.95c-2.87-1.316-5.86-2.274-8.97-2.514-6.23-1.316-12.33-.478-17.36 2.754-2.03 1.317-3.83 2.993-5.38 4.908-7.66 10.176-7.07 27.534 2.39 42.618l.36.479c8.98 14.006 23.1 21.907 35.07 20.83-1.68 7.182-.48 14.844 3.71 21.548a24.6 24.6 0 0 0 4.19 5.028c1.31.957 3.47.239 3.47-1.557Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__ar)",
    stroke: "url(#fish_svg__as)",
    d: "M1807.07 513.327c-.12-9.338 4.55-18.555 12.92-23.942 7.9-5.148 17.48-5.747 25.62-2.514 2.27.957 4.43-1.317 3.47-3.592a30 30 0 0 0-3.23-5.626c-6.94-9.458-19.15-13.408-30.16-10.415 1.19-9.338-1.2-20.351-7.66-30.407 6.34-2.275 11.96-3.951 17.35-.12 1.56 1.197 3.83-.239 3.47-2.155-.24-1.436-.6-2.873-1.2-4.309-4.66-12.929-18.67-19.633-31.23-14.964a24.2 24.2 0 0 0-6.83 3.95c-2.87-1.317-5.86-2.274-8.97-2.514-6.23-1.317-12.33-.479-17.36 2.753-2.03 1.317-3.83 2.993-5.38 4.909-7.66 10.175-7.07 27.534 2.39 42.617l.36.479c8.98 14.007 23.1 21.908 35.07 20.83-1.68 7.183-.48 14.845 3.71 21.548a24.6 24.6 0 0 0 4.19 5.028c1.31.958 3.47.12 3.47-1.556Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__at)",
    stroke: "url(#fish_svg__au)",
    d: "M1964.58 555.945c-.12-9.338 4.55-18.556 12.93-23.943 7.9-5.147 17.47-5.746 25.61-2.514 2.27.958 4.43-1.317 3.47-3.591a29.6 29.6 0 0 0-3.23-5.627c-6.94-9.457-19.15-13.407-30.16-10.415 1.19-9.337-1.2-20.351-7.66-30.407 6.34-2.274 11.97-3.95 17.35-.119 1.56 1.197 3.83-.24 3.47-2.155-.24-1.437-.6-2.873-1.19-4.31-4.67-12.929-18.68-19.633-31.24-14.964a24 24 0 0 0-6.82 3.951c-2.88-1.317-5.87-2.275-8.98-2.514-6.23-1.317-12.33-.479-17.36 2.753-2.03 1.317-3.83 2.993-5.38 4.908-7.66 10.176-7.06 27.534 2.39 42.618l.36.479c8.98 14.006 23.1 21.907 35.07 20.83-1.68 7.183-.48 14.844 3.71 21.548a24.6 24.6 0 0 0 4.19 5.028c1.32.958 3.47.12 3.47-1.556Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__av)",
    stroke: "url(#fish_svg__aw)",
    d: "M2122.09 598.562c-.12-9.337 4.55-18.555 12.93-23.942 7.9-5.148 17.47-5.746 25.61-2.514 2.28.958 4.43-1.317 3.47-3.591a29.6 29.6 0 0 0-3.23-5.627c-6.94-9.457-19.15-13.408-30.16-10.415 1.2-9.338-1.2-20.351-7.66-30.407 6.34-2.274 11.97-3.95 17.35-.12 1.56 1.198 3.83-.239 3.48-2.154-.24-1.437-.6-2.874-1.2-4.31-4.67-12.929-18.67-19.633-31.24-14.964a24.2 24.2 0 0 0-6.82 3.95c-2.88-1.316-5.87-2.274-8.98-2.514-6.22-1.316-12.33-.478-17.35 2.754-2.04 1.317-3.83 2.993-5.39 4.908-7.66 10.176-7.06 27.534 2.39 42.618l.36.479c8.98 14.006 23.1 21.907 35.07 20.829-1.67 7.183-.48 14.845 3.71 21.549a24.6 24.6 0 0 0 4.19 5.028c1.32.957 3.47.119 3.47-1.557Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__ax)",
    stroke: "url(#fish_svg__ay)",
    d: "M2279.6 641.06c-.12-9.337 4.55-18.555 12.93-23.942 7.9-5.148 17.47-5.746 25.61-2.514 2.28.958 4.43-1.317 3.47-3.592a29.6 29.6 0 0 0-3.23-5.626c-6.94-9.457-19.15-13.408-30.16-10.415 1.2-9.338-1.2-20.351-7.66-30.407 6.34-2.274 11.97-3.95 17.35-.12 1.56 1.197 3.83-.239 3.48-2.154-.24-1.437-.6-2.874-1.2-4.31-4.67-12.929-18.67-19.633-31.24-14.964a24.2 24.2 0 0 0-6.82 3.95c-2.88-1.317-5.87-2.274-8.98-2.514-6.22-1.317-12.33-.478-17.35 2.754-2.04 1.317-3.83 2.993-5.39 4.908-7.66 10.176-7.06 27.534 2.39 42.618l.36.478c8.98 14.007 23.1 21.908 35.07 20.83-1.67 7.183-.48 14.845 3.71 21.549a24.6 24.6 0 0 0 4.19 5.028c1.32 1.077 3.47.239 3.47-1.557Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__az)",
    stroke: "url(#fish_svg__aA)",
    d: "M2437.11 683.678c-.12-9.338 4.55-18.556 12.93-23.943 7.9-5.147 17.47-5.746 25.61-2.514 2.28.958 4.43-1.316 3.47-3.591a29 29 0 0 0-3.23-5.626c-6.94-9.458-19.15-13.408-30.16-10.415 1.2-9.338-1.2-20.351-7.66-30.407 6.34-2.275 11.97-3.951 17.36-.12 1.55 1.197 3.83-.239 3.47-2.155-.24-1.436-.6-2.873-1.2-4.309-4.67-12.929-18.67-19.633-31.24-14.965a24.2 24.2 0 0 0-6.82 3.951c-2.87-1.317-5.87-2.275-8.98-2.514-6.22-1.317-12.33-.479-17.35 2.753-2.04 1.317-3.83 2.993-5.39 4.909-7.66 10.175-7.06 27.533 2.39 42.617l.36.479c8.98 14.006 23.1 21.907 35.07 20.83-1.67 7.183-.48 14.844 3.71 21.548a24.9 24.9 0 0 0 4.19 5.028c1.32 1.078 3.47.24 3.47-1.556Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__aB)",
    stroke: "url(#fish_svg__aC)",
    d: "M2594.63 726.296c-.12-9.338 4.54-18.556 12.92-23.943 7.9-5.148 17.48-5.746 25.61-2.514 2.28.958 4.43-1.317 3.48-3.591a29.6 29.6 0 0 0-3.24-5.627c-6.94-9.457-19.15-13.407-30.16-10.415 1.2-9.337-1.19-20.351-7.66-30.407 6.35-2.274 11.97-3.95 17.36-.119 1.55 1.197 3.83-.24 3.47-2.155-.24-1.437-.6-2.873-1.2-4.31-4.67-12.929-18.67-19.633-31.24-14.964a24.3 24.3 0 0 0-6.82 3.951c-2.87-1.317-5.86-2.275-8.98-2.514-6.22-1.317-12.32-.479-17.35 2.753-2.04 1.317-3.83 2.993-5.39 4.908-7.66 10.176-7.06 27.534 2.4 42.618l.36.479c8.97 14.006 23.1 21.907 35.06 20.83-1.67 7.182-.47 14.844 3.71 21.548a25 25 0 0 0 4.19 5.028c1.32 1.077 3.48.239 3.48-1.556Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__aD)",
    stroke: "url(#fish_svg__aE)",
    d: "M1395.34 510.095c-.12-9.338 4.55-18.556 12.92-23.943 7.9-5.147 17.48-5.746 25.62-2.514 2.27.958 4.43-1.316 3.47-3.591a30 30 0 0 0-3.23-5.626c-6.94-9.458-19.15-13.408-30.16-10.415 1.19-9.338-1.2-20.352-7.66-30.407 6.34-2.275 11.96-3.951 17.35-.12 1.56 1.197 3.83-.24 3.47-2.155-.24-1.437-.6-2.873-1.2-4.31-4.66-12.929-18.67-19.632-31.23-14.964a24.2 24.2 0 0 0-6.83 3.951c-2.87-1.317-5.86-2.275-8.97-2.514-6.23-1.317-12.33-.479-17.36 2.753-2.03 1.317-3.83 2.993-5.38 4.908-7.66 10.176-7.07 27.534 2.39 42.618l.36.479c8.98 14.006 23.1 21.907 35.07 20.83-1.68 7.183-.48 14.844 3.71 21.548a24.2 24.2 0 0 0 4.19 5.028c1.43.958 3.47.12 3.47-1.556Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__aF)",
    stroke: "url(#fish_svg__aG)",
    d: "M1552.85 552.713c-.12-9.338 4.55-18.556 12.93-23.943 7.9-5.148 17.47-5.746 25.61-2.514 2.27.958 4.43-1.317 3.47-3.591a29.6 29.6 0 0 0-3.23-5.627c-6.94-9.457-19.15-13.408-30.16-10.415 1.19-9.337-1.2-20.351-7.66-30.407 6.34-2.274 11.97-3.95 17.35-.119 1.56 1.197 3.83-.24 3.47-2.155-.24-1.437-.6-2.873-1.19-4.31-4.67-12.929-18.68-19.633-31.24-14.964a24.3 24.3 0 0 0-6.83 3.95c-2.87-1.316-5.86-2.274-8.97-2.513-6.23-1.317-12.33-.479-17.36 2.753-2.03 1.317-3.83 2.993-5.38 4.908-7.66 10.176-7.06 27.534 2.39 42.618l.36.479c8.98 14.006 23.1 21.907 35.07 20.83-1.68 7.182-.48 14.844 3.71 21.548a24.6 24.6 0 0 0 4.19 5.028c1.43.957 3.47.119 3.47-1.556Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__aH)",
    stroke: "url(#fish_svg__aI)",
    d: "M1710.36 595.33c-.12-9.337 4.55-18.555 12.93-23.942 7.9-5.148 17.47-5.747 25.61-2.514 2.27.957 4.43-1.317 3.47-3.592a29.6 29.6 0 0 0-3.23-5.626c-6.94-9.457-19.15-13.408-30.16-10.415 1.19-9.338-1.2-20.351-7.66-30.407 6.34-2.275 11.97-3.951 17.35-.12 1.56 1.197 3.83-.239 3.47-2.155-.24-1.436-.6-2.873-1.19-4.309-4.67-12.929-18.68-19.633-31.24-14.964a24.2 24.2 0 0 0-6.83 3.95c-2.87-1.317-5.86-2.274-8.97-2.514-6.23-1.317-12.33-.479-17.36 2.754-2.03 1.316-3.83 2.992-5.38 4.908-7.66 10.175-7.06 27.534 2.39 42.617l.36.479c8.98 14.007 23.1 21.908 35.07 20.83-1.68 7.183-.48 14.845 3.71 21.548a24.6 24.6 0 0 0 4.19 5.028c1.43.958 3.47.12 3.47-1.556Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__aJ)",
    stroke: "url(#fish_svg__aK)",
    d: "M1867.87 637.828c-.12-9.338 4.55-18.555 12.93-23.942 7.9-5.148 17.47-5.747 25.61-2.514 2.28.957 4.43-1.317 3.47-3.592a29.6 29.6 0 0 0-3.23-5.626c-6.94-9.458-19.15-13.408-30.16-10.415 1.2-9.338-1.2-20.351-7.66-30.407 6.34-2.275 11.97-3.951 17.35-.12 1.56 1.197 3.83-.239 3.47-2.155-.23-1.436-.59-2.873-1.19-4.309-4.67-12.929-18.67-19.633-31.24-14.964a24.2 24.2 0 0 0-6.82 3.95c-2.88-1.317-5.87-2.274-8.98-2.514-6.22-1.317-12.33-.479-17.36 2.753-2.03 1.317-3.83 2.993-5.38 4.909-7.66 10.175-7.06 27.534 2.39 42.617l.36.479c8.98 14.007 23.1 21.908 35.07 20.83-1.68 7.183-.48 14.845 3.71 21.548a24.6 24.6 0 0 0 4.19 5.028c1.44 1.078 3.47.24 3.47-1.556Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__aL)",
    stroke: "url(#fish_svg__aM)",
    d: "M2025.38 680.446c-.12-9.338 4.55-18.556 12.93-23.943 7.9-5.147 17.47-5.746 25.61-2.514 2.28.958 4.43-1.317 3.47-3.591a29 29 0 0 0-3.23-5.627c-6.94-9.457-19.15-13.407-30.16-10.415 1.2-9.337-1.2-20.351-7.66-30.407 6.34-2.274 11.97-3.95 17.36-.119 1.55 1.197 3.83-.24 3.47-2.155-.24-1.437-.6-2.873-1.2-4.31-4.67-12.929-18.67-19.633-31.24-14.964a24.2 24.2 0 0 0-6.82 3.951c-2.87-1.317-5.87-2.275-8.98-2.514-6.22-1.317-12.33-.479-17.35 2.753-2.04 1.317-3.83 2.993-5.39 4.908-7.66 10.176-7.06 27.534 2.39 42.618l.36.479c8.98 14.006 23.1 21.907 35.07 20.83-1.67 7.183-.48 14.844 3.71 21.548a25 25 0 0 0 4.19 5.028c1.44 1.077 3.47.239 3.47-1.556Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__aN)",
    stroke: "url(#fish_svg__aO)",
    d: "M2182.89 723.063c-.12-9.337 4.55-18.555 12.93-23.942 7.9-5.148 17.47-5.746 25.61-2.514 2.28.958 4.43-1.317 3.47-3.591a29 29 0 0 0-3.23-5.627c-6.94-9.457-19.15-13.408-30.16-10.415 1.2-9.337-1.2-20.351-7.66-30.407 6.34-2.274 11.97-3.95 17.36-.12 1.55 1.198 3.83-.239 3.47-2.154-.24-1.437-.6-2.874-1.2-4.31-4.67-12.929-18.67-19.633-31.24-14.964a24.2 24.2 0 0 0-6.82 3.95c-2.87-1.316-5.87-2.274-8.98-2.514-6.22-1.316-12.33-.478-17.35 2.754-2.04 1.317-3.83 2.993-5.39 4.908-7.66 10.176-7.06 27.534 2.39 42.618l.36.479c8.98 14.006 23.1 21.907 35.07 20.829-1.67 7.183-.48 14.845 3.71 21.549a25 25 0 0 0 4.19 5.028c1.44 1.077 3.47.239 3.47-1.557Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__aP)",
    stroke: "url(#fish_svg__aQ)",
    d: "M2340.4 765.681c-.12-9.338 4.55-18.555 12.93-23.943 7.9-5.147 17.48-5.746 25.61-2.513 2.28.957 4.43-1.317 3.48-3.592a29.6 29.6 0 0 0-3.24-5.626c-6.94-9.458-19.15-13.408-30.16-10.415 1.2-9.338-1.2-20.351-7.66-30.407 6.35-2.275 11.97-3.951 17.36-.12 1.55 1.197 3.83-.239 3.47-2.155-.24-1.436-.6-2.873-1.2-4.309-4.67-12.929-18.67-19.633-31.24-14.964a24.2 24.2 0 0 0-6.82 3.95c-2.87-1.317-5.87-2.275-8.98-2.514-6.22-1.317-12.33-.479-17.35 2.753-2.04 1.317-3.83 2.993-5.39 4.909-7.66 10.175-7.06 27.534 2.4 42.617l.35.479c8.98 14.006 23.1 21.908 35.07 20.83-1.67 7.183-.48 14.844 3.71 21.548a24.9 24.9 0 0 0 4.19 5.028c1.44.958 3.47.24 3.47-1.556Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__aR)",
    stroke: "url(#fish_svg__aS)",
    d: "M2497.92 808.299c-.12-9.338 4.54-18.556 12.92-23.943 7.9-5.147 17.48-5.746 25.62-2.514 2.27.958 4.42-1.317 3.47-3.591a30 30 0 0 0-3.23-5.627c-6.95-9.457-19.16-13.407-30.17-10.415 1.2-9.337-1.19-20.351-7.66-30.407 6.35-2.274 11.97-3.95 17.36-.119 1.55 1.197 3.83-.24 3.47-2.155-.24-1.437-.6-2.873-1.2-4.31-4.67-12.929-18.67-19.633-31.24-14.964a24.3 24.3 0 0 0-6.82 3.951c-2.87-1.317-5.86-2.275-8.98-2.514-6.22-1.317-12.32-.479-17.35 2.753-2.04 1.317-3.83 2.993-5.39 4.908-7.66 10.176-7.06 27.534 2.4 42.618l.36.479c8.97 14.006 23.1 21.907 35.07 20.83-1.68 7.182-.48 14.844 3.71 21.548a24.3 24.3 0 0 0 4.19 5.028c1.43.958 3.47.12 3.47-1.556Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__aT)",
    stroke: "url(#fish_svg__aU)",
    d: "M1298.75 591.978c-.12-9.337 4.55-18.555 12.92-23.942 7.9-5.148 17.48-5.747 25.62-2.514 2.27.957 4.43-1.317 3.47-3.592a30 30 0 0 0-3.23-5.626c-6.94-9.457-19.15-13.408-30.16-10.415 1.19-9.338-1.2-20.351-7.66-30.407 6.34-2.275 11.96-3.951 17.35-.12 1.56 1.197 3.83-.239 3.47-2.155-.24-1.436-.6-2.873-1.2-4.309-4.66-12.929-18.67-19.633-31.23-14.964a24.2 24.2 0 0 0-6.83 3.95c-2.87-1.317-5.86-2.274-8.97-2.514-6.23-1.317-12.33-.479-17.36 2.754-2.03 1.316-3.83 2.992-5.38 4.908-7.66 10.175-7.07 27.534 2.39 42.617l.36.479c8.98 14.007 23.1 21.908 35.07 20.83-1.68 7.183-.48 14.845 3.71 21.549a24.3 24.3 0 0 0 4.19 5.027c1.31 1.078 3.47.24 3.47-1.556Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__aV)",
    stroke: "url(#fish_svg__aW)",
    d: "M1456.26 634.596c-.12-9.338 4.55-18.556 12.93-23.943 7.89-5.147 17.47-5.746 25.61-2.514 2.27.958 4.43-1.316 3.47-3.591a30 30 0 0 0-3.23-5.626c-6.94-9.458-19.15-13.408-30.16-10.415 1.19-9.338-1.2-20.352-7.66-30.407 6.34-2.275 11.97-3.951 17.35-.12 1.56 1.197 3.83-.24 3.47-2.155-.24-1.437-.6-2.873-1.19-4.31-4.67-12.929-18.68-19.632-31.24-14.964a24.2 24.2 0 0 0-6.83 3.951c-2.87-1.317-5.86-2.275-8.97-2.514-6.23-1.317-12.33-.479-17.36 2.753-2.03 1.317-3.83 2.993-5.38 4.908-7.66 10.176-7.07 27.534 2.39 42.618l.36.479c8.98 14.006 23.1 21.907 35.07 20.83-1.68 7.183-.48 14.844 3.71 21.548a24.6 24.6 0 0 0 4.19 5.028c1.31 1.078 3.47.24 3.47-1.556Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__aX)",
    stroke: "url(#fish_svg__aY)",
    d: "M1613.77 677.214c-.12-9.338 4.55-18.556 12.93-23.943 7.9-5.148 17.47-5.746 25.61-2.514 2.27.958 4.43-1.317 3.47-3.591a29.6 29.6 0 0 0-3.23-5.627c-6.94-9.457-19.15-13.408-30.16-10.415 1.19-9.337-1.2-20.351-7.66-30.407 6.34-2.274 11.97-3.95 17.35-.119 1.56 1.197 3.83-.24 3.47-2.155-.24-1.437-.6-2.873-1.19-4.31-4.67-12.929-18.68-19.633-31.24-14.964a24.2 24.2 0 0 0-6.83 3.951c-2.87-1.317-5.86-2.275-8.97-2.514-6.23-1.317-12.33-.479-17.36 2.753-2.03 1.317-3.83 2.993-5.38 4.908-7.66 10.176-7.06 27.534 2.39 42.618l.36.479c8.98 14.006 23.1 21.907 35.07 20.83-1.68 7.182-.48 14.844 3.71 21.548a24.6 24.6 0 0 0 4.19 5.028c1.32 1.077 3.47.239 3.47-1.556Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__aZ)",
    stroke: "url(#fish_svg__ba)",
    d: "M1771.28 719.831c-.12-9.337 4.55-18.555 12.93-23.942 7.9-5.148 17.47-5.747 25.61-2.514 2.28.957 4.43-1.317 3.47-3.592a29.6 29.6 0 0 0-3.23-5.626c-6.94-9.457-19.15-13.408-30.16-10.415 1.2-9.338-1.2-20.351-7.66-30.407 6.34-2.275 11.97-3.951 17.35-.12 1.56 1.197 3.83-.239 3.47-2.155-.23-1.436-.59-2.873-1.19-4.309-4.67-12.929-18.67-19.633-31.24-14.964a24.2 24.2 0 0 0-6.82 3.95c-2.88-1.317-5.87-2.274-8.98-2.514-6.22-1.317-12.33-.479-17.36 2.754-2.03 1.316-3.83 2.992-5.38 4.908-7.66 10.175-7.06 27.534 2.39 42.617l.36.479c8.98 14.007 23.1 21.908 35.07 20.83-1.67 7.183-.48 14.845 3.71 21.549a24.6 24.6 0 0 0 4.19 5.027c1.32.958 3.47.24 3.47-1.556Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__bb)",
    stroke: "url(#fish_svg__bc)",
    d: "M1928.79 762.449c-.12-9.338 4.55-18.556 12.93-23.943 7.9-5.147 17.47-5.746 25.61-2.514 2.28.958 4.43-1.317 3.47-3.591a29 29 0 0 0-3.23-5.627c-6.94-9.457-19.15-13.407-30.16-10.414 1.2-9.338-1.2-20.352-7.66-30.407 6.34-2.275 11.97-3.951 17.36-.12 1.55 1.197 3.83-.24 3.47-2.155-.24-1.437-.6-2.873-1.2-4.31-4.67-12.929-18.67-19.633-31.24-14.964a24.2 24.2 0 0 0-6.82 3.951c-2.87-1.317-5.87-2.275-8.98-2.514-6.22-1.317-12.33-.479-17.35 2.753-2.04 1.317-3.83 2.993-5.39 4.908-7.66 10.176-7.06 27.534 2.39 42.618l.36.479c8.98 14.006 23.1 21.907 35.07 20.83-1.67 7.183-.48 14.844 3.71 21.548a24.9 24.9 0 0 0 4.19 5.028c1.32.958 3.47.24 3.47-1.556Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__bd)",
    stroke: "url(#fish_svg__be)",
    d: "M2086.3 805.066c-.12-9.337 4.55-18.555 12.93-23.942 7.9-5.148 17.47-5.746 25.61-2.514 2.28.958 4.43-1.317 3.47-3.591a29 29 0 0 0-3.23-5.627c-6.94-9.457-19.15-13.408-30.16-10.415 1.2-9.337-1.2-20.351-7.66-30.407 6.34-2.274 11.97-3.95 17.36-.12 1.55 1.198 3.83-.239 3.47-2.154-.24-1.437-.6-2.874-1.2-4.31-4.67-12.929-18.67-19.633-31.24-14.964a24.2 24.2 0 0 0-6.82 3.95c-2.87-1.316-5.87-2.274-8.98-2.514-6.22-1.316-12.33-.478-17.35 2.754-2.04 1.317-3.83 2.993-5.39 4.908-7.66 10.176-7.06 27.534 2.39 42.618l.36.479c8.98 14.006 23.1 21.907 35.07 20.829-1.67 7.183-.48 14.845 3.71 21.549a25 25 0 0 0 4.19 5.028c1.32.957 3.47.119 3.47-1.557Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__bf)",
    stroke: "url(#fish_svg__bg)",
    d: "M2243.81 847.684c-.12-9.338 4.55-18.555 12.93-23.942 7.9-5.148 17.48-5.747 25.61-2.514 2.28.957 4.43-1.317 3.48-3.592a29.6 29.6 0 0 0-3.24-5.626c-6.94-9.458-19.15-13.408-30.16-10.415 1.2-9.338-1.19-20.351-7.66-30.407 6.35-2.275 11.97-3.951 17.36-.12 1.55 1.197 3.83-.239 3.47-2.155-.24-1.436-.6-2.873-1.2-4.309-4.67-12.929-18.67-19.633-31.24-14.964a24.2 24.2 0 0 0-6.82 3.95c-2.87-1.317-5.87-2.274-8.98-2.514-6.22-1.317-12.32-.479-17.35 2.753-2.04 1.317-3.83 2.993-5.39 4.909-7.66 10.175-7.06 27.534 2.4 42.617l.36.479c8.97 14.007 23.09 21.908 35.06 20.83-1.67 7.183-.47 14.845 3.71 21.548a24.9 24.9 0 0 0 4.19 5.028c1.32.958 3.47.12 3.47-1.556Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__bh)",
    stroke: "url(#fish_svg__bi)",
    d: "M2401.33 890.302c-.12-9.338 4.54-18.556 12.92-23.943 7.9-5.147 17.48-5.746 25.62-2.514 2.27.958 4.42-1.317 3.47-3.591a30 30 0 0 0-3.23-5.627c-6.95-9.457-19.15-13.407-30.17-10.415 1.2-9.337-1.19-20.351-7.66-30.407 6.35-2.274 11.97-3.95 17.36-.119 1.55 1.197 3.83-.24 3.47-2.155-.24-1.437-.6-2.873-1.2-4.31-4.67-12.929-18.67-19.633-31.24-14.964a24.3 24.3 0 0 0-6.82 3.951c-2.87-1.317-5.86-2.275-8.98-2.514-6.22-1.317-12.32-.479-17.35 2.753-2.03 1.317-3.83 2.993-5.39 4.908-7.66 10.176-7.06 27.534 2.4 42.618l.36.479c8.97 14.006 23.1 21.907 35.07 20.83-1.68 7.183-.48 14.844 3.71 21.548a24.3 24.3 0 0 0 4.19 5.028c1.31.958 3.47.12 3.47-1.556Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__bj)",
    stroke: "url(#fish_svg__bk)",
    d: "M1202.04 673.981c-.12-9.337 4.55-18.555 12.93-23.942 7.89-5.148 17.47-5.746 25.61-2.514 2.27.958 4.43-1.317 3.47-3.592a30 30 0 0 0-3.23-5.626c-6.94-9.457-19.15-13.408-30.16-10.415 1.19-9.338-1.2-20.351-7.66-30.407 6.34-2.275 11.97-3.951 17.35-.12 1.56 1.197 3.83-.239 3.47-2.155-.24-1.436-.6-2.873-1.19-4.309-4.67-12.929-18.68-19.633-31.24-14.964a24.2 24.2 0 0 0-6.83 3.95c-2.87-1.317-5.86-2.274-8.97-2.514-6.23-1.317-12.33-.479-17.36 2.754-2.03 1.317-3.83 2.992-5.38 4.908-7.66 10.175-7.06 27.534 2.39 42.618l.36.478c8.98 14.007 23.1 21.908 35.07 20.83-1.68 7.183-.48 14.845 3.71 21.549a24.6 24.6 0 0 0 4.19 5.027c1.31 1.078 3.47.24 3.47-1.556Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__bl)",
    stroke: "url(#fish_svg__bm)",
    d: "M1359.55 716.599c-.12-9.338 4.55-18.556 12.93-23.943 7.9-5.147 17.47-5.746 25.61-2.514 2.27.958 4.43-1.316 3.47-3.591a29.6 29.6 0 0 0-3.23-5.626c-6.94-9.458-19.15-13.408-30.16-10.415 1.19-9.338-1.2-20.352-7.66-30.407 6.34-2.275 11.97-3.951 17.35-.12 1.56 1.197 3.83-.24 3.47-2.155-.24-1.437-.6-2.873-1.19-4.31-4.67-12.929-18.68-19.632-31.24-14.964a24 24 0 0 0-6.82 3.951c-2.88-1.317-5.87-2.275-8.98-2.514-6.23-1.317-12.33-.479-17.36 2.753-2.03 1.317-3.83 2.993-5.38 4.908-7.66 10.176-7.06 27.534 2.39 42.618l.36.479c8.98 14.006 23.1 21.907 35.07 20.83-1.68 7.183-.48 14.844 3.71 21.548a24.6 24.6 0 0 0 4.19 5.028c1.32.958 3.47.24 3.47-1.556Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__bn)",
    stroke: "url(#fish_svg__bo)",
    d: "M1517.06 759.217c-.12-9.338 4.55-18.556 12.93-23.943 7.9-5.148 17.47-5.746 25.61-2.514 2.28.958 4.43-1.317 3.47-3.591a29.6 29.6 0 0 0-3.23-5.627c-6.94-9.457-19.15-13.408-30.16-10.415 1.2-9.337-1.2-20.351-7.66-30.407 6.34-2.274 11.97-3.95 17.35-.119 1.56 1.197 3.83-.24 3.47-2.155-.23-1.437-.59-2.873-1.19-4.31-4.67-12.929-18.67-19.633-31.24-14.964a24.2 24.2 0 0 0-6.82 3.95c-2.88-1.316-5.87-2.274-8.98-2.513-6.22-1.317-12.33-.479-17.35 2.753-2.04 1.317-3.83 2.993-5.39 4.908-7.66 10.176-7.06 27.534 2.39 42.618l.36.479c8.98 14.006 23.1 21.907 35.07 20.83-1.67 7.182-.48 14.844 3.71 21.548a24.6 24.6 0 0 0 4.19 5.028c1.32.957 3.47.119 3.47-1.556Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__bp)",
    stroke: "url(#fish_svg__bq)",
    d: "M1674.57 801.834c-.12-9.337 4.55-18.555 12.93-23.942 7.9-5.148 17.47-5.747 25.61-2.514 2.28.957 4.43-1.317 3.47-3.592a29 29 0 0 0-3.23-5.626c-6.94-9.457-19.15-13.408-30.16-10.415 1.2-9.338-1.2-20.351-7.66-30.407 6.34-2.275 11.97-3.951 17.35-.12 1.56 1.197 3.83-.239 3.48-2.155-.24-1.436-.6-2.873-1.2-4.309-4.67-12.929-18.67-19.633-31.24-14.964a24.2 24.2 0 0 0-6.82 3.95c-2.87-1.317-5.87-2.274-8.98-2.514-6.22-1.317-12.33-.479-17.35 2.754-2.04 1.316-3.83 2.992-5.39 4.908-7.66 10.175-7.06 27.534 2.39 42.617l.36.479c8.98 14.007 23.1 21.908 35.07 20.83-1.67 7.183-.48 14.845 3.71 21.548a24.9 24.9 0 0 0 4.19 5.028c1.32.958 3.47.12 3.47-1.556Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__br)",
    stroke: "url(#fish_svg__bs)",
    d: "M1832.08 844.452c-.12-9.338 4.55-18.556 12.93-23.943 7.9-5.147 17.48-5.746 25.61-2.514 2.28.958 4.43-1.316 3.47-3.591a29 29 0 0 0-3.23-5.627c-6.94-9.457-19.15-13.407-30.16-10.414 1.2-9.338-1.2-20.352-7.66-30.407 6.35-2.275 11.97-3.951 17.36-.12 1.55 1.197 3.83-.24 3.47-2.155-.24-1.437-.6-2.873-1.2-4.31-4.67-12.929-18.67-19.632-31.24-14.964a24.2 24.2 0 0 0-6.82 3.951c-2.87-1.317-5.87-2.275-8.98-2.514-6.22-1.317-12.33-.479-17.35 2.753-2.04 1.317-3.83 2.993-5.39 4.908-7.66 10.176-7.06 27.534 2.4 42.618l.35.479c8.98 14.006 23.1 21.907 35.07 20.83-1.67 7.183-.48 14.844 3.71 21.548a24.9 24.9 0 0 0 4.19 5.028c1.32.958 3.47.12 3.47-1.556Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__bt)",
    stroke: "url(#fish_svg__bu)",
    d: "M1989.59 887.069c-.12-9.337 4.55-18.555 12.93-23.942 7.9-5.148 17.47-5.746 25.61-2.514 2.28.958 4.43-1.317 3.47-3.591a29 29 0 0 0-3.23-5.627c-6.94-9.457-19.15-13.408-30.16-10.415 1.2-9.337-1.2-20.351-7.66-30.407 6.34-2.274 11.97-3.95 17.36-.12 1.55 1.198 3.83-.239 3.47-2.154-.24-1.437-.6-2.874-1.2-4.31-4.67-12.929-18.67-19.633-31.24-14.964a24.2 24.2 0 0 0-6.82 3.95c-2.87-1.316-5.87-2.274-8.98-2.514-6.22-1.316-12.33-.478-17.35 2.754-2.04 1.317-3.83 2.993-5.39 4.908-7.66 10.176-7.06 27.534 2.4 42.618l.35.479c8.98 14.006 23.1 21.907 35.07 20.829-1.67 7.183-.48 14.845 3.71 21.549a25 25 0 0 0 4.19 5.028c1.32.957 3.47.119 3.47-1.557Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__bv)",
    stroke: "url(#fish_svg__bw)",
    d: "M2147.11 929.567c-.12-9.337 4.54-18.555 12.92-23.942 7.9-5.148 17.48-5.746 25.62-2.514 2.27.958 4.42-1.317 3.47-3.591a29.6 29.6 0 0 0-3.24-5.627c-6.94-9.457-19.15-13.408-30.16-10.415 1.2-9.338-1.19-20.351-7.66-30.407 6.35-2.274 11.97-3.95 17.36-.12 1.55 1.197 3.83-.239 3.47-2.154-.24-1.437-.6-2.874-1.2-4.31-4.67-12.929-18.67-19.633-31.24-14.964a24.3 24.3 0 0 0-6.82 3.95c-2.87-1.316-5.86-2.274-8.98-2.514-6.22-1.316-12.32-.479-17.35 2.754-2.04 1.317-3.83 2.993-5.39 4.908-7.66 10.176-7.06 27.534 2.4 42.618l.36.478c8.97 14.007 23.1 21.908 35.06 20.83-1.67 7.183-.47 14.845 3.72 21.549 1.19 1.915 2.63 3.591 4.18 5.028 1.32 1.077 3.48.239 3.48-1.557Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__bx)",
    stroke: "url(#fish_svg__by)",
    d: "M2304.62 972.185c-.12-9.338 4.55-18.555 12.92-23.943 7.9-5.147 17.48-5.746 25.62-2.513 2.27.957 4.43-1.317 3.47-3.592a30 30 0 0 0-3.23-5.626c-6.95-9.458-19.15-13.408-30.17-10.415 1.2-9.338-1.19-20.351-7.66-30.407 6.35-2.275 11.97-3.951 17.36-.12 1.56 1.197 3.83-.239 3.47-2.155-.24-1.436-.6-2.873-1.2-4.309-4.66-12.929-18.67-19.633-31.24-14.965a24.3 24.3 0 0 0-6.82 3.951c-2.87-1.317-5.86-2.275-8.97-2.514-6.23-1.317-12.33-.479-17.36 2.753-2.03 1.317-3.83 2.993-5.39 4.909-7.66 10.175-7.06 27.534 2.4 42.617l.36.479c8.97 14.006 23.1 21.907 35.07 20.83-1.68 7.183-.48 14.844 3.71 21.548a24.2 24.2 0 0 0 4.19 5.028c1.31 1.078 3.47.24 3.47-1.556Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__bz)",
    stroke: "url(#fish_svg__bA)",
    d: "M1105.33 755.984c-.12-9.337 4.55-18.555 12.93-23.942 7.9-5.148 17.47-5.746 25.61-2.514 2.27.958 4.43-1.317 3.47-3.591a29.6 29.6 0 0 0-3.23-5.627c-6.94-9.457-19.15-13.408-30.16-10.415 1.19-9.338-1.2-20.351-7.66-30.407 6.34-2.275 11.97-3.95 17.35-.12 1.56 1.197 3.83-.239 3.47-2.154-.24-1.437-.59-2.874-1.19-4.31-4.67-12.929-18.68-19.633-31.24-14.964a24 24 0 0 0-6.82 3.95c-2.88-1.316-5.87-2.274-8.98-2.514-6.23-1.316-12.33-.479-17.36 2.754-2.03 1.317-3.83 2.993-5.38 4.908-7.66 10.176-7.06 27.534 2.39 42.618l.36.478c8.98 14.007 23.1 21.908 35.07 20.83-1.68 7.183-.48 14.845 3.71 21.549a24.6 24.6 0 0 0 4.19 5.028c1.44.957 3.47.119 3.47-1.557Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__bB)",
    stroke: "url(#fish_svg__bC)",
    d: "M1262.84 798.602c-.12-9.338 4.55-18.555 12.93-23.943 7.9-5.147 17.47-5.746 25.61-2.513 2.27.957 4.43-1.317 3.47-3.592a29.6 29.6 0 0 0-3.23-5.626c-6.94-9.458-19.15-13.408-30.16-10.415 1.2-9.338-1.2-20.351-7.66-30.407 6.34-2.275 11.97-3.951 17.35-.12 1.56 1.197 3.83-.239 3.47-2.155-.24-1.436-.59-2.873-1.19-4.309-4.67-12.929-18.67-19.633-31.24-14.965a24 24 0 0 0-6.82 3.951c-2.88-1.317-5.87-2.275-8.98-2.514-6.22-1.317-12.33-.479-17.36 2.753-2.03 1.317-3.83 2.993-5.38 4.909-7.66 10.175-7.06 27.533 2.39 42.617l.36.479c8.98 14.006 23.1 21.907 35.07 20.83-1.68 7.183-.48 14.844 3.71 21.548a24.6 24.6 0 0 0 4.19 5.028c1.44.958 3.47.12 3.47-1.556Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__bD)",
    stroke: "url(#fish_svg__bE)",
    d: "M1420.35 841.22c-.12-9.338 4.55-18.556 12.93-23.943 7.9-5.148 17.47-5.746 25.61-2.514 2.28.958 4.43-1.317 3.47-3.591a29 29 0 0 0-3.23-5.627c-6.94-9.457-19.15-13.407-30.16-10.415 1.2-9.337-1.2-20.351-7.66-30.407 6.34-2.274 11.97-3.95 17.35-.119 1.56 1.197 3.84-.24 3.48-2.155-.24-1.437-.6-2.873-1.2-4.31-4.67-12.929-18.67-19.633-31.24-14.964a24.2 24.2 0 0 0-6.82 3.951c-2.87-1.317-5.87-2.275-8.98-2.514-6.22-1.317-12.33-.479-17.35 2.753-2.04 1.317-3.83 2.993-5.39 4.908-7.66 10.176-7.06 27.534 2.39 42.618l.36.479c8.98 14.006 23.1 21.907 35.07 20.83-1.67 7.182-.48 14.844 3.71 21.548a25 25 0 0 0 4.19 5.028c1.44.958 3.47.12 3.47-1.556Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__bF)",
    stroke: "url(#fish_svg__bG)",
    d: "M1577.86 883.718c-.12-9.338 4.55-18.556 12.93-23.943 7.9-5.148 17.47-5.746 25.61-2.514 2.28.958 4.43-1.317 3.47-3.591a29 29 0 0 0-3.23-5.627c-6.94-9.457-19.15-13.408-30.16-10.415 1.2-9.337-1.2-20.351-7.66-30.407 6.34-2.274 11.97-3.95 17.36-.119 1.55 1.197 3.83-.24 3.47-2.155-.24-1.437-.6-2.873-1.2-4.31-4.67-12.929-18.67-19.633-31.24-14.964a24.2 24.2 0 0 0-6.82 3.95c-2.87-1.316-5.87-2.274-8.98-2.513-6.22-1.317-12.33-.479-17.35 2.753-2.04 1.317-3.83 2.993-5.39 4.908-7.66 10.176-7.06 27.534 2.39 42.618l.36.479c8.98 14.006 23.1 21.907 35.07 20.83-1.67 7.182-.48 14.844 3.71 21.548a25 25 0 0 0 4.19 5.028c1.44 1.077 3.47.239 3.47-1.556Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__bH)",
    stroke: "url(#fish_svg__bI)",
    d: "M1735.37 926.335c-.11-9.337 4.55-18.555 12.93-23.942 7.9-5.148 17.48-5.747 25.61-2.514 2.28.957 4.43-1.317 3.48-3.592a29.6 29.6 0 0 0-3.24-5.626c-6.94-9.457-19.15-13.408-30.16-10.415 1.2-9.338-1.19-20.351-7.66-30.407 6.35-2.275 11.97-3.951 17.36-.12 1.55 1.197 3.83-.239 3.47-2.155-.24-1.436-.6-2.873-1.2-4.309-4.67-12.929-18.67-19.633-31.24-14.964a24.3 24.3 0 0 0-6.82 3.95c-2.87-1.317-5.86-2.274-8.98-2.514-6.22-1.317-12.32-.479-17.35 2.754-2.04 1.316-3.83 2.992-5.39 4.908-7.66 10.175-7.06 27.534 2.4 42.617l.36.479c8.97 14.007 23.1 21.908 35.06 20.83-1.67 7.183-.47 14.845 3.71 21.549a25 25 0 0 0 4.19 5.027c1.44 1.078 3.47.24 3.47-1.556Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__bJ)",
    stroke: "url(#fish_svg__bK)",
    d: "M1892.88 968.953c-.12-9.338 4.55-18.556 12.93-23.943 7.9-5.147 17.48-5.746 25.61-2.514 2.28.958 4.43-1.316 3.48-3.591a29.7 29.7 0 0 0-3.24-5.627c-6.94-9.457-19.15-13.407-30.16-10.414 1.2-9.338-1.19-20.352-7.66-30.407 6.35-2.275 11.97-3.951 17.36-.12 1.55 1.197 3.83-.24 3.47-2.155-.24-1.437-.6-2.873-1.2-4.31-4.67-12.929-18.67-19.632-31.24-14.964a24.2 24.2 0 0 0-6.82 3.951c-2.87-1.317-5.86-2.275-8.98-2.514-6.22-1.317-12.32-.479-17.35 2.753-2.04 1.317-3.83 2.993-5.39 4.908-7.66 10.176-7.06 27.534 2.4 42.618l.36.479c8.97 14.006 23.1 21.907 35.06 20.83-1.67 7.183-.47 14.844 3.71 21.548a24.9 24.9 0 0 0 4.19 5.028c1.44 1.078 3.47.24 3.47-1.556Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__bL)",
    stroke: "url(#fish_svg__bM)",
    d: "M2050.4 1011.57c-.12-9.34 4.54-18.555 12.92-23.942 7.9-5.148 17.48-5.746 25.62-2.514 2.27.958 4.42-1.317 3.47-3.591a30 30 0 0 0-3.23-5.627c-6.95-9.457-19.15-13.408-30.17-10.415 1.2-9.337-1.19-20.351-7.66-30.407 6.35-2.274 11.97-3.95 17.36-.12 1.55 1.198 3.83-.239 3.47-2.154-.24-1.437-.6-2.873-1.2-4.31-4.66-12.929-18.67-19.633-31.24-14.964a24.4 24.4 0 0 0-6.82 3.95c-2.87-1.316-5.86-2.274-8.97-2.514-6.23-1.316-12.33-.478-17.36 2.754-2.03 1.317-3.83 2.993-5.39 4.908-7.66 10.176-7.06 27.534 2.4 42.618l.36.479c8.97 14.006 23.1 21.907 35.07 20.83-1.68 7.182-.48 14.839 3.71 21.549a24.5 24.5 0 0 0 4.19 5.03c1.43.95 3.47.24 3.47-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__bN)",
    stroke: "url(#fish_svg__bO)",
    d: "M2207.91 1054.19c-.12-9.34 4.55-18.56 12.92-23.94 7.9-5.15 17.48-5.75 25.62-2.52 2.27.96 4.43-1.32 3.47-3.59-.84-1.92-1.92-3.83-3.23-5.63-6.94-9.45-19.15-13.4-30.16-10.41 1.19-9.339-1.2-20.352-7.66-30.408 6.34-2.275 11.96-3.951 17.35-.12 1.56 1.197 3.83-.239 3.47-2.155-.24-1.436-.6-2.873-1.2-4.309-4.66-12.929-18.67-19.633-31.23-14.964a24.2 24.2 0 0 0-6.83 3.95c-2.87-1.317-5.86-2.274-8.97-2.514-6.23-1.317-12.33-.479-17.36 2.754-2.03 1.316-3.83 2.992-5.38 4.908-7.66 10.175-7.07 27.534 2.39 42.618l.36.48c8.98 14 23.1 21.91 35.07 20.83-1.68 7.18-.48 14.84 3.71 21.55a24.5 24.5 0 0 0 4.19 5.02c1.43.96 3.47.12 3.47-1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__bP)",
    stroke: "url(#fish_svg__bQ)",
    d: "M1008.74 837.868c-.12-9.338 4.55-18.556 12.93-23.943 7.9-5.147 17.47-5.746 25.61-2.514 2.28.958 4.43-1.317 3.47-3.591a29.6 29.6 0 0 0-3.23-5.627c-6.94-9.457-19.15-13.407-30.16-10.415 1.2-9.337-1.2-20.351-7.66-30.407 6.34-2.274 11.97-3.95 17.35-.119 1.56 1.197 3.83-.24 3.47-2.155-.23-1.437-.59-2.873-1.19-4.31-4.67-12.929-18.67-19.633-31.241-14.964a24.2 24.2 0 0 0-6.822 3.951c-2.873-1.317-5.865-2.275-8.977-2.514-6.224-1.317-12.328-.479-17.355 2.753-2.035 1.317-3.83 2.993-5.386 4.908-7.66 10.176-7.062 27.534 2.394 42.618l.359.479c8.976 14.006 23.1 21.907 35.069 20.83-1.676 7.183-.479 14.844 3.709 21.548a24.6 24.6 0 0 0 4.19 5.028c1.32 1.077 3.47.239 3.47-1.556Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__bR)",
    stroke: "url(#fish_svg__bS)",
    d: "M1166.25 880.485c-.12-9.337 4.55-18.555 12.93-23.942 7.9-5.148 17.47-5.746 25.61-2.514 2.28.958 4.43-1.317 3.47-3.591a29 29 0 0 0-3.23-5.627c-6.94-9.457-19.15-13.408-30.16-10.415 1.2-9.338-1.2-20.351-7.66-30.407 6.34-2.275 11.97-3.95 17.35-.12 1.56 1.197 3.83-.239 3.48-2.154-.24-1.437-.6-2.874-1.2-4.31-4.67-12.929-18.67-19.633-31.24-14.964a24.2 24.2 0 0 0-6.82 3.95c-2.88-1.317-5.87-2.274-8.98-2.514-6.22-1.317-12.33-.479-17.35 2.754-2.04 1.317-3.83 2.993-5.39 4.908-7.66 10.176-7.06 27.534 2.39 42.618l.36.478c8.98 14.007 23.1 21.908 35.07 20.83-1.67 7.183-.48 14.845 3.71 21.549a24.6 24.6 0 0 0 4.19 5.028c1.32 1.077 3.47.239 3.47-1.557Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__bT)",
    stroke: "url(#fish_svg__bU)",
    d: "M1323.76 923.103c-.12-9.338 4.55-18.556 12.93-23.943 7.9-5.147 17.47-5.746 25.61-2.514 2.28.958 4.43-1.316 3.47-3.591a29 29 0 0 0-3.23-5.626c-6.94-9.458-19.15-13.408-30.16-10.415 1.2-9.338-1.2-20.351-7.66-30.407 6.34-2.275 11.97-3.951 17.36-.12 1.55 1.197 3.83-.239 3.47-2.155-.24-1.436-.6-2.873-1.2-4.31-4.67-12.928-18.67-19.632-31.24-14.964a24.2 24.2 0 0 0-6.82 3.951c-2.87-1.317-5.87-2.275-8.98-2.514-6.22-1.317-12.33-.479-17.35 2.753-2.04 1.317-3.83 2.993-5.39 4.909-7.66 10.175-7.06 27.533 2.4 42.617l.35.479c8.98 14.006 23.1 21.907 35.07 20.83-1.67 7.183-.48 14.844 3.71 21.548a24.9 24.9 0 0 0 4.19 5.028c1.32 1.078 3.47.24 3.47-1.556Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__bV)",
    stroke: "url(#fish_svg__bW)",
    d: "M1481.27 965.721c-.12-9.338 4.55-18.556 12.93-23.943 7.9-5.148 17.48-5.746 25.61-2.514 2.28.958 4.43-1.317 3.48-3.591a29.6 29.6 0 0 0-3.24-5.627c-6.94-9.457-19.15-13.408-30.16-10.415 1.2-9.337-1.19-20.351-7.66-30.407 6.35-2.274 11.97-3.95 17.36-.119 1.55 1.197 3.83-.24 3.47-2.155-.24-1.437-.6-2.873-1.2-4.31-4.67-12.929-18.67-19.633-31.24-14.964a24.2 24.2 0 0 0-6.82 3.951c-2.87-1.317-5.87-2.275-8.98-2.514-6.22-1.317-12.32-.479-17.35 2.753-2.04 1.317-3.83 2.993-5.39 4.908-7.66 10.176-7.06 27.534 2.4 42.618l.35.479c8.98 14.006 23.1 21.907 35.07 20.83-1.67 7.182-.47 14.844 3.71 21.548a25 25 0 0 0 4.19 5.028c1.32 1.077 3.47.239 3.47-1.556Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__bX)",
    stroke: "url(#fish_svg__bY)",
    d: "M1638.79 1008.34c-.12-9.339 4.54-18.557 12.92-23.944 7.9-5.148 17.48-5.746 25.62-2.514 2.27.957 4.42-1.317 3.47-3.592a29.6 29.6 0 0 0-3.24-5.626c-6.94-9.457-19.15-13.408-30.16-10.415 1.2-9.338-1.19-20.351-7.66-30.407 6.35-2.275 11.97-3.951 17.36-.12 1.55 1.197 3.83-.239 3.47-2.155-.24-1.436-.6-2.873-1.2-4.309-4.67-12.929-18.67-19.633-31.24-14.964a24.3 24.3 0 0 0-6.82 3.95c-2.87-1.317-5.86-2.274-8.98-2.514-6.22-1.317-12.32-.479-17.35 2.754-2.04 1.317-3.83 2.992-5.39 4.908-7.66 10.175-7.06 27.534 2.4 42.617l.36.479c8.97 14.007 23.1 21.908 35.06 20.83-1.67 7.183-.47 14.845 3.72 21.552 1.19 1.91 2.63 3.59 4.18 5.02 1.32.96 3.48.24 3.48-1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__bZ)",
    stroke: "url(#fish_svg__ca)",
    d: "M1796.3 1050.96c-.12-9.34 4.55-18.56 12.92-23.95 7.9-5.14 17.48-5.74 25.62-2.51 2.27.96 4.43-1.32 3.47-3.59-.84-1.92-1.92-3.83-3.23-5.63-6.95-9.46-19.15-13.41-30.17-10.41 1.2-9.341-1.19-20.355-7.66-30.41 6.35-2.275 11.97-3.951 17.36-.12 1.56 1.197 3.83-.24 3.47-2.155-.24-1.437-.6-2.873-1.2-4.31-4.66-12.929-18.67-19.632-31.24-14.964a24.3 24.3 0 0 0-6.82 3.951c-2.87-1.317-5.86-2.275-8.97-2.514-6.23-1.317-12.33-.479-17.36 2.753-2.03 1.317-3.83 2.993-5.39 4.908-7.66 10.176-7.06 27.534 2.4 42.621l.36.48c8.97 14 23.1 21.9 35.07 20.83-1.68 7.18-.48 14.84 3.71 21.54 1.19 1.92 2.63 3.6 4.19 5.03 1.31.96 3.47.12 3.47-1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__cb)",
    stroke: "url(#fish_svg__cc)",
    d: "M1953.81 1093.57c-.12-9.33 4.55-18.55 12.92-23.94 7.9-5.15 17.48-5.75 25.62-2.51 2.27.95 4.43-1.32 3.47-3.59-.84-1.92-1.92-3.84-3.23-5.63-6.94-9.46-19.15-13.41-30.16-10.42 1.19-9.33-1.2-20.35-7.66-30.4 6.34-2.28 11.96-3.95 17.35-.12 1.56 1.19 3.83-.24 3.47-2.16-.24-1.43-.6-2.87-1.2-4.31-4.66-12.926-18.67-19.63-31.23-14.961a24.2 24.2 0 0 0-6.83 3.951c-2.87-1.317-5.86-2.275-8.97-2.514-6.23-1.317-12.33-.479-17.36 2.753-2.03 1.321-3.83 2.991-5.38 4.911-7.66 10.17-7.07 27.53 2.39 42.61l.36.48c8.98 14.01 23.1 21.91 35.07 20.83-1.68 7.19-.48 14.85 3.71 21.55 1.2 1.92 2.63 3.59 4.19 5.03 1.31.96 3.47.12 3.47-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__cd)",
    stroke: "url(#fish_svg__ce)",
    d: "M2111.32 1136.19c-.12-9.34 4.55-18.55 12.92-23.94 7.9-5.15 17.48-5.75 25.62-2.52 2.27.96 4.43-1.31 3.47-3.59-.84-1.91-1.92-3.83-3.23-5.62-6.94-9.46-19.15-13.41-30.16-10.42 1.19-9.34-1.2-20.35-7.66-30.41 6.34-2.27 11.96-3.95 17.35-.11 1.56 1.19 3.83-.24 3.47-2.16-.24-1.44-.6-2.87-1.2-4.31-4.66-12.93-18.67-19.63-31.23-14.96-2.52.95-4.79 2.27-6.83 3.95-2.87-1.32-5.86-2.28-8.97-2.52-6.23-1.31-12.33-.48-17.36 2.76-2.03 1.31-3.83 2.99-5.38 4.9-7.66 10.18-7.07 27.54 2.39 42.62l.36.48c8.98 14.01 23.1 21.91 35.07 20.83-1.68 7.18-.48 14.85 3.71 21.55 1.2 1.91 2.63 3.59 4.19 5.03 1.31.96 3.47.12 3.47-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__cf)",
    stroke: "url(#fish_svg__cg)",
    d: "M3122.57 442.098c-.12-9.337 4.55-18.555 12.93-23.942 7.9-5.148 17.48-5.747 25.61-2.514 2.28.957 4.43-1.317 3.48-3.592a29.6 29.6 0 0 0-3.24-5.626c-6.94-9.457-19.15-13.408-30.16-10.415 1.2-9.338-1.2-20.351-7.66-30.407 6.35-2.275 11.97-3.951 17.36-.12 1.55 1.197 3.83-.239 3.47-2.155-.24-1.436-.6-2.873-1.2-4.309-4.67-12.929-18.67-19.633-31.24-14.964a24.2 24.2 0 0 0-6.82 3.95c-2.87-1.317-5.87-2.274-8.98-2.514-6.22-1.317-12.33-.479-17.35 2.754-2.04 1.316-3.83 2.992-5.39 4.908-7.66 10.175-7.06 27.534 2.4 42.617l.35.479c8.98 14.007 23.1 21.908 35.07 20.83-1.67 7.183-.48 14.845 3.71 21.548a24.9 24.9 0 0 0 4.19 5.028c1.32.958 3.47.24 3.47-1.556Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__ch)",
    stroke: "url(#fish_svg__ci)",
    d: "M3280.09 484.716c-.12-9.338 4.54-18.556 12.92-23.943 7.9-5.147 17.48-5.746 25.62-2.514 2.27.958 4.42-1.316 3.47-3.591a30 30 0 0 0-3.23-5.626c-6.95-9.458-19.16-13.408-30.17-10.415 1.2-9.338-1.19-20.352-7.66-30.407 6.35-2.275 11.97-3.951 17.36-.12 1.55 1.197 3.83-.24 3.47-2.155-.24-1.437-.6-2.873-1.2-4.31-4.67-12.929-18.67-19.632-31.24-14.964a24.3 24.3 0 0 0-6.82 3.951c-2.87-1.317-5.86-2.275-8.98-2.514-6.22-1.317-12.32-.479-17.35 2.753-2.04 1.317-3.83 2.993-5.39 4.908-7.66 10.176-7.06 27.534 2.4 42.618l.36.479c8.97 14.006 23.1 21.907 35.07 20.83-1.68 7.183-.48 14.844 3.71 21.548a24.2 24.2 0 0 0 4.19 5.028c1.31.958 3.47.12 3.47-1.556Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__cj)",
    stroke: "url(#fish_svg__ck)",
    d: "M3437.6 527.333c-.12-9.337 4.54-18.555 12.92-23.942 7.9-5.148 17.48-5.746 25.62-2.514 2.27.958 4.42-1.317 3.47-3.591a29.6 29.6 0 0 0-3.24-5.627c-6.94-9.457-19.15-13.408-30.16-10.415 1.2-9.337-1.19-20.351-7.66-30.407 6.35-2.274 11.97-3.95 17.36-.12 1.55 1.198 3.83-.239 3.47-2.154-.24-1.437-.6-2.873-1.2-4.31-4.67-12.929-18.67-19.633-31.24-14.964a24.3 24.3 0 0 0-6.82 3.95c-2.87-1.316-5.86-2.274-8.98-2.514-6.22-1.316-12.32-.478-17.35 2.754-2.04 1.317-3.83 2.993-5.39 4.908-7.66 10.176-7.06 27.534 2.4 42.618l.36.479c8.97 14.006 23.1 21.907 35.07 20.83-1.68 7.182-.48 14.844 3.71 21.548 1.19 1.915 2.63 3.591 4.18 5.028 1.32.957 3.48.119 3.48-1.557Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__cl)",
    stroke: "url(#fish_svg__cm)",
    d: "M3595.11 569.951c-.12-9.337 4.55-18.555 12.92-23.942 7.9-5.148 17.48-5.747 25.62-2.514 2.27.957 4.43-1.317 3.47-3.592a30 30 0 0 0-3.23-5.626c-6.95-9.458-19.15-13.408-30.17-10.415 1.2-9.338-1.19-20.351-7.66-30.407 6.35-2.275 11.97-3.951 17.36-.12 1.56 1.197 3.83-.239 3.47-2.155-.24-1.436-.6-2.873-1.2-4.309-4.66-12.929-18.67-19.633-31.24-14.964a24.3 24.3 0 0 0-6.82 3.95c-2.87-1.317-5.86-2.274-8.97-2.514-6.23-1.317-12.33-.479-17.36 2.754-2.03 1.316-3.83 2.992-5.38 4.908-7.67 10.175-7.07 27.534 2.39 42.617l.36.479c8.97 14.007 23.1 21.908 35.07 20.83-1.68 7.183-.48 14.845 3.71 21.548a24.2 24.2 0 0 0 4.19 5.028c1.31.958 3.47.12 3.47-1.556Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__cn)",
    stroke: "url(#fish_svg__co)",
    d: "M3752.62 612.569c-.12-9.338 4.55-18.556 12.93-23.943 7.9-5.147 17.47-5.746 25.61-2.514 2.27.958 4.43-1.317 3.47-3.591a30 30 0 0 0-3.23-5.627c-6.94-9.457-19.15-13.407-30.16-10.415 1.19-9.337-1.2-20.351-7.66-30.407 6.34-2.274 11.97-3.95 17.35-.119 1.56 1.197 3.83-.24 3.47-2.155-.24-1.437-.6-2.873-1.19-4.31-4.67-12.929-18.68-19.633-31.24-14.964a24.2 24.2 0 0 0-6.83 3.951c-2.87-1.317-5.86-2.275-8.97-2.514-6.23-1.317-12.33-.479-17.36 2.753-2.03 1.317-3.83 2.993-5.38 4.908-7.66 10.176-7.06 27.534 2.39 42.618l.36.479c8.98 14.006 23.1 21.907 35.07 20.83-1.68 7.183-.48 14.844 3.71 21.548a24.6 24.6 0 0 0 4.19 5.028c1.31.958 3.47.12 3.47-1.556Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__cp)",
    stroke: "url(#fish_svg__cq)",
    d: "M3910.13 655.067c-.12-9.338 4.55-18.556 12.93-23.943 7.89-5.147 17.47-5.746 25.61-2.514 2.27.958 4.43-1.317 3.47-3.591a30 30 0 0 0-3.23-5.627c-6.94-9.457-19.15-13.407-30.16-10.415 1.19-9.337-1.2-20.351-7.66-30.407 6.34-2.274 11.97-3.95 17.35-.119 1.56 1.197 3.83-.24 3.47-2.155-.24-1.437-.6-2.873-1.19-4.31-4.67-12.929-18.68-19.633-31.24-14.964a24.2 24.2 0 0 0-6.83 3.951c-2.87-1.317-5.86-2.275-8.97-2.514-6.23-1.317-12.33-.479-17.36 2.753-2.03 1.317-3.83 2.993-5.38 4.908-7.66 10.176-7.07 27.534 2.39 42.618l.36.479c8.98 14.006 23.1 21.907 35.07 20.83-1.68 7.182-.48 14.844 3.71 21.548a24.6 24.6 0 0 0 4.19 5.028c1.31 1.077 3.47.239 3.47-1.556Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__cr)",
    stroke: "url(#fish_svg__cs)",
    d: "M4067.64 697.684c-.12-9.337 4.55-18.555 12.93-23.942 7.9-5.148 17.47-5.746 25.61-2.514 2.27.958 4.43-1.317 3.47-3.591a29.6 29.6 0 0 0-3.23-5.627c-6.94-9.457-19.15-13.408-30.16-10.415 1.2-9.338-1.2-20.351-7.66-30.407 6.34-2.274 11.97-3.95 17.35-.12 1.56 1.197 3.83-.239 3.47-2.154-.24-1.437-.59-2.874-1.19-4.31-4.67-12.929-18.67-19.633-31.24-14.964a24 24 0 0 0-6.82 3.95c-2.88-1.317-5.87-2.274-8.98-2.514-6.22-1.316-12.33-.479-17.36 2.754-2.03 1.317-3.83 2.993-5.38 4.908-7.66 10.176-7.06 27.534 2.39 42.618l.36.478c8.98 14.007 23.1 21.908 35.07 20.83-1.68 7.183-.48 14.845 3.71 21.549a24.6 24.6 0 0 0 4.19 5.028c1.32 1.077 3.47.239 3.47-1.557Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__ct)",
    stroke: "url(#fish_svg__cu)",
    d: "M4225.15 740.302c-.12-9.338 4.55-18.555 12.93-23.942 7.9-5.148 17.47-5.747 25.61-2.515 2.28.958 4.43-1.316 3.47-3.591a29 29 0 0 0-3.23-5.626c-6.94-9.458-19.15-13.408-30.16-10.415 1.2-9.338-1.2-20.351-7.66-30.407 6.34-2.275 11.97-3.951 17.35-.12 1.56 1.197 3.83-.239 3.48-2.155-.24-1.436-.6-2.873-1.2-4.309-4.67-12.929-18.67-19.633-31.24-14.965a24.2 24.2 0 0 0-6.82 3.951c-2.87-1.317-5.87-2.275-8.98-2.514-6.22-1.317-12.33-.479-17.35 2.753-2.04 1.317-3.83 2.993-5.39 4.909-7.66 10.175-7.06 27.533 2.39 42.617l.36.479c8.98 14.006 23.1 21.907 35.07 20.83-1.67 7.183-.48 14.844 3.71 21.548a24.9 24.9 0 0 0 4.19 5.028c1.32 1.078 3.47.24 3.47-1.556Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__cv)",
    stroke: "url(#fish_svg__cw)",
    d: "M3025.87 524.101c-.12-9.337 4.54-18.555 12.92-23.942 7.9-5.148 17.48-5.746 25.62-2.514 2.27.957 4.42-1.317 3.47-3.592a29.6 29.6 0 0 0-3.24-5.626c-6.94-9.457-19.15-13.408-30.16-10.415 1.2-9.338-1.19-20.351-7.66-30.407 6.35-2.275 11.97-3.951 17.36-.12 1.55 1.197 3.83-.239 3.47-2.155-.24-1.436-.6-2.873-1.2-4.309-4.67-12.929-18.67-19.633-31.24-14.964a24.3 24.3 0 0 0-6.82 3.95c-2.87-1.317-5.86-2.274-8.98-2.514-6.22-1.317-12.32-.479-17.35 2.754-2.04 1.316-3.83 2.992-5.39 4.908-7.66 10.175-7.06 27.534 2.4 42.618l.36.478c8.97 14.007 23.1 21.908 35.06 20.83-1.67 7.183-.47 14.845 3.72 21.549 1.19 1.915 2.63 3.591 4.18 5.027 1.44.958 3.48.12 3.48-1.556Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__cx)",
    stroke: "url(#fish_svg__cy)",
    d: "M3183.38 566.719c-.12-9.338 4.54-18.556 12.92-23.943 7.9-5.147 17.48-5.746 25.62-2.514 2.27.958 4.43-1.316 3.47-3.591a30 30 0 0 0-3.23-5.626c-6.95-9.458-19.15-13.408-30.17-10.415 1.2-9.338-1.19-20.352-7.66-30.407 6.35-2.275 11.97-3.951 17.36-.12 1.56 1.197 3.83-.24 3.47-2.155-.24-1.436-.6-2.873-1.2-4.31-4.66-12.929-18.67-19.632-31.24-14.964a24.3 24.3 0 0 0-6.82 3.951c-2.87-1.317-5.86-2.275-8.97-2.514-6.23-1.317-12.33-.479-17.36 2.753-2.03 1.317-3.83 2.993-5.39 4.908-7.66 10.176-7.06 27.534 2.4 42.618l.36.479c8.97 14.006 23.1 21.907 35.07 20.83-1.68 7.183-.48 14.844 3.71 21.548a24.2 24.2 0 0 0 4.19 5.028c1.43.958 3.47.12 3.47-1.556Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__cz)",
    stroke: "url(#fish_svg__cA)",
    d: "M3340.89 609.217c-.12-9.338 4.55-18.556 12.92-23.943 7.9-5.147 17.48-5.746 25.62-2.514 2.27.958 4.43-1.317 3.47-3.591a30 30 0 0 0-3.23-5.627c-6.95-9.457-19.15-13.407-30.17-10.415 1.2-9.337-1.19-20.351-7.66-30.406 6.35-2.275 11.97-3.951 17.36-.12 1.56 1.197 3.83-.24 3.47-2.155-.24-1.437-.6-2.873-1.2-4.31-4.66-12.929-18.67-19.633-31.24-14.964a24.3 24.3 0 0 0-6.82 3.951c-2.87-1.317-5.86-2.275-8.97-2.514-6.23-1.317-12.33-.479-17.36 2.753-2.03 1.317-3.83 2.993-5.39 4.908-7.66 10.176-7.06 27.534 2.4 42.618l.36.479c8.97 14.006 23.1 21.907 35.07 20.83-1.68 7.183-.48 14.844 3.71 21.548a24.2 24.2 0 0 0 4.19 5.028c1.43 1.077 3.47.239 3.47-1.556Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__cB)",
    stroke: "url(#fish_svg__cC)",
    d: "M3498.4 651.834c-.12-9.337 4.55-18.555 12.92-23.942 7.9-5.148 17.48-5.746 25.62-2.514 2.27.958 4.43-1.317 3.47-3.591a30 30 0 0 0-3.23-5.627c-6.94-9.457-19.15-13.408-30.16-10.415 1.19-9.337-1.2-20.351-7.66-30.407 6.34-2.274 11.96-3.95 17.35-.12 1.56 1.198 3.83-.239 3.47-2.154-.24-1.437-.6-2.873-1.2-4.31-4.66-12.929-18.67-19.633-31.23-14.964a24.2 24.2 0 0 0-6.83 3.95c-2.87-1.316-5.86-2.274-8.97-2.514-6.23-1.316-12.33-.478-17.36 2.754-2.03 1.317-3.83 2.993-5.38 4.908-7.66 10.176-7.07 27.534 2.39 42.618l.36.479c8.98 14.006 23.1 21.907 35.07 20.83-1.68 7.182-.48 14.844 3.71 21.548a24.6 24.6 0 0 0 4.19 5.028c1.43 1.077 3.47.239 3.47-1.557Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__cD)",
    stroke: "url(#fish_svg__cE)",
    d: "M3655.91 694.452c-.12-9.338 4.55-18.555 12.93-23.942 7.9-5.148 17.47-5.747 25.61-2.514 2.27.957 4.43-1.317 3.47-3.592a29.6 29.6 0 0 0-3.23-5.626c-6.94-9.458-19.15-13.408-30.16-10.415 1.19-9.338-1.2-20.351-7.66-30.407 6.34-2.275 11.97-3.951 17.35-.12 1.56 1.197 3.83-.239 3.47-2.155-.24-1.436-.59-2.873-1.19-4.309-4.67-12.929-18.67-19.633-31.24-14.964a24 24 0 0 0-6.82 3.95c-2.88-1.317-5.87-2.274-8.98-2.514-6.23-1.317-12.33-.479-17.36 2.754-2.03 1.316-3.83 2.992-5.38 4.908-7.66 10.175-7.06 27.534 2.39 42.617l.36.479c8.98 14.007 23.1 21.908 35.07 20.83-1.68 7.183-.48 14.845 3.71 21.548a24.6 24.6 0 0 0 4.19 5.028c1.44 1.078 3.47.24 3.47-1.556Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__cF)",
    stroke: "url(#fish_svg__cG)",
    d: "M3813.42 737.07c-.12-9.338 4.55-18.556 12.93-23.943 7.9-5.147 17.47-5.746 25.61-2.514 2.27.958 4.43-1.317 3.47-3.591a29.6 29.6 0 0 0-3.23-5.627c-6.94-9.457-19.15-13.407-30.16-10.415 1.19-9.337-1.2-20.351-7.66-30.407 6.34-2.274 11.97-3.95 17.35-.119 1.56 1.197 3.83-.24 3.47-2.155-.24-1.437-.6-2.873-1.19-4.31-4.67-12.929-18.68-19.633-31.24-14.964a24 24 0 0 0-6.82 3.951c-2.88-1.317-5.87-2.275-8.98-2.514-6.23-1.317-12.33-.479-17.36 2.753-2.03 1.317-3.83 2.993-5.38 4.908-7.66 10.176-7.06 27.534 2.39 42.618l.36.479c8.98 14.006 23.1 21.907 35.07 20.83-1.68 7.183-.48 14.844 3.71 21.548a24.6 24.6 0 0 0 4.19 5.028c1.32 1.077 3.47.239 3.47-1.556Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__cH)",
    stroke: "url(#fish_svg__cI)",
    d: "M3970.93 779.687c-.12-9.337 4.55-18.555 12.93-23.942 7.9-5.148 17.47-5.746 25.61-2.514 2.28.958 4.43-1.317 3.47-3.591a29.6 29.6 0 0 0-3.23-5.627c-6.94-9.457-19.15-13.408-30.16-10.415 1.2-9.338-1.2-20.351-7.66-30.407 6.34-2.274 11.97-3.95 17.35-.12 1.56 1.197 3.83-.239 3.47-2.154-.23-1.437-.59-2.874-1.19-4.31-4.67-12.929-18.67-19.633-31.24-14.964a24.2 24.2 0 0 0-6.82 3.95c-2.88-1.316-5.87-2.274-8.98-2.514-6.22-1.316-12.33-.478-17.35 2.754-2.04 1.317-3.83 2.993-5.39 4.908-7.66 10.176-7.06 27.534 2.39 42.618l.36.478c8.98 14.007 23.1 21.908 35.07 20.83-1.67 7.183-.48 14.845 3.71 21.549a24.6 24.6 0 0 0 4.19 5.028c1.32.957 3.47.239 3.47-1.557Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__cJ)",
    stroke: "url(#fish_svg__cK)",
    d: "M4128.44 822.305c-.12-9.338 4.55-18.555 12.93-23.942 7.9-5.148 17.47-5.747 25.61-2.514 2.28.957 4.43-1.317 3.47-3.592a29 29 0 0 0-3.23-5.626c-6.94-9.458-19.15-13.408-30.16-10.415 1.2-9.338-1.2-20.351-7.66-30.407 6.34-2.275 11.97-3.951 17.36-.12 1.55 1.197 3.83-.239 3.47-2.155-.24-1.436-.6-2.873-1.2-4.309-4.67-12.929-18.67-19.633-31.24-14.965a24.2 24.2 0 0 0-6.82 3.951c-2.87-1.317-5.87-2.275-8.98-2.514-6.22-1.317-12.33-.479-17.35 2.753-2.04 1.317-3.83 2.993-5.39 4.909-7.66 10.175-7.06 27.534 2.39 42.617l.36.479c8.98 14.006 23.1 21.907 35.07 20.83-1.67 7.183-.48 14.844 3.71 21.548a24.9 24.9 0 0 0 4.19 5.028c1.32.958 3.47.12 3.47-1.556Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__cL)",
    stroke: "url(#fish_svg__cM)",
    d: "M2929.16 605.985c-.12-9.338 4.54-18.556 12.92-23.943 7.9-5.148 17.48-5.746 25.62-2.514 2.27.958 4.42-1.317 3.47-3.591a30 30 0 0 0-3.23-5.627c-6.95-9.457-19.15-13.408-30.17-10.415 1.2-9.337-1.19-20.351-7.66-30.407 6.35-2.274 11.97-3.95 17.36-.119 1.55 1.197 3.83-.24 3.47-2.155-.24-1.437-.6-2.873-1.2-4.31-4.67-12.929-18.67-19.633-31.24-14.964a24.3 24.3 0 0 0-6.82 3.951c-2.87-1.317-5.86-2.275-8.98-2.514-6.22-1.317-12.32-.479-17.35 2.753-2.03 1.317-3.83 2.993-5.39 4.908-7.66 10.176-7.06 27.534 2.4 42.618l.36.479c8.97 14.006 23.1 21.907 35.07 20.83-1.68 7.182-.48 14.844 3.71 21.548a24.3 24.3 0 0 0 4.19 5.028c1.43 1.077 3.59.239 3.47-1.556Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__cN)",
    stroke: "url(#fish_svg__cO)",
    d: "M3086.67 648.602c-.12-9.337 4.55-18.555 12.92-23.942 7.9-5.148 17.48-5.746 25.62-2.514 2.27.957 4.43-1.317 3.47-3.592a30 30 0 0 0-3.23-5.626c-6.94-9.457-19.15-13.408-30.16-10.415 1.19-9.338-1.2-20.351-7.66-30.407 6.34-2.275 11.96-3.951 17.35-.12 1.56 1.197 3.83-.239 3.47-2.155-.24-1.436-.6-2.873-1.2-4.309-4.66-12.929-18.67-19.633-31.23-14.964a24.2 24.2 0 0 0-6.83 3.95c-2.87-1.317-5.86-2.274-8.97-2.514-6.23-1.317-12.33-.479-17.36 2.754-2.03 1.316-3.83 2.992-5.38 4.908-7.66 10.175-7.07 27.534 2.39 42.617l.36.479c8.98 14.007 23.1 21.908 35.07 20.83-1.68 7.183-.48 14.845 3.71 21.549a24.3 24.3 0 0 0 4.19 5.027c1.43 1.078 3.59.24 3.47-1.556Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__cP)",
    stroke: "url(#fish_svg__cQ)",
    d: "M3244.18 691.22c-.12-9.338 4.55-18.556 12.92-23.943 7.9-5.147 17.48-5.746 25.62-2.514 2.27.958 4.43-1.316 3.47-3.591a30 30 0 0 0-3.23-5.627c-6.94-9.457-19.15-13.407-30.16-10.414 1.19-9.338-1.2-20.352-7.66-30.407 6.34-2.275 11.96-3.951 17.35-.12 1.56 1.197 3.83-.24 3.47-2.155-.24-1.437-.6-2.873-1.2-4.31-4.66-12.929-18.67-19.632-31.23-14.964a24.2 24.2 0 0 0-6.83 3.951c-2.87-1.317-5.86-2.275-8.97-2.514-6.23-1.317-12.33-.479-17.36 2.753-2.03 1.317-3.83 2.993-5.38 4.908-7.66 10.176-7.07 27.534 2.39 42.618l.36.479c8.97 14.006 23.1 21.907 35.07 20.83-1.68 7.183-.48 14.844 3.71 21.548a24.2 24.2 0 0 0 4.19 5.028c1.43 1.078 3.59.24 3.47-1.556Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__cR)",
    stroke: "url(#fish_svg__cS)",
    d: "M3401.69 733.837c-.12-9.337 4.55-18.555 12.93-23.942 7.9-5.148 17.47-5.746 25.61-2.514 2.27.958 4.43-1.317 3.47-3.591a29.6 29.6 0 0 0-3.23-5.627c-6.94-9.457-19.15-13.408-30.16-10.415 1.19-9.337-1.2-20.351-7.66-30.407 6.34-2.274 11.97-3.95 17.35-.12 1.56 1.198 3.83-.239 3.47-2.154-.24-1.437-.6-2.873-1.19-4.31-4.67-12.929-18.68-19.633-31.24-14.964a24.2 24.2 0 0 0-6.83 3.951c-2.87-1.317-5.86-2.275-8.97-2.515-6.23-1.316-12.33-.478-17.36 2.754-2.03 1.317-3.83 2.993-5.38 4.908-7.66 10.176-7.06 27.534 2.39 42.618l.36.479c8.98 14.006 23.1 21.907 35.07 20.83-1.68 7.182-.48 14.844 3.71 21.548a24.6 24.6 0 0 0 4.19 5.028c1.43.957 3.59.239 3.47-1.557Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__cT)",
    stroke: "url(#fish_svg__cU)",
    d: "M3559.2 776.455c-.12-9.337 4.55-18.555 12.93-23.942 7.9-5.148 17.47-5.747 25.61-2.514 2.27.957 4.43-1.317 3.47-3.592a29.6 29.6 0 0 0-3.23-5.626c-6.94-9.457-19.15-13.408-30.16-10.415 1.2-9.338-1.2-20.351-7.66-30.407 6.34-2.275 11.97-3.951 17.35-.12 1.56 1.197 3.83-.239 3.47-2.155-.24-1.436-.59-2.873-1.19-4.309-4.67-12.929-18.67-19.633-31.24-14.964a24.2 24.2 0 0 0-6.82 3.95c-2.88-1.317-5.87-2.274-8.98-2.514-6.22-1.317-12.33-.479-17.36 2.754-2.03 1.316-3.83 2.992-5.38 4.908-7.66 10.175-7.06 27.534 2.39 42.617l.36.479c8.98 14.007 23.1 21.908 35.07 20.83-1.68 7.183-.48 14.845 3.71 21.548a24.6 24.6 0 0 0 4.19 5.028c1.44.958 3.47.12 3.47-1.556Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__cV)",
    stroke: "url(#fish_svg__cW)",
    d: "M3716.71 819.073c-.12-9.338 4.55-18.556 12.93-23.943 7.9-5.147 17.47-5.746 25.61-2.514 2.27.958 4.43-1.316 3.47-3.591a29.6 29.6 0 0 0-3.23-5.626c-6.94-9.458-19.15-13.408-30.16-10.415 1.2-9.338-1.2-20.352-7.66-30.407 6.34-2.275 11.97-3.951 17.35-.12 1.56 1.197 3.83-.24 3.47-2.155-.23-1.437-.59-2.873-1.19-4.31-4.67-12.929-18.67-19.633-31.24-14.964a24 24 0 0 0-6.82 3.951c-2.88-1.317-5.87-2.275-8.98-2.514-6.22-1.317-12.33-.479-17.36 2.753-2.03 1.317-3.83 2.993-5.38 4.908-7.66 10.176-7.06 27.534 2.39 42.618l.36.479c8.98 14.006 23.1 21.907 35.07 20.83-1.68 7.183-.48 14.844 3.71 21.548a24.6 24.6 0 0 0 4.19 5.028c1.44.958 3.47.12 3.47-1.556Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__cX)",
    stroke: "url(#fish_svg__cY)",
    d: "M3874.22 861.69c-.12-9.337 4.55-18.555 12.93-23.942 7.9-5.148 17.47-5.746 25.61-2.514 2.28.958 4.43-1.317 3.47-3.591a29 29 0 0 0-3.23-5.627c-6.94-9.457-19.15-13.408-30.16-10.415 1.2-9.337-1.2-20.351-7.66-30.407 6.34-2.274 11.97-3.95 17.35-.12 1.56 1.198 3.84-.239 3.48-2.154-.24-1.437-.6-2.873-1.2-4.31-4.67-12.929-18.67-19.633-31.24-14.964a24.2 24.2 0 0 0-6.82 3.95c-2.87-1.316-5.87-2.274-8.98-2.514-6.22-1.316-12.33-.478-17.35 2.754-2.04 1.317-3.83 2.993-5.39 4.908-7.66 10.176-7.06 27.534 2.39 42.618l.36.479c8.98 14.006 23.1 21.907 35.07 20.83-1.67 7.182-.48 14.844 3.71 21.548a25 25 0 0 0 4.19 5.028c1.44.957 3.47.119 3.47-1.557Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__cZ)",
    stroke: "url(#fish_svg__da)",
    d: "M4031.73 904.308c-.12-9.338 4.55-18.555 12.93-23.942 7.9-5.148 17.48-5.747 25.61-2.514 2.28.957 4.43-1.317 3.48-3.592a29.6 29.6 0 0 0-3.24-5.626c-6.94-9.458-19.15-13.408-30.16-10.415 1.2-9.338-1.19-20.351-7.66-30.407 6.35-2.275 11.97-3.951 17.36-.12 1.55 1.197 3.83-.239 3.47-2.155-.24-1.436-.6-2.873-1.2-4.309-4.67-12.929-18.67-19.633-31.24-14.964a24.2 24.2 0 0 0-6.82 3.95c-2.87-1.317-5.87-2.274-8.98-2.514-6.22-1.317-12.33-.479-17.35 2.753-2.04 1.317-3.83 2.993-5.39 4.909-7.66 10.175-7.06 27.534 2.4 42.617l.35.479c8.98 14.006 23.11 21.908 35.07 20.83-1.67 7.183-.47 14.844 3.71 21.548a24.9 24.9 0 0 0 4.19 5.028c1.44.958 3.47.12 3.47-1.556Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__db)",
    stroke: "url(#fish_svg__dc)",
    d: "M2832.57 687.988c-.12-9.338 4.54-18.556 12.92-23.943 7.9-5.147 17.48-5.746 25.62-2.514 2.27.958 4.42-1.317 3.47-3.591a30 30 0 0 0-3.23-5.627c-6.95-9.457-19.15-13.407-30.17-10.415 1.2-9.337-1.19-20.351-7.66-30.407 6.35-2.274 11.97-3.95 17.36-.119 1.55 1.197 3.83-.24 3.47-2.155-.24-1.437-.6-2.873-1.2-4.31-4.66-12.929-18.67-19.633-31.24-14.964a24.3 24.3 0 0 0-6.82 3.951c-2.87-1.317-5.86-2.275-8.97-2.514-6.23-1.317-12.33-.479-17.36 2.753-2.03 1.317-3.83 2.993-5.39 4.908-7.66 10.176-7.06 27.534 2.4 42.618l.36.479c8.97 14.006 23.1 21.907 35.07 20.83-1.68 7.182-.48 14.844 3.71 21.548a24.3 24.3 0 0 0 4.19 5.028c1.31.958 3.47.239 3.47-1.556Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__dd)",
    stroke: "url(#fish_svg__de)",
    d: "M2990.08 730.605c-.12-9.337 4.55-18.555 12.92-23.942 7.9-5.148 17.48-5.746 25.62-2.514 2.27.958 4.43-1.317 3.47-3.592a30 30 0 0 0-3.23-5.626c-6.94-9.457-19.15-13.408-30.16-10.415 1.19-9.338-1.2-20.351-7.66-30.407 6.34-2.275 11.96-3.951 17.35-.12 1.56 1.197 3.83-.239 3.47-2.155-.24-1.436-.6-2.873-1.2-4.309-4.66-12.929-18.67-19.633-31.23-14.964a24.2 24.2 0 0 0-6.83 3.95c-2.87-1.317-5.86-2.274-8.97-2.514-6.23-1.317-12.33-.479-17.36 2.754-2.03 1.317-3.83 2.992-5.38 4.908-7.66 10.175-7.07 27.534 2.39 42.617l.36.479c8.98 14.007 23.1 21.908 35.07 20.83-1.68 7.183-.48 14.845 3.71 21.549a24.3 24.3 0 0 0 4.19 5.027c1.31.958 3.47.24 3.47-1.556Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__df)",
    stroke: "url(#fish_svg__dg)",
    d: "M3147.59 773.223c-.12-9.338 4.55-18.556 12.92-23.943 7.9-5.147 17.48-5.746 25.62-2.514 2.27.958 4.43-1.316 3.47-3.591a30 30 0 0 0-3.23-5.626c-6.94-9.458-19.15-13.408-30.16-10.415 1.19-9.338-1.2-20.352-7.66-30.407 6.34-2.275 11.96-3.951 17.35-.12 1.56 1.197 3.83-.24 3.47-2.155-.24-1.436-.6-2.873-1.2-4.31-4.66-12.929-18.67-19.632-31.23-14.964a24.2 24.2 0 0 0-6.83 3.951c-2.87-1.317-5.86-2.275-8.97-2.514-6.23-1.317-12.33-.479-17.36 2.753-2.03 1.317-3.83 2.993-5.38 4.908-7.66 10.176-7.07 27.534 2.39 42.618l.36.479c8.98 14.006 23.1 21.907 35.07 20.83-1.68 7.183-.48 14.844 3.71 21.548a24.2 24.2 0 0 0 4.19 5.028c1.31.958 3.47.12 3.47-1.556Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__dh)",
    stroke: "url(#fish_svg__di)",
    d: "M3305.1 815.841c-.12-9.338 4.55-18.556 12.93-23.943 7.9-5.148 17.47-5.746 25.61-2.514 2.27.958 4.43-1.317 3.47-3.591a29.6 29.6 0 0 0-3.23-5.627c-6.94-9.457-19.15-13.408-30.16-10.415 1.19-9.337-1.2-20.351-7.66-30.407 6.34-2.274 11.97-3.95 17.35-.119 1.56 1.197 3.83-.24 3.47-2.155-.24-1.437-.6-2.873-1.19-4.31-4.67-12.929-18.68-19.633-31.24-14.964a24.2 24.2 0 0 0-6.83 3.951c-2.87-1.317-5.86-2.275-8.97-2.514-6.23-1.317-12.33-.479-17.36 2.753-2.03 1.317-3.83 2.993-5.38 4.908-7.66 10.176-7.06 27.534 2.39 42.618l.36.479c8.98 14.006 23.1 21.907 35.07 20.83-1.68 7.182-.48 14.844 3.71 21.548a24.6 24.6 0 0 0 4.19 5.028c1.32.957 3.47.12 3.47-1.556Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__dj)",
    stroke: "url(#fish_svg__dk)",
    d: "M3462.61 858.458c-.12-9.337 4.55-18.555 12.93-23.942 7.9-5.148 17.47-5.747 25.61-2.514 2.28.957 4.43-1.317 3.47-3.592a29.6 29.6 0 0 0-3.23-5.626c-6.94-9.457-19.15-13.408-30.16-10.415 1.2-9.338-1.2-20.351-7.66-30.407 6.34-2.275 11.97-3.951 17.35-.12 1.56 1.197 3.83-.239 3.47-2.155-.23-1.436-.59-2.873-1.19-4.309-4.67-12.929-18.67-19.633-31.24-14.964a24.2 24.2 0 0 0-6.82 3.95c-2.88-1.317-5.87-2.274-8.98-2.514-6.22-1.317-12.33-.479-17.36 2.754-2.03 1.316-3.83 2.992-5.38 4.908-7.66 10.175-7.06 27.534 2.39 42.617l.36.479c8.98 14.007 23.1 21.908 35.07 20.83-1.67 7.183-.48 14.845 3.71 21.549a24.6 24.6 0 0 0 4.19 5.027c1.32.958 3.47.12 3.47-1.556Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__dl)",
    stroke: "url(#fish_svg__dm)",
    d: "M3620.12 900.956c-.12-9.338 4.55-18.555 12.93-23.942 7.9-5.148 17.47-5.747 25.61-2.514 2.28.957 4.43-1.317 3.47-3.592a29.6 29.6 0 0 0-3.23-5.626c-6.94-9.458-19.15-13.408-30.16-10.415 1.2-9.338-1.2-20.351-7.66-30.407 6.34-2.275 11.97-3.951 17.35-.12 1.56 1.197 3.83-.239 3.47-2.155-.23-1.436-.59-2.873-1.19-4.309-4.67-12.929-18.67-19.633-31.24-14.964a24.2 24.2 0 0 0-6.82 3.95c-2.88-1.317-5.87-2.274-8.98-2.514-6.22-1.317-12.33-.479-17.36 2.754-2.03 1.316-3.83 2.992-5.38 4.908-7.66 10.175-7.06 27.534 2.39 42.617l.36.479c8.98 14.007 23.1 21.908 35.07 20.83-1.67 7.183-.48 14.845 3.71 21.548a24.6 24.6 0 0 0 4.19 5.028c1.32 1.078 3.47.24 3.47-1.556Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__dn)",
    stroke: "url(#fish_svg__do)",
    d: "M3777.63 943.574c-.12-9.338 4.55-18.556 12.93-23.943 7.9-5.147 17.47-5.746 25.61-2.514 2.28.958 4.43-1.317 3.47-3.591a29 29 0 0 0-3.23-5.626c-6.94-9.458-19.15-13.408-30.16-10.415 1.2-9.338-1.2-20.352-7.66-30.407 6.34-2.275 11.97-3.951 17.36-.12 1.55 1.197 3.83-.24 3.47-2.155-.24-1.437-.6-2.873-1.2-4.31-4.67-12.929-18.67-19.633-31.24-14.964a24.2 24.2 0 0 0-6.82 3.951c-2.87-1.317-5.87-2.275-8.98-2.514-6.22-1.317-12.33-.479-17.35 2.753-2.04 1.317-3.83 2.993-5.39 4.908-7.66 10.176-7.06 27.534 2.39 42.618l.36.479c8.98 14.006 23.1 21.907 35.07 20.83-1.67 7.183-.48 14.844 3.71 21.548a24.9 24.9 0 0 0 4.19 5.028c1.32 1.077 3.47.24 3.47-1.556Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__dp)",
    stroke: "url(#fish_svg__dq)",
    d: "M3935.14 986.191c-.12-9.337 4.55-18.555 12.93-23.942 7.9-5.148 17.48-5.746 25.61-2.514 2.28.958 4.43-1.317 3.48-3.591a29.6 29.6 0 0 0-3.24-5.627c-6.94-9.457-19.15-13.408-30.16-10.415 1.2-9.337-1.19-20.351-7.66-30.407 6.35-2.274 11.97-3.95 17.36-.12 1.55 1.198 3.83-.239 3.47-2.154-.24-1.437-.6-2.873-1.2-4.31-4.67-12.929-18.67-19.633-31.24-14.964a24.2 24.2 0 0 0-6.82 3.95c-2.87-1.316-5.86-2.274-8.98-2.514-6.22-1.316-12.32-.478-17.35 2.754-2.04 1.317-3.83 2.993-5.39 4.908-7.66 10.176-7.06 27.534 2.4 42.618l.36.479c8.97 14.006 23.1 21.907 35.06 20.83-1.67 7.182-.47 14.844 3.71 21.548a25 25 0 0 0 4.19 5.028c1.32 1.077 3.47.239 3.47-1.557Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__dr)",
    stroke: "url(#fish_svg__ds)",
    d: "M2735.86 769.991c-.12-9.338 4.55-18.556 12.92-23.943 7.9-5.147 17.48-5.746 25.62-2.514 2.27.958 4.43-1.317 3.47-3.591a30 30 0 0 0-3.23-5.627c-6.95-9.457-19.15-13.407-30.16-10.415 1.19-9.337-1.2-20.351-7.66-30.407 6.34-2.274 11.96-3.95 17.35-.119 1.56 1.197 3.83-.24 3.47-2.155-.24-1.437-.6-2.873-1.2-4.31-4.66-12.929-18.67-19.633-31.24-14.964a24.3 24.3 0 0 0-6.82 3.951c-2.87-1.317-5.86-2.275-8.97-2.514-6.23-1.317-12.33-.479-17.36 2.753-2.03 1.317-3.83 2.993-5.38 4.908-7.67 10.176-7.07 27.534 2.39 42.618l.36.479c8.97 14.006 23.1 21.907 35.07 20.83-1.68 7.182-.48 14.844 3.71 21.548a24.3 24.3 0 0 0 4.19 5.028c1.31.958 3.47.12 3.47-1.556Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__dt)",
    stroke: "url(#fish_svg__du)",
    d: "M2893.37 812.608c-.12-9.337 4.55-18.555 12.93-23.942 7.89-5.148 17.47-5.746 25.61-2.514 2.27.958 4.43-1.317 3.47-3.592a30 30 0 0 0-3.23-5.626c-6.94-9.457-19.15-13.408-30.16-10.415 1.19-9.338-1.2-20.351-7.66-30.407 6.34-2.274 11.97-3.951 17.35-.12 1.56 1.197 3.83-.239 3.47-2.155-.24-1.436-.6-2.873-1.19-4.309-4.67-12.929-18.68-19.633-31.24-14.964a24.2 24.2 0 0 0-6.83 3.95c-2.87-1.317-5.86-2.274-8.97-2.514-6.23-1.317-12.33-.478-17.36 2.754-2.03 1.317-3.83 2.993-5.38 4.908-7.66 10.175-7.06 27.534 2.39 42.618l.36.478c8.98 14.007 23.1 21.908 35.07 20.83-1.68 7.183-.48 14.845 3.71 21.549a24.6 24.6 0 0 0 4.19 5.028c1.31.957 3.47.119 3.47-1.557Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__dv)",
    stroke: "url(#fish_svg__dw)",
    d: "M3050.88 855.226c-.12-9.338 4.55-18.555 12.93-23.943 7.89-5.147 17.47-5.746 25.61-2.514 2.27.958 4.43-1.316 3.47-3.591a30 30 0 0 0-3.23-5.626c-6.94-9.458-19.15-13.408-30.16-10.415 1.19-9.338-1.2-20.351-7.66-30.407 6.34-2.275 11.97-3.951 17.35-.12 1.56 1.197 3.83-.239 3.47-2.155-.24-1.436-.6-2.873-1.19-4.31-4.67-12.928-18.68-19.632-31.24-14.964a24.2 24.2 0 0 0-6.83 3.951c-2.87-1.317-5.86-2.275-8.97-2.514-6.23-1.317-12.33-.479-17.36 2.753-2.03 1.317-3.83 2.993-5.38 4.909-7.66 10.175-7.07 27.533 2.39 42.617l.36.479c8.98 14.006 23.1 21.907 35.07 20.83-1.68 7.183-.48 14.844 3.71 21.548a24.6 24.6 0 0 0 4.19 5.028c1.31.958 3.47.12 3.47-1.556Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__dx)",
    stroke: "url(#fish_svg__dy)",
    d: "M3208.39 897.724c-.12-9.338 4.55-18.556 12.93-23.943 7.9-5.147 17.47-5.746 25.61-2.514 2.27.958 4.43-1.316 3.47-3.591a29.6 29.6 0 0 0-3.23-5.626c-6.94-9.458-19.15-13.408-30.16-10.415 1.2-9.338-1.2-20.352-7.66-30.407 6.34-2.275 11.97-3.951 17.35-.12 1.56 1.197 3.83-.24 3.47-2.155-.24-1.437-.59-2.873-1.19-4.31-4.67-12.929-18.67-19.632-31.24-14.964a24 24 0 0 0-6.82 3.951c-2.88-1.317-5.87-2.275-8.98-2.514-6.22-1.317-12.33-.479-17.36 2.753-2.03 1.317-3.83 2.993-5.38 4.908-7.66 10.176-7.06 27.534 2.39 42.618l.36.479c8.98 14.006 23.1 21.907 35.07 20.83-1.68 7.183-.48 14.844 3.71 21.548a24.6 24.6 0 0 0 4.19 5.028c1.32 1.078 3.47.24 3.47-1.556Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__dz)",
    stroke: "url(#fish_svg__dA)",
    d: "M3365.9 940.342c-.12-9.338 4.55-18.556 12.93-23.943 7.9-5.148 17.47-5.746 25.61-2.514 2.28.958 4.43-1.317 3.47-3.591a29 29 0 0 0-3.23-5.627c-6.94-9.457-19.15-13.408-30.16-10.415 1.2-9.337-1.2-20.351-7.66-30.407 6.34-2.274 11.97-3.95 17.35-.119 1.56 1.197 3.83-.24 3.48-2.155-.24-1.437-.6-2.873-1.2-4.31-4.67-12.929-18.67-19.633-31.24-14.964a24.2 24.2 0 0 0-6.82 3.951c-2.87-1.317-5.87-2.275-8.98-2.514-6.22-1.317-12.33-.479-17.35 2.753-2.04 1.317-3.83 2.993-5.39 4.908-7.66 10.176-7.06 27.534 2.39 42.618l.36.479c8.98 14.006 23.1 21.907 35.07 20.83-1.67 7.182-.48 14.844 3.71 21.548a25 25 0 0 0 4.19 5.028c1.32 1.077 3.47.239 3.47-1.556Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__dB)",
    stroke: "url(#fish_svg__dC)",
    d: "M3523.41 982.959c-.12-9.337 4.55-18.555 12.93-23.942 7.9-5.148 17.47-5.747 25.61-2.514 2.28.957 4.43-1.317 3.47-3.592a29 29 0 0 0-3.23-5.626c-6.94-9.457-19.15-13.408-30.16-10.415 1.2-9.338-1.2-20.351-7.66-30.407 6.34-2.275 11.97-3.951 17.35-.12 1.56 1.197 3.83-.239 3.48-2.155-.24-1.436-.6-2.873-1.2-4.309-4.67-12.929-18.67-19.633-31.24-14.964a24.2 24.2 0 0 0-6.82 3.95c-2.88-1.317-5.87-2.274-8.98-2.514-6.22-1.317-12.33-.479-17.35 2.754-2.04 1.316-3.83 2.992-5.39 4.908-7.66 10.175-7.06 27.534 2.39 42.617l.36.479c8.98 14.007 23.1 21.908 35.07 20.83-1.67 7.183-.48 14.845 3.71 21.548a24.9 24.9 0 0 0 4.19 5.028c1.32 1.078 3.47.24 3.47-1.556Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__dD)",
    stroke: "url(#fish_svg__dE)",
    d: "M3680.92 1025.58c-.12-9.34 4.55-18.56 12.93-23.95 7.9-5.143 17.47-5.742 25.61-2.51 2.28.96 4.43-1.316 3.47-3.591a29 29 0 0 0-3.23-5.626c-6.94-9.458-19.15-13.408-30.16-10.415 1.2-9.338-1.2-20.352-7.66-30.407 6.34-2.275 11.97-3.951 17.36-.12 1.55 1.197 3.83-.24 3.47-2.155-.24-1.436-.6-2.873-1.2-4.31-4.67-12.929-18.67-19.632-31.24-14.964a24.2 24.2 0 0 0-6.82 3.951c-2.87-1.317-5.87-2.275-8.98-2.514-6.22-1.317-12.33-.479-17.35 2.753-2.04 1.317-3.83 2.993-5.39 4.909-7.66 10.175-7.06 27.533 2.4 42.617l.35.479c8.98 14.006 23.1 21.903 35.07 20.833-1.67 7.18-.48 14.84 3.71 21.55 1.2 1.91 2.64 3.59 4.19 5.02 1.32.96 3.47.24 3.47-1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__dF)",
    stroke: "url(#fish_svg__dG)",
    d: "M3838.44 1068.19c-.12-9.33 4.54-18.55 12.92-23.94 7.9-5.15 17.48-5.74 25.62-2.51 2.27.96 4.42-1.32 3.47-3.59-.84-1.92-1.92-3.83-3.24-5.63-6.94-9.46-19.15-13.41-30.16-10.41 1.2-9.34-1.19-20.36-7.66-30.412 6.35-2.274 11.97-3.95 17.36-.12 1.55 1.198 3.83-.239 3.47-2.154-.24-1.437-.6-2.873-1.2-4.31-4.67-12.929-18.67-19.633-31.24-14.964a24.4 24.4 0 0 0-6.82 3.95c-2.87-1.316-5.86-2.274-8.98-2.514-6.22-1.316-12.32-.478-17.35 2.754-2.04 1.317-3.83 2.993-5.39 4.908-7.66 10.176-7.06 27.532 2.4 42.622l.36.47c8.97 14.01 23.1 21.91 35.07 20.83-1.68 7.19-.48 14.85 3.71 21.55 1.19 1.92 2.63 3.59 4.18 5.03 1.32.96 3.48.12 3.48-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__dH)",
    stroke: "url(#fish_svg__dI)",
    d: "M2639.15 851.874c-.12-9.338 4.55-18.555 12.92-23.943 7.9-5.147 17.48-5.746 25.62-2.513 2.27.957 4.43-1.317 3.47-3.592a30 30 0 0 0-3.23-5.626c-6.94-9.458-19.15-13.408-30.16-10.415 1.19-9.338-1.2-20.351-7.66-30.407 6.34-2.275 11.96-3.951 17.35-.12 1.56 1.197 3.83-.239 3.47-2.155-.24-1.436-.6-2.873-1.2-4.309-4.66-12.929-18.67-19.633-31.23-14.965a24.2 24.2 0 0 0-6.83 3.951c-2.87-1.317-5.86-2.275-8.97-2.514-6.23-1.317-12.33-.479-17.36 2.753-2.03 1.317-3.83 2.993-5.38 4.909-7.66 10.175-7.07 27.534 2.39 42.617l.36.479c8.98 14.006 23.1 21.908 35.07 20.83-1.68 7.183-.48 14.844 3.71 21.548a24.6 24.6 0 0 0 4.19 5.028c1.43 1.078 3.47.24 3.47-1.556Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__dJ)",
    stroke: "url(#fish_svg__dK)",
    d: "M2796.66 894.492c-.12-9.338 4.55-18.556 12.93-23.943 7.9-5.147 17.47-5.746 25.61-2.514 2.27.958 4.43-1.317 3.47-3.591a29.6 29.6 0 0 0-3.23-5.627c-6.94-9.457-19.15-13.407-30.16-10.415 1.19-9.337-1.2-20.351-7.66-30.407 6.34-2.274 11.97-3.95 17.35-.119 1.56 1.197 3.83-.24 3.47-2.155-.24-1.437-.59-2.873-1.19-4.31-4.67-12.929-18.67-19.633-31.24-14.964a24 24 0 0 0-6.82 3.951c-2.88-1.317-5.87-2.275-8.98-2.514-6.23-1.317-12.33-.479-17.36 2.753-2.03 1.317-3.83 2.993-5.38 4.908-7.66 10.176-7.06 27.534 2.39 42.618l.36.479c8.98 14.006 23.1 21.907 35.07 20.83-1.68 7.182-.48 14.844 3.71 21.548a24.6 24.6 0 0 0 4.19 5.028c1.44 1.077 3.47.239 3.47-1.556Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__dL)",
    stroke: "url(#fish_svg__dM)",
    d: "M2954.17 937.109c-.12-9.337 4.55-18.555 12.93-23.942 7.9-5.148 17.47-5.746 25.61-2.514 2.27.958 4.43-1.317 3.47-3.592a29.6 29.6 0 0 0-3.23-5.626c-6.94-9.457-19.15-13.408-30.16-10.415 1.19-9.338-1.2-20.351-7.66-30.407 6.34-2.275 11.97-3.951 17.35-.12 1.56 1.197 3.83-.239 3.47-2.155-.24-1.436-.6-2.873-1.19-4.309-4.67-12.929-18.68-19.633-31.24-14.964a24 24 0 0 0-6.82 3.95c-2.88-1.317-5.87-2.274-8.98-2.514-6.23-1.317-12.33-.479-17.36 2.754-2.03 1.317-3.83 2.993-5.38 4.908-7.66 10.175-7.06 27.534 2.39 42.618l.36.478c8.98 14.007 23.1 21.908 35.07 20.83-1.68 7.183-.48 14.845 3.71 21.549a24.6 24.6 0 0 0 4.19 5.028c1.44 1.077 3.47.239 3.47-1.557Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__dN)",
    stroke: "url(#fish_svg__dO)",
    d: "M3111.68 979.727c-.12-9.338 4.55-18.555 12.93-23.943 7.9-5.147 17.47-5.746 25.61-2.514 2.28.958 4.43-1.316 3.47-3.591a29.6 29.6 0 0 0-3.23-5.626c-6.94-9.458-19.15-13.408-30.16-10.415 1.2-9.338-1.2-20.352-7.66-30.407 6.34-2.275 11.97-3.951 17.35-.12 1.56 1.197 3.83-.24 3.48-2.155-.24-1.436-.6-2.873-1.2-4.31-4.67-12.928-18.67-19.632-31.24-14.964a24.2 24.2 0 0 0-6.82 3.951c-2.88-1.317-5.87-2.275-8.98-2.514-6.22-1.317-12.33-.479-17.35 2.753-2.04 1.317-3.83 2.993-5.39 4.909-7.66 10.175-7.06 27.533 2.39 42.617l.36.479c8.98 14.006 23.1 21.907 35.07 20.83-1.67 7.183-.48 14.844 3.71 21.548a24.6 24.6 0 0 0 4.19 5.028c1.44.958 3.47.24 3.47-1.556Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__dP)",
    stroke: "url(#fish_svg__dQ)",
    d: "M3269.19 1022.34c-.12-9.33 4.55-18.55 12.93-23.938 7.9-5.148 17.47-5.746 25.61-2.514 2.28.958 4.43-1.317 3.47-3.591a29 29 0 0 0-3.23-5.627c-6.94-9.457-19.15-13.408-30.16-10.415 1.2-9.337-1.2-20.351-7.66-30.407 6.34-2.274 11.97-3.95 17.36-.119 1.55 1.197 3.83-.24 3.47-2.155-.24-1.437-.6-2.873-1.2-4.31-4.67-12.929-18.67-19.633-31.24-14.964a24.2 24.2 0 0 0-6.82 3.951c-2.87-1.317-5.87-2.275-8.98-2.514-6.22-1.317-12.33-.479-17.35 2.753-2.04 1.317-3.83 2.993-5.39 4.908-7.66 10.176-7.06 27.534 2.39 42.618l.36.479c8.98 14.006 23.1 21.907 35.07 20.83-1.67 7.185-.48 14.845 3.71 21.545 1.2 1.92 2.64 3.59 4.19 5.03 1.44.96 3.47.24 3.47-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__dR)",
    stroke: "url(#fish_svg__dS)",
    d: "M3426.7 1064.96c-.12-9.34 4.55-18.55 12.93-23.94 7.9-5.15 17.47-5.75 25.61-2.51 2.28.95 4.43-1.32 3.47-3.6-.83-1.91-1.91-3.83-3.23-5.62-6.94-9.46-19.15-13.41-30.16-10.42 1.2-9.33-1.2-20.348-7.66-30.404 6.34-2.275 11.97-3.951 17.36-.12 1.55 1.197 3.83-.239 3.47-2.155-.24-1.436-.6-2.873-1.2-4.309-4.67-12.929-18.67-19.633-31.24-14.964a24.2 24.2 0 0 0-6.82 3.95c-2.87-1.317-5.87-2.274-8.98-2.514-6.22-1.317-12.33-.479-17.35 2.754-2.04 1.316-3.83 2.992-5.39 4.908-7.66 10.175-7.06 27.534 2.39 42.614l.36.48c8.98 14.01 23.1 21.91 35.07 20.83-1.67 7.19-.48 14.85 3.71 21.55 1.2 1.92 2.64 3.59 4.19 5.03 1.44.96 3.47.12 3.47-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__dT)",
    stroke: "url(#fish_svg__dU)",
    d: "M3584.21 1107.58a28.14 28.14 0 0 1 12.93-23.94c7.9-5.15 17.48-5.75 25.61-2.52 2.28.96 4.43-1.31 3.48-3.59-.84-1.91-1.92-3.83-3.24-5.62-6.94-9.46-19.15-13.41-30.16-10.42 1.2-9.34-1.19-20.35-7.66-30.41 6.35-2.27 11.97-3.95 17.36-.12 1.55 1.2 3.83-.24 3.47-2.15-.24-1.44-.6-2.87-1.2-4.31-4.67-12.93-18.67-19.63-31.24-14.96a23.9 23.9 0 0 0-6.82 3.95c-2.87-1.32-5.86-2.28-8.98-2.52-6.22-1.31-12.32-.48-17.35 2.76-2.04 1.31-3.83 2.99-5.39 4.9-7.66 10.18-7.06 27.54 2.4 42.62l.36.48c8.97 14.01 23.1 21.91 35.06 20.83-1.67 7.18-.47 14.84 3.71 21.55 1.2 1.91 2.64 3.59 4.19 5.03 1.44.95 3.47.12 3.47-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__dV)",
    stroke: "url(#fish_svg__dW)",
    d: "M3741.73 1150.2c-.12-9.34 4.54-18.56 12.92-23.94 7.9-5.15 17.48-5.75 25.62-2.52 2.27.96 4.42-1.32 3.47-3.59-.84-1.92-1.92-3.83-3.23-5.63-6.95-9.45-19.15-13.4-30.17-10.41 1.2-9.34-1.19-20.35-7.66-30.41 6.35-2.27 11.97-3.95 17.36-.12 1.55 1.2 3.83-.24 3.47-2.15-.24-1.44-.6-2.88-1.2-4.31-4.67-12.93-18.67-19.64-31.24-14.97a24.5 24.5 0 0 0-6.82 3.95c-2.87-1.31-5.86-2.27-8.97-2.51-6.23-1.32-12.33-.48-17.36 2.75-2.03 1.32-3.83 3-5.39 4.91-7.66 10.18-7.06 27.54 2.4 42.62l.36.48c8.97 14 23.1 21.91 35.07 20.83-1.68 7.18-.48 14.84 3.71 21.55 1.19 1.91 2.63 3.59 4.19 5.02 1.43.96 3.47.12 3.47-1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__dX)",
    stroke: "url(#fish_svg__dY)",
    d: "M2542.56 933.877c-.12-9.338 4.55-18.555 12.93-23.942 7.9-5.148 17.47-5.747 25.61-2.514 2.27.957 4.43-1.317 3.47-3.592a29.6 29.6 0 0 0-3.23-5.626c-6.94-9.458-19.15-13.408-30.16-10.415 1.2-9.338-1.2-20.351-7.66-30.407 6.34-2.275 11.97-3.951 17.35-.12 1.56 1.197 3.83-.239 3.47-2.155-.24-1.436-.59-2.873-1.19-4.309-4.67-12.929-18.67-19.633-31.24-14.964a24 24 0 0 0-6.82 3.95c-2.88-1.317-5.87-2.274-8.98-2.514-6.22-1.317-12.33-.479-17.36 2.753-2.03 1.317-3.83 2.993-5.38 4.909-7.66 10.175-7.06 27.534 2.39 42.617l.36.479c8.98 14.007 23.1 21.908 35.07 20.83-1.68 7.183-.48 14.844 3.71 21.548a24.6 24.6 0 0 0 4.19 5.028c1.32 1.078 3.47.24 3.47-1.556Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__dZ)",
    stroke: "url(#fish_svg__ea)",
    d: "M2700.07 976.495c-.12-9.338 4.55-18.556 12.93-23.943 7.9-5.147 17.47-5.746 25.61-2.514 2.28.958 4.43-1.317 3.47-3.591a29 29 0 0 0-3.23-5.627c-6.94-9.457-19.15-13.407-30.16-10.415 1.2-9.337-1.2-20.351-7.66-30.407 6.34-2.274 11.97-3.95 17.35-.119 1.56 1.197 3.83-.24 3.48-2.155-.24-1.437-.6-2.873-1.2-4.31-4.67-12.929-18.67-19.633-31.24-14.964a24.2 24.2 0 0 0-6.82 3.951c-2.87-1.317-5.87-2.275-8.98-2.514-6.22-1.317-12.33-.479-17.35 2.753-2.04 1.317-3.83 2.993-5.39 4.908-7.66 10.176-7.06 27.534 2.39 42.618l.36.479c8.98 14.006 23.1 21.907 35.07 20.83-1.67 7.183-.48 14.844 3.71 21.548a25 25 0 0 0 4.19 5.028c1.32.958 3.47.239 3.47-1.556Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__eb)",
    stroke: "url(#fish_svg__ec)",
    d: "M2857.58 1019.11c-.12-9.34 4.55-18.55 12.93-23.94 7.9-5.148 17.47-5.746 25.61-2.514 2.28.958 4.43-1.317 3.47-3.591a29 29 0 0 0-3.23-5.627c-6.94-9.457-19.15-13.408-30.16-10.415 1.2-9.338-1.2-20.351-7.66-30.407 6.34-2.274 11.97-3.95 17.35-.12 1.56 1.197 3.83-.239 3.48-2.154-.24-1.437-.6-2.874-1.2-4.31-4.67-12.929-18.67-19.633-31.24-14.964a24.2 24.2 0 0 0-6.82 3.95c-2.88-1.317-5.87-2.274-8.98-2.514-6.22-1.317-12.33-.478-17.35 2.754-2.04 1.317-3.83 2.993-5.39 4.908-7.66 10.176-7.06 27.534 2.39 42.618l.36.478c8.98 14.007 23.1 21.908 35.07 20.83-1.67 7.188-.48 14.848 3.71 21.548 1.2 1.92 2.64 3.59 4.19 5.03 1.32.96 3.47.12 3.47-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__ed)",
    stroke: "url(#fish_svg__ee)",
    d: "M3015.09 1061.73c-.12-9.34 4.55-18.56 12.93-23.94 7.9-5.15 17.47-5.75 25.61-2.52 2.28.96 4.43-1.31 3.47-3.59-.83-1.91-1.91-3.83-3.23-5.62-6.94-9.46-19.15-13.41-30.16-10.42 1.2-9.34-1.2-20.35-7.66-30.406 6.34-2.275 11.97-3.951 17.36-.12 1.55 1.197 3.83-.239 3.47-2.155-.24-1.436-.6-2.873-1.2-4.309-4.67-12.929-18.67-19.633-31.24-14.965a24.2 24.2 0 0 0-6.82 3.951c-2.87-1.317-5.87-2.275-8.98-2.514-6.22-1.317-12.33-.479-17.35 2.753-2.04 1.317-3.83 2.993-5.39 4.909-7.66 10.175-7.06 27.536 2.4 42.616l.35.48c8.98 14.01 23.1 21.91 35.07 20.83-1.67 7.18-.48 14.84 3.71 21.55 1.2 1.91 2.64 3.59 4.19 5.03 1.32.95 3.47.12 3.47-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__ef)",
    stroke: "url(#fish_svg__eg)",
    d: "M3172.61 1104.35c-.12-9.34 4.54-18.56 12.92-23.94 7.9-5.15 17.48-5.75 25.62-2.52 2.27.96 4.42-1.32 3.47-3.59-.84-1.92-1.92-3.83-3.24-5.63-6.94-9.45-19.15-13.4-30.16-10.41 1.2-9.34-1.19-20.35-7.66-30.41 6.35-2.27 11.97-3.95 17.36-.12 1.55 1.2 3.83-.24 3.47-2.15-.24-1.44-.6-2.88-1.2-4.31-4.67-12.93-18.67-19.64-31.24-14.97a24.5 24.5 0 0 0-6.82 3.95c-2.87-1.31-5.86-2.27-8.98-2.51-6.22-1.32-12.32-.48-17.35 2.75-2.04 1.32-3.83 3-5.39 4.91-7.66 10.18-7.06 27.54 2.4 42.62l.36.48c8.97 14 23.1 21.91 35.06 20.83-1.67 7.18-.47 14.84 3.72 21.55 1.19 1.91 2.63 3.59 4.18 5.02 1.32.96 3.48.12 3.48-1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__eh)",
    stroke: "url(#fish_svg__ei)",
    d: "M3330.12 1146.97c-.12-9.34 4.54-18.56 12.92-23.95 7.9-5.14 17.48-5.74 25.62-2.51 2.27.96 4.42-1.32 3.47-3.59-.84-1.92-1.92-3.83-3.24-5.63-6.94-9.46-19.15-13.41-30.16-10.41 1.2-9.34-1.19-20.36-7.66-30.41 6.35-2.28 11.97-3.95 17.36-.12 1.55 1.2 3.83-.24 3.47-2.16-.24-1.43-.6-2.87-1.2-4.31-4.67-12.92-18.67-19.63-31.24-14.96a24.5 24.5 0 0 0-6.82 3.95c-2.87-1.32-5.86-2.27-8.98-2.51-6.22-1.32-12.32-.48-17.35 2.75-2.04 1.32-3.83 2.99-5.39 4.91-7.66 10.17-7.06 27.53 2.4 42.62l.36.48c8.97 14 23.1 21.9 35.06 20.83-1.67 7.18-.47 14.84 3.72 21.54 1.19 1.92 2.63 3.59 4.18 5.03 1.32.96 3.48.12 3.48-1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__ej)",
    stroke: "url(#fish_svg__ek)",
    d: "M3487.63 1189.46c-.12-9.33 4.54-18.55 12.92-23.94 7.9-5.15 17.48-5.75 25.62-2.51 2.27.95 4.43-1.32 3.47-3.59-.84-1.92-1.92-3.84-3.23-5.63-6.95-9.46-19.15-13.41-30.17-10.42 1.2-9.33-1.19-20.35-7.66-30.4 6.35-2.28 11.97-3.95 17.36-.12 1.56 1.19 3.83-.24 3.47-2.16-.24-1.43-.6-2.87-1.2-4.31-4.66-12.93-18.67-19.63-31.24-14.96-2.51.96-4.78 2.27-6.82 3.95-2.87-1.32-5.86-2.28-8.97-2.51-6.23-1.32-12.33-.48-17.36 2.75-2.03 1.32-3.83 2.99-5.39 4.91-7.66 10.17-7.06 27.53 2.4 42.61l.36.48c8.97 14.01 23.1 21.91 35.07 20.83-1.68 7.19-.48 14.85 3.71 21.55 1.19 1.92 2.63 3.59 4.19 5.03 1.31 1.08 3.47.24 3.47-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__el)",
    stroke: "url(#fish_svg__em)",
    d: "M3645.14 1232.08c-.12-9.34 4.55-18.55 12.93-23.94 7.89-5.15 17.47-5.75 25.61-2.52 2.27.96 4.43-1.31 3.47-3.59-.84-1.91-1.92-3.83-3.23-5.62-6.94-9.46-19.15-13.41-30.16-10.42 1.19-9.34-1.2-20.35-7.66-30.41 6.34-2.27 11.97-3.95 17.35-.12 1.56 1.2 3.83-.23 3.47-2.15-.24-1.44-.6-2.87-1.19-4.31-4.67-12.93-18.68-19.63-31.24-14.96-2.52.95-4.79 2.27-6.83 3.95-2.87-1.32-5.86-2.28-8.97-2.52-6.23-1.31-12.33-.48-17.36 2.76-2.03 1.31-3.83 2.99-5.38 4.9-7.66 10.18-7.07 27.54 2.39 42.62l.36.48c8.98 14.01 23.1 21.91 35.07 20.83-1.68 7.18-.48 14.85 3.71 21.55 1.2 1.91 2.63 3.59 4.19 5.03 1.31 1.07 3.47.24 3.47-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__en)",
    stroke: "url(#fish_svg__eo)",
    d: "M2445.85 1015.88c-.12-9.34 4.55-18.555 12.93-23.942 7.9-5.148 17.47-5.747 25.61-2.514 2.28.957 4.43-1.317 3.47-3.592a29.6 29.6 0 0 0-3.23-5.626c-6.94-9.458-19.15-13.408-30.16-10.415 1.2-9.338-1.2-20.351-7.66-30.407 6.34-2.275 11.97-3.951 17.35-.12 1.56 1.197 3.83-.239 3.47-2.155-.23-1.436-.59-2.873-1.19-4.309-4.67-12.929-18.67-19.633-31.24-14.964a24.2 24.2 0 0 0-6.82 3.95c-2.88-1.317-5.87-2.274-8.98-2.514-6.22-1.317-12.33-.479-17.35 2.754-2.04 1.316-3.83 2.992-5.39 4.908-7.66 10.175-7.06 27.534 2.39 42.617l.36.479c8.98 14.007 23.1 21.908 35.07 20.83-1.67 7.183-.48 14.84 3.71 21.55 1.2 1.91 2.63 3.59 4.19 5.03 1.32.95 3.47.12 3.47-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__ep)",
    stroke: "url(#fish_svg__eq)",
    d: "M2603.36 1058.5c-.12-9.34 4.55-18.56 12.93-23.94 7.9-5.15 17.47-5.75 25.61-2.52 2.28.96 4.43-1.32 3.47-3.59-.83-1.92-1.91-3.83-3.23-5.63-6.94-9.45-19.15-13.4-30.16-10.41 1.2-9.34-1.2-20.353-7.66-30.409 6.34-2.274 11.97-3.95 17.36-.119 1.55 1.197 3.83-.24 3.47-2.155-.24-1.437-.6-2.873-1.2-4.31-4.67-12.929-18.67-19.633-31.24-14.964a24.2 24.2 0 0 0-6.82 3.951c-2.87-1.317-5.87-2.275-8.98-2.514-6.22-1.317-12.33-.479-17.35 2.753-2.04 1.317-3.83 2.993-5.39 4.908-7.66 10.176-7.06 27.534 2.39 42.619l.36.48c8.98 14 23.1 21.91 35.07 20.83-1.67 7.18-.48 14.84 3.71 21.55 1.2 1.91 2.64 3.59 4.19 5.02 1.32.96 3.47.12 3.47-1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__er)",
    stroke: "url(#fish_svg__es)",
    d: "M2760.87 1101.12c-.12-9.34 4.55-18.56 12.93-23.95 7.9-5.14 17.47-5.74 25.61-2.51 2.28.96 4.43-1.32 3.47-3.59-.83-1.92-1.91-3.83-3.23-5.63-6.94-9.46-19.15-13.41-30.16-10.41 1.2-9.34-1.2-20.36-7.66-30.41 6.34-2.28 11.97-3.95 17.36-.12 1.55 1.2 3.83-.24 3.47-2.16-.24-1.43-.6-2.87-1.2-4.31-4.67-12.92-18.67-19.628-31.24-14.96-2.51.96-4.79 2.28-6.82 3.95-2.87-1.32-5.87-2.27-8.98-2.51-6.22-1.32-12.33-.48-17.35 2.75-2.04 1.32-3.83 2.99-5.39 4.91-7.66 10.17-7.06 27.53 2.39 42.62l.36.48c8.98 14 23.1 21.9 35.07 20.83-1.67 7.18-.48 14.84 3.71 21.54 1.2 1.92 2.64 3.6 4.19 5.03 1.32.96 3.47.12 3.47-1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__et)",
    stroke: "url(#fish_svg__eu)",
    d: "M2918.38 1143.61c-.11-9.33 4.55-18.55 12.93-23.94 7.9-5.15 17.48-5.75 25.61-2.51 2.28.95 4.43-1.32 3.48-3.59-.84-1.92-1.92-3.84-3.24-5.63-6.94-9.46-19.15-13.41-30.16-10.42 1.2-9.33-1.19-20.35-7.66-30.4 6.35-2.28 11.97-3.95 17.36-.12 1.55 1.19 3.83-.24 3.47-2.16-.24-1.43-.6-2.87-1.2-4.31-4.67-12.93-18.67-19.63-31.24-14.96-2.51.96-4.79 2.27-6.82 3.95-2.87-1.32-5.86-2.28-8.98-2.51-6.22-1.32-12.32-.48-17.35 2.75-2.04 1.32-3.83 2.99-5.39 4.91-7.66 10.17-7.06 27.53 2.4 42.61l.36.48c8.97 14.01 23.1 21.91 35.06 20.83-1.67 7.19-.47 14.85 3.71 21.55 1.2 1.92 2.64 3.59 4.19 5.03 1.32 1.08 3.47.24 3.47-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__ev)",
    stroke: "url(#fish_svg__ew)",
    d: "M3075.9 1186.23c-.12-9.34 4.54-18.55 12.92-23.94 7.9-5.15 17.48-5.75 25.62-2.52 2.27.96 4.42-1.31 3.47-3.59-.84-1.91-1.92-3.83-3.23-5.62-6.95-9.46-19.15-13.41-30.17-10.42 1.2-9.34-1.19-20.35-7.66-30.41 6.35-2.27 11.97-3.95 17.36-.12 1.55 1.2 3.83-.23 3.47-2.15-.24-1.44-.6-2.87-1.2-4.31-4.66-12.93-18.67-19.63-31.24-14.96-2.51.95-4.78 2.27-6.82 3.95-2.87-1.32-5.86-2.28-8.97-2.52-6.23-1.31-12.33-.48-17.36 2.76-2.03 1.31-3.83 2.99-5.39 4.9-7.66 10.18-7.06 27.54 2.4 42.62l.36.48c8.97 14.01 23.1 21.91 35.07 20.83-1.68 7.18-.48 14.85 3.71 21.55a24.5 24.5 0 0 0 4.19 5.03c1.31 1.07 3.47.24 3.47-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__ex)",
    stroke: "url(#fish_svg__ey)",
    d: "M3233.41 1228.85c-.12-9.34 4.54-18.56 12.92-23.94 7.9-5.15 17.48-5.75 25.62-2.52 2.27.96 4.42-1.31 3.47-3.59-.84-1.91-1.92-3.83-3.23-5.63-6.95-9.45-19.15-13.4-30.17-10.41 1.2-9.34-1.19-20.35-7.66-30.41 6.35-2.27 11.97-3.95 17.36-.12 1.55 1.2 3.83-.24 3.47-2.15-.24-1.44-.6-2.88-1.2-4.31-4.67-12.93-18.67-19.63-31.24-14.97a24.5 24.5 0 0 0-6.82 3.95c-2.87-1.31-5.86-2.27-8.98-2.51-6.22-1.32-12.32-.48-17.35 2.75-2.03 1.32-3.83 3-5.39 4.91-7.66 10.18-7.06 27.54 2.4 42.62l.36.48c8.97 14.01 23.1 21.91 35.07 20.83-1.68 7.18-.48 14.84 3.71 21.55 1.19 1.91 2.63 3.59 4.19 5.02 1.31 1.08 3.47.24 3.47-1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__ez)",
    stroke: "url(#fish_svg__eA)",
    d: "M3390.92 1271.47c-.12-9.34 4.55-18.56 12.92-23.95 7.9-5.14 17.48-5.74 25.62-2.51 2.27.96 4.43-1.32 3.47-3.59-.84-1.92-1.92-3.83-3.23-5.63-6.94-9.46-19.15-13.41-30.16-10.41 1.19-9.34-1.2-20.35-7.66-30.41 6.34-2.27 11.96-3.95 17.35-.12 1.56 1.2 3.83-.24 3.47-2.15-.24-1.44-.6-2.88-1.2-4.31-4.66-12.93-18.67-19.64-31.23-14.97-2.52.96-4.79 2.28-6.83 3.95-2.87-1.31-5.86-2.27-8.97-2.51-6.23-1.32-12.33-.48-17.36 2.75-2.03 1.32-3.83 2.99-5.38 4.91-7.66 10.18-7.07 27.53 2.39 42.62l.36.48c8.98 14 23.1 21.9 35.07 20.83-1.68 7.18-.48 14.84 3.71 21.54 1.19 1.92 2.63 3.6 4.19 5.03 1.31.96 3.47.24 3.47-1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__eB)",
    stroke: "url(#fish_svg__eC)",
    d: "M3548.43 1314.08c-.12-9.33 4.55-18.55 12.93-23.94 7.9-5.15 17.47-5.74 25.61-2.51 2.27.96 4.43-1.32 3.47-3.59-.84-1.92-1.91-3.83-3.23-5.63-6.94-9.46-19.15-13.41-30.16-10.42 1.19-9.33-1.2-20.35-7.66-30.4 6.34-2.28 11.97-3.95 17.35-.12 1.56 1.2 3.83-.24 3.47-2.16-.24-1.43-.6-2.87-1.19-4.31-4.67-12.93-18.68-19.63-31.24-14.96a24.2 24.2 0 0 0-6.83 3.95c-2.87-1.32-5.86-2.27-8.97-2.51-6.23-1.32-12.33-.48-17.36 2.75-2.03 1.32-3.83 2.99-5.38 4.91-7.66 10.17-7.06 27.53 2.39 42.62l.36.47c8.98 14.01 23.1 21.91 35.07 20.83-1.68 7.19-.48 14.85 3.71 21.55 1.2 1.92 2.63 3.59 4.19 5.03 1.32.96 3.47.24 3.47-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__eD)",
    stroke: "url(#fish_svg__eE)",
    d: "M2349.14 1097.76c-.12-9.33 4.55-18.55 12.93-23.94 7.9-5.15 17.47-5.75 25.61-2.51 2.28.95 4.43-1.32 3.47-3.59-.83-1.92-1.91-3.84-3.23-5.63-6.94-9.46-19.15-13.41-30.16-10.42 1.2-9.33-1.2-20.35-7.66-30.4 6.34-2.28 11.97-3.95 17.36-.12 1.55 1.19 3.83-.24 3.47-2.16-.24-1.43-.6-2.87-1.2-4.31-4.67-12.93-18.67-19.63-31.24-14.961-2.51.961-4.79 2.271-6.82 3.951-2.87-1.32-5.87-2.28-8.98-2.51-6.22-1.321-12.33-.48-17.35 2.75-2.04 1.32-3.83 2.99-5.39 4.91-7.66 10.17-7.06 27.53 2.39 42.61l.36.48c8.98 14.01 23.1 21.91 35.07 20.83-1.67 7.19-.48 14.85 3.71 21.55 1.2 1.92 2.64 3.59 4.19 5.03 1.44 1.08 3.47.24 3.47-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__eF)",
    stroke: "url(#fish_svg__eG)",
    d: "M2506.65 1140.38c-.12-9.34 4.55-18.55 12.93-23.94 7.9-5.15 17.48-5.75 25.61-2.52 2.28.96 4.43-1.31 3.48-3.59-.84-1.91-1.92-3.83-3.24-5.62-6.94-9.46-19.15-13.41-30.16-10.42 1.2-9.34-1.19-20.35-7.66-30.41 6.35-2.27 11.97-3.95 17.36-.11 1.55 1.19 3.83-.24 3.47-2.16-.24-1.44-.6-2.87-1.2-4.31-4.67-12.93-18.67-19.63-31.24-14.96a23.9 23.9 0 0 0-6.82 3.95c-2.87-1.32-5.87-2.28-8.98-2.52-6.22-1.31-12.33-.48-17.35 2.76-2.04 1.31-3.83 2.99-5.39 4.9-7.66 10.18-7.06 27.54 2.4 42.62l.35.48c8.98 14.01 23.1 21.91 35.07 20.83-1.67 7.18-.48 14.85 3.71 21.55 1.2 1.91 2.64 3.59 4.19 5.03 1.44 1.07 3.47.24 3.47-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__eH)",
    stroke: "url(#fish_svg__eI)",
    d: "M2664.16 1183c-.12-9.34 4.55-18.56 12.93-23.94 7.9-5.15 17.48-5.75 25.61-2.52 2.28.96 4.43-1.31 3.47-3.59-.83-1.91-1.91-3.83-3.23-5.63-6.94-9.45-19.15-13.4-30.16-10.41 1.2-9.34-1.2-20.35-7.66-30.41 6.34-2.27 11.97-3.95 17.36-.12 1.55 1.2 3.83-.24 3.47-2.15-.24-1.44-.6-2.88-1.2-4.31-4.67-12.93-18.67-19.63-31.24-14.97-2.51.96-4.79 2.28-6.82 3.95-2.87-1.31-5.87-2.27-8.98-2.51-6.22-1.32-12.33-.48-17.35 2.75-2.04 1.32-3.83 3-5.39 4.91-7.66 10.18-7.06 27.54 2.4 42.62l.35.48c8.98 14.01 23.1 21.91 35.07 20.83-1.67 7.18-.48 14.84 3.71 21.55 1.2 1.91 2.64 3.59 4.19 5.02 1.44 1.08 3.47.24 3.47-1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__eJ)",
    stroke: "url(#fish_svg__eK)",
    d: "M2821.68 1225.62c-.12-9.34 4.54-18.56 12.92-23.95 7.9-5.14 17.48-5.74 25.62-2.51 2.27.96 4.42-1.32 3.47-3.59-.84-1.92-1.92-3.83-3.23-5.63-6.95-9.46-19.16-13.41-30.17-10.41 1.2-9.34-1.19-20.35-7.66-30.41 6.35-2.27 11.97-3.95 17.36-.12 1.55 1.2 3.83-.24 3.47-2.15-.24-1.44-.6-2.88-1.2-4.31-4.67-12.93-18.67-19.64-31.24-14.97a24.5 24.5 0 0 0-6.82 3.95c-2.87-1.31-5.86-2.27-8.98-2.51-6.22-1.32-12.32-.48-17.35 2.75-2.04 1.32-3.83 2.99-5.39 4.91-7.66 10.18-7.06 27.53 2.4 42.62l.36.48c8.97 14 23.1 21.9 35.07 20.83-1.68 7.18-.48 14.84 3.71 21.54 1.19 1.92 2.63 3.6 4.18 5.03 1.44 1.08 3.48.24 3.48-1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__eL)",
    stroke: "url(#fish_svg__eM)",
    d: "M2979.19 1268.23c-.12-9.33 4.55-18.55 12.92-23.94 7.9-5.15 17.48-5.74 25.62-2.51 2.27.96 4.43-1.32 3.47-3.59-.84-1.92-1.92-3.83-3.23-5.63-6.95-9.46-19.15-13.41-30.16-10.42 1.19-9.33-1.2-20.35-7.67-30.4 6.35-2.28 11.97-3.95 17.36-.12 1.56 1.2 3.83-.24 3.47-2.16-.24-1.43-.6-2.87-1.2-4.31-4.66-12.93-18.67-19.63-31.23-14.96a24.2 24.2 0 0 0-6.83 3.95c-2.87-1.32-5.86-2.27-8.97-2.51-6.23-1.32-12.33-.48-17.36 2.75-2.03 1.32-3.83 2.99-5.38 4.91-7.66 10.17-7.07 27.53 2.39 42.62l.36.47c8.97 14.01 23.1 21.91 35.07 20.83-1.68 7.19-.48 14.85 3.71 21.55 1.19 1.92 2.63 3.59 4.19 5.03 1.43.96 3.47.24 3.47-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__eN)",
    stroke: "url(#fish_svg__eO)",
    d: "M3136.7 1310.85c-.12-9.34 4.55-18.55 12.92-23.94 7.9-5.15 17.48-5.75 25.62-2.51 2.27.95 4.43-1.32 3.47-3.6-.84-1.91-1.92-3.83-3.23-5.62-6.95-9.46-19.15-13.41-30.17-10.42 1.2-9.34-1.19-20.35-7.66-30.4 6.35-2.28 11.97-3.96 17.36-.12 1.56 1.19 3.83-.24 3.47-2.16-.24-1.44-.6-2.87-1.2-4.31-4.66-12.93-18.67-19.63-31.24-14.96-2.51.95-4.78 2.27-6.82 3.95-2.87-1.32-5.86-2.28-8.97-2.52-6.23-1.31-12.33-.48-17.36 2.76-2.03 1.31-3.83 2.99-5.39 4.91-7.66 10.17-7.06 27.53 2.4 42.61l.36.48c8.97 14.01 23.1 21.91 35.07 20.83-1.68 7.18-.48 14.85 3.71 21.55 1.19 1.92 2.63 3.59 4.19 5.03 1.43.96 3.47.12 3.47-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__eP)",
    stroke: "url(#fish_svg__eQ)",
    d: "M3294.21 1353.47c-.12-9.34 4.55-18.56 12.93-23.94 7.9-5.15 17.47-5.75 25.61-2.52 2.27.96 4.43-1.31 3.47-3.59-.84-1.91-1.92-3.83-3.23-5.63-6.94-9.45-19.15-13.4-30.16-10.41 1.19-9.34-1.2-20.35-7.66-30.41 6.34-2.27 11.97-3.95 17.35-.12 1.56 1.2 3.83-.24 3.47-2.15-.24-1.44-.6-2.87-1.19-4.31-4.67-12.93-18.68-19.63-31.24-14.97-2.52.96-4.79 2.28-6.83 3.96-2.87-1.32-5.86-2.28-8.97-2.52-6.23-1.32-12.33-.48-17.36 2.75-2.03 1.32-3.83 3-5.38 4.91-7.66 10.18-7.07 27.54 2.39 42.62l.36.48c8.98 14.01 23.1 21.91 35.07 20.83-1.68 7.18-.48 14.84 3.71 21.55 1.2 1.91 2.63 3.59 4.19 5.03 1.43.95 3.47.12 3.47-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__eR)",
    stroke: "url(#fish_svg__eS)",
    d: "M3451.72 1396.09c-.12-9.34 4.55-18.56 12.93-23.95 7.9-5.14 17.47-5.74 25.61-2.51 2.27.96 4.43-1.32 3.47-3.59-.84-1.92-1.91-3.83-3.23-5.63-6.94-9.45-19.15-13.41-30.16-10.41 1.2-9.34-1.2-20.35-7.66-30.41 6.34-2.27 11.97-3.95 17.35-.12 1.56 1.2 3.83-.24 3.47-2.15-.24-1.44-.59-2.88-1.19-4.31-4.67-12.93-18.67-19.64-31.24-14.97-2.52.96-4.79 2.28-6.82 3.95-2.88-1.31-5.87-2.27-8.98-2.51-6.22-1.32-12.33-.48-17.36 2.75-2.03 1.32-3.83 3-5.38 4.91-7.66 10.18-7.06 27.53 2.39 42.62l.36.48c8.98 14 23.1 21.9 35.07 20.83-1.68 7.18-.48 14.84 3.71 21.55a24.5 24.5 0 0 0 4.19 5.02c1.44.96 3.47.12 3.47-1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__eT)",
    stroke: "url(#fish_svg__eU)",
    d: "M2252.55 1179.77c-.12-9.34 4.55-18.56 12.93-23.95 7.9-5.14 17.47-5.74 25.61-2.51 2.28.96 4.43-1.32 3.47-3.59-.83-1.92-1.91-3.83-3.23-5.63-6.94-9.46-19.15-13.41-30.16-10.41 1.2-9.34-1.2-20.35-7.66-30.41 6.34-2.27 11.97-3.95 17.36-.12 1.55 1.2 3.83-.24 3.47-2.15-.24-1.44-.6-2.88-1.2-4.31-4.67-12.93-18.67-19.64-31.24-14.97-2.51.96-4.79 2.28-6.82 3.95-2.87-1.31-5.87-2.27-8.98-2.51-6.22-1.32-12.33-.48-17.35 2.75-2.04 1.32-3.83 2.99-5.39 4.91-7.66 10.18-7.06 27.53 2.39 42.62l.36.48c8.98 14 23.1 21.9 35.07 20.83-1.67 7.18-.48 14.84 3.71 21.54 1.2 1.92 2.64 3.6 4.19 5.03 1.32 1.08 3.47.24 3.47-1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__eV)",
    stroke: "url(#fish_svg__eW)",
    d: "M2410.06 1222.38c-.12-9.33 4.55-18.55 12.93-23.94 7.9-5.15 17.48-5.74 25.61-2.51 2.28.96 4.43-1.32 3.48-3.59-.84-1.92-1.92-3.83-3.24-5.63-6.94-9.46-19.15-13.41-30.16-10.42 1.2-9.33-1.19-20.35-7.66-30.4 6.35-2.28 11.97-3.95 17.36-.12 1.55 1.2 3.83-.24 3.47-2.16-.24-1.43-.6-2.87-1.2-4.31-4.67-12.93-18.67-19.63-31.24-14.96-2.51.96-4.79 2.27-6.82 3.95-2.87-1.32-5.87-2.27-8.98-2.51-6.22-1.32-12.32-.48-17.35 2.75-2.04 1.32-3.83 2.99-5.39 4.91-7.66 10.17-7.06 27.53 2.4 42.62l.36.47c8.97 14.01 23.09 21.91 35.06 20.83-1.67 7.19-.47 14.85 3.71 21.55 1.2 1.92 2.64 3.59 4.19 5.03 1.32.96 3.47.24 3.47-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__eX)",
    stroke: "url(#fish_svg__eY)",
    d: "M2567.57 1265c-.12-9.34 4.55-18.55 12.93-23.94 7.9-5.15 17.48-5.75 25.61-2.51 2.28.95 4.43-1.32 3.48-3.6-.84-1.91-1.92-3.83-3.24-5.62-6.94-9.46-19.15-13.41-30.16-10.42 1.2-9.34-1.2-20.35-7.66-30.4 6.35-2.28 11.97-3.96 17.36-.12 1.55 1.19 3.83-.24 3.47-2.16-.24-1.44-.6-2.87-1.2-4.31-4.67-12.93-18.67-19.63-31.24-14.96a23.9 23.9 0 0 0-6.82 3.95c-2.87-1.32-5.87-2.28-8.98-2.52-6.22-1.31-12.33-.48-17.35 2.76-2.04 1.31-3.83 2.99-5.39 4.91-7.66 10.17-7.06 27.53 2.4 42.61l.35.48c8.98 14.01 23.1 21.91 35.07 20.83-1.67 7.18-.48 14.85 3.71 21.55 1.2 1.92 2.64 3.59 4.19 5.03 1.32.96 3.47.12 3.47-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__eZ)",
    stroke: "url(#fish_svg__fa)",
    d: "M2725.09 1307.62c-.12-9.34 4.54-18.56 12.92-23.94 7.9-5.15 17.48-5.75 25.62-2.52 2.27.96 4.42-1.31 3.47-3.59-.84-1.91-1.92-3.83-3.23-5.62-6.95-9.46-19.16-13.41-30.17-10.42 1.2-9.34-1.19-20.35-7.66-30.41 6.35-2.27 11.97-3.95 17.36-.12 1.55 1.2 3.83-.24 3.47-2.15-.24-1.44-.6-2.87-1.2-4.31-4.67-12.93-18.67-19.63-31.24-14.97-2.51.96-4.78 2.28-6.82 3.96-2.87-1.32-5.86-2.28-8.98-2.52-6.22-1.32-12.32-.48-17.35 2.75-2.04 1.32-3.83 3-5.39 4.91-7.66 10.18-7.06 27.54 2.4 42.62l.36.48c8.97 14.01 23.1 21.91 35.07 20.83-1.68 7.18-.48 14.84 3.71 21.55 1.19 1.91 2.63 3.59 4.18 5.03 1.32.95 3.48.12 3.48-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__fb)",
    stroke: "url(#fish_svg__fc)",
    d: "M2882.6 1350.24c-.12-9.34 4.55-18.56 12.92-23.95 7.9-5.14 17.48-5.74 25.62-2.51 2.27.96 4.43-1.32 3.47-3.59-.84-1.92-1.92-3.83-3.23-5.63-6.95-9.45-19.15-13.41-30.16-10.41 1.19-9.34-1.2-20.35-7.67-30.41 6.35-2.27 11.97-3.95 17.36-.12 1.56 1.2 3.83-.24 3.47-2.15-.24-1.44-.6-2.88-1.2-4.31-4.66-12.93-18.67-19.64-31.23-14.97-2.52.96-4.79 2.28-6.83 3.95-2.87-1.31-5.86-2.27-8.97-2.51-6.23-1.32-12.33-.48-17.36 2.75-2.03 1.32-3.83 3-5.38 4.91-7.66 10.18-7.07 27.53 2.39 42.62l.36.48c8.97 14 23.1 21.9 35.07 20.83-1.68 7.18-.48 14.84 3.71 21.55 1.19 1.91 2.63 3.59 4.19 5.02 1.31.96 3.47.12 3.47-1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__fd)",
    stroke: "url(#fish_svg__fe)",
    d: "M3039.99 1392.85c-.12-9.33 4.55-18.55 12.92-23.94 7.9-5.15 17.48-5.74 25.62-2.51 2.27.96 4.43-1.32 3.47-3.59-.84-1.92-1.92-3.83-3.23-5.63-6.94-9.46-19.15-13.41-30.16-10.41 1.19-9.34-1.2-20.36-7.66-30.41 6.34-2.28 11.96-3.95 17.35-.12 1.56 1.2 3.83-.24 3.47-2.16-.24-1.43-.6-2.87-1.2-4.31-4.66-12.92-18.67-19.63-31.23-14.96a24.2 24.2 0 0 0-6.83 3.95c-2.87-1.32-5.86-2.27-8.97-2.51-6.23-1.32-12.33-.48-17.36 2.75-2.03 1.32-3.83 2.99-5.38 4.91-7.66 10.17-7.07 27.53 2.39 42.62l.36.47c8.98 14.01 23.1 21.91 35.07 20.83-1.68 7.19-.48 14.85 3.71 21.55 1.19 1.92 2.63 3.59 4.19 5.03 1.43.96 3.59.12 3.47-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__ff)",
    stroke: "url(#fish_svg__fg)",
    d: "M3197.5 1435.35c-.12-9.33 4.55-18.55 12.93-23.94 7.9-5.15 17.47-5.75 25.61-2.51 2.27.95 4.43-1.32 3.47-3.6-.84-1.91-1.91-3.83-3.23-5.62-6.94-9.46-19.15-13.41-30.16-10.42 1.19-9.33-1.2-20.35-7.66-30.4 6.34-2.28 11.97-3.95 17.35-.12 1.56 1.19 3.83-.24 3.47-2.16-.24-1.43-.6-2.87-1.19-4.31-4.67-12.93-18.67-19.63-31.24-14.96-2.52.96-4.79 2.27-6.82 3.95-2.88-1.32-5.87-2.28-8.98-2.52-6.23-1.31-12.33-.47-17.36 2.76-2.03 1.31-3.83 2.99-5.38 4.91-7.66 10.17-7.06 27.53 2.39 42.61l.36.48c8.98 14.01 23.1 21.91 35.07 20.83-1.68 7.19-.48 14.85 3.71 21.55 1.2 1.92 2.63 3.59 4.19 5.03 1.44 1.08 3.59.24 3.47-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__fh)",
    stroke: "url(#fish_svg__fi)",
    d: "M3355.01 1477.97c-.12-9.34 4.55-18.56 12.93-23.94 7.9-5.15 17.47-5.75 25.61-2.52 2.27.96 4.43-1.31 3.47-3.59-.84-1.91-1.91-3.83-3.23-5.62-6.94-9.46-19.15-13.41-30.16-10.42 1.19-9.34-1.2-20.35-7.66-30.41 6.34-2.27 11.97-3.95 17.35-.12 1.56 1.2 3.83-.24 3.47-2.15-.24-1.44-.6-2.87-1.19-4.31-4.67-12.93-18.68-19.63-31.24-14.96-2.52.95-4.79 2.27-6.82 3.95-2.88-1.32-5.87-2.28-8.98-2.52-6.23-1.31-12.33-.48-17.36 2.76-2.03 1.31-3.83 2.99-5.38 4.9-7.66 10.18-7.06 27.54 2.39 42.62l.36.48c8.98 14.01 23.1 21.91 35.07 20.83-1.68 7.18-.48 14.84 3.71 21.55 1.2 1.91 2.63 3.59 4.19 5.03 1.43 1.07 3.59.24 3.47-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__fj)",
    stroke: "url(#fish_svg__fk)",
    d: "M924.959 934.715c-.12-9.338 4.548-18.555 12.926-23.942 7.9-5.148 17.475-5.747 25.614-2.514 2.274.957 4.428-1.317 3.471-3.592a29.6 29.6 0 0 0-3.232-5.626c-6.942-9.458-19.15-13.408-30.161-10.415 1.196-9.338-1.197-20.351-7.661-30.407 6.344-2.275 11.969-3.951 17.355-.12 1.556 1.197 3.83-.239 3.471-2.155-.239-1.436-.598-2.873-1.197-4.309-4.667-12.929-18.671-19.633-31.238-14.964a24.2 24.2 0 0 0-6.823 3.95c-2.872-1.317-5.864-2.275-8.976-2.514-6.224-1.317-12.328-.479-17.355 2.753-2.035 1.317-3.83 2.993-5.386 4.909-7.66 10.175-7.062 27.534 2.393 42.617l.359.479c8.977 14.007 23.1 21.908 35.069 20.83-1.675 7.183-.478 14.845 3.711 21.548a24.6 24.6 0 0 0 4.189 5.028c1.436.958 3.471.12 3.471-1.556Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__fl)",
    stroke: "url(#fish_svg__fm)",
    d: "M1082.47 977.333c-.12-9.338 4.55-18.556 12.93-23.943 7.9-5.147 17.47-5.746 25.61-2.514 2.27.958 4.43-1.317 3.47-3.591a29.6 29.6 0 0 0-3.23-5.627c-6.94-9.457-19.15-13.407-30.16-10.415 1.19-9.337-1.2-20.351-7.66-30.407 6.34-2.274 11.97-3.95 17.35-.119 1.56 1.197 3.83-.24 3.47-2.155-.24-1.437-.6-2.873-1.19-4.31-4.67-12.929-18.68-19.633-31.24-14.964a24 24 0 0 0-6.82 3.951c-2.88-1.317-5.87-2.275-8.98-2.514-6.23-1.317-12.33-.479-17.36 2.753-2.03 1.317-3.83 2.993-5.38 4.908-7.66 10.176-7.06 27.534 2.39 42.618l.36.479c8.98 14.006 23.1 21.907 35.07 20.83-1.68 7.183-.48 14.844 3.71 21.548a24.6 24.6 0 0 0 4.19 5.028c1.43.958 3.47.12 3.47-1.556Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__fn)",
    stroke: "url(#fish_svg__fo)",
    d: "M1239.98 1019.95c-.12-9.34 4.55-18.56 12.93-23.942 7.9-5.148 17.47-5.746 25.61-2.514 2.28.958 4.43-1.317 3.47-3.591a29.6 29.6 0 0 0-3.23-5.627c-6.94-9.457-19.15-13.408-30.16-10.415 1.2-9.338-1.2-20.351-7.66-30.407 6.34-2.275 11.97-3.95 17.35-.12 1.56 1.197 3.83-.239 3.47-2.154-.23-1.437-.59-2.874-1.19-4.31-4.67-12.929-18.67-19.633-31.24-14.964a24.2 24.2 0 0 0-6.82 3.95c-2.88-1.316-5.87-2.274-8.98-2.514-6.22-1.316-12.33-.479-17.35 2.754-2.04 1.317-3.83 2.993-5.39 4.908-7.66 10.176-7.06 27.534 2.39 42.618l.36.478c8.98 14.007 23.1 21.908 35.07 20.83-1.67 7.18-.48 14.84 3.71 21.55 1.2 1.91 2.63 3.59 4.19 5.03 1.44.95 3.47.12 3.47-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__fp)",
    stroke: "url(#fish_svg__fq)",
    d: "M1397.49 1062.45c-.12-9.34 4.55-18.56 12.93-23.94 7.9-5.15 17.47-5.75 25.61-2.52 2.28.96 4.43-1.31 3.47-3.59-.83-1.91-1.91-3.83-3.23-5.63-6.94-9.45-19.15-13.4-30.16-10.41 1.2-9.34-1.2-20.352-7.66-30.408 6.34-2.275 11.97-3.951 17.35-.12 1.56 1.197 3.83-.239 3.48-2.155-.24-1.436-.6-2.873-1.2-4.309-4.67-12.929-18.67-19.633-31.24-14.964a24.2 24.2 0 0 0-6.82 3.95c-2.88-1.317-5.87-2.274-8.98-2.514-6.22-1.317-12.33-.479-17.35 2.754-2.04 1.316-3.83 2.993-5.39 4.908-7.66 10.175-7.06 27.538 2.39 42.618l.36.48c8.98 14 23.1 21.91 35.07 20.83-1.67 7.18-.48 14.84 3.71 21.55 1.2 1.91 2.64 3.59 4.19 5.02 1.44 1.08 3.47.24 3.47-1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__fr)",
    stroke: "url(#fish_svg__fs)",
    d: "M1555 1105.07c-.12-9.34 4.55-18.56 12.93-23.95 7.9-5.14 17.47-5.74 25.61-2.51 2.28.96 4.43-1.32 3.47-3.59-.83-1.92-1.91-3.83-3.23-5.63-6.94-9.46-19.15-13.41-30.16-10.41 1.2-9.34-1.2-20.35-7.66-30.41 6.34-2.27 11.97-3.95 17.36-.12 1.55 1.2 3.83-.24 3.47-2.15-.24-1.44-.6-2.88-1.2-4.31-4.67-12.93-18.67-19.64-31.24-14.97-2.51.96-4.79 2.28-6.82 3.95-2.87-1.31-5.87-2.27-8.98-2.51-6.22-1.32-12.33-.48-17.35 2.75-2.04 1.32-3.83 2.99-5.39 4.91-7.66 10.18-7.06 27.53 2.4 42.62l.35.48c8.98 14 23.1 21.9 35.07 20.83-1.67 7.18-.48 14.84 3.71 21.54 1.2 1.92 2.64 3.6 4.19 5.03 1.44 1.08 3.47.24 3.47-1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__ft)",
    stroke: "url(#fish_svg__fu)",
    d: "M1712.51 1147.68c-.12-9.33 4.55-18.55 12.93-23.94 7.9-5.15 17.47-5.75 25.61-2.51 2.28.95 4.43-1.32 3.47-3.59-.83-1.92-1.91-3.84-3.23-5.63-6.94-9.46-19.15-13.41-30.16-10.42 1.2-9.33-1.2-20.35-7.66-30.4 6.34-2.28 11.97-3.95 17.36-.12 1.55 1.19 3.83-.24 3.47-2.16-.24-1.43-.6-2.87-1.2-4.31-4.67-12.93-18.67-19.63-31.24-14.96-2.51.96-4.79 2.27-6.82 3.95-2.87-1.32-5.87-2.28-8.98-2.51-6.22-1.32-12.33-.48-17.35 2.75-2.04 1.32-3.83 2.99-5.39 4.91-7.66 10.17-7.06 27.53 2.4 42.61l.35.48c8.98 14.01 23.1 21.91 35.07 20.83-1.67 7.19-.48 14.85 3.71 21.55 1.2 1.92 2.64 3.59 4.19 5.03 1.44 1.08 3.47.24 3.47-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__fv)",
    stroke: "url(#fish_svg__fw)",
    d: "M1870.03 1190.3c-.12-9.34 4.54-18.55 12.92-23.94 7.9-5.15 17.48-5.75 25.62-2.52 2.27.96 4.42-1.31 3.47-3.59-.84-1.91-1.92-3.83-3.24-5.62-6.94-9.46-19.15-13.41-30.16-10.42 1.2-9.34-1.19-20.35-7.66-30.41 6.35-2.27 11.97-3.95 17.36-.11 1.55 1.19 3.83-.24 3.47-2.16-.24-1.44-.6-2.87-1.2-4.31-4.67-12.93-18.67-19.63-31.24-14.96-2.51.95-4.78 2.27-6.82 3.95-2.87-1.32-5.86-2.28-8.98-2.52-6.22-1.31-12.32-.48-17.35 2.76-2.04 1.31-3.83 2.99-5.39 4.9-7.66 10.18-7.06 27.54 2.4 42.62l.36.48c8.97 14.01 23.1 21.91 35.06 20.83-1.67 7.18-.47 14.85 3.72 21.55 1.19 1.91 2.63 3.59 4.18 5.03 1.44 1.07 3.48.24 3.48-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__fx)",
    stroke: "url(#fish_svg__fy)",
    d: "M2027.54 1232.92c-.12-9.34 4.55-18.56 12.92-23.94 7.9-5.15 17.48-5.75 25.62-2.52 2.27.96 4.43-1.31 3.47-3.59-.84-1.91-1.92-3.83-3.23-5.63-6.95-9.45-19.15-13.4-30.17-10.41 1.2-9.34-1.19-20.35-7.66-30.41 6.35-2.27 11.97-3.95 17.36-.12 1.56 1.2 3.83-.24 3.47-2.15-.24-1.44-.6-2.88-1.2-4.31-4.66-12.93-18.67-19.63-31.24-14.97a24.5 24.5 0 0 0-6.82 3.95c-2.87-1.31-5.86-2.27-8.97-2.51-6.23-1.32-12.33-.48-17.36 2.75-2.03 1.32-3.83 3-5.39 4.91-7.66 10.18-7.06 27.54 2.4 42.62l.36.48c8.97 14.01 23.1 21.91 35.07 20.83-1.68 7.18-.48 14.84 3.71 21.55a24.5 24.5 0 0 0 4.19 5.03c1.43.95 3.47.23 3.47-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__fz)",
    stroke: "url(#fish_svg__fA)",
    d: "M828.369 1016.72c-.12-9.34 4.548-18.557 12.927-23.944 7.899-5.148 17.474-5.747 25.613-2.514 2.274.957 4.429-1.317 3.471-3.592a29.6 29.6 0 0 0-3.232-5.626c-6.942-9.457-19.15-13.408-30.161-10.415 1.197-9.338-1.197-20.351-7.66-30.407 6.343-2.275 11.969-3.951 17.355-.12 1.556 1.197 3.83-.239 3.471-2.155-.24-1.436-.599-2.873-1.197-4.309-4.668-12.929-18.672-19.633-31.239-14.964a24.2 24.2 0 0 0-6.823 3.95c-2.872-1.317-5.864-2.274-8.976-2.514-6.224-1.317-12.328-.479-17.355 2.754-2.035 1.316-3.83 2.992-5.386 4.908-7.66 10.175-7.062 27.534 2.394 42.617l.359.479c8.976 14.007 23.1 21.908 35.069 20.83-1.676 7.183-.479 14.842 3.71 21.552a24.5 24.5 0 0 0 4.189 5.02c1.317.96 3.471.12 3.471-1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__fB)",
    stroke: "url(#fish_svg__fC)",
    d: "M985.88 1059.22c-.12-9.34 4.548-18.56 12.926-23.95 7.904-5.14 17.474-5.74 25.614-2.51 2.27.96 4.43-1.32 3.47-3.59-.84-1.92-1.91-3.83-3.23-5.63-6.94-9.46-19.15-13.41-30.162-10.41 1.196-9.34-1.197-20.354-7.661-30.41 6.344-2.275 11.969-3.951 17.353-.12 1.56 1.197 3.83-.239 3.47-2.155-.24-1.436-.6-2.873-1.19-4.309-4.67-12.929-18.675-19.633-31.243-14.964a24.2 24.2 0 0 0-6.822 3.95c-2.872-1.317-5.865-2.275-8.977-2.514-6.223-1.317-12.328-.479-17.354 2.753-2.035 1.317-3.831 2.993-5.386 4.909-7.661 10.175-7.062 27.533 2.393 42.62l.359.48c8.977 14 23.1 21.9 35.069 20.83-1.675 7.18-.478 14.84 3.711 21.54a24.3 24.3 0 0 0 4.189 5.03c1.316 1.08 3.471.24 3.471-1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__fD)",
    stroke: "url(#fish_svg__fE)",
    d: "M1143.39 1101.83c-.12-9.33 4.55-18.55 12.93-23.94 7.9-5.15 17.47-5.75 25.61-2.51 2.28.95 4.43-1.32 3.47-3.59-.84-1.92-1.91-3.83-3.23-5.63-6.94-9.46-19.15-13.41-30.16-10.42 1.2-9.33-1.2-20.35-7.66-30.4 6.34-2.28 11.97-3.95 17.35-.12 1.56 1.19 3.83-.24 3.47-2.16-.23-1.43-.59-2.87-1.19-4.31-4.67-12.93-18.67-19.63-31.24-14.96-2.51.96-4.79 2.27-6.82 3.95-2.88-1.32-5.87-2.27-8.98-2.51-6.22-1.32-12.33-.48-17.35 2.75-2.04 1.32-3.83 2.99-5.39 4.91-7.66 10.17-7.06 27.53 2.39 42.61l.36.48c8.98 14.01 23.1 21.91 35.07 20.83-1.67 7.19-.48 14.85 3.71 21.55 1.2 1.92 2.63 3.59 4.19 5.03 1.32 1.08 3.47.24 3.47-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__fF)",
    stroke: "url(#fish_svg__fG)",
    d: "M1300.9 1144.45c-.12-9.34 4.55-18.55 12.93-23.94 7.9-5.15 17.47-5.75 25.61-2.52 2.28.96 4.43-1.31 3.47-3.59-.83-1.91-1.91-3.83-3.23-5.62-6.94-9.46-19.15-13.41-30.16-10.42 1.2-9.34-1.2-20.35-7.66-30.4 6.34-2.28 11.97-3.96 17.35-.12 1.56 1.19 3.83-.24 3.48-2.16-.24-1.44-.6-2.87-1.2-4.31-4.67-12.93-18.67-19.63-31.24-14.96a23.9 23.9 0 0 0-6.82 3.95c-2.87-1.32-5.87-2.28-8.98-2.52-6.22-1.31-12.33-.48-17.35 2.76-2.04 1.31-3.83 2.99-5.39 4.9-7.66 10.18-7.06 27.54 2.39 42.62l.36.48c8.98 14.01 23.1 21.91 35.07 20.83-1.67 7.18-.48 14.85 3.71 21.55 1.2 1.92 2.64 3.59 4.19 5.03 1.32 1.07 3.47.24 3.47-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__fH)",
    stroke: "url(#fish_svg__fI)",
    d: "M1458.41 1187.07c-.12-9.34 4.55-18.56 12.93-23.94 7.9-5.15 17.47-5.75 25.61-2.52 2.28.96 4.43-1.31 3.47-3.59-.83-1.91-1.91-3.83-3.23-5.63-6.94-9.45-19.15-13.4-30.16-10.41 1.2-9.34-1.2-20.35-7.66-30.41 6.34-2.27 11.97-3.95 17.36-.12 1.55 1.2 3.83-.24 3.47-2.15-.24-1.44-.6-2.87-1.2-4.31-4.67-12.93-18.67-19.63-31.24-14.97-2.51.96-4.79 2.28-6.82 3.95-2.87-1.31-5.87-2.27-8.98-2.51-6.22-1.32-12.33-.48-17.35 2.75-2.04 1.32-3.83 3-5.39 4.91-7.66 10.18-7.06 27.54 2.39 42.62l.36.48c8.98 14.01 23.1 21.91 35.07 20.83-1.67 7.18-.48 14.84 3.71 21.55 1.2 1.91 2.64 3.59 4.19 5.03 1.32.95 3.47.23 3.47-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__fJ)",
    stroke: "url(#fish_svg__fK)",
    d: "M1615.92 1229.69c-.12-9.34 4.55-18.56 12.93-23.95 7.9-5.14 17.47-5.74 25.61-2.51 2.28.96 4.43-1.32 3.47-3.59-.83-1.92-1.91-3.83-3.23-5.63-6.94-9.45-19.15-13.41-30.16-10.41 1.2-9.34-1.2-20.35-7.66-30.41 6.34-2.27 11.97-3.95 17.36-.12 1.55 1.2 3.83-.24 3.47-2.15-.24-1.44-.6-2.88-1.2-4.31-4.67-12.93-18.67-19.64-31.24-14.97-2.51.96-4.79 2.28-6.82 3.95-2.87-1.31-5.87-2.27-8.98-2.51-6.22-1.32-12.33-.48-17.35 2.75-2.04 1.32-3.83 2.99-5.39 4.91-7.66 10.18-7.06 27.53 2.4 42.62l.35.48c8.98 14 23.1 21.9 35.07 20.83-1.67 7.18-.48 14.84 3.71 21.54 1.2 1.92 2.64 3.6 4.19 5.03 1.32.96 3.47.12 3.47-1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__fL)",
    stroke: "url(#fish_svg__fM)",
    d: "M1773.44 1272.3c-.12-9.33 4.54-18.55 12.92-23.94 7.9-5.15 17.48-5.74 25.62-2.51 2.27.96 4.42-1.32 3.47-3.59-.84-1.92-1.92-3.83-3.24-5.63-6.94-9.46-19.15-13.41-30.16-10.42 1.2-9.33-1.19-20.35-7.66-30.4 6.35-2.28 11.97-3.95 17.36-.12 1.55 1.2 3.83-.24 3.47-2.16-.24-1.43-.6-2.87-1.2-4.31-4.67-12.93-18.67-19.63-31.24-14.96-2.51.96-4.78 2.27-6.82 3.95-2.87-1.32-5.86-2.27-8.98-2.51-6.22-1.32-12.32-.48-17.35 2.75-2.04 1.32-3.83 2.99-5.39 4.91-7.66 10.17-7.06 27.53 2.4 42.62l.36.47c8.97 14.01 23.1 21.91 35.06 20.83-1.67 7.19-.47 14.85 3.72 21.55 1.19 1.92 2.63 3.59 4.18 5.03 1.32.96 3.48.12 3.48-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__fN)",
    stroke: "url(#fish_svg__fO)",
    d: "M1930.95 1314.92c-.12-9.34 4.55-18.55 12.92-23.94 7.9-5.15 17.48-5.75 25.62-2.51 2.27.95 4.43-1.32 3.47-3.6-.84-1.91-1.92-3.83-3.23-5.62-6.95-9.46-19.15-13.41-30.17-10.42 1.2-9.33-1.19-20.35-7.66-30.4 6.35-2.28 11.97-3.95 17.36-.12 1.56 1.19 3.83-.24 3.47-2.16-.24-1.44-.6-2.87-1.2-4.31-4.66-12.93-18.67-19.63-31.24-14.96-2.51.96-4.78 2.27-6.82 3.95-2.87-1.32-5.86-2.28-8.97-2.52-6.23-1.31-12.33-.47-17.36 2.76-2.03 1.31-3.83 2.99-5.39 4.91-7.66 10.17-7.06 27.53 2.4 42.61l.36.48c8.97 14.01 23.1 21.91 35.07 20.83-1.68 7.18-.48 14.85 3.71 21.55 1.19 1.92 2.63 3.59 4.19 5.03 1.31.96 3.47.12 3.47-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__fP)",
    stroke: "url(#fish_svg__fQ)",
    d: "M731.661 1098.6c-.12-9.34 4.548-18.55 12.926-23.94 7.9-5.15 17.475-5.75 25.614-2.52 2.274.96 4.429-1.31 3.471-3.59a29.6 29.6 0 0 0-3.232-5.62c-6.942-9.46-19.15-13.41-30.161-10.42 1.197-9.34-1.197-20.35-7.66-30.4 6.343-2.28 11.968-3.96 17.354-.12 1.556 1.19 3.831-.24 3.472-2.16-.24-1.44-.599-2.87-1.197-4.31-4.668-12.93-18.672-19.632-31.239-14.96a24 24 0 0 0-6.823 3.95c-2.872-1.32-5.864-2.28-8.976-2.52-6.224-1.31-12.328-.48-17.355 2.76-2.035 1.31-3.83 2.99-5.386 4.91-7.66 10.17-7.062 27.53 2.394 42.61l.359.48c8.976 14.01 23.1 21.91 35.069 20.83-1.676 7.18-.479 14.85 3.71 21.55a24.6 24.6 0 0 0 4.189 5.03c1.317 1.08 3.471.24 3.471-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__fR)",
    stroke: "url(#fish_svg__fS)",
    d: "M889.172 1141.22c-.12-9.34 4.548-18.56 12.926-23.94 7.9-5.15 17.475-5.75 25.614-2.52 2.274.96 4.428-1.31 3.471-3.59a30 30 0 0 0-3.232-5.63c-6.942-9.45-19.15-13.4-30.162-10.41 1.197-9.34-1.196-20.35-7.66-30.41 6.344-2.27 11.969-3.95 17.355-.12 1.556 1.2 3.83-.24 3.471-2.15-.239-1.44-.598-2.87-1.197-4.31-4.668-12.93-18.671-19.63-31.239-14.97a24.2 24.2 0 0 0-6.822 3.96c-2.872-1.32-5.865-2.28-8.977-2.52-6.223-1.32-12.328-.48-17.354 2.75-2.035 1.32-3.831 3-5.386 4.91-7.661 10.18-7.062 27.54 2.393 42.62l.359.48c8.977 14.01 23.1 21.91 35.069 20.83-1.675 7.18-.478 14.84 3.711 21.55a24.9 24.9 0 0 0 4.189 5.03c1.316.95 3.471.23 3.471-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__fT)",
    stroke: "url(#fish_svg__fU)",
    d: "M1046.68 1183.84c-.12-9.34 4.55-18.56 12.93-23.95 7.9-5.14 17.47-5.74 25.61-2.51 2.28.96 4.43-1.32 3.47-3.59-.83-1.92-1.91-3.83-3.23-5.63-6.94-9.45-19.15-13.41-30.16-10.41 1.2-9.34-1.2-20.35-7.66-30.41 6.34-2.27 11.97-3.95 17.36-.12 1.55 1.2 3.83-.24 3.47-2.15-.24-1.44-.6-2.88-1.2-4.31-4.67-12.93-18.67-19.64-31.24-14.97-2.51.96-4.79 2.28-6.82 3.95-2.87-1.31-5.87-2.27-8.98-2.51-6.22-1.32-12.33-.48-17.35 2.75-2.04 1.32-3.833 2.99-5.389 4.91-7.66 10.18-7.061 27.53 2.394 42.62l.355.48c8.98 14 23.1 21.9 35.07 20.83-1.67 7.18-.48 14.84 3.71 21.55 1.2 1.91 2.64 3.59 4.19 5.02 1.32.96 3.47.12 3.47-1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__fV)",
    stroke: "url(#fish_svg__fW)",
    d: "M1204.19 1226.45c-.12-9.33 4.55-18.55 12.93-23.94 7.9-5.15 17.48-5.74 25.61-2.51 2.28.96 4.43-1.32 3.48-3.59-.84-1.92-1.92-3.83-3.24-5.63-6.94-9.46-19.15-13.41-30.16-10.41 1.2-9.34-1.19-20.36-7.66-30.41 6.35-2.28 11.97-3.95 17.36-.12 1.55 1.2 3.83-.24 3.47-2.16-.24-1.43-.6-2.87-1.2-4.31-4.67-12.93-18.67-19.63-31.24-14.96-2.51.96-4.79 2.27-6.82 3.95-2.87-1.32-5.87-2.27-8.98-2.51-6.22-1.32-12.33-.48-17.35 2.75-2.04 1.32-3.83 2.99-5.39 4.91-7.66 10.17-7.06 27.53 2.4 42.62l.35.47c8.98 14.01 23.1 21.91 35.07 20.83-1.67 7.19-.47 14.85 3.71 21.55 1.2 1.92 2.64 3.59 4.19 5.03 1.32.96 3.47.12 3.47-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__fX)",
    stroke: "url(#fish_svg__fY)",
    d: "M1361.7 1269.07c-.11-9.34 4.55-18.55 12.93-23.94 7.9-5.15 17.48-5.75 25.62-2.51 2.27.95 4.42-1.32 3.47-3.6-.84-1.91-1.92-3.83-3.24-5.62-6.94-9.46-19.15-13.41-30.16-10.42 1.2-9.33-1.19-20.35-7.66-30.4 6.35-2.28 11.97-3.95 17.36-.12 1.55 1.19 3.83-.24 3.47-2.16-.24-1.44-.6-2.87-1.2-4.31-4.67-12.93-18.67-19.63-31.24-14.96-2.51.96-4.78 2.27-6.82 3.95-2.87-1.32-5.86-2.28-8.98-2.52-6.22-1.31-12.32-.47-17.35 2.76-2.04 1.31-3.83 2.99-5.39 4.91-7.66 10.17-7.06 27.53 2.4 42.61l.36.48c8.97 14.01 23.1 21.91 35.06 20.83-1.67 7.18-.47 14.85 3.71 21.55 1.2 1.92 2.64 3.59 4.19 5.03 1.32.96 3.47.12 3.47-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__fZ)",
    stroke: "url(#fish_svg__ga)",
    d: "M1519.22 1311.69c-.12-9.34 4.54-18.56 12.92-23.94 7.9-5.15 17.48-5.75 25.62-2.52 2.27.96 4.43-1.31 3.47-3.59-.84-1.91-1.92-3.83-3.23-5.62-6.95-9.46-19.15-13.41-30.17-10.42 1.2-9.34-1.19-20.35-7.66-30.41 6.35-2.27 11.97-3.95 17.36-.12 1.56 1.2 3.83-.24 3.47-2.15-.24-1.44-.6-2.87-1.2-4.31-4.66-12.93-18.67-19.63-31.24-14.96-2.51.95-4.78 2.27-6.82 3.95-2.87-1.32-5.86-2.28-8.97-2.52-6.23-1.32-12.33-.48-17.36 2.76-2.03 1.31-3.83 2.99-5.39 4.9-7.66 10.18-7.06 27.54 2.4 42.62l.36.48c8.97 14.01 23.1 21.91 35.07 20.83-1.68 7.18-.48 14.84 3.71 21.55a24.5 24.5 0 0 0 4.19 5.03c1.31.95 3.47.12 3.47-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__gb)",
    stroke: "url(#fish_svg__gc)",
    d: "M1676.73 1354.19c-.12-9.34 4.55-18.56 12.92-23.94 7.9-5.15 17.48-5.75 25.62-2.52 2.27.96 4.43-1.32 3.47-3.59-.84-1.92-1.92-3.83-3.23-5.63-6.94-9.45-19.15-13.4-30.16-10.41 1.19-9.34-1.2-20.35-7.66-30.41 6.34-2.27 11.96-3.95 17.35-.12 1.56 1.2 3.83-.24 3.47-2.15-.24-1.44-.6-2.88-1.2-4.31-4.66-12.93-18.67-19.64-31.23-14.97-2.52.96-4.79 2.28-6.83 3.95-2.87-1.31-5.86-2.27-8.97-2.51-6.23-1.32-12.33-.48-17.36 2.75-2.03 1.32-3.83 3-5.38 4.91-7.66 10.18-7.07 27.54 2.39 42.62l.36.48c8.98 14 23.1 21.91 35.07 20.83-1.68 7.18-.48 14.84 3.71 21.55a24.5 24.5 0 0 0 4.19 5.02c1.31 1.08 3.47.24 3.47-1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__gd)",
    stroke: "url(#fish_svg__ge)",
    d: "M1834.24 1396.81c-.12-9.34 4.55-18.56 12.92-23.95 7.9-5.14 17.48-5.74 25.62-2.51 2.27.96 4.43-1.32 3.47-3.59-.84-1.92-1.92-3.83-3.23-5.63-6.94-9.46-19.15-13.41-30.16-10.41 1.19-9.34-1.2-20.36-7.66-30.41 6.34-2.28 11.96-3.95 17.35-.12 1.56 1.2 3.83-.24 3.47-2.16-.24-1.43-.6-2.87-1.2-4.31-4.66-12.92-18.67-19.63-31.23-14.96-2.52.96-4.79 2.28-6.83 3.95-2.87-1.32-5.86-2.27-8.97-2.51-6.23-1.32-12.33-.48-17.36 2.75-2.03 1.32-3.83 2.99-5.38 4.91-7.66 10.17-7.07 27.53 2.39 42.62l.36.48c8.98 14 23.1 21.9 35.07 20.83-1.68 7.18-.48 14.84 3.71 21.54 1.19 1.92 2.63 3.59 4.19 5.03 1.31 1.08 3.47.24 3.47-1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__gf)",
    stroke: "url(#fish_svg__gg)",
    d: "M634.952 1180.6c-.12-9.33 4.548-18.55 12.927-23.94 7.899-5.15 17.474-5.74 25.613-2.51 2.274.96 4.429-1.32 3.471-3.59a29.7 29.7 0 0 0-3.232-5.63c-6.942-9.46-19.15-13.41-30.161-10.41 1.197-9.34-1.197-20.36-7.66-30.41 6.343-2.28 11.969-3.95 17.355-.12 1.556 1.2 3.83-.24 3.471-2.16-.24-1.43-.599-2.87-1.197-4.31-4.668-12.92-18.672-19.63-31.239-14.96a24.2 24.2 0 0 0-6.823 3.95c-2.872-1.32-5.864-2.27-8.976-2.51-6.224-1.32-12.328-.48-17.355 2.75-2.035 1.32-3.83 2.99-5.386 4.91-7.66 10.17-7.062 27.53 2.394 42.62l.359.47c8.976 14.01 23.1 21.91 35.069 20.83-1.676 7.19-.479 14.85 3.71 21.55a24.6 24.6 0 0 0 4.189 5.03c1.436.96 3.471.12 3.471-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__gh)",
    stroke: "url(#fish_svg__gi)",
    d: "M792.463 1223.22c-.12-9.34 4.548-18.55 12.926-23.94 7.9-5.15 17.475-5.75 25.614-2.51 2.274.95 4.428-1.32 3.471-3.6a29.6 29.6 0 0 0-3.232-5.62c-6.942-9.46-19.15-13.41-30.162-10.42 1.197-9.33-1.196-20.35-7.66-30.4 6.344-2.28 11.969-3.95 17.355-.12 1.556 1.19 3.83-.24 3.471-2.16-.239-1.44-.598-2.87-1.197-4.31-4.668-12.93-18.671-19.63-31.239-14.96a24.2 24.2 0 0 0-6.822 3.95c-2.872-1.32-5.865-2.28-8.977-2.52-6.223-1.31-12.327-.47-17.354 2.76-2.035 1.31-3.831 2.99-5.386 4.91-7.661 10.17-7.062 27.53 2.393 42.61l.359.48c8.977 14.01 23.1 21.91 35.069 20.83-1.675 7.19-.478 14.85 3.711 21.55a24.6 24.6 0 0 0 4.189 5.03c1.436.96 3.471.12 3.471-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__gj)",
    stroke: "url(#fish_svg__gk)",
    d: "M949.975 1265.84c-.12-9.34 4.548-18.56 12.926-23.94 7.9-5.15 17.475-5.75 25.614-2.52 2.274.96 4.428-1.31 3.47-3.59a29.6 29.6 0 0 0-3.231-5.62c-6.942-9.46-19.15-13.41-30.162-10.42 1.197-9.34-1.197-20.35-7.66-30.41 6.344-2.27 11.969-3.95 17.355-.12 1.556 1.2 3.83-.24 3.471-2.15-.239-1.44-.598-2.87-1.197-4.31-4.668-12.93-18.671-19.63-31.239-14.96a24 24 0 0 0-6.822 3.95c-2.873-1.32-5.865-2.28-8.977-2.52-6.224-1.32-12.328-.48-17.355 2.76-2.034 1.31-3.83 2.99-5.386 4.9-7.66 10.18-7.061 27.54 2.394 42.62l.359.48c8.977 14.01 23.1 21.91 35.069 20.83-1.676 7.18-.479 14.84 3.71 21.55a24.9 24.9 0 0 0 4.19 5.03c1.436.95 3.471.12 3.471-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__gl)",
    stroke: "url(#fish_svg__gm)",
    d: "M1107.49 1308.46c-.12-9.34 4.54-18.56 12.92-23.95 7.9-5.14 17.48-5.74 25.62-2.51 2.27.96 4.42-1.32 3.47-3.59-.84-1.92-1.92-3.83-3.24-5.63-6.94-9.45-19.15-13.4-30.16-10.41 1.2-9.34-1.19-20.35-7.66-30.41 6.35-2.27 11.97-3.95 17.36-.12 1.55 1.2 3.83-.24 3.47-2.15-.24-1.44-.6-2.88-1.2-4.31-4.67-12.93-18.67-19.64-31.24-14.97a24.5 24.5 0 0 0-6.82 3.95c-2.87-1.31-5.86-2.27-8.98-2.51-6.22-1.32-12.32-.48-17.35 2.75-2.04 1.32-3.83 3-5.39 4.91-7.66 10.18-7.06 27.54 2.4 42.62l.36.48c8.97 14 23.1 21.9 35.06 20.83-1.67 7.18-.47 14.84 3.72 21.55 1.19 1.91 2.63 3.59 4.18 5.02 1.44.96 3.48.12 3.48-1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__gn)",
    stroke: "url(#fish_svg__go)",
    d: "M1265 1350.96c-.12-9.34 4.54-18.56 12.92-23.95 7.9-5.14 17.48-5.74 25.62-2.51 2.27.96 4.42-1.32 3.47-3.59-.84-1.92-1.92-3.83-3.23-5.63-6.95-9.46-19.15-13.41-30.17-10.41 1.2-9.34-1.19-20.36-7.66-30.41 6.35-2.28 11.97-3.95 17.36-.12 1.55 1.2 3.83-.24 3.47-2.16-.24-1.43-.6-2.87-1.2-4.31-4.67-12.92-18.67-19.63-31.24-14.96a24.5 24.5 0 0 0-6.82 3.95c-2.87-1.32-5.86-2.27-8.98-2.51-6.22-1.32-12.32-.48-17.35 2.75-2.03 1.32-3.83 2.99-5.39 4.91-7.66 10.17-7.06 27.53 2.4 42.62l.36.48c8.97 14 23.1 21.9 35.07 20.83-1.68 7.18-.48 14.84 3.71 21.54 1.19 1.92 2.63 3.6 4.19 5.03 1.43 1.08 3.47.24 3.47-1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__gp)",
    stroke: "url(#fish_svg__gq)",
    d: "M1422.51 1393.57c-.12-9.33 4.55-18.55 12.92-23.94 7.9-5.15 17.48-5.75 25.62-2.51 2.27.95 4.43-1.32 3.47-3.59-.84-1.92-1.92-3.84-3.23-5.63-6.94-9.46-19.15-13.41-30.16-10.42 1.19-9.33-1.2-20.35-7.66-30.4 6.34-2.28 11.96-3.95 17.35-.12 1.56 1.19 3.83-.24 3.47-2.16-.24-1.43-.6-2.87-1.2-4.31-4.66-12.93-18.67-19.63-31.23-14.96a24.2 24.2 0 0 0-6.83 3.95c-2.87-1.32-5.86-2.28-8.97-2.51-6.23-1.32-12.33-.48-17.36 2.75-2.03 1.32-3.83 2.99-5.38 4.91-7.66 10.17-7.07 27.53 2.39 42.61l.36.48c8.97 14.01 23.1 21.91 35.07 20.83-1.68 7.19-.48 14.85 3.71 21.55 1.19 1.92 2.63 3.59 4.19 5.03 1.43 1.08 3.47.24 3.47-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__gr)",
    stroke: "url(#fish_svg__gs)",
    d: "M1580.02 1436.19c-.12-9.34 4.55-18.55 12.93-23.94 7.9-5.15 17.47-5.75 25.61-2.52 2.27.96 4.43-1.31 3.47-3.59-.84-1.91-1.91-3.83-3.23-5.62-6.94-9.46-19.15-13.41-30.16-10.42 1.19-9.34-1.2-20.35-7.66-30.41 6.34-2.27 11.97-3.95 17.35-.12 1.56 1.2 3.83-.23 3.47-2.15-.24-1.44-.6-2.87-1.19-4.31-4.67-12.93-18.68-19.63-31.24-14.96-2.52.95-4.79 2.27-6.83 3.95-2.87-1.32-5.86-2.28-8.97-2.52-6.23-1.31-12.33-.48-17.36 2.76-2.03 1.31-3.83 2.99-5.38 4.9-7.66 10.18-7.06 27.54 2.39 42.62l.36.48c8.98 14.01 23.1 21.91 35.07 20.83-1.68 7.18-.48 14.85 3.71 21.55 1.2 1.91 2.63 3.59 4.19 5.03 1.43 1.07 3.47.24 3.47-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__gt)",
    stroke: "url(#fish_svg__gu)",
    d: "M1737.53 1478.81c-.12-9.34 4.55-18.56 12.93-23.94 7.9-5.15 17.47-5.75 25.61-2.52 2.27.96 4.43-1.32 3.47-3.59-.84-1.92-1.91-3.83-3.23-5.63-6.94-9.45-19.15-13.4-30.16-10.41 1.19-9.34-1.2-20.35-7.66-30.41 6.34-2.27 11.97-3.95 17.35-.12 1.56 1.2 3.83-.24 3.47-2.15-.24-1.44-.6-2.88-1.19-4.31-4.67-12.93-18.68-19.64-31.24-14.97-2.52.96-4.79 2.28-6.83 3.95-2.87-1.31-5.86-2.27-8.97-2.51-6.23-1.32-12.33-.48-17.36 2.75-2.03 1.32-3.83 3-5.38 4.91-7.66 10.18-7.06 27.54 2.39 42.62l.36.48c8.98 14 23.1 21.91 35.07 20.83-1.68 7.18-.48 14.84 3.71 21.55a24.5 24.5 0 0 0 4.19 5.02c1.43.96 3.47.24 3.47-1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__gv)",
    stroke: "url(#fish_svg__gw)",
    d: "M538.362 1262.61c-.119-9.34 4.548-18.56 12.927-23.95 7.899-5.14 17.474-5.74 25.613-2.51 2.274.96 4.429-1.32 3.471-3.59a29.7 29.7 0 0 0-3.231-5.63c-6.942-9.45-19.151-13.4-30.162-10.41 1.197-9.34-1.197-20.35-7.66-30.41 6.343-2.27 11.969-3.95 17.355-.12 1.556 1.2 3.83-.24 3.471-2.15-.24-1.44-.599-2.88-1.197-4.31-4.668-12.93-18.672-19.64-31.239-14.97a24.4 24.4 0 0 0-6.822 3.95c-2.873-1.31-5.865-2.27-8.977-2.51-6.224-1.32-12.328-.48-17.355 2.75-2.035 1.32-3.83 3-5.386 4.91-7.66 10.18-7.062 27.53 2.394 42.62l.359.48c8.976 14 23.1 21.91 35.069 20.83-1.676 7.18-.479 14.84 3.71 21.55a24.5 24.5 0 0 0 4.189 5.02c1.317.96 3.471.12 3.471-1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__gx)",
    stroke: "url(#fish_svg__gy)",
    d: "M695.873 1305.11c-.12-9.34 4.548-18.56 12.926-23.95 7.9-5.14 17.475-5.74 25.614-2.51 2.274.96 4.428-1.32 3.471-3.59a29.7 29.7 0 0 0-3.232-5.63c-6.942-9.46-19.15-13.41-30.161-10.41 1.196-9.34-1.197-20.35-7.66-30.41 6.343-2.28 11.968-3.95 17.354-.12 1.556 1.2 3.83-.24 3.471-2.16-.239-1.43-.598-2.87-1.196-4.31-4.668-12.92-18.672-19.63-31.239-14.96a24.4 24.4 0 0 0-6.823 3.95c-2.872-1.32-5.864-2.27-8.976-2.51-6.224-1.32-12.328-.48-17.355 2.75-2.035 1.32-3.83 2.99-5.386 4.91-7.66 10.17-7.062 27.53 2.393 42.62l.36.48c8.976 14 23.1 21.9 35.069 20.83-1.676 7.18-.479 14.84 3.71 21.54a24.3 24.3 0 0 0 4.189 5.03c1.317 1.08 3.471.24 3.471-1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__gz)",
    stroke: "url(#fish_svg__gA)",
    d: "M853.385 1347.72c-.12-9.33 4.548-18.55 12.926-23.94 7.9-5.15 17.475-5.75 25.614-2.51 2.274.95 4.428-1.32 3.471-3.59a29.3 29.3 0 0 0-3.232-5.63c-6.942-9.46-19.15-13.41-30.162-10.42 1.197-9.33-1.197-20.35-7.66-30.4 6.344-2.28 11.969-3.95 17.355-.12 1.556 1.19 3.83-.24 3.471-2.16-.239-1.43-.598-2.87-1.197-4.31-4.668-12.93-18.671-19.63-31.239-14.96a24.2 24.2 0 0 0-6.822 3.95c-2.872-1.32-5.865-2.28-8.977-2.51-6.223-1.32-12.328-.48-17.355 2.75-2.034 1.32-3.83 2.99-5.386 4.91-7.66 10.17-7.061 27.53 2.394 42.61l.359.48c8.977 14.01 23.1 21.91 35.069 20.83-1.675 7.19-.479 14.85 3.711 21.55a24.6 24.6 0 0 0 4.189 5.03c1.316 1.08 3.471.24 3.471-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__gB)",
    stroke: "url(#fish_svg__gC)",
    d: "M1010.9 1390.34c-.12-9.34 4.54-18.55 12.92-23.94 7.9-5.15 17.48-5.75 25.62-2.52 2.27.96 4.42-1.31 3.47-3.59-.84-1.91-1.92-3.83-3.24-5.62-6.94-9.46-19.15-13.41-30.16-10.42 1.2-9.34-1.19-20.35-7.66-30.41 6.35-2.27 11.97-3.95 17.36-.12 1.55 1.2 3.83-.23 3.47-2.15-.24-1.44-.6-2.87-1.2-4.31-4.67-12.93-18.67-19.63-31.24-14.96-2.51.95-4.784 2.27-6.819 3.95-2.873-1.32-5.865-2.28-8.977-2.52-6.224-1.31-12.328-.48-17.355 2.76-2.035 1.31-3.83 2.99-5.386 4.9-7.66 10.18-7.062 27.54 2.394 42.62l.359.48c8.977 14.01 23.1 21.91 35.069 20.83-1.676 7.18-.479 14.85 3.715 21.55 1.19 1.91 2.63 3.59 4.18 5.03 1.32 1.07 3.48.24 3.48-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__gD)",
    stroke: "url(#fish_svg__gE)",
    d: "M1168.41 1432.96c-.12-9.34 4.54-18.56 12.92-23.94 7.9-5.15 17.48-5.75 25.62-2.52 2.27.96 4.42-1.31 3.47-3.59-.84-1.91-1.92-3.83-3.23-5.63-6.95-9.45-19.15-13.4-30.17-10.41 1.2-9.34-1.19-20.35-7.66-30.41 6.35-2.27 11.97-3.95 17.36-.12 1.55 1.2 3.83-.24 3.47-2.15-.24-1.44-.6-2.88-1.2-4.31-4.67-12.93-18.67-19.64-31.24-14.97a24.5 24.5 0 0 0-6.82 3.95c-2.87-1.31-5.86-2.27-8.98-2.51-6.22-1.32-12.32-.48-17.35 2.75-2.03 1.32-3.83 3-5.39 4.91-7.66 10.18-7.06 27.54 2.4 42.62l.36.48c8.97 14 23.1 21.91 35.07 20.83-1.68 7.18-.48 14.84 3.71 21.55 1.19 1.91 2.63 3.59 4.19 5.02 1.31.96 3.47.24 3.47-1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__gF)",
    stroke: "url(#fish_svg__gG)",
    d: "M1325.92 1475.58c-.12-9.34 4.55-18.56 12.92-23.95 7.9-5.14 17.48-5.74 25.62-2.51 2.27.96 4.43-1.32 3.47-3.59-.84-1.92-1.92-3.83-3.23-5.63-6.94-9.46-19.15-13.41-30.16-10.41 1.19-9.34-1.2-20.35-7.66-30.41 6.34-2.27 11.96-3.95 17.35-.12 1.56 1.2 3.83-.24 3.47-2.15-.24-1.44-.6-2.88-1.2-4.31-4.66-12.93-18.67-19.64-31.23-14.97-2.52.96-4.79 2.28-6.83 3.95-2.87-1.31-5.86-2.27-8.97-2.51-6.23-1.32-12.33-.48-17.36 2.75-2.03 1.32-3.83 2.99-5.38 4.91-7.66 10.18-7.07 27.53 2.39 42.62l.36.48c8.98 14 23.1 21.9 35.07 20.83-1.68 7.18-.48 14.84 3.71 21.54 1.19 1.92 2.63 3.6 4.19 5.03 1.31.96 3.47.12 3.47-1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__gH)",
    stroke: "url(#fish_svg__gI)",
    d: "M1483.43 1518.19c-.12-9.33 4.55-18.55 12.92-23.94 7.9-5.15 17.48-5.75 25.62-2.51 2.27.95 4.43-1.32 3.47-3.59-.84-1.92-1.92-3.84-3.23-5.63-6.94-9.46-19.15-13.41-30.16-10.42 1.19-9.33-1.2-20.35-7.66-30.4 6.34-2.28 11.96-3.95 17.35-.12 1.56 1.19 3.83-.24 3.47-2.16-.24-1.43-.6-2.87-1.19-4.31-4.67-12.93-18.68-19.63-31.24-14.96a24.2 24.2 0 0 0-6.83 3.95c-2.87-1.32-5.86-2.27-8.97-2.51-6.23-1.32-12.33-.48-17.36 2.75-2.03 1.32-3.83 2.99-5.38 4.91-7.66 10.17-7.07 27.53 2.39 42.61l.36.48c8.98 14.01 23.1 21.91 35.07 20.83-1.68 7.19-.48 14.85 3.71 21.55 1.2 1.92 2.63 3.59 4.19 5.03 1.31.96 3.47.12 3.47-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__gJ)",
    stroke: "url(#fish_svg__gK)",
    d: "M1640.94 1560.81c-.12-9.34 4.55-18.55 12.93-23.94 7.9-5.15 17.47-5.75 25.61-2.52 2.27.96 4.43-1.31 3.47-3.59-.84-1.91-1.91-3.83-3.23-5.62-6.94-9.46-19.15-13.41-30.16-10.42 1.19-9.34-1.2-20.35-7.66-30.4 6.34-2.28 11.97-3.96 17.35-.12 1.56 1.19 3.83-.24 3.47-2.16-.24-1.44-.6-2.87-1.19-4.31-4.67-12.93-18.68-19.63-31.24-14.96-2.52.95-4.79 2.27-6.83 3.95-2.87-1.32-5.86-2.28-8.97-2.52-6.23-1.31-12.33-.48-17.36 2.76-2.03 1.31-3.83 2.99-5.38 4.9-7.66 10.18-7.06 27.54 2.39 42.62l.36.48c8.98 14.01 23.1 21.91 35.07 20.83-1.68 7.18-.48 14.85 3.71 21.55 1.2 1.92 2.63 3.59 4.19 5.03 1.31.96 3.47.12 3.47-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__gL)",
    stroke: "url(#fish_svg__gM)",
    d: "M441.653 1344.49c-.119-9.34 4.548-18.55 12.927-23.94 7.899-5.15 17.474-5.75 25.613-2.52 2.274.96 4.429-1.31 3.471-3.59a29.6 29.6 0 0 0-3.231-5.62c-6.942-9.46-19.151-13.41-30.162-10.42 1.197-9.34-1.197-20.35-7.66-30.41 6.343-2.27 11.969-3.95 17.355-.12 1.556 1.2 3.83-.23 3.471-2.15-.24-1.44-.599-2.87-1.197-4.31-4.668-12.93-18.672-19.63-31.239-14.96a23.9 23.9 0 0 0-6.822 3.95c-2.873-1.32-5.865-2.28-8.977-2.52-6.224-1.31-12.328-.48-17.355 2.76-2.035 1.31-3.83 2.99-5.386 4.9-7.66 10.18-7.062 27.54 2.394 42.62l.359.48c8.977 14.01 23.1 21.91 35.069 20.83-1.676 7.18-.479 14.85 3.71 21.55a24.9 24.9 0 0 0 4.189 5.03c1.317 1.07 3.471.24 3.471-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__gN)",
    stroke: "url(#fish_svg__gO)",
    d: "M599.164 1387.11c-.12-9.34 4.548-18.56 12.926-23.94 7.9-5.15 17.475-5.75 25.614-2.52 2.274.96 4.428-1.31 3.471-3.59a30 30 0 0 0-3.232-5.63c-6.942-9.45-19.15-13.4-30.161-10.41 1.197-9.34-1.197-20.35-7.66-30.41 6.343-2.27 11.968-3.95 17.354-.12 1.556 1.2 3.83-.24 3.471-2.15-.239-1.44-.598-2.88-1.196-4.31-4.668-12.93-18.672-19.63-31.239-14.97a24.4 24.4 0 0 0-6.823 3.95c-2.872-1.31-5.864-2.27-8.976-2.51-6.224-1.32-12.328-.48-17.355 2.75-2.035 1.32-3.83 3-5.386 4.91-7.66 10.18-7.062 27.54 2.393 42.62l.36.48c8.976 14.01 23.1 21.91 35.069 20.83-1.676 7.18-.479 14.84 3.71 21.55a24.5 24.5 0 0 0 4.189 5.02c1.317 1.08 3.471.24 3.471-1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__gP)",
    stroke: "url(#fish_svg__gQ)",
    d: "M756.676 1429.73c-.12-9.34 4.548-18.56 12.926-23.95 7.9-5.14 17.475-5.74 25.614-2.51 2.274.96 4.428-1.32 3.471-3.59a29.7 29.7 0 0 0-3.232-5.63c-6.942-9.46-19.15-13.41-30.162-10.41 1.197-9.34-1.197-20.35-7.66-30.41 6.344-2.27 11.969-3.95 17.355-.12 1.556 1.2 3.83-.24 3.471-2.15-.239-1.44-.598-2.88-1.197-4.31-4.668-12.93-18.671-19.64-31.239-14.97a24.4 24.4 0 0 0-6.822 3.95c-2.872-1.31-5.865-2.27-8.977-2.51-6.223-1.32-12.328-.48-17.355 2.75-2.034 1.32-3.83 2.99-5.386 4.91-7.66 10.18-7.061 27.53 2.394 42.62l.359.48c8.977 14 23.1 21.9 35.069 20.83-1.675 7.18-.479 14.84 3.711 21.54a24.3 24.3 0 0 0 4.189 5.03c1.316.96 3.471.24 3.471-1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__gR)",
    stroke: "url(#fish_svg__gS)",
    d: "M914.186 1472.34c-.119-9.33 4.549-18.55 12.927-23.94 7.899-5.15 17.475-5.74 25.613-2.51 2.274.96 4.429-1.32 3.471-3.59a29.6 29.6 0 0 0-3.231-5.63c-6.942-9.46-19.151-13.41-30.162-10.42 1.197-9.33-1.197-20.35-7.66-30.4 6.343-2.28 11.969-3.95 17.355-.12 1.556 1.19 3.83-.24 3.471-2.16-.239-1.43-.599-2.87-1.197-4.31-4.668-12.93-18.671-19.63-31.239-14.96a24.2 24.2 0 0 0-6.822 3.95c-2.873-1.32-5.865-2.27-8.977-2.51-6.224-1.32-12.328-.48-17.355 2.75-2.035 1.32-3.83 2.99-5.386 4.91-7.66 10.17-7.061 27.53 2.394 42.62l.359.47c8.977 14.01 23.1 21.91 35.069 20.83-1.676 7.19-.479 14.85 3.71 21.55a24.6 24.6 0 0 0 4.189 5.03c1.317.96 3.471.12 3.471-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__gT)",
    stroke: "url(#fish_svg__gU)",
    d: "M1071.7 1514.96c-.12-9.34 4.55-18.55 12.92-23.94 7.9-5.15 17.48-5.75 25.62-2.51 2.27.95 4.43-1.32 3.47-3.6-.84-1.91-1.92-3.83-3.23-5.62-6.95-9.46-19.15-13.41-30.17-10.42 1.2-9.34-1.19-20.35-7.66-30.4 6.35-2.28 11.97-3.96 17.36-.12 1.56 1.19 3.83-.24 3.47-2.16-.24-1.44-.6-2.87-1.2-4.31-4.66-12.93-18.67-19.63-31.24-14.96-2.51.95-4.78 2.27-6.82 3.95-2.87-1.32-5.86-2.28-8.97-2.52-6.23-1.31-12.33-.48-17.36 2.76-2.03 1.31-3.83 2.99-5.39 4.91-7.66 10.17-7.06 27.53 2.4 42.61l.36.48c8.97 14.01 23.1 21.91 35.07 20.83-1.68 7.18-.48 14.85 3.71 21.55 1.19 1.92 2.63 3.59 4.19 5.03 1.31.96 3.47.12 3.47-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__gV)",
    stroke: "url(#fish_svg__gW)",
    d: "M1229.21 1557.58c-.12-9.34 4.55-18.56 12.93-23.94 7.89-5.15 17.47-5.75 25.61-2.52 2.27.96 4.43-1.31 3.47-3.59-.84-1.91-1.92-3.83-3.23-5.63-6.94-9.45-19.15-13.4-30.16-10.41 1.19-9.34-1.2-20.35-7.66-30.41 6.34-2.27 11.97-3.95 17.35-.12 1.56 1.2 3.83-.24 3.47-2.15-.24-1.44-.6-2.87-1.19-4.31-4.67-12.93-18.68-19.63-31.24-14.97-2.52.96-4.79 2.28-6.83 3.96-2.87-1.32-5.86-2.28-8.97-2.52-6.23-1.32-12.33-.48-17.36 2.75-2.03 1.32-3.83 3-5.38 4.91-7.66 10.18-7.07 27.54 2.39 42.62l.36.48c8.98 14.01 23.1 21.91 35.07 20.83-1.68 7.18-.48 14.84 3.71 21.55 1.2 1.91 2.63 3.59 4.19 5.03 1.31.95 3.47.12 3.47-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__gX)",
    stroke: "url(#fish_svg__gY)",
    d: "M1386.72 1600.2c-.12-9.34 4.55-18.56 12.93-23.95 7.9-5.14 17.47-5.74 25.61-2.51 2.27.96 4.43-1.32 3.47-3.59-.84-1.92-1.91-3.83-3.23-5.63-6.94-9.45-19.15-13.41-30.16-10.41 1.19-9.34-1.2-20.35-7.66-30.41 6.34-2.27 11.97-3.95 17.35-.12 1.56 1.2 3.83-.24 3.47-2.15-.24-1.44-.6-2.88-1.19-4.31-4.67-12.93-18.68-19.64-31.24-14.97-2.52.96-4.79 2.28-6.82 3.95-2.88-1.31-5.87-2.27-8.98-2.51-6.23-1.32-12.33-.48-17.36 2.75-2.03 1.32-3.83 3-5.38 4.91-7.66 10.18-7.06 27.53 2.39 42.62l.36.48c8.98 14 23.1 21.9 35.07 20.83-1.68 7.18-.48 14.84 3.71 21.55a24.5 24.5 0 0 0 4.19 5.02c1.32.96 3.47.12 3.47-1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__gZ)",
    stroke: "url(#fish_svg__ha)",
    d: "M1544.23 1642.69c-.12-9.33 4.55-18.55 12.93-23.94 7.9-5.15 17.47-5.74 25.61-2.51 2.27.96 4.43-1.32 3.47-3.59-.84-1.92-1.91-3.83-3.23-5.63-6.94-9.46-19.15-13.41-30.16-10.41 1.19-9.34-1.2-20.36-7.66-30.41 6.34-2.28 11.97-3.95 17.35-.12 1.56 1.2 3.83-.24 3.47-2.16-.24-1.43-.59-2.87-1.19-4.31-4.67-12.92-18.67-19.63-31.24-14.96-2.52.96-4.79 2.27-6.82 3.95-2.88-1.32-5.87-2.27-8.98-2.51-6.22-1.32-12.33-.48-17.36 2.75-2.03 1.32-3.83 2.99-5.38 4.91-7.66 10.17-7.06 27.53 2.39 42.62l.36.47c8.98 14.01 23.1 21.91 35.07 20.83-1.68 7.19-.48 14.85 3.71 21.55 1.2 1.92 2.63 3.59 4.19 5.03 1.32 1.08 3.47.24 3.47-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__hb)",
    stroke: "url(#fish_svg__hc)",
    d: "M344.944 1426.49c-.119-9.33 4.548-18.55 12.927-23.94 7.899-5.15 17.474-5.74 25.613-2.51 2.274.96 4.429-1.32 3.471-3.59a29.7 29.7 0 0 0-3.231-5.63c-6.942-9.46-19.151-13.41-30.162-10.42 1.197-9.33-1.197-20.35-7.66-30.4 6.343-2.28 11.969-3.95 17.355-.12 1.556 1.19 3.83-.24 3.471-2.16-.24-1.43-.599-2.87-1.197-4.31-4.668-12.93-18.672-19.63-31.239-14.96-2.514.96-4.788 2.27-6.822 3.95-2.873-1.32-5.865-2.27-8.977-2.51-6.224-1.32-12.328-.48-17.355 2.75-2.035 1.32-3.83 2.99-5.386 4.91-7.66 10.17-7.062 27.53 2.394 42.62l.359.47c8.977 14.01 23.1 21.91 35.069 20.83-1.676 7.19-.479 14.85 3.71 21.55a24.6 24.6 0 0 0 4.189 5.03c1.437.96 3.471.12 3.471-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__hd)",
    stroke: "url(#fish_svg__he)",
    d: "M502.455 1469.11c-.12-9.34 4.548-18.55 12.926-23.94 7.9-5.15 17.475-5.75 25.614-2.51 2.274.95 4.428-1.32 3.471-3.6a29.6 29.6 0 0 0-3.232-5.62c-6.942-9.46-19.15-13.41-30.161-10.42 1.197-9.34-1.197-20.35-7.66-30.4 6.343-2.28 11.968-3.96 17.354-.12 1.556 1.19 3.831-.24 3.471-2.16-.239-1.44-.598-2.87-1.196-4.31-4.668-12.93-18.672-19.63-31.239-14.96a24 24 0 0 0-6.823 3.95c-2.872-1.32-5.864-2.28-8.976-2.52-6.224-1.31-12.328-.48-17.355 2.76-2.035 1.31-3.83 2.99-5.386 4.91-7.66 10.17-7.062 27.53 2.394 42.61l.359.48c8.976 14.01 23.1 21.91 35.069 20.83-1.676 7.18-.479 14.85 3.71 21.55a24.6 24.6 0 0 0 4.189 5.03c1.436.96 3.471.12 3.471-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__hf)",
    stroke: "url(#fish_svg__hg)",
    d: "M659.967 1511.73c-.12-9.34 4.548-18.56 12.926-23.94 7.9-5.15 17.475-5.75 25.614-2.52 2.274.96 4.428-1.31 3.471-3.59a30 30 0 0 0-3.232-5.63c-6.942-9.45-19.15-13.4-30.162-10.41 1.197-9.34-1.197-20.35-7.66-30.41 6.344-2.27 11.969-3.95 17.355-.12 1.556 1.2 3.83-.24 3.471-2.15-.239-1.44-.598-2.87-1.197-4.31-4.668-12.93-18.671-19.63-31.239-14.97a24.2 24.2 0 0 0-6.822 3.96c-2.872-1.32-5.865-2.28-8.977-2.52-6.223-1.32-12.328-.48-17.355 2.75-2.034 1.32-3.83 3-5.386 4.91-7.66 10.18-7.061 27.54 2.394 42.62l.359.48c8.977 14.01 23.1 21.91 35.069 20.83-1.675 7.18-.478 14.84 3.711 21.55a24.9 24.9 0 0 0 4.189 5.03c1.436.95 3.471.12 3.471-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__hh)",
    stroke: "url(#fish_svg__hi)",
    d: "M817.477 1554.35c-.119-9.34 4.549-18.56 12.927-23.95 7.899-5.14 17.475-5.74 25.613-2.51 2.275.96 4.429-1.32 3.471-3.59a29.6 29.6 0 0 0-3.231-5.63c-6.942-9.45-19.15-13.41-30.162-10.41 1.197-9.34-1.197-20.35-7.66-30.41 6.343-2.27 11.969-3.95 17.355-.12 1.556 1.2 3.83-.24 3.471-2.15-.239-1.44-.599-2.88-1.197-4.31-4.668-12.93-18.672-19.64-31.239-14.97a24.4 24.4 0 0 0-6.822 3.95c-2.873-1.31-5.865-2.27-8.977-2.51-6.224-1.32-12.328-.48-17.355 2.75-2.035 1.32-3.83 3-5.386 4.91-7.66 10.18-7.061 27.53 2.394 42.62l.359.48c8.977 14 23.1 21.9 35.069 20.83-1.676 7.18-.479 14.84 3.71 21.55a24.5 24.5 0 0 0 4.189 5.02c1.437.96 3.471.12 3.471-1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__hj)",
    stroke: "url(#fish_svg__hk)",
    d: "M974.988 1596.84c-.12-9.33 4.548-18.55 12.927-23.94 7.899-5.15 17.475-5.74 25.615-2.51 2.27.96 4.43-1.32 3.47-3.59-.84-1.92-1.92-3.83-3.23-5.63-6.94-9.46-19.153-13.41-30.164-10.41 1.197-9.34-1.197-20.36-7.66-30.41 6.343-2.28 11.969-3.95 17.355-.12 1.556 1.2 3.83-.24 3.471-2.16-.24-1.43-.599-2.87-1.197-4.31-4.668-12.92-18.672-19.63-31.239-14.96-2.514.96-4.788 2.27-6.822 3.95-2.873-1.32-5.865-2.27-8.977-2.51-6.224-1.32-12.328-.48-17.355 2.75-2.035 1.32-3.83 2.99-5.386 4.91-7.66 10.17-7.062 27.53 2.394 42.62l.359.47c8.976 14.01 23.1 21.91 35.069 20.83-1.676 7.19-.479 14.85 3.71 21.55a24.6 24.6 0 0 0 4.189 5.03c1.437 1.08 3.471.24 3.471-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__hl)",
    stroke: "url(#fish_svg__hm)",
    d: "M1132.5 1639.46c-.12-9.34 4.55-18.55 12.93-23.94 7.9-5.15 17.47-5.75 25.61-2.51 2.27.95 4.43-1.32 3.47-3.6-.84-1.91-1.91-3.83-3.23-5.62-6.94-9.46-19.15-13.41-30.16-10.42 1.19-9.33-1.2-20.35-7.66-30.4 6.34-2.28 11.97-3.95 17.35-.12 1.56 1.19 3.83-.24 3.47-2.16-.24-1.44-.6-2.87-1.19-4.31-4.67-12.93-18.68-19.63-31.24-14.96-2.52.96-4.79 2.27-6.82 3.95-2.88-1.32-5.87-2.28-8.98-2.52-6.23-1.31-12.33-.47-17.36 2.76-2.03 1.31-3.83 2.99-5.38 4.91-7.66 10.17-7.06 27.53 2.39 42.61l.36.48c8.98 14.01 23.1 21.91 35.07 20.83-1.68 7.19-.48 14.85 3.71 21.55 1.2 1.92 2.63 3.59 4.19 5.03 1.44 1.08 3.47.24 3.47-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__hn)",
    stroke: "url(#fish_svg__ho)",
    d: "M1290.01 1682.08c-.12-9.34 4.55-18.56 12.93-23.94 7.9-5.15 17.47-5.75 25.61-2.52 2.27.96 4.43-1.31 3.47-3.59-.84-1.91-1.91-3.83-3.23-5.62-6.94-9.46-19.15-13.41-30.16-10.42 1.2-9.34-1.2-20.35-7.66-30.41 6.34-2.27 11.97-3.95 17.35-.12 1.56 1.2 3.83-.24 3.47-2.15-.24-1.44-.59-2.87-1.19-4.31-4.67-12.93-18.67-19.63-31.24-14.96-2.52.95-4.79 2.27-6.82 3.95-2.88-1.32-5.87-2.28-8.98-2.52-6.22-1.31-12.33-.48-17.36 2.76-2.03 1.31-3.83 2.99-5.38 4.9-7.66 10.18-7.06 27.54 2.39 42.62l.36.48c8.98 14.01 23.1 21.91 35.07 20.83-1.68 7.18-.48 14.84 3.71 21.55 1.2 1.91 2.63 3.59 4.19 5.03 1.44 1.07 3.47.24 3.47-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__hp)",
    stroke: "url(#fish_svg__hq)",
    d: "M1447.52 1724.7c-.12-9.34 4.55-18.56 12.93-23.94 7.9-5.15 17.47-5.75 25.61-2.52 2.28.96 4.43-1.32 3.47-3.59-.83-1.92-1.91-3.83-3.23-5.63-6.94-9.45-19.15-13.4-30.16-10.41 1.2-9.34-1.2-20.35-7.66-30.41 6.34-2.27 11.97-3.95 17.35-.12 1.56 1.2 3.83-.24 3.48-2.15-.24-1.44-.6-2.88-1.2-4.31-4.67-12.93-18.67-19.64-31.24-14.97-2.51.96-4.79 2.28-6.82 3.95-2.87-1.31-5.87-2.27-8.98-2.51-6.22-1.32-12.33-.48-17.35 2.75-2.04 1.32-3.83 3-5.39 4.91-7.66 10.18-7.06 27.54 2.39 42.62l.36.48c8.98 14 23.1 21.91 35.07 20.83-1.67 7.18-.48 14.84 3.71 21.55 1.2 1.91 2.64 3.59 4.19 5.02 1.44.96 3.47.24 3.47-1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__hr)",
    stroke: "url(#fish_svg__hs)",
    d: "M248.355 1508.5c-.119-9.34 4.549-18.56 12.927-23.95 7.899-5.14 17.474-5.74 25.613-2.51 2.274.96 4.429-1.32 3.471-3.59a29.6 29.6 0 0 0-3.231-5.63c-6.942-9.45-19.151-13.41-30.162-10.41 1.197-9.34-1.197-20.35-7.66-30.41 6.343-2.27 11.969-3.95 17.355-.12 1.556 1.2 3.83-.24 3.471-2.15-.24-1.44-.599-2.88-1.197-4.31-4.668-12.93-18.672-19.64-31.239-14.97a24.4 24.4 0 0 0-6.822 3.95c-2.873-1.31-5.865-2.27-8.977-2.51-6.224-1.32-12.328-.48-17.355 2.75-2.035 1.32-3.83 3-5.386 4.91-7.66 10.18-7.062 27.53 2.394 42.62l.359.48c8.977 14 23.1 21.9 35.069 20.83-1.676 7.18-.479 14.84 3.71 21.55a24.5 24.5 0 0 0 4.189 5.02c1.317.96 3.471.12 3.471-1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__ht)",
    stroke: "url(#fish_svg__hu)",
    d: "M405.747 1550.99c-.12-9.33 4.548-18.55 12.926-23.94 7.9-5.15 17.475-5.74 25.614-2.51 2.274.96 4.428-1.32 3.471-3.59a29.7 29.7 0 0 0-3.232-5.63c-6.942-9.46-19.15-13.41-30.161-10.41 1.197-9.34-1.197-20.36-7.66-30.41 6.343-2.28 11.968-3.95 17.354-.12 1.556 1.2 3.831-.24 3.471-2.16-.239-1.43-.598-2.87-1.196-4.31-4.668-12.92-18.672-19.63-31.239-14.96a24.2 24.2 0 0 0-6.823 3.95c-2.872-1.32-5.864-2.27-8.976-2.51-6.224-1.32-12.328-.48-17.355 2.75-2.035 1.32-3.83 2.99-5.386 4.91-7.66 10.17-7.062 27.53 2.394 42.62l.359.48c8.976 14 23.1 21.9 35.069 20.82-1.676 7.19-.479 14.85 3.71 21.55a24.6 24.6 0 0 0 4.189 5.03c1.436 1.08 3.591.24 3.471-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__hv)",
    stroke: "url(#fish_svg__hw)",
    d: "M563.258 1593.61c-.12-9.34 4.548-18.55 12.926-23.94 7.9-5.15 17.475-5.75 25.614-2.51 2.274.95 4.428-1.32 3.471-3.6a29.6 29.6 0 0 0-3.232-5.62c-6.942-9.46-19.15-13.41-30.162-10.42 1.197-9.33-1.197-20.35-7.66-30.4 6.344-2.28 11.969-3.95 17.355-.12 1.556 1.19 3.83-.24 3.471-2.16-.239-1.43-.598-2.87-1.197-4.31-4.668-12.93-18.671-19.63-31.239-14.96a24.2 24.2 0 0 0-6.822 3.95c-2.872-1.32-5.865-2.28-8.977-2.52-6.223-1.31-12.328-.47-17.355 2.76-2.034 1.31-3.83 2.99-5.386 4.91-7.66 10.17-7.061 27.53 2.394 42.61l.359.48c8.977 14.01 23.1 21.91 35.069 20.83-1.675 7.19-.478 14.85 3.711 21.55a24.6 24.6 0 0 0 4.189 5.03c1.436 1.08 3.59.24 3.471-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__hx)",
    stroke: "url(#fish_svg__hy)",
    d: "M720.77 1636.23c-.12-9.34 4.548-18.56 12.926-23.94 7.899-5.15 17.475-5.75 25.613-2.52 2.275.96 4.429-1.31 3.471-3.59a29.6 29.6 0 0 0-3.231-5.62c-6.942-9.46-19.15-13.41-30.162-10.42 1.197-9.34-1.197-20.35-7.66-30.41 6.344-2.27 11.969-3.95 17.355-.12 1.556 1.2 3.83-.24 3.471-2.15-.239-1.44-.598-2.87-1.197-4.31-4.668-12.93-18.671-19.63-31.239-14.96a24 24 0 0 0-6.822 3.95c-2.873-1.32-5.865-2.28-8.977-2.52-6.224-1.31-12.328-.48-17.355 2.76-2.035 1.31-3.83 2.99-5.386 4.9-7.66 10.18-7.061 27.54 2.394 42.62l.359.48c8.977 14.01 23.1 21.91 35.069 20.83-1.676 7.18-.479 14.84 3.71 21.55a25 25 0 0 0 4.189 5.03c1.437 1.07 3.591.24 3.472-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__hz)",
    stroke: "url(#fish_svg__hA)",
    d: "M878.28 1678.85c-.12-9.34 4.548-18.56 12.927-23.94 7.899-5.15 17.474-5.75 25.613-2.52 2.274.96 4.429-1.32 3.471-3.59a29.7 29.7 0 0 0-3.231-5.63c-6.942-9.45-19.151-13.4-30.162-10.41 1.197-9.34-1.197-20.35-7.66-30.41 6.343-2.27 11.969-3.95 17.355-.12 1.556 1.2 3.83-.24 3.471-2.15-.24-1.44-.599-2.88-1.197-4.31-4.668-12.93-18.672-19.64-31.239-14.97a24.4 24.4 0 0 0-6.822 3.95c-2.873-1.31-5.865-2.27-8.977-2.51-6.224-1.32-12.328-.48-17.355 2.75-2.035 1.32-3.83 3-5.386 4.91-7.66 10.18-7.062 27.54 2.394 42.62l.359.48c8.976 14 23.1 21.91 35.069 20.83-1.676 7.18-.479 14.84 3.71 21.55a24.5 24.5 0 0 0 4.189 5.02c1.437.96 3.591.24 3.471-1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__hB)",
    stroke: "url(#fish_svg__hC)",
    d: "M1035.79 1721.47c-.12-9.34 4.55-18.56 12.93-23.95 7.9-5.14 17.47-5.74 25.61-2.51 2.27.96 4.43-1.32 3.47-3.59-.84-1.92-1.91-3.83-3.23-5.63-6.94-9.46-19.15-13.41-30.16-10.41 1.2-9.34-1.2-20.35-7.66-30.41 6.34-2.28 11.97-3.95 17.35-.12 1.56 1.2 3.83-.24 3.47-2.16-.23-1.43-.59-2.87-1.19-4.3-4.67-12.93-18.67-19.64-31.24-14.97-2.51.96-4.79 2.28-6.82 3.95-2.88-1.32-5.87-2.27-8.98-2.51-6.22-1.32-12.328-.48-17.355 2.75-2.035 1.32-3.83 2.99-5.386 4.91-7.66 10.17-7.062 27.53 2.393 42.62l.36.48c8.976 14 23.098 21.9 35.068 20.83-1.68 7.18-.48 14.84 3.71 21.54 1.2 1.92 2.63 3.6 4.19 5.03 1.44.96 3.59.24 3.47-1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__hD)",
    stroke: "url(#fish_svg__hE)",
    d: "M1193.3 1764.08c-.12-9.33 4.55-18.55 12.93-23.94 7.9-5.15 17.47-5.75 25.61-2.51 2.28.95 4.43-1.32 3.47-3.59-.83-1.92-1.91-3.84-3.23-5.63-6.94-9.46-19.15-13.41-30.16-10.42 1.2-9.33-1.2-20.35-7.66-30.4 6.34-2.28 11.97-3.95 17.36-.12 1.55 1.19 3.83-.24 3.47-2.16-.24-1.43-.6-2.87-1.2-4.31-4.67-12.93-18.67-19.63-31.24-14.96-2.51.96-4.79 2.27-6.82 3.95-2.87-1.32-5.87-2.28-8.98-2.51-6.22-1.32-12.33-.48-17.35 2.75-2.04 1.32-3.83 2.99-5.39 4.91-7.66 10.17-7.06 27.53 2.39 42.61l.36.48c8.98 14.01 23.1 21.91 35.07 20.83-1.67 7.19-.48 14.85 3.71 21.55 1.2 1.92 2.64 3.59 4.19 5.03 1.44.96 3.59.12 3.47-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__hF)",
    stroke: "url(#fish_svg__hG)",
    d: "M1350.81 1806.7c-.12-9.34 4.55-18.55 12.93-23.94 7.9-5.15 17.47-5.75 25.61-2.52 2.28.96 4.43-1.31 3.47-3.59-.83-1.91-1.91-3.83-3.23-5.62-6.94-9.46-19.15-13.41-30.16-10.42 1.2-9.34-1.2-20.35-7.66-30.41 6.34-2.27 11.97-3.95 17.36-.12 1.55 1.2 3.83-.23 3.47-2.15-.24-1.44-.6-2.87-1.2-4.31-4.67-12.93-18.67-19.63-31.24-14.96a23.9 23.9 0 0 0-6.82 3.95c-2.87-1.32-5.87-2.28-8.98-2.52-6.22-1.31-12.33-.48-17.35 2.76-2.04 1.31-3.83 2.99-5.39 4.9-7.66 10.18-7.06 27.54 2.39 42.62l.36.48c8.98 14.01 23.1 21.91 35.07 20.83-1.67 7.18-.48 14.85 3.71 21.55 1.2 1.91 2.64 3.59 4.19 5.03 1.44.95 3.59.12 3.47-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__hH)",
    stroke: "url(#fish_svg__hI)",
    d: "M151.646 1590.38c-.119-9.34 4.549-18.56 12.927-23.94 7.899-5.15 17.475-5.75 25.613-2.52 2.274.96 4.429-1.31 3.471-3.59a29.6 29.6 0 0 0-3.231-5.62c-6.942-9.46-19.151-13.41-30.162-10.42 1.197-9.34-1.197-20.35-7.66-30.41 6.343-2.27 11.969-3.95 17.355-.12 1.556 1.2 3.83-.24 3.471-2.15-.24-1.44-.599-2.87-1.197-4.31-4.668-12.93-18.672-19.63-31.239-14.96a24 24 0 0 0-6.822 3.95c-2.873-1.32-5.865-2.28-8.977-2.52-6.224-1.31-12.328-.48-17.355 2.76-2.035 1.31-3.83 2.99-5.386 4.9-7.66 10.18-7.061 27.54 2.394 42.62l.359.48c8.977 14.01 23.1 21.91 35.069 20.83-1.676 7.18-.479 14.84 3.71 21.55a24.9 24.9 0 0 0 4.189 5.03c1.317 1.07 3.471.24 3.471-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__hJ)",
    stroke: "url(#fish_svg__hK)",
    d: "M309.157 1633c-.12-9.34 4.548-18.56 12.927-23.94 7.899-5.15 17.474-5.75 25.613-2.52 2.274.96 4.429-1.32 3.471-3.59a29.7 29.7 0 0 0-3.231-5.63c-6.942-9.45-19.151-13.4-30.162-10.41 1.197-9.34-1.197-20.35-7.66-30.41 6.343-2.27 11.969-3.95 17.355-.12 1.556 1.2 3.83-.24 3.471-2.15-.24-1.44-.599-2.88-1.197-4.31-4.668-12.93-18.672-19.64-31.239-14.97a24.4 24.4 0 0 0-6.822 3.95c-2.873-1.31-5.865-2.27-8.977-2.51-6.224-1.32-12.328-.48-17.355 2.75-2.035 1.32-3.83 3-5.386 4.91-7.66 10.18-7.062 27.54 2.394 42.62l.359.48c8.976 14 23.1 21.91 35.069 20.83-1.676 7.18-.479 14.84 3.71 21.55a24.5 24.5 0 0 0 4.189 5.02c1.317 1.08 3.471.24 3.471-1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__hL)",
    stroke: "url(#fish_svg__hM)",
    d: "M466.669 1675.62c-.12-9.34 4.548-18.56 12.926-23.95 7.9-5.14 17.475-5.74 25.614-2.51 2.274.96 4.428-1.32 3.471-3.59a29.7 29.7 0 0 0-3.232-5.63c-6.942-9.46-19.15-13.41-30.161-10.41 1.196-9.34-1.197-20.35-7.661-30.41 6.344-2.28 11.969-3.95 17.355-.12 1.556 1.2 3.83-.24 3.471-2.16-.239-1.43-.598-2.87-1.197-4.3-4.667-12.93-18.671-19.64-31.238-14.97a24.4 24.4 0 0 0-6.823 3.95c-2.872-1.32-5.865-2.27-8.976-2.51-6.224-1.32-12.328-.48-17.355 2.75-2.035 1.32-3.83 2.99-5.386 4.91-7.661 10.17-7.062 27.53 2.393 42.62l.359.48c8.977 14 23.1 21.9 35.069 20.83-1.675 7.18-.478 14.84 3.711 21.54a24.3 24.3 0 0 0 4.189 5.03c1.316.96 3.471.24 3.471-1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__hN)",
    stroke: "url(#fish_svg__hO)",
    d: "M624.18 1718.23c-.12-9.33 4.548-18.55 12.926-23.94 7.9-5.15 17.475-5.75 25.614-2.51 2.274.95 4.428-1.32 3.471-3.59a29.3 29.3 0 0 0-3.232-5.63c-6.942-9.46-19.15-13.41-30.162-10.42 1.197-9.33-1.197-20.35-7.66-30.4 6.344-2.28 11.969-3.95 17.355-.12 1.556 1.19 3.83-.24 3.471-2.16-.239-1.43-.598-2.87-1.197-4.31-4.668-12.93-18.671-19.63-31.239-14.96a24.2 24.2 0 0 0-6.822 3.95c-2.873-1.32-5.865-2.28-8.977-2.51-6.224-1.32-12.328-.48-17.355 2.75-2.034 1.32-3.83 2.99-5.386 4.91-7.66 10.17-7.061 27.53 2.394 42.61l.359.48c8.977 14.01 23.1 21.91 35.069 20.83-1.675 7.19-.479 14.85 3.71 21.55a24.6 24.6 0 0 0 4.19 5.03c1.316.96 3.471.12 3.471-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__hP)",
    stroke: "url(#fish_svg__hQ)",
    d: "M781.69 1760.85c-.119-9.34 4.549-18.55 12.927-23.94 7.899-5.15 17.474-5.75 25.613-2.52 2.274.96 4.429-1.31 3.471-3.59a29.6 29.6 0 0 0-3.231-5.62c-6.942-9.46-19.151-13.41-30.162-10.42 1.197-9.34-1.197-20.35-7.66-30.41 6.343-2.27 11.969-3.95 17.355-.11 1.556 1.19 3.83-.24 3.471-2.16-.24-1.44-.599-2.87-1.197-4.31-4.668-12.93-18.672-19.63-31.239-14.96a23.9 23.9 0 0 0-6.822 3.95c-2.873-1.32-5.865-2.28-8.977-2.52-6.224-1.31-12.328-.48-17.355 2.76-2.035 1.31-3.83 2.99-5.386 4.9-7.66 10.18-7.062 27.54 2.394 42.62l.359.48c8.977 14.01 23.1 21.91 35.069 20.83-1.676 7.18-.479 14.85 3.71 21.55a24.9 24.9 0 0 0 4.189 5.03c1.317.95 3.471.12 3.471-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__hR)",
    stroke: "url(#fish_svg__hS)",
    d: "M939.202 1803.47c-.12-9.34 4.548-18.56 12.927-23.94 7.899-5.15 17.474-5.75 25.613-2.52 2.274.96 4.429-1.31 3.471-3.59a30 30 0 0 0-3.232-5.63c-6.942-9.45-19.15-13.4-30.161-10.41 1.197-9.34-1.197-20.35-7.66-30.41 6.343-2.27 11.969-3.95 17.355-.12 1.556 1.2 3.83-.24 3.471-2.15-.24-1.44-.599-2.88-1.197-4.31-4.668-12.93-18.672-19.63-31.239-14.97a24.4 24.4 0 0 0-6.823 3.95c-2.872-1.31-5.864-2.27-8.976-2.51-6.224-1.32-12.328-.48-17.355 2.75-2.035 1.32-3.83 3-5.386 4.91-7.66 10.18-7.062 27.54 2.394 42.62l.359.48c8.976 14.01 23.1 21.91 35.069 20.83-1.676 7.18-.479 14.84 3.71 21.55a24.5 24.5 0 0 0 4.189 5.02c1.317.96 3.471.12 3.471-1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__hT)",
    stroke: "url(#fish_svg__hU)",
    d: "M1096.71 1846.09c-.12-9.34 4.55-18.56 12.93-23.95 7.9-5.14 17.47-5.74 25.61-2.51 2.28.96 4.43-1.32 3.47-3.59-.83-1.92-1.91-3.83-3.23-5.63-6.94-9.46-19.15-13.41-30.16-10.41 1.2-9.34-1.2-20.35-7.66-30.41 6.34-2.27 11.97-3.95 17.36-.12 1.55 1.2 3.83-.24 3.47-2.15-.24-1.44-.6-2.88-1.2-4.31-4.67-12.93-18.67-19.64-31.24-14.97-2.51.96-4.79 2.28-6.82 3.95-2.87-1.31-5.87-2.27-8.98-2.51-6.22-1.32-12.33-.48-17.35 2.75-2.04 1.32-3.83 2.99-5.39 4.91-7.66 10.18-7.06 27.53 2.39 42.62l.36.48c8.98 14 23.1 21.9 35.07 20.83-1.67 7.18-.48 14.84 3.71 21.54 1.2 1.92 2.64 3.6 4.19 5.03 1.32.96 3.47.12 3.47-1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__hV)",
    stroke: "url(#fish_svg__hW)",
    d: "M1254.22 1888.58c-.12-9.33 4.55-18.55 12.93-23.94 7.9-5.15 17.48-5.74 25.61-2.51 2.28.96 4.43-1.32 3.48-3.59-.84-1.92-1.92-3.83-3.24-5.63-6.94-9.46-19.15-13.41-30.16-10.42 1.2-9.33-1.19-20.35-7.66-30.4 6.35-2.28 11.97-3.95 17.36-.12 1.55 1.2 3.83-.24 3.47-2.16-.24-1.43-.6-2.87-1.2-4.31-4.67-12.93-18.67-19.63-31.24-14.96-2.51.96-4.79 2.27-6.82 3.95-2.87-1.32-5.86-2.27-8.98-2.51-6.22-1.32-12.32-.48-17.35 2.75-2.04 1.32-3.83 2.99-5.39 4.91-7.66 10.17-7.06 27.53 2.4 42.62l.36.47c8.97 14.01 23.1 21.91 35.06 20.83-1.67 7.19-.47 14.85 3.71 21.55 1.2 1.92 2.64 3.59 4.19 5.03 1.32 1.08 3.47.24 3.47-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__hX)",
    stroke: "url(#fish_svg__hY)",
    d: "M54.937 1672.38c-.12-9.33 4.549-18.55 12.927-23.94 7.9-5.15 17.474-5.75 25.613-2.51 2.274.95 4.429-1.32 3.471-3.59a29.4 29.4 0 0 0-3.231-5.63c-6.942-9.46-19.15-13.41-30.162-10.42 1.197-9.33-1.197-20.35-7.66-30.4 6.343-2.28 11.969-3.95 17.355-.12 1.556 1.19 3.83-.24 3.47-2.16-.239-1.43-.598-2.87-1.196-4.31-4.668-12.93-18.672-19.63-31.239-14.96a24.2 24.2 0 0 0-6.822 3.95c-2.873-1.32-5.865-2.28-8.977-2.51-6.224-1.32-12.328-.48-17.355 2.75-2.035 1.32-3.83 2.99-5.386 4.91-7.66 10.17-7.062 27.53 2.394 42.61l.359.48c8.977 14.01 23.1 21.91 35.069 20.83-1.676 7.19-.479 14.85 3.71 21.55a24.6 24.6 0 0 0 4.19 5.03c1.436.96 3.47.12 3.47-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__hZ)",
    stroke: "url(#fish_svg__ia)",
    d: "M212.448 1715c-.12-9.34 4.548-18.55 12.927-23.94 7.899-5.15 17.474-5.75 25.613-2.52 2.274.96 4.429-1.31 3.471-3.59a29.6 29.6 0 0 0-3.231-5.62c-6.942-9.46-19.151-13.41-30.162-10.42 1.197-9.34-1.197-20.35-7.66-30.41 6.343-2.27 11.969-3.95 17.355-.12 1.556 1.2 3.83-.23 3.471-2.15-.24-1.44-.599-2.87-1.197-4.31-4.668-12.93-18.672-19.63-31.239-14.96a23.9 23.9 0 0 0-6.822 3.95c-2.873-1.32-5.865-2.28-8.977-2.52-6.224-1.31-12.328-.48-17.355 2.76-2.035 1.31-3.83 2.99-5.386 4.9-7.66 10.18-7.062 27.54 2.394 42.62l.359.48c8.976 14.01 23.1 21.91 35.069 20.83-1.676 7.18-.479 14.85 3.71 21.55a24.9 24.9 0 0 0 4.189 5.03c1.436.95 3.471.12 3.471-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__ib)",
    stroke: "url(#fish_svg__ic)",
    d: "M369.96 1757.62c-.12-9.34 4.548-18.56 12.926-23.94 7.9-5.15 17.475-5.75 25.614-2.52 2.274.96 4.428-1.31 3.471-3.59a30 30 0 0 0-3.232-5.63c-6.942-9.45-19.15-13.4-30.161-10.41 1.196-9.34-1.197-20.35-7.661-30.41 6.344-2.27 11.969-3.95 17.355-.12 1.556 1.2 3.83-.24 3.471-2.15-.239-1.44-.598-2.88-1.197-4.31-4.667-12.93-18.671-19.63-31.238-14.97a24.4 24.4 0 0 0-6.823 3.95c-2.872-1.31-5.865-2.27-8.976-2.51-6.224-1.32-12.328-.48-17.355 2.75-2.035 1.32-3.83 3-5.386 4.91-7.661 10.18-7.062 27.54 2.393 42.62l.359.48c8.977 14.01 23.1 21.91 35.069 20.83-1.675 7.18-.478 14.84 3.711 21.55a24.5 24.5 0 0 0 4.189 5.02c1.436.96 3.471.12 3.471-1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__id)",
    stroke: "url(#fish_svg__ie)",
    d: "M527.471 1800.24c-.12-9.34 4.548-18.56 12.926-23.95 7.9-5.14 17.475-5.74 25.614-2.51 2.274.96 4.428-1.32 3.471-3.59a29.7 29.7 0 0 0-3.232-5.63c-6.942-9.46-19.15-13.41-30.162-10.41 1.197-9.34-1.197-20.35-7.66-30.41 6.344-2.27 11.969-3.95 17.355-.12 1.556 1.2 3.83-.24 3.471-2.15-.239-1.44-.598-2.88-1.197-4.31-4.668-12.93-18.671-19.64-31.239-14.97a24.4 24.4 0 0 0-6.822 3.95c-2.873-1.31-5.865-2.27-8.977-2.51-6.224-1.32-12.328-.48-17.355 2.75-2.034 1.32-3.83 2.99-5.386 4.91-7.66 10.18-7.061 27.53 2.394 42.62l.359.48c8.977 14 23.1 21.9 35.069 20.83-1.675 7.18-.479 14.84 3.711 21.54a24.3 24.3 0 0 0 4.189 5.03c1.436.96 3.471.12 3.471-1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__if)",
    stroke: "url(#fish_svg__ig)",
    d: "M684.981 1842.73c-.119-9.33 4.549-18.55 12.927-23.94 7.899-5.15 17.474-5.74 25.613-2.51 2.274.96 4.429-1.32 3.471-3.59a29.6 29.6 0 0 0-3.231-5.63c-6.942-9.46-19.151-13.41-30.162-10.42 1.197-9.33-1.197-20.35-7.66-30.4 6.343-2.28 11.969-3.95 17.355-.12 1.556 1.2 3.83-.24 3.471-2.16-.24-1.43-.599-2.87-1.197-4.31-4.668-12.93-18.672-19.63-31.239-14.96-2.513.96-4.788 2.27-6.822 3.95-2.873-1.32-5.865-2.27-8.977-2.51-6.224-1.32-12.328-.48-17.355 2.75-2.035 1.32-3.83 2.99-5.386 4.91-7.66 10.17-7.062 27.53 2.394 42.62l.359.47c8.977 14.01 23.1 21.91 35.069 20.83-1.676 7.19-.479 14.85 3.71 21.55a24.6 24.6 0 0 0 4.189 5.03c1.437 1.08 3.471.24 3.471-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__ih)",
    stroke: "url(#fish_svg__ii)",
    d: "M842.493 1885.35c-.12-9.34 4.548-18.55 12.927-23.94 7.899-5.15 17.474-5.75 25.613-2.51 2.274.95 4.429-1.32 3.471-3.6a29.6 29.6 0 0 0-3.232-5.62c-6.942-9.46-19.15-13.41-30.161-10.42 1.197-9.34-1.197-20.35-7.66-30.4 6.343-2.28 11.969-3.96 17.355-.12 1.556 1.19 3.83-.24 3.471-2.16-.24-1.44-.599-2.87-1.197-4.31-4.668-12.93-18.672-19.63-31.239-14.96a24 24 0 0 0-6.823 3.95c-2.872-1.32-5.864-2.28-8.976-2.52-6.224-1.31-12.328-.48-17.355 2.76-2.035 1.31-3.83 2.99-5.386 4.91-7.66 10.17-7.062 27.53 2.394 42.61l.359.48c8.976 14.01 23.1 21.91 35.069 20.83-1.676 7.18-.479 14.85 3.71 21.55a24.6 24.6 0 0 0 4.189 5.03c1.317 1.08 3.471.24 3.471-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__ij)",
    stroke: "url(#fish_svg__ik)",
    d: "M1000 1927.97c-.116-9.34 4.55-18.56 12.93-23.94 7.9-5.15 17.47-5.75 25.61-2.52 2.28.96 4.43-1.31 3.47-3.59-.83-1.91-1.91-3.83-3.23-5.62-6.94-9.46-19.15-13.41-30.16-10.42 1.2-9.34-1.2-20.35-7.66-30.41 6.34-2.27 11.97-3.95 17.36-.12 1.55 1.2 3.83-.24 3.47-2.15-.24-1.44-.6-2.87-1.2-4.31-4.67-12.93-18.67-19.63-31.239-14.97a24.2 24.2 0 0 0-6.822 3.96c-2.872-1.32-5.865-2.28-8.976-2.52-6.224-1.32-12.328-.48-17.355 2.75-2.035 1.32-3.83 3-5.386 4.91-7.661 10.18-7.062 27.54 2.393 42.62l.359.48c8.977 14.01 23.1 21.91 35.069 20.83-1.675 7.18-.478 14.84 3.711 21.55a24.9 24.9 0 0 0 4.189 5.03c1.316 1.07 3.467.24 3.467-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__il)",
    stroke: "url(#fish_svg__im)",
    d: "M1157.52 1970.59c-.12-9.34 4.54-18.56 12.92-23.95 7.9-5.14 17.48-5.74 25.62-2.51 2.27.96 4.42-1.32 3.47-3.59-.84-1.92-1.92-3.83-3.24-5.63-6.94-9.45-19.15-13.4-30.16-10.41 1.2-9.34-1.19-20.35-7.66-30.41 6.35-2.27 11.97-3.95 17.36-.12 1.55 1.2 3.83-.24 3.47-2.15-.24-1.44-.6-2.88-1.2-4.31-4.67-12.93-18.67-19.64-31.24-14.97a24.5 24.5 0 0 0-6.82 3.95c-2.87-1.31-5.86-2.27-8.98-2.51-6.22-1.32-12.32-.48-17.35 2.75-2.04 1.32-3.83 3-5.39 4.91-7.66 10.18-7.06 27.53 2.4 42.62l.36.48c8.97 14 23.1 21.9 35.07 20.83-1.68 7.18-.48 14.84 3.71 21.55 1.19 1.91 2.63 3.59 4.18 5.02 1.32.96 3.48.24 3.48-1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__in)",
    stroke: "url(#fish_svg__io)",
    d: "M2168.77 1276.61c-.12-9.33 4.55-18.55 12.93-23.94 7.9-5.15 17.47-5.74 25.61-2.51 2.27.96 4.43-1.32 3.47-3.59-.84-1.92-1.91-3.83-3.23-5.63-6.94-9.46-19.15-13.41-30.16-10.42 1.19-9.33-1.2-20.35-7.66-30.4 6.34-2.28 11.97-3.95 17.35-.12 1.56 1.2 3.83-.24 3.47-2.16-.24-1.43-.6-2.87-1.19-4.31-4.67-12.93-18.68-19.63-31.24-14.96a24.2 24.2 0 0 0-6.83 3.95c-2.87-1.32-5.86-2.27-8.97-2.51-6.23-1.32-12.33-.48-17.36 2.75-2.03 1.32-3.83 2.99-5.38 4.91-7.66 10.17-7.06 27.53 2.39 42.62l.36.47c8.98 14.01 23.1 21.91 35.07 20.83-1.68 7.19-.48 14.85 3.71 21.55 1.2 1.92 2.63 3.59 4.19 5.03 1.43.96 3.47.12 3.47-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__ip)",
    stroke: "url(#fish_svg__iq)",
    d: "M2326.28 1319.11c-.12-9.34 4.55-18.55 12.93-23.94 7.9-5.15 17.47-5.75 25.61-2.51 2.28.95 4.43-1.32 3.47-3.6-.84-1.91-1.91-3.83-3.23-5.62-6.94-9.46-19.15-13.41-30.16-10.42 1.2-9.33-1.2-20.35-7.66-30.4 6.34-2.28 11.97-3.95 17.35-.12 1.56 1.19 3.83-.24 3.47-2.16-.23-1.44-.59-2.87-1.19-4.31-4.67-12.93-18.67-19.63-31.24-14.96-2.51.96-4.79 2.27-6.82 3.95-2.88-1.32-5.87-2.28-8.98-2.52-6.22-1.31-12.33-.47-17.36 2.76-2.03 1.31-3.83 2.99-5.38 4.91-7.66 10.17-7.06 27.53 2.39 42.61l.36.48c8.98 14.01 23.1 21.91 35.07 20.83-1.67 7.18-.48 14.85 3.71 21.55 1.2 1.92 2.63 3.59 4.19 5.03 1.44 1.08 3.47.24 3.47-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__ir)",
    stroke: "url(#fish_svg__is)",
    d: "M2483.79 1361.73c-.12-9.34 4.55-18.56 12.93-23.94 7.9-5.15 17.47-5.75 25.61-2.52 2.27.96 4.43-1.31 3.47-3.59-.84-1.91-1.91-3.83-3.23-5.62-6.94-9.46-19.15-13.41-30.16-10.42 1.2-9.34-1.2-20.35-7.66-30.41 6.34-2.27 11.97-3.95 17.35-.12 1.56 1.2 3.83-.24 3.47-2.15-.24-1.44-.59-2.87-1.19-4.31-4.67-12.93-18.67-19.63-31.24-14.97-2.51.96-4.79 2.28-6.82 3.96-2.88-1.32-5.87-2.28-8.98-2.52-6.22-1.32-12.33-.48-17.36 2.75-2.03 1.32-3.83 3-5.38 4.91-7.66 10.18-7.06 27.54 2.39 42.62l.36.48c8.98 14.01 23.1 21.91 35.07 20.83-1.68 7.18-.48 14.84 3.71 21.55 1.2 1.91 2.63 3.59 4.19 5.03 1.44 1.07 3.47.24 3.47-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__it)",
    stroke: "url(#fish_svg__iu)",
    d: "M2641.3 1404.35c-.12-9.34 4.55-18.56 12.93-23.95 7.9-5.14 17.47-5.74 25.61-2.51 2.28.96 4.43-1.32 3.47-3.59-.83-1.92-1.91-3.83-3.23-5.63-6.94-9.45-19.15-13.4-30.16-10.41 1.2-9.34-1.2-20.35-7.66-30.41 6.34-2.27 11.97-3.95 17.36-.12 1.55 1.2 3.83-.24 3.47-2.15-.24-1.44-.6-2.88-1.2-4.31-4.67-12.93-18.67-19.64-31.24-14.97-2.51.96-4.79 2.28-6.82 3.95-2.87-1.31-5.87-2.27-8.98-2.51-6.22-1.32-12.33-.48-17.35 2.75-2.04 1.32-3.83 3-5.39 4.91-7.66 10.18-7.06 27.53 2.39 42.62l.36.48c8.98 14 23.1 21.9 35.07 20.83-1.67 7.18-.48 14.84 3.71 21.55 1.2 1.91 2.64 3.59 4.19 5.02 1.44 1.08 3.47.24 3.47-1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__iv)",
    stroke: "url(#fish_svg__iw)",
    d: "M2798.81 1446.96c-.12-9.33 4.55-18.55 12.93-23.94 7.9-5.15 17.48-5.74 25.61-2.51 2.28.96 4.43-1.32 3.48-3.59-.84-1.92-1.92-3.83-3.24-5.63-6.94-9.46-19.15-13.41-30.16-10.41 1.2-9.34-1.19-20.36-7.66-30.41 6.35-2.28 11.97-3.95 17.36-.12 1.55 1.2 3.83-.24 3.47-2.16-.24-1.43-.6-2.87-1.2-4.31-4.67-12.92-18.67-19.63-31.24-14.96-2.51.96-4.79 2.27-6.82 3.95-2.87-1.32-5.87-2.27-8.98-2.51-6.22-1.32-12.32-.48-17.35 2.75-2.04 1.32-3.83 2.99-5.39 4.91-7.66 10.17-7.06 27.53 2.4 42.62l.36.47c8.97 14.01 23.09 21.91 35.06 20.83-1.67 7.19-.47 14.85 3.71 21.55 1.2 1.92 2.64 3.59 4.19 5.03 1.44.96 3.47.24 3.47-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__ix)",
    stroke: "url(#fish_svg__iy)",
    d: "M2956.32 1489.58c-.12-9.34 4.55-18.55 12.93-23.94 7.9-5.15 17.48-5.75 25.61-2.51 2.28.95 4.43-1.32 3.48-3.6-.84-1.91-1.92-3.83-3.24-5.62-6.94-9.46-19.15-13.41-30.16-10.42 1.2-9.33-1.19-20.35-7.66-30.4 6.35-2.28 11.97-3.95 17.36-.12 1.55 1.19 3.83-.24 3.47-2.16-.24-1.43-.6-2.87-1.2-4.31-4.67-12.93-18.67-19.63-31.24-14.96-2.51.96-4.79 2.27-6.82 3.95-2.87-1.32-5.87-2.28-8.98-2.52-6.22-1.31-12.33-.47-17.35 2.76-2.04 1.31-3.83 2.99-5.39 4.91-7.66 10.17-7.06 27.53 2.4 42.61l.35.48c8.98 14.01 23.1 21.91 35.07 20.83-1.67 7.19-.47 14.85 3.71 21.55 1.2 1.92 2.64 3.59 4.19 5.03 1.44.96 3.47.12 3.47-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__iz)",
    stroke: "url(#fish_svg__iA)",
    d: "M3113.84 1532.2c-.12-9.34 4.54-18.56 12.92-23.94 7.9-5.15 17.48-5.75 25.62-2.52 2.27.96 4.42-1.31 3.47-3.59-.84-1.91-1.92-3.83-3.23-5.62-6.95-9.46-19.16-13.41-30.17-10.42 1.2-9.34-1.19-20.35-7.66-30.41 6.35-2.27 11.97-3.95 17.36-.12 1.55 1.2 3.83-.24 3.47-2.15-.24-1.44-.6-2.87-1.2-4.31-4.67-12.93-18.67-19.63-31.24-14.96-2.51.95-4.78 2.27-6.82 3.95-2.87-1.32-5.86-2.28-8.98-2.52-6.22-1.31-12.32-.48-17.35 2.76-2.04 1.31-3.83 2.99-5.39 4.9-7.66 10.18-7.06 27.54 2.4 42.62l.36.48c8.97 14.01 23.1 21.91 35.07 20.83-1.68 7.18-.48 14.84 3.71 21.55 1.19 1.91 2.63 3.59 4.18 5.03 1.44.95 3.48.12 3.48-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__iB)",
    stroke: "url(#fish_svg__iC)",
    d: "M3271.35 1574.82c-.12-9.34 4.55-18.56 12.92-23.94 7.9-5.15 17.48-5.75 25.62-2.52 2.27.96 4.43-1.32 3.47-3.59-.84-1.92-1.92-3.83-3.23-5.63-6.95-9.45-19.15-13.4-30.17-10.41 1.2-9.34-1.19-20.35-7.66-30.41 6.35-2.27 11.97-3.95 17.36-.12 1.56 1.2 3.83-.24 3.47-2.15-.24-1.44-.6-2.88-1.2-4.31-4.66-12.93-18.67-19.64-31.23-14.97-2.52.96-4.79 2.28-6.83 3.95-2.87-1.31-5.86-2.27-8.97-2.51-6.23-1.32-12.33-.48-17.36 2.75-2.03 1.32-3.83 3-5.38 4.91-7.66 10.18-7.07 27.54 2.39 42.62l.36.48c8.97 14 23.1 21.91 35.07 20.83-1.68 7.18-.48 14.84 3.71 21.55 1.19 1.91 2.63 3.59 4.19 5.02 1.43.96 3.47.12 3.47-1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__iD)",
    stroke: "url(#fish_svg__iE)",
    d: "M2072.18 1358.5c-.12-9.34 4.55-18.56 12.93-23.95 7.9-5.14 17.47-5.74 25.61-2.51 2.27.96 4.43-1.32 3.47-3.59-.84-1.92-1.91-3.83-3.23-5.63-6.94-9.45-19.15-13.4-30.16-10.41 1.19-9.34-1.2-20.35-7.66-30.41 6.34-2.27 11.97-3.95 17.35-.12 1.56 1.2 3.83-.24 3.47-2.15-.24-1.44-.6-2.88-1.19-4.31-4.67-12.93-18.68-19.64-31.24-14.97-2.52.96-4.79 2.28-6.83 3.95-2.87-1.31-5.86-2.27-8.97-2.51-6.23-1.32-12.33-.48-17.36 2.75-2.03 1.32-3.83 3-5.38 4.91-7.66 10.18-7.06 27.53 2.39 42.62l.36.48c8.98 14 23.1 21.9 35.07 20.83-1.68 7.18-.48 14.84 3.71 21.55a24.5 24.5 0 0 0 4.19 5.02c1.32 1.08 3.47.24 3.47-1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__iF)",
    stroke: "url(#fish_svg__iG)",
    d: "M2229.69 1401.11c-.12-9.33 4.55-18.55 12.93-23.94 7.9-5.15 17.47-5.74 25.61-2.51 2.28.96 4.43-1.32 3.47-3.59-.84-1.92-1.91-3.83-3.23-5.63-6.94-9.46-19.15-13.41-30.16-10.41 1.2-9.34-1.2-20.36-7.66-30.41 6.34-2.28 11.97-3.95 17.35-.12 1.56 1.2 3.83-.24 3.47-2.16-.23-1.43-.59-2.87-1.19-4.31-4.67-12.92-18.67-19.63-31.24-14.96-2.51.96-4.79 2.27-6.82 3.95-2.88-1.32-5.87-2.27-8.98-2.51-6.22-1.32-12.33-.48-17.35 2.75-2.04 1.32-3.83 2.99-5.39 4.91-7.66 10.17-7.06 27.53 2.39 42.62l.36.48c8.98 14 23.1 21.9 35.07 20.83-1.67 7.18-.48 14.84 3.71 21.54 1.2 1.92 2.63 3.59 4.19 5.03 1.32.96 3.47.24 3.47-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__iH)",
    stroke: "url(#fish_svg__iI)",
    d: "M2387.2 1443.73c-.12-9.34 4.55-18.55 12.93-23.94 7.9-5.15 17.47-5.75 25.61-2.51 2.28.95 4.43-1.32 3.47-3.6-.84-1.91-1.91-3.83-3.23-5.62-6.94-9.46-19.15-13.41-30.16-10.42 1.2-9.33-1.2-20.35-7.66-30.4 6.34-2.28 11.97-3.95 17.35-.12 1.56 1.19 3.83-.24 3.47-2.16-.23-1.43-.59-2.87-1.19-4.31-4.67-12.93-18.67-19.63-31.24-14.96-2.51.96-4.79 2.27-6.82 3.95-2.88-1.32-5.87-2.28-8.98-2.52-6.22-1.31-12.33-.47-17.36 2.76-2.03 1.31-3.83 2.99-5.38 4.91-7.66 10.17-7.06 27.53 2.39 42.61l.36.48c8.98 14.01 23.1 21.91 35.07 20.83-1.68 7.19-.48 14.85 3.71 21.55 1.2 1.92 2.63 3.59 4.19 5.03 1.32.96 3.47.24 3.47-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__iJ)",
    stroke: "url(#fish_svg__iK)",
    d: "M2544.71 1486.35c-.12-9.34 4.55-18.56 12.93-23.94 7.9-5.15 17.47-5.75 25.61-2.52 2.28.96 4.43-1.31 3.47-3.59-.83-1.91-1.91-3.83-3.23-5.62-6.94-9.46-19.15-13.41-30.16-10.42 1.2-9.34-1.2-20.35-7.66-30.41 6.34-2.27 11.97-3.95 17.36-.12 1.55 1.2 3.83-.24 3.47-2.15-.24-1.44-.6-2.87-1.2-4.31-4.67-12.93-18.67-19.63-31.24-14.96a23.9 23.9 0 0 0-6.82 3.95c-2.87-1.32-5.87-2.28-8.98-2.52-6.22-1.31-12.33-.48-17.35 2.76-2.04 1.31-3.83 2.99-5.39 4.9-7.66 10.18-7.06 27.54 2.39 42.62l.36.48c8.98 14.01 23.1 21.91 35.07 20.83-1.67 7.18-.48 14.84 3.71 21.55 1.2 1.91 2.64 3.59 4.19 5.03 1.32.95 3.47.12 3.47-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__iL)",
    stroke: "url(#fish_svg__iM)",
    d: "M2702.22 1528.97c-.12-9.34 4.55-18.56 12.93-23.94 7.9-5.15 17.48-5.75 25.61-2.52 2.28.96 4.43-1.32 3.48-3.59-.84-1.92-1.92-3.83-3.24-5.63-6.94-9.45-19.15-13.4-30.16-10.41 1.2-9.34-1.19-20.35-7.66-30.41 6.35-2.27 11.97-3.95 17.36-.12 1.55 1.2 3.83-.24 3.47-2.15-.24-1.44-.6-2.88-1.2-4.31-4.67-12.93-18.67-19.64-31.24-14.97-2.51.96-4.79 2.28-6.82 3.95-2.87-1.31-5.86-2.27-8.98-2.51-6.22-1.32-12.32-.48-17.35 2.75-2.04 1.32-3.83 3-5.39 4.91-7.66 10.18-7.06 27.54 2.4 42.62l.35.48c8.98 14 23.1 21.91 35.07 20.83-1.67 7.18-.47 14.84 3.71 21.55 1.2 1.91 2.64 3.59 4.19 5.02 1.32.96 3.47.12 3.47-1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__iN)",
    stroke: "url(#fish_svg__iO)",
    d: "M2859.73 1571.59c-.12-9.34 4.55-18.56 12.93-23.95 7.9-5.14 17.48-5.74 25.61-2.51 2.28.96 4.43-1.32 3.48-3.59-.84-1.92-1.92-3.83-3.24-5.63-6.94-9.46-19.15-13.41-30.16-10.41 1.2-9.34-1.19-20.35-7.66-30.41 6.35-2.28 11.97-3.95 17.36-.12 1.55 1.2 3.83-.24 3.47-2.16-.24-1.43-.6-2.87-1.2-4.3-4.67-12.93-18.67-19.64-31.24-14.97-2.51.96-4.79 2.28-6.82 3.95-2.87-1.32-5.87-2.27-8.98-2.51-6.22-1.32-12.33-.48-17.35 2.75-2.04 1.32-3.83 2.99-5.39 4.91-7.66 10.17-7.06 27.53 2.4 42.62l.35.48c8.98 14 23.11 21.9 35.07 20.83-1.67 7.18-.47 14.84 3.71 21.54 1.2 1.92 2.64 3.6 4.19 5.03 1.32.96 3.47.12 3.47-1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__iP)",
    stroke: "url(#fish_svg__iQ)",
    d: "M3017.25 1614.08c-.12-9.33 4.54-18.55 12.92-23.94 7.9-5.15 17.48-5.75 25.62-2.51 2.27.95 4.42-1.32 3.47-3.59-.84-1.92-1.92-3.84-3.23-5.63-6.95-9.46-19.15-13.41-30.17-10.42 1.2-9.33-1.19-20.35-7.66-30.4 6.35-2.28 11.97-3.95 17.36-.12 1.55 1.19 3.83-.24 3.47-2.16-.24-1.43-.6-2.87-1.2-4.31-4.67-12.93-18.67-19.63-31.24-14.96-2.51.96-4.78 2.27-6.82 3.95-2.87-1.32-5.86-2.28-8.98-2.51-6.22-1.32-12.32-.48-17.35 2.75-2.03 1.32-3.83 2.99-5.39 4.91-7.66 10.17-7.06 27.53 2.4 42.61l.36.48c8.97 14.01 23.1 21.91 35.07 20.83-1.68 7.19-.48 14.85 3.71 21.55 1.19 1.92 2.63 3.59 4.18 5.03 1.32 1.08 3.48.24 3.48-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__iR)",
    stroke: "url(#fish_svg__iS)",
    d: "M3174.76 1656.7c-.12-9.34 4.55-18.55 12.92-23.94 7.9-5.15 17.48-5.75 25.62-2.52 2.27.96 4.43-1.31 3.47-3.59-.84-1.91-1.92-3.83-3.23-5.62-6.94-9.46-19.15-13.41-30.16-10.42 1.19-9.34-1.2-20.35-7.66-30.41 6.34-2.27 11.96-3.95 17.35-.11 1.56 1.19 3.83-.24 3.47-2.16-.24-1.44-.6-2.87-1.2-4.31-4.66-12.93-18.67-19.63-31.23-14.96-2.52.95-4.79 2.27-6.83 3.95-2.87-1.32-5.86-2.28-8.97-2.52-6.23-1.31-12.33-.48-17.36 2.76-2.03 1.31-3.83 2.99-5.38 4.9-7.66 10.18-7.07 27.54 2.39 42.62l.36.48c8.98 14.01 23.1 21.91 35.07 20.83-1.68 7.18-.48 14.85 3.71 21.55a24.5 24.5 0 0 0 4.19 5.03c1.31 1.07 3.47.24 3.47-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__iT)",
    stroke: "url(#fish_svg__iU)",
    d: "M1975.47 1440.5c-.12-9.34 4.55-18.56 12.93-23.94 7.9-5.15 17.47-5.75 25.61-2.52 2.27.96 4.43-1.31 3.47-3.59-.84-1.91-1.91-3.83-3.23-5.62-6.94-9.46-19.15-13.41-30.16-10.42 1.2-9.34-1.2-20.35-7.66-30.41 6.34-2.27 11.97-3.95 17.35-.12 1.56 1.2 3.83-.24 3.47-2.15-.24-1.44-.59-2.87-1.19-4.31-4.67-12.93-18.67-19.63-31.24-14.96-2.52.95-4.79 2.27-6.82 3.95-2.88-1.32-5.87-2.28-8.98-2.52-6.22-1.31-12.33-.48-17.36 2.76-2.03 1.31-3.83 2.99-5.38 4.9-7.66 10.18-7.06 27.54 2.39 42.62l.36.48c8.98 14.01 23.1 21.91 35.07 20.83-1.68 7.18-.48 14.84 3.71 21.55 1.2 1.91 2.63 3.59 4.19 5.03 1.32.95 3.47.12 3.47-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__iV)",
    stroke: "url(#fish_svg__iW)",
    d: "M2132.98 1483.12c-.12-9.34 4.55-18.56 12.93-23.94 7.9-5.15 17.47-5.75 25.61-2.52 2.28.96 4.43-1.32 3.47-3.59-.83-1.92-1.91-3.83-3.23-5.63-6.94-9.45-19.15-13.4-30.16-10.41 1.2-9.34-1.2-20.35-7.66-30.41 6.34-2.27 11.97-3.95 17.35-.12 1.56 1.2 3.83-.24 3.48-2.15-.24-1.44-.6-2.88-1.2-4.31-4.67-12.93-18.67-19.64-31.24-14.97-2.51.96-4.79 2.28-6.82 3.95-2.87-1.31-5.87-2.27-8.98-2.51-6.22-1.32-12.33-.48-17.35 2.75-2.04 1.32-3.83 3-5.39 4.91-7.66 10.18-7.06 27.54 2.39 42.62l.36.48c8.98 14 23.1 21.91 35.07 20.83-1.67 7.18-.48 14.84 3.71 21.55 1.2 1.91 2.64 3.59 4.19 5.02 1.32.96 3.47.12 3.47-1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__iX)",
    stroke: "url(#fish_svg__iY)",
    d: "M2290.49 1525.74c-.12-9.34 4.55-18.56 12.93-23.95 7.9-5.14 17.47-5.74 25.61-2.51 2.28.96 4.43-1.32 3.47-3.59-.83-1.92-1.91-3.83-3.23-5.63-6.94-9.46-19.15-13.41-30.16-10.41 1.2-9.34-1.2-20.35-7.66-30.41 6.34-2.28 11.97-3.95 17.35-.12 1.56 1.2 3.83-.24 3.48-2.16-.24-1.43-.6-2.87-1.2-4.3-4.67-12.93-18.67-19.64-31.24-14.97-2.51.96-4.79 2.28-6.82 3.95-2.88-1.32-5.87-2.27-8.98-2.51-6.22-1.32-12.33-.48-17.35 2.75-2.04 1.32-3.83 2.99-5.39 4.91-7.66 10.17-7.06 27.53 2.39 42.62l.36.48c8.98 14 23.1 21.9 35.07 20.83-1.67 7.18-.48 14.84 3.71 21.54 1.2 1.92 2.64 3.6 4.19 5.03 1.32.96 3.47.12 3.47-1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__iZ)",
    stroke: "url(#fish_svg__ja)",
    d: "M2448 1568.35c-.12-9.33 4.55-18.55 12.93-23.94 7.9-5.15 17.47-5.75 25.61-2.51 2.28.95 4.43-1.32 3.47-3.59-.83-1.92-1.91-3.84-3.23-5.63-6.94-9.46-19.15-13.41-30.16-10.42 1.2-9.33-1.2-20.35-7.66-30.4 6.34-2.28 11.97-3.95 17.36-.12 1.55 1.19 3.83-.24 3.47-2.16-.24-1.43-.6-2.87-1.2-4.31-4.67-12.93-18.67-19.63-31.24-14.96-2.51.96-4.79 2.27-6.82 3.95-2.87-1.32-5.87-2.28-8.98-2.51-6.22-1.32-12.33-.48-17.35 2.75-2.04 1.32-3.83 2.99-5.39 4.91-7.66 10.17-7.06 27.53 2.4 42.61l.35.48c8.98 14.01 23.1 21.91 35.07 20.83-1.67 7.19-.48 14.85 3.71 21.55 1.2 1.92 2.64 3.59 4.19 5.03 1.32.96 3.47.12 3.47-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__jb)",
    stroke: "url(#fish_svg__jc)",
    d: "M2605.52 1610.85c-.12-9.34 4.54-18.55 12.92-23.94 7.9-5.15 17.48-5.75 25.62-2.52 2.27.96 4.42-1.31 3.47-3.59-.84-1.91-1.92-3.83-3.24-5.62-6.94-9.46-19.15-13.41-30.16-10.42 1.2-9.34-1.19-20.35-7.66-30.41 6.35-2.27 11.97-3.95 17.36-.11 1.55 1.19 3.83-.24 3.47-2.16-.24-1.44-.6-2.87-1.2-4.31-4.67-12.93-18.67-19.63-31.24-14.96-2.51.95-4.78 2.27-6.82 3.95-2.87-1.32-5.86-2.28-8.98-2.52-6.22-1.31-12.32-.48-17.35 2.76-2.04 1.31-3.83 2.99-5.39 4.9-7.66 10.18-7.06 27.54 2.4 42.62l.36.48c8.97 14.01 23.1 21.91 35.06 20.83-1.67 7.18-.47 14.85 3.72 21.55 1.19 1.91 2.63 3.59 4.18 5.03 1.32 1.07 3.48.24 3.48-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__jd)",
    stroke: "url(#fish_svg__je)",
    d: "M2763.03 1653.47c-.12-9.34 4.54-18.56 12.92-23.94 7.9-5.15 17.48-5.75 25.62-2.52 2.27.96 4.42-1.31 3.47-3.59-.84-1.91-1.92-3.83-3.24-5.63-6.94-9.45-19.15-13.4-30.16-10.41 1.2-9.34-1.19-20.35-7.66-30.41 6.35-2.27 11.97-3.95 17.36-.12 1.55 1.2 3.83-.24 3.47-2.15-.24-1.44-.6-2.88-1.2-4.31-4.67-12.93-18.67-19.63-31.24-14.97a24.5 24.5 0 0 0-6.82 3.95c-2.87-1.31-5.86-2.27-8.98-2.51-6.22-1.32-12.32-.48-17.35 2.75-2.04 1.32-3.83 3-5.39 4.91-7.66 10.18-7.06 27.54 2.4 42.62l.36.48c8.97 14.01 23.1 21.91 35.06 20.83-1.67 7.18-.47 14.84 3.72 21.55 1.19 1.91 2.63 3.59 4.18 5.03 1.32 1.07 3.48.23 3.48-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__jf)",
    stroke: "url(#fish_svg__jg)",
    d: "M2920.54 1696.09c-.12-9.34 4.55-18.56 12.92-23.95 7.9-5.14 17.48-5.74 25.62-2.51 2.27.96 4.43-1.32 3.47-3.59-.84-1.92-1.92-3.83-3.23-5.63-6.95-9.46-19.15-13.41-30.17-10.41 1.2-9.34-1.19-20.35-7.66-30.41 6.35-2.27 11.97-3.95 17.36-.12 1.56 1.2 3.83-.24 3.47-2.15-.24-1.44-.6-2.88-1.2-4.31-4.66-12.93-18.67-19.64-31.24-14.97a24.5 24.5 0 0 0-6.82 3.95c-2.87-1.31-5.86-2.27-8.97-2.51-6.23-1.32-12.33-.48-17.36 2.75-2.03 1.32-3.83 2.99-5.39 4.91-7.66 10.18-7.06 27.53 2.4 42.62l.36.48c8.97 14 23.1 21.9 35.07 20.83-1.68 7.18-.48 14.84 3.71 21.54 1.19 1.92 2.63 3.6 4.19 5.03 1.31 1.08 3.47.24 3.47-1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__jh)",
    stroke: "url(#fish_svg__ji)",
    d: "M3078.05 1738.7c-.12-9.33 4.55-18.55 12.93-23.94 7.89-5.15 17.47-5.74 25.61-2.51 2.27.96 4.43-1.32 3.47-3.59-.84-1.92-1.92-3.83-3.23-5.63-6.94-9.46-19.15-13.41-30.16-10.42 1.19-9.33-1.2-20.35-7.66-30.4 6.34-2.28 11.97-3.95 17.35-.12 1.56 1.2 3.83-.24 3.47-2.16-.24-1.43-.6-2.87-1.19-4.31-4.67-12.93-18.68-19.63-31.24-14.96a24.2 24.2 0 0 0-6.83 3.95c-2.87-1.32-5.86-2.27-8.97-2.51-6.23-1.32-12.33-.48-17.36 2.75-2.03 1.32-3.83 2.99-5.38 4.91-7.66 10.17-7.07 27.53 2.39 42.62l.36.47c8.98 14.01 23.1 21.91 35.07 20.83-1.68 7.19-.48 14.85 3.71 21.55 1.2 1.92 2.63 3.59 4.19 5.03 1.31.96 3.47.24 3.47-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__jj)",
    stroke: "url(#fish_svg__jk)",
    d: "M1878.76 1522.5c-.12-9.33 4.55-18.55 12.93-23.94 7.9-5.15 17.47-5.75 25.61-2.51 2.28.95 4.43-1.32 3.47-3.59-.84-1.92-1.91-3.84-3.23-5.63-6.94-9.46-19.15-13.41-30.16-10.42 1.2-9.33-1.2-20.35-7.66-30.4 6.34-2.28 11.97-3.95 17.35-.12 1.56 1.19 3.83-.24 3.48-2.16-.24-1.43-.6-2.87-1.2-4.31-4.67-12.93-18.67-19.63-31.24-14.96-2.51.96-4.79 2.27-6.82 3.95-2.88-1.32-5.87-2.28-8.98-2.51-6.22-1.32-12.33-.48-17.35 2.75-2.04 1.32-3.83 2.99-5.39 4.91-7.66 10.17-7.06 27.53 2.39 42.61l.36.48c8.98 14.01 23.1 21.91 35.07 20.83-1.67 7.19-.48 14.85 3.71 21.55 1.2 1.92 2.63 3.59 4.19 5.03 1.44.96 3.47.12 3.47-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__jl)",
    stroke: "url(#fish_svg__jm)",
    d: "M2036.27 1565c-.12-9.34 4.55-18.55 12.93-23.94 7.9-5.15 17.47-5.75 25.61-2.52 2.28.96 4.43-1.31 3.47-3.59-.83-1.91-1.91-3.83-3.23-5.62-6.94-9.46-19.15-13.41-30.16-10.42 1.2-9.34-1.2-20.35-7.66-30.41 6.34-2.27 11.97-3.95 17.36-.11 1.55 1.19 3.83-.24 3.47-2.16-.24-1.44-.6-2.87-1.2-4.31-4.67-12.93-18.67-19.63-31.24-14.96a23.9 23.9 0 0 0-6.82 3.95c-2.87-1.32-5.87-2.28-8.98-2.52-6.22-1.31-12.33-.48-17.35 2.76-2.04 1.31-3.83 2.99-5.39 4.9-7.66 10.18-7.06 27.54 2.39 42.62l.36.48c8.98 14.01 23.1 21.91 35.07 20.83-1.67 7.18-.48 14.85 3.71 21.55 1.2 1.92 2.64 3.59 4.19 5.03 1.44 1.07 3.47.24 3.47-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__jn)",
    stroke: "url(#fish_svg__jo)",
    d: "M2193.78 1607.62c-.12-9.34 4.55-18.56 12.93-23.94 7.9-5.15 17.47-5.75 25.61-2.52 2.28.96 4.43-1.31 3.47-3.59-.83-1.91-1.91-3.83-3.23-5.63-6.94-9.45-19.15-13.4-30.16-10.41 1.2-9.34-1.2-20.35-7.66-30.41 6.34-2.27 11.97-3.95 17.36-.12 1.55 1.2 3.83-.24 3.47-2.15-.24-1.44-.6-2.87-1.2-4.31-4.67-12.93-18.67-19.63-31.24-14.97-2.51.96-4.79 2.28-6.82 3.95-2.87-1.31-5.87-2.27-8.98-2.51-6.22-1.32-12.33-.48-17.35 2.75-2.04 1.32-3.83 3-5.39 4.91-7.66 10.18-7.06 27.54 2.39 42.62l.36.48c8.98 14.01 23.1 21.91 35.07 20.83-1.67 7.18-.48 14.84 3.71 21.55 1.2 1.91 2.64 3.59 4.19 5.03 1.44 1.07 3.47.23 3.47-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__jp)",
    stroke: "url(#fish_svg__jq)",
    d: "M2351.29 1650.24c-.11-9.34 4.55-18.56 12.93-23.95 7.9-5.14 17.48-5.74 25.61-2.51 2.28.96 4.43-1.32 3.48-3.59-.84-1.92-1.92-3.83-3.24-5.63-6.94-9.46-19.15-13.41-30.16-10.41 1.2-9.34-1.19-20.35-7.66-30.41 6.35-2.27 11.97-3.95 17.36-.12 1.55 1.2 3.83-.24 3.47-2.15-.24-1.44-.6-2.88-1.2-4.31-4.67-12.93-18.67-19.64-31.24-14.97-2.51.96-4.79 2.28-6.82 3.95-2.87-1.31-5.86-2.27-8.98-2.51-6.22-1.32-12.32-.48-17.35 2.75-2.04 1.32-3.83 2.99-5.39 4.91-7.66 10.18-7.06 27.53 2.4 42.62l.36.48c8.97 14 23.1 21.9 35.06 20.83-1.67 7.18-.47 14.84 3.71 21.54 1.2 1.92 2.64 3.6 4.19 5.03 1.44 1.08 3.47.24 3.47-1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__jr)",
    stroke: "url(#fish_svg__js)",
    d: "M2508.81 1692.85c-.12-9.33 4.54-18.55 12.92-23.94 7.9-5.15 17.48-5.74 25.62-2.51 2.27.96 4.42-1.32 3.47-3.59-.84-1.92-1.92-3.83-3.23-5.63-6.95-9.46-19.15-13.41-30.17-10.42 1.2-9.33-1.19-20.35-7.66-30.4 6.35-2.28 11.97-3.95 17.36-.12 1.55 1.2 3.83-.24 3.47-2.16-.24-1.43-.6-2.87-1.2-4.31-4.66-12.93-18.67-19.63-31.24-14.96-2.51.96-4.78 2.27-6.82 3.95-2.87-1.32-5.86-2.27-8.97-2.51-6.23-1.32-12.33-.48-17.36 2.75-2.03 1.32-3.83 2.99-5.39 4.91-7.66 10.17-7.06 27.53 2.4 42.62l.36.47c8.97 14.01 23.1 21.91 35.07 20.83-1.68 7.19-.48 14.85 3.71 21.55 1.19 1.92 2.63 3.59 4.19 5.03 1.43.96 3.47.24 3.47-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__jt)",
    stroke: "url(#fish_svg__ju)",
    d: "M2666.32 1735.47c-.12-9.34 4.55-18.55 12.92-23.94 7.9-5.15 17.48-5.75 25.62-2.51 2.27.95 4.43-1.32 3.47-3.6-.84-1.91-1.92-3.83-3.23-5.62-6.94-9.46-19.15-13.41-30.16-10.42 1.19-9.34-1.2-20.35-7.66-30.4 6.34-2.28 11.96-3.96 17.35-.12 1.56 1.19 3.83-.24 3.47-2.16-.24-1.44-.6-2.87-1.2-4.31-4.66-12.93-18.67-19.63-31.23-14.96a24.2 24.2 0 0 0-6.83 3.95c-2.87-1.32-5.86-2.28-8.97-2.52-6.23-1.31-12.33-.47-17.36 2.76-2.03 1.31-3.83 2.99-5.38 4.91-7.66 10.17-7.07 27.53 2.39 42.61l.36.48c8.98 14.01 23.1 21.91 35.07 20.83-1.68 7.18-.48 14.85 3.71 21.55 1.2 1.92 2.63 3.59 4.19 5.03 1.43.96 3.47.24 3.47-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__jv)",
    stroke: "url(#fish_svg__jw)",
    d: "M2823.83 1778.09c-.12-9.34 4.55-18.56 12.92-23.94 7.9-5.15 17.48-5.75 25.62-2.52 2.27.96 4.43-1.31 3.47-3.59-.84-1.91-1.92-3.83-3.23-5.62-6.94-9.46-19.15-13.41-30.16-10.42 1.19-9.34-1.2-20.35-7.66-30.41 6.34-2.27 11.96-3.95 17.35-.12 1.56 1.2 3.83-.24 3.47-2.15-.24-1.44-.6-2.87-1.2-4.31-4.66-12.93-18.67-19.63-31.23-14.96-2.52.95-4.79 2.27-6.83 3.95-2.87-1.32-5.86-2.28-8.97-2.52-6.23-1.32-12.33-.48-17.36 2.75-2.03 1.32-3.83 3-5.38 4.91-7.66 10.18-7.07 27.54 2.39 42.62l.36.48c8.98 14.01 23.1 21.91 35.07 20.83-1.68 7.18-.48 14.84 3.71 21.55a24.5 24.5 0 0 0 4.19 5.03c1.43.95 3.47.12 3.47-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__jx)",
    stroke: "url(#fish_svg__jy)",
    d: "M2981.34 1820.71c-.12-9.34 4.55-18.56 12.93-23.95 7.9-5.14 17.47-5.74 25.61-2.51 2.27.96 4.43-1.32 3.47-3.59-.84-1.92-1.91-3.83-3.23-5.63-6.94-9.45-19.15-13.4-30.16-10.41 1.19-9.34-1.2-20.35-7.66-30.41 6.34-2.27 11.97-3.95 17.35-.12 1.56 1.2 3.83-.24 3.47-2.15-.24-1.44-.6-2.88-1.19-4.31-4.67-12.93-18.68-19.64-31.24-14.97-2.52.96-4.79 2.28-6.82 3.95-2.88-1.31-5.87-2.27-8.98-2.51-6.23-1.32-12.33-.48-17.36 2.75-2.03 1.32-3.83 3-5.38 4.91-7.66 10.18-7.06 27.53 2.39 42.62l.36.48c8.98 14 23.1 21.9 35.07 20.83-1.68 7.18-.48 14.84 3.71 21.55a24.5 24.5 0 0 0 4.19 5.02c1.44.96 3.47.12 3.47-1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__jz)",
    stroke: "url(#fish_svg__jA)",
    d: "M1782.17 1604.39c-.12-9.34 4.55-18.56 12.93-23.95 7.9-5.14 17.47-5.74 25.61-2.51 2.28.96 4.43-1.32 3.47-3.59-.83-1.92-1.91-3.83-3.23-5.63-6.94-9.45-19.15-13.41-30.16-10.41 1.2-9.34-1.2-20.35-7.66-30.41 6.34-2.27 11.97-3.95 17.36-.12 1.55 1.2 3.83-.24 3.47-2.15-.24-1.44-.6-2.88-1.2-4.31-4.67-12.93-18.67-19.64-31.24-14.97-2.51.96-4.79 2.28-6.82 3.95-2.87-1.31-5.87-2.27-8.98-2.51-6.22-1.32-12.33-.48-17.35 2.75-2.04 1.32-3.83 2.99-5.39 4.91-7.66 10.18-7.06 27.53 2.4 42.62l.35.48c8.98 14 23.1 21.9 35.07 20.83-1.67 7.18-.48 14.84 3.71 21.54 1.2 1.92 2.64 3.6 4.19 5.03 1.32 1.08 3.47.24 3.47-1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__jB)",
    stroke: "url(#fish_svg__jC)",
    d: "M1939.69 1647c-.12-9.33 4.54-18.55 12.92-23.94 7.9-5.15 17.48-5.74 25.62-2.51 2.27.96 4.42-1.32 3.47-3.59-.84-1.92-1.92-3.83-3.24-5.63-6.94-9.46-19.15-13.41-30.16-10.41 1.2-9.34-1.19-20.36-7.66-30.41 6.35-2.28 11.97-3.95 17.36-.12 1.55 1.2 3.83-.24 3.47-2.16-.24-1.43-.6-2.87-1.2-4.31-4.67-12.93-18.67-19.63-31.24-14.96-2.51.96-4.78 2.27-6.82 3.95-2.87-1.32-5.86-2.27-8.98-2.51-6.22-1.32-12.32-.48-17.35 2.75-2.04 1.32-3.83 2.99-5.39 4.91-7.66 10.17-7.06 27.53 2.4 42.62l.36.47c8.97 14.01 23.1 21.91 35.06 20.83-1.67 7.19-.47 14.85 3.72 21.55 1.19 1.92 2.63 3.59 4.18 5.03 1.32 1.08 3.48.24 3.48-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__jD)",
    stroke: "url(#fish_svg__jE)",
    d: "M2097.2 1689.62c-.12-9.34 4.54-18.55 12.92-23.94 7.9-5.15 17.48-5.75 25.62-2.51 2.27.95 4.42-1.32 3.47-3.6-.84-1.91-1.92-3.83-3.24-5.62-6.94-9.46-19.15-13.41-30.16-10.42 1.2-9.33-1.19-20.35-7.66-30.4 6.35-2.28 11.97-3.95 17.36-.12 1.55 1.19 3.83-.24 3.47-2.16-.24-1.44-.6-2.87-1.2-4.31-4.67-12.93-18.67-19.63-31.24-14.96-2.51.96-4.78 2.27-6.82 3.95-2.87-1.32-5.86-2.28-8.98-2.52-6.22-1.31-12.32-.47-17.35 2.76-2.04 1.31-3.83 2.99-5.39 4.91-7.66 10.17-7.06 27.53 2.4 42.61l.36.48c8.97 14.01 23.1 21.91 35.06 20.83-1.67 7.18-.47 14.85 3.72 21.55 1.19 1.92 2.63 3.59 4.18 5.03 1.32.96 3.48.24 3.48-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__jF)",
    stroke: "url(#fish_svg__jG)",
    d: "M2254.71 1732.24c-.12-9.34 4.55-18.56 12.92-23.94 7.9-5.15 17.48-5.75 25.62-2.52 2.27.96 4.43-1.31 3.47-3.59-.84-1.91-1.92-3.83-3.23-5.62-6.95-9.46-19.15-13.41-30.17-10.42 1.2-9.34-1.19-20.35-7.66-30.41 6.35-2.27 11.97-3.95 17.36-.12 1.56 1.2 3.83-.24 3.47-2.15-.24-1.44-.6-2.87-1.2-4.31-4.66-12.93-18.67-19.63-31.24-14.96-2.51.95-4.78 2.27-6.82 3.95-2.87-1.32-5.86-2.28-8.97-2.52-6.23-1.32-12.33-.48-17.36 2.75-2.03 1.32-3.83 3-5.39 4.91-7.66 10.18-7.06 27.54 2.4 42.62l.36.48c8.97 14.01 23.1 21.91 35.07 20.83-1.68 7.18-.48 14.84 3.71 21.55a24.5 24.5 0 0 0 4.19 5.03c1.31.95 3.47.12 3.47-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__jH)",
    stroke: "url(#fish_svg__jI)",
    d: "M2412.22 1774.86c-.12-9.34 4.55-18.56 12.93-23.95 7.89-5.14 17.47-5.74 25.61-2.51 2.27.96 4.43-1.32 3.47-3.59-.84-1.92-1.92-3.83-3.23-5.63-6.94-9.45-19.15-13.4-30.16-10.41 1.19-9.34-1.2-20.35-7.66-30.41 6.34-2.27 11.97-3.95 17.35-.12 1.56 1.2 3.83-.24 3.47-2.15-.24-1.44-.6-2.88-1.19-4.31-4.67-12.93-18.68-19.64-31.24-14.97-2.52.96-4.79 2.28-6.83 3.95-2.87-1.31-5.86-2.27-8.97-2.51-6.23-1.32-12.33-.48-17.36 2.75-2.03 1.32-3.83 3-5.38 4.91-7.66 10.18-7.07 27.53 2.39 42.62l.36.48c8.98 14 23.1 21.9 35.07 20.83-1.68 7.18-.48 14.84 3.71 21.55a24.5 24.5 0 0 0 4.19 5.02c1.31.96 3.47.12 3.47-1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__jJ)",
    stroke: "url(#fish_svg__jK)",
    d: "M2569.73 1817.47c-.12-9.33 4.55-18.55 12.93-23.94 7.89-5.15 17.47-5.74 25.61-2.51 2.27.96 4.43-1.32 3.47-3.59-.84-1.92-1.92-3.83-3.23-5.63-6.94-9.46-19.15-13.41-30.16-10.41 1.19-9.34-1.2-20.36-7.66-30.41 6.34-2.28 11.97-3.95 17.35-.12 1.56 1.2 3.83-.24 3.47-2.16-.24-1.43-.6-2.87-1.19-4.31-4.67-12.92-18.68-19.63-31.24-14.96a24.2 24.2 0 0 0-6.83 3.95c-2.87-1.32-5.86-2.27-8.97-2.51-6.23-1.32-12.33-.48-17.36 2.75-2.03 1.32-3.83 2.99-5.38 4.91-7.66 10.17-7.07 27.53 2.39 42.62l.36.48c8.98 14 23.1 21.9 35.07 20.83-1.68 7.18-.48 14.84 3.71 21.54 1.2 1.92 2.63 3.59 4.19 5.03 1.31.96 3.47.12 3.47-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__jL)",
    stroke: "url(#fish_svg__jM)",
    d: "M2727.24 1860.09c-.12-9.34 4.55-18.55 12.93-23.94 7.9-5.15 17.47-5.75 25.61-2.51 2.27.95 4.43-1.32 3.47-3.6-.84-1.91-1.91-3.83-3.23-5.62-6.94-9.46-19.15-13.41-30.16-10.42 1.19-9.33-1.2-20.35-7.66-30.4 6.34-2.28 11.97-3.95 17.35-.12 1.56 1.19 3.83-.24 3.47-2.16-.24-1.43-.59-2.87-1.19-4.31-4.67-12.93-18.67-19.63-31.24-14.96-2.52.96-4.79 2.27-6.82 3.95-2.88-1.32-5.87-2.28-8.98-2.52-6.22-1.31-12.33-.47-17.36 2.76-2.03 1.31-3.83 2.99-5.38 4.91-7.66 10.17-7.06 27.53 2.39 42.61l.36.48c8.98 14.01 23.1 21.91 35.07 20.83-1.68 7.19-.48 14.85 3.71 21.55 1.2 1.92 2.63 3.59 4.19 5.03 1.32.96 3.47.12 3.47-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__jN)",
    stroke: "url(#fish_svg__jO)",
    d: "M2884.63 1902.59c-.12-9.34 4.55-18.56 12.93-23.94 7.9-5.15 17.47-5.75 25.61-2.52 2.27.96 4.43-1.31 3.47-3.59-.84-1.91-1.91-3.83-3.23-5.62-6.94-9.46-19.15-13.41-30.16-10.42 1.2-9.34-1.2-20.35-7.66-30.41 6.34-2.27 11.97-3.95 17.35-.12 1.56 1.2 3.83-.24 3.47-2.15-.24-1.44-.59-2.87-1.19-4.31-4.67-12.93-18.67-19.63-31.24-14.96-2.52.95-4.79 2.27-6.82 3.95-2.88-1.32-5.87-2.28-8.98-2.52-6.22-1.31-12.33-.48-17.36 2.76-2.03 1.31-3.83 2.99-5.38 4.9-7.66 10.18-7.06 27.54 2.39 42.62l.36.48c8.98 14.01 23.1 21.91 35.07 20.83-1.68 7.18-.48 14.84 3.71 21.55 1.2 1.91 2.63 3.59 4.19 5.03 1.44 1.07 3.59.24 3.47-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__jP)",
    stroke: "url(#fish_svg__jQ)",
    d: "M1685.46 1686.39a28.14 28.14 0 0 1 12.93-23.94c7.9-5.15 17.48-5.75 25.61-2.52 2.28.96 4.43-1.31 3.48-3.59-.84-1.91-1.92-3.83-3.24-5.62-6.94-9.46-19.15-13.41-30.16-10.42 1.2-9.34-1.19-20.35-7.66-30.41 6.35-2.27 11.97-3.95 17.36-.12 1.55 1.2 3.83-.24 3.47-2.15-.24-1.44-.6-2.87-1.2-4.31-4.67-12.93-18.67-19.63-31.24-14.96a23.9 23.9 0 0 0-6.82 3.95c-2.87-1.32-5.86-2.28-8.98-2.52-6.22-1.32-12.32-.48-17.35 2.76-2.04 1.31-3.83 2.99-5.39 4.9-7.66 10.18-7.06 27.54 2.4 42.62l.36.48c8.97 14.01 23.1 21.91 35.06 20.83-1.67 7.18-.47 14.84 3.71 21.55 1.2 1.91 2.64 3.59 4.19 5.03 1.32.95 3.47.12 3.47-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__jR)",
    stroke: "url(#fish_svg__jS)",
    d: "M1842.98 1729.01c-.12-9.34 4.54-18.56 12.92-23.94 7.9-5.15 17.48-5.75 25.62-2.52 2.27.96 4.43-1.32 3.47-3.59-.84-1.92-1.92-3.83-3.23-5.63-6.95-9.45-19.15-13.4-30.17-10.41 1.2-9.34-1.19-20.35-7.66-30.41 6.35-2.27 11.97-3.95 17.36-.12 1.55 1.2 3.83-.24 3.47-2.15-.24-1.44-.6-2.88-1.2-4.31-4.66-12.93-18.67-19.64-31.24-14.97a24.5 24.5 0 0 0-6.82 3.95c-2.87-1.31-5.86-2.27-8.97-2.51-6.23-1.32-12.33-.48-17.36 2.75-2.03 1.32-3.83 3-5.39 4.91-7.66 10.18-7.06 27.53 2.4 42.62l.36.48c8.97 14 23.1 21.91 35.07 20.83-1.68 7.18-.48 14.84 3.71 21.55 1.19 1.91 2.63 3.59 4.19 5.02 1.31.96 3.47.12 3.47-1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__jT)",
    stroke: "url(#fish_svg__jU)",
    d: "M2000.49 1771.63c-.12-9.34 4.54-18.56 12.92-23.95 7.9-5.15 17.48-5.74 25.62-2.51 2.27.96 4.42-1.32 3.47-3.59-.84-1.92-1.92-3.83-3.23-5.63-6.95-9.46-19.15-13.41-30.17-10.41 1.2-9.34-1.19-20.36-7.66-30.41 6.35-2.28 11.97-3.95 17.36-.12 1.55 1.2 3.83-.24 3.47-2.16-.24-1.43-.6-2.87-1.2-4.31-4.67-12.92-18.67-19.63-31.24-14.96a24.5 24.5 0 0 0-6.82 3.95c-2.87-1.32-5.86-2.27-8.98-2.51-6.22-1.32-12.32-.48-17.35 2.75-2.03 1.32-3.83 2.99-5.39 4.91-7.66 10.17-7.06 27.53 2.4 42.62l.36.48c8.97 14 23.1 21.9 35.07 20.83-1.68 7.18-.48 14.84 3.71 21.54 1.19 1.92 2.63 3.59 4.19 5.03 1.31.96 3.47.12 3.47-1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__jV)",
    stroke: "url(#fish_svg__jW)",
    d: "M2158 1814.24c-.12-9.33 4.55-18.55 12.92-23.94 7.9-5.15 17.48-5.75 25.62-2.51 2.27.95 4.43-1.32 3.47-3.6-.84-1.91-1.92-3.83-3.23-5.62-6.94-9.46-19.15-13.41-30.16-10.42 1.19-9.33-1.2-20.35-7.66-30.4 6.34-2.28 11.96-3.95 17.35-.12 1.56 1.19 3.83-.24 3.47-2.16-.24-1.43-.6-2.87-1.2-4.31-4.66-12.93-18.67-19.63-31.23-14.96a24.2 24.2 0 0 0-6.83 3.95c-2.87-1.32-5.86-2.28-8.97-2.52-6.23-1.31-12.33-.47-17.36 2.76-2.03 1.31-3.83 2.99-5.38 4.91-7.66 10.17-7.07 27.53 2.39 42.61l.36.48c8.98 14.01 23.1 21.91 35.07 20.83-1.68 7.19-.48 14.85 3.71 21.55 1.19 1.92 2.63 3.59 4.19 5.03 1.31.96 3.47.12 3.47-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__jX)",
    stroke: "url(#fish_svg__jY)",
    d: "M2315.51 1856.74c-.12-9.34 4.55-18.55 12.93-23.94 7.9-5.15 17.47-5.75 25.61-2.52 2.27.96 4.43-1.31 3.47-3.59-.84-1.91-1.91-3.83-3.23-5.62-6.94-9.46-19.15-13.41-30.16-10.42 1.19-9.34-1.2-20.35-7.66-30.41 6.34-2.27 11.97-3.95 17.35-.12 1.56 1.2 3.83-.23 3.47-2.15-.24-1.44-.6-2.87-1.19-4.31-4.67-12.93-18.68-19.63-31.24-14.96-2.52.95-4.79 2.27-6.82 3.95-2.88-1.32-5.87-2.28-8.98-2.52-6.23-1.31-12.33-.48-17.36 2.76-2.03 1.31-3.83 2.99-5.38 4.9-7.66 10.18-7.06 27.54 2.39 42.62l.36.48c8.98 14.01 23.1 21.91 35.07 20.83-1.68 7.18-.48 14.85 3.71 21.55 1.2 1.91 2.63 3.59 4.19 5.03 1.32 1.07 3.47.24 3.47-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__jZ)",
    stroke: "url(#fish_svg__ka)",
    d: "M2473.02 1899.36c-.12-9.34 4.55-18.56 12.93-23.94 7.9-5.15 17.47-5.75 25.61-2.52 2.27.96 4.43-1.32 3.47-3.59a30 30 0 0 0-3.23-5.63c-6.94-9.45-19.15-13.4-30.16-10.41 1.19-9.34-1.2-20.35-7.66-30.41 6.34-2.27 11.97-3.95 17.35-.12 1.56 1.2 3.83-.24 3.47-2.15-.24-1.44-.6-2.88-1.19-4.31-4.67-12.93-18.68-19.64-31.24-14.97-2.52.96-4.79 2.28-6.83 3.95-2.87-1.31-5.86-2.27-8.97-2.51-6.23-1.32-12.33-.48-17.36 2.75-2.03 1.32-3.83 3-5.38 4.91-7.66 10.18-7.06 27.54 2.39 42.62l.36.48c8.98 14 23.1 21.91 35.07 20.83-1.68 7.18-.48 14.84 3.71 21.55a24.5 24.5 0 0 0 4.19 5.02c1.32 1.08 3.47.24 3.47-1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__kb)",
    stroke: "url(#fish_svg__kc)",
    d: "M2630.53 1941.98c-.12-9.34 4.55-18.56 12.93-23.95 7.9-5.14 17.47-5.74 25.61-2.51 2.28.96 4.43-1.32 3.47-3.59-.84-1.92-1.91-3.83-3.23-5.63-6.94-9.46-19.15-13.41-30.16-10.41 1.2-9.34-1.2-20.35-7.66-30.41 6.34-2.27 11.97-3.95 17.35-.12 1.56 1.2 3.83-.24 3.47-2.15-.23-1.44-.59-2.88-1.19-4.31-4.67-12.93-18.67-19.64-31.24-14.97-2.51.96-4.79 2.28-6.82 3.95-2.88-1.31-5.87-2.27-8.98-2.51-6.22-1.32-12.33-.48-17.36 2.75-2.03 1.32-3.83 2.99-5.38 4.91-7.66 10.18-7.06 27.53 2.39 42.62l.36.48c8.98 14 23.1 21.9 35.07 20.83-1.67 7.18-.48 14.84 3.71 21.54 1.2 1.92 2.63 3.6 4.19 5.03 1.32 1.08 3.47.24 3.47-1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__kd)",
    stroke: "url(#fish_svg__ke)",
    d: "M2788.04 1984.59c-.12-9.33 4.55-18.55 12.93-23.94 7.9-5.15 17.47-5.75 25.61-2.51 2.28.95 4.43-1.32 3.47-3.59-.83-1.92-1.91-3.84-3.23-5.63-6.94-9.46-19.15-13.41-30.16-10.42 1.2-9.33-1.2-20.35-7.66-30.4 6.34-2.28 11.97-3.95 17.36-.12 1.55 1.19 3.83-.24 3.47-2.16-.24-1.43-.6-2.87-1.2-4.31-4.67-12.93-18.67-19.63-31.24-14.96-2.51.96-4.79 2.27-6.82 3.95-2.87-1.32-5.87-2.28-8.98-2.51-6.22-1.32-12.33-.48-17.35 2.75-2.04 1.32-3.83 2.99-5.39 4.91-7.66 10.17-7.06 27.53 2.39 42.61l.36.48c8.98 14.01 23.1 21.91 35.07 20.83-1.67 7.19-.48 14.85 3.71 21.55 1.2 1.92 2.64 3.59 4.19 5.03 1.32.96 3.47.24 3.47-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__kf)",
    stroke: "url(#fish_svg__kg)",
    d: "M1588.76 1768.39c-.12-9.33 4.54-18.55 12.92-23.94 7.9-5.15 17.48-5.75 25.62-2.51 2.27.95 4.42-1.32 3.47-3.6-.84-1.91-1.92-3.83-3.23-5.62-6.95-9.46-19.16-13.41-30.17-10.42 1.2-9.33-1.19-20.35-7.66-30.4 6.35-2.28 11.97-3.95 17.36-.12 1.55 1.19 3.83-.24 3.47-2.16-.24-1.43-.6-2.87-1.2-4.31-4.67-12.93-18.67-19.63-31.24-14.96-2.51.96-4.78 2.27-6.82 3.95-2.87-1.32-5.86-2.28-8.98-2.52-6.22-1.31-12.32-.47-17.35 2.76-2.04 1.32-3.83 2.99-5.39 4.91-7.66 10.17-7.06 27.53 2.4 42.61l.36.48c8.97 14.01 23.1 21.91 35.07 20.83-1.68 7.19-.48 14.85 3.71 21.55 1.19 1.92 2.63 3.59 4.18 5.03 1.44.96 3.48.12 3.48-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__kh)",
    stroke: "url(#fish_svg__ki)",
    d: "M1746.27 1810.89c-.12-9.34 4.55-18.55 12.92-23.94 7.9-5.15 17.48-5.75 25.62-2.52 2.27.96 4.43-1.31 3.47-3.59-.84-1.91-1.92-3.83-3.23-5.62-6.95-9.46-19.15-13.41-30.16-10.42 1.19-9.34-1.2-20.35-7.66-30.41 6.34-2.27 11.96-3.95 17.35-.12 1.56 1.2 3.83-.23 3.47-2.15-.24-1.44-.6-2.87-1.2-4.31-4.66-12.93-18.67-19.63-31.23-14.96-2.52.95-4.79 2.27-6.83 3.95-2.87-1.32-5.86-2.28-8.97-2.52-6.23-1.31-12.33-.48-17.36 2.76-2.03 1.31-3.83 2.99-5.38 4.9-7.66 10.18-7.07 27.54 2.39 42.62l.36.48c8.97 14.01 23.1 21.91 35.07 20.83-1.68 7.18-.48 14.85 3.71 21.55a24.5 24.5 0 0 0 4.19 5.03c1.43 1.07 3.47.24 3.47-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__kj)",
    stroke: "url(#fish_svg__kk)",
    d: "M1903.78 1853.51c-.12-9.34 4.55-18.56 12.92-23.94 7.9-5.15 17.48-5.75 25.62-2.52 2.27.96 4.43-1.32 3.47-3.59-.84-1.91-1.92-3.83-3.23-5.63-6.95-9.45-19.15-13.4-30.17-10.41 1.2-9.34-1.19-20.35-7.66-30.41 6.35-2.27 11.97-3.95 17.36-.12 1.56 1.2 3.83-.24 3.47-2.15-.24-1.44-.6-2.88-1.2-4.31-4.66-12.93-18.67-19.63-31.24-14.97a24.5 24.5 0 0 0-6.82 3.95c-2.87-1.31-5.86-2.27-8.97-2.51-6.23-1.32-12.33-.48-17.36 2.75-2.03 1.32-3.83 3-5.39 4.91-7.66 10.18-7.06 27.54 2.4 42.62l.36.48c8.97 14 23.1 21.91 35.07 20.83-1.68 7.18-.48 14.84 3.71 21.55 1.19 1.91 2.63 3.59 4.19 5.02 1.43 1.08 3.47.24 3.47-1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__kl)",
    stroke: "url(#fish_svg__km)",
    d: "M2061.29 1896.13c-.12-9.34 4.55-18.56 12.93-23.95 7.89-5.14 17.47-5.74 25.61-2.51 2.27.96 4.43-1.32 3.47-3.59-.84-1.92-1.92-3.83-3.23-5.63-6.94-9.46-19.15-13.41-30.16-10.41 1.19-9.34-1.2-20.35-7.66-30.41 6.34-2.27 11.97-3.95 17.35-.12 1.56 1.2 3.83-.24 3.47-2.15-.24-1.44-.6-2.88-1.19-4.31-4.67-12.93-18.68-19.64-31.24-14.97-2.52.96-4.79 2.28-6.83 3.95-2.87-1.31-5.86-2.27-8.97-2.51-6.23-1.32-12.33-.48-17.36 2.75-2.03 1.32-3.83 2.99-5.38 4.91-7.66 10.18-7.06 27.53 2.39 42.62l.36.48c8.98 14 23.1 21.9 35.07 20.83-1.68 7.18-.48 14.84 3.71 21.54 1.2 1.92 2.63 3.6 4.19 5.03 1.43 1.08 3.47.24 3.47-1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__kn)",
    stroke: "url(#fish_svg__ko)",
    d: "M2218.8 1938.74c-.12-9.33 4.55-18.55 12.93-23.94 7.9-5.15 17.47-5.75 25.61-2.51 2.27.95 4.43-1.32 3.47-3.59-.84-1.92-1.91-3.84-3.23-5.63-6.94-9.46-19.15-13.41-30.16-10.42 1.2-9.33-1.2-20.35-7.66-30.4 6.34-2.28 11.97-3.95 17.35-.12 1.56 1.19 3.83-.24 3.47-2.16-.24-1.43-.59-2.87-1.19-4.31-4.67-12.93-18.67-19.63-31.24-14.96-2.52.96-4.79 2.27-6.82 3.95-2.88-1.32-5.87-2.27-8.98-2.51-6.22-1.32-12.33-.48-17.36 2.75-2.03 1.32-3.83 2.99-5.38 4.91-7.66 10.17-7.06 27.53 2.39 42.61l.36.48c8.98 14.01 23.1 21.91 35.07 20.83-1.68 7.19-.48 14.85 3.71 21.55 1.2 1.92 2.63 3.59 4.19 5.03 1.44 1.08 3.47.24 3.47-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__kp)",
    stroke: "url(#fish_svg__kq)",
    d: "M2376.31 1981.36c-.12-9.34 4.55-18.55 12.93-23.94 7.9-5.15 17.47-5.75 25.61-2.52 2.27.96 4.43-1.31 3.47-3.59-.84-1.91-1.91-3.83-3.23-5.62-6.94-9.46-19.15-13.41-30.16-10.42 1.19-9.34-1.2-20.35-7.66-30.41 6.34-2.27 11.97-3.95 17.35-.11 1.56 1.19 3.83-.24 3.47-2.16-.24-1.44-.59-2.87-1.19-4.31-4.67-12.93-18.67-19.63-31.24-14.96-2.52.95-4.79 2.27-6.82 3.95-2.88-1.32-5.87-2.28-8.98-2.52-6.22-1.31-12.33-.48-17.36 2.76-2.03 1.31-3.83 2.99-5.38 4.9-7.66 10.18-7.06 27.54 2.39 42.62l.36.48c8.98 14.01 23.1 21.91 35.07 20.83-1.68 7.18-.48 14.85 3.71 21.55 1.2 1.91 2.63 3.59 4.19 5.03 1.44.96 3.47.24 3.47-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__kr)",
    stroke: "url(#fish_svg__ks)",
    d: "M2533.82 2023.98c-.12-9.34 4.55-18.56 12.93-23.94 7.9-5.15 17.47-5.75 25.61-2.52 2.28.96 4.43-1.31 3.47-3.59-.83-1.91-1.91-3.83-3.23-5.63-6.94-9.45-19.15-13.4-30.16-10.41 1.2-9.34-1.2-20.35-7.66-30.41 6.34-2.27 11.97-3.95 17.35-.12 1.56 1.2 3.83-.24 3.48-2.15-.24-1.44-.6-2.87-1.2-4.31-4.67-12.93-18.67-19.63-31.24-14.97-2.51.96-4.79 2.28-6.82 3.95-2.87-1.31-5.87-2.27-8.98-2.51-6.22-1.32-12.33-.48-17.35 2.75-2.04 1.32-3.83 3-5.39 4.91-7.66 10.18-7.06 27.54 2.39 42.62l.36.48c8.98 14.01 23.1 21.91 35.07 20.83-1.67 7.18-.48 14.84 3.71 21.55 1.2 1.91 2.64 3.59 4.19 5.03 1.44.95 3.47.11 3.47-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__kt)",
    stroke: "url(#fish_svg__ku)",
    d: "M2691.33 2066.6c-.12-9.34 4.55-18.56 12.93-23.95 7.9-5.14 17.48-5.74 25.61-2.51 2.28.96 4.43-1.32 3.47-3.59-.83-1.92-1.91-3.83-3.23-5.63-6.94-9.46-19.15-13.41-30.16-10.41 1.2-9.34-1.2-20.35-7.66-30.41 6.34-2.27 11.97-3.95 17.36-.12 1.55 1.2 3.83-.24 3.47-2.15-.24-1.44-.6-2.88-1.2-4.31-4.67-12.93-18.67-19.64-31.24-14.97-2.51.96-4.79 2.28-6.82 3.95-2.87-1.31-5.87-2.27-8.98-2.51-6.22-1.32-12.33-.48-17.35 2.75-2.04 1.32-3.83 2.99-5.39 4.91-7.66 10.18-7.06 27.53 2.4 42.62l.35.48c8.98 14 23.1 21.9 35.07 20.83-1.67 7.18-.48 14.84 3.71 21.54 1.2 1.92 2.64 3.6 4.19 5.03 1.44.96 3.47.12 3.47-1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__kv)",
    stroke: "url(#fish_svg__kw)",
    d: "M1492.05 1850.28c-.12-9.34 4.54-18.56 12.92-23.95 7.9-5.14 17.48-5.74 25.62-2.51 2.27.96 4.42-1.32 3.47-3.59-.84-1.92-1.92-3.83-3.23-5.63-6.95-9.46-19.16-13.41-30.17-10.41 1.2-9.34-1.19-20.35-7.66-30.41 6.35-2.27 11.97-3.95 17.36-.12 1.55 1.2 3.83-.24 3.47-2.15-.24-1.44-.6-2.88-1.2-4.31-4.67-12.93-18.67-19.64-31.24-14.97a24.5 24.5 0 0 0-6.82 3.95c-2.87-1.31-5.86-2.27-8.98-2.51-6.22-1.32-12.32-.48-17.35 2.75-2.04 1.32-3.83 2.99-5.39 4.91-7.66 10.18-7.06 27.53 2.4 42.62l.36.48c8.97 14 23.1 21.9 35.07 20.83-1.68 7.18-.48 14.84 3.71 21.54 1.19 1.92 2.63 3.6 4.18 5.03 1.44 1.08 3.6.24 3.48-1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__kx)",
    stroke: "url(#fish_svg__ky)",
    d: "M1649.56 1892.89c-.12-9.33 4.54-18.55 12.92-23.94 7.9-5.15 17.48-5.74 25.62-2.51 2.27.96 4.43-1.32 3.47-3.59-.84-1.92-1.92-3.83-3.23-5.63-6.95-9.46-19.15-13.41-30.17-10.42 1.2-9.33-1.19-20.35-7.66-30.4 6.35-2.28 11.97-3.95 17.36-.12 1.56 1.19 3.83-.24 3.47-2.16-.24-1.43-.6-2.87-1.2-4.31-4.66-12.93-18.67-19.63-31.24-14.96-2.51.96-4.78 2.27-6.82 3.95-2.87-1.32-5.86-2.27-8.97-2.51-6.23-1.32-12.33-.48-17.36 2.75-2.03 1.32-3.83 2.99-5.39 4.91-7.66 10.17-7.06 27.53 2.4 42.62l.36.47c8.97 14.01 23.1 21.91 35.07 20.83-1.68 7.19-.48 14.85 3.71 21.55 1.19 1.92 2.63 3.59 4.19 5.03 1.43 1.08 3.59.24 3.47-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__kz)",
    stroke: "url(#fish_svg__kA)",
    d: "M1807.07 1935.51c-.12-9.34 4.55-18.55 12.92-23.94 7.9-5.15 17.48-5.75 25.62-2.52 2.27.96 4.43-1.31 3.47-3.59-.84-1.91-1.92-3.83-3.23-5.62-6.94-9.46-19.15-13.41-30.16-10.42 1.19-9.34-1.2-20.35-7.66-30.4 6.34-2.28 11.96-3.96 17.35-.12 1.56 1.19 3.83-.24 3.47-2.16-.24-1.44-.6-2.87-1.2-4.31-4.66-12.93-18.67-19.63-31.23-14.96-2.52.95-4.79 2.27-6.83 3.95-2.87-1.32-5.86-2.28-8.97-2.52-6.23-1.31-12.33-.48-17.36 2.76-2.03 1.31-3.83 2.99-5.38 4.91-7.66 10.17-7.07 27.53 2.39 42.61l.36.48c8.98 14.01 23.1 21.91 35.07 20.83-1.68 7.18-.48 14.85 3.71 21.55 1.2 1.92 2.63 3.59 4.19 5.03 1.43.96 3.59.24 3.47-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__kB)",
    stroke: "url(#fish_svg__kC)",
    d: "M1964.58 1978.13c-.12-9.34 4.55-18.56 12.93-23.94 7.9-5.15 17.47-5.75 25.61-2.52 2.27.96 4.43-1.31 3.47-3.59a30 30 0 0 0-3.23-5.63c-6.94-9.45-19.15-13.4-30.16-10.41 1.19-9.34-1.2-20.35-7.66-30.41 6.34-2.27 11.97-3.95 17.35-.12 1.56 1.2 3.83-.24 3.47-2.15-.24-1.44-.6-2.87-1.19-4.31-4.67-12.93-18.68-19.63-31.24-14.97-2.52.96-4.79 2.28-6.82 3.96-2.88-1.32-5.87-2.28-8.98-2.52-6.23-1.32-12.33-.48-17.36 2.75-2.03 1.32-3.83 3-5.38 4.91-7.66 10.18-7.06 27.54 2.39 42.62l.36.48c8.98 14.01 23.1 21.91 35.07 20.83-1.68 7.18-.48 14.84 3.71 21.55 1.2 1.91 2.63 3.59 4.19 5.03 1.44.95 3.59.12 3.47-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__kD)",
    stroke: "url(#fish_svg__kE)",
    d: "M2122.09 2020.75c-.12-9.34 4.55-18.56 12.93-23.95 7.9-5.14 17.47-5.74 25.61-2.51 2.27.96 4.43-1.32 3.47-3.59-.84-1.92-1.91-3.83-3.23-5.63-6.94-9.45-19.15-13.41-30.16-10.41 1.19-9.34-1.2-20.35-7.66-30.41 6.34-2.27 11.97-3.95 17.35-.12 1.56 1.2 3.83-.24 3.47-2.15-.24-1.44-.6-2.88-1.19-4.31-4.67-12.93-18.68-19.64-31.24-14.97-2.52.96-4.79 2.28-6.82 3.95-2.88-1.31-5.87-2.27-8.98-2.51-6.23-1.32-12.33-.48-17.36 2.75-2.03 1.32-3.83 2.99-5.38 4.91-7.66 10.18-7.06 27.53 2.39 42.62l.36.48c8.98 14 23.1 21.9 35.07 20.83-1.68 7.18-.48 14.84 3.71 21.54 1.2 1.92 2.63 3.6 4.19 5.03 1.44.96 3.59.12 3.47-1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__kF)",
    stroke: "url(#fish_svg__kG)",
    d: "M2279.6 2063.36c-.12-9.33 4.55-18.55 12.93-23.94 7.9-5.15 17.47-5.74 25.61-2.51 2.28.96 4.43-1.32 3.47-3.59-.84-1.92-1.91-3.83-3.23-5.63-6.94-9.46-19.15-13.41-30.16-10.42 1.2-9.33-1.2-20.35-7.66-30.4 6.34-2.28 11.97-3.95 17.35-.12 1.56 1.2 3.83-.24 3.48-2.16-.24-1.43-.6-2.87-1.2-4.31-4.67-12.93-18.67-19.63-31.24-14.96-2.51.96-4.79 2.27-6.82 3.95-2.88-1.32-5.87-2.27-8.98-2.51-6.22-1.32-12.33-.48-17.35 2.75-2.04 1.32-3.83 2.99-5.39 4.91-7.66 10.17-7.06 27.53 2.39 42.62l.36.47c8.98 14.01 23.1 21.91 35.07 20.83-1.67 7.19-.48 14.85 3.71 21.55 1.2 1.92 2.63 3.59 4.19 5.03 1.44.96 3.59.12 3.47-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__kH)",
    stroke: "url(#fish_svg__kI)",
    d: "M2437.11 2105.98c-.12-9.34 4.55-18.55 12.93-23.94 7.9-5.15 17.47-5.75 25.61-2.51 2.28.95 4.43-1.32 3.47-3.6-.83-1.91-1.91-3.83-3.23-5.62-6.94-9.46-19.15-13.41-30.16-10.42 1.2-9.34-1.2-20.35-7.66-30.4 6.34-2.28 11.97-3.95 17.36-.12 1.55 1.19 3.83-.24 3.47-2.16-.24-1.44-.6-2.87-1.2-4.31-4.67-12.93-18.67-19.63-31.24-14.96-2.51.96-4.79 2.27-6.82 3.95-2.87-1.32-5.87-2.28-8.98-2.52-6.22-1.31-12.33-.47-17.35 2.76-2.04 1.31-3.83 2.99-5.39 4.91-7.66 10.17-7.06 27.53 2.39 42.61l.36.48c8.98 14.01 23.1 21.91 35.07 20.83-1.67 7.18-.48 14.85 3.71 21.55 1.2 1.92 2.64 3.59 4.19 5.03 1.44.96 3.59.12 3.47-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__kJ)",
    stroke: "url(#fish_svg__kK)",
    d: "M2594.62 2148.48c-.12-9.34 4.55-18.56 12.93-23.94 7.9-5.15 17.47-5.75 25.61-2.52 2.28.96 4.43-1.31 3.47-3.59-.83-1.91-1.91-3.83-3.23-5.62-6.94-9.46-19.15-13.41-30.16-10.42 1.2-9.34-1.2-20.35-7.66-30.41 6.34-2.27 11.97-3.95 17.36-.12 1.55 1.2 3.83-.24 3.47-2.15-.24-1.44-.6-2.87-1.2-4.31-4.67-12.93-18.67-19.63-31.24-14.96a23.9 23.9 0 0 0-6.82 3.95c-2.87-1.32-5.87-2.28-8.98-2.52-6.22-1.31-12.33-.48-17.35 2.76-2.04 1.31-3.83 2.99-5.39 4.9-7.66 10.18-7.06 27.54 2.39 42.62l.36.48c8.98 14.01 23.1 21.91 35.07 20.83-1.67 7.18-.48 14.84 3.71 21.55 1.2 1.91 2.64 3.59 4.19 5.03 1.44 1.07 3.59.24 3.47-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__kL)",
    stroke: "url(#fish_svg__kM)",
    d: "M1395.46 1932.28c-.12-9.34 4.55-18.56 12.92-23.94 7.9-5.15 17.48-5.75 25.62-2.52 2.27.96 4.43-1.31 3.47-3.59-.84-1.91-1.92-3.83-3.23-5.63-6.95-9.45-19.15-13.4-30.17-10.41 1.2-9.34-1.19-20.35-7.66-30.41 6.35-2.27 11.97-3.95 17.36-.12 1.56 1.2 3.83-.24 3.47-2.15-.24-1.44-.6-2.87-1.2-4.31-4.66-12.93-18.67-19.63-31.24-14.97-2.51.96-4.78 2.28-6.82 3.96-2.87-1.32-5.86-2.28-8.97-2.52-6.23-1.32-12.33-.48-17.36 2.75-2.03 1.32-3.83 3-5.39 4.91-7.66 10.18-7.06 27.54 2.4 42.62l.36.48c8.97 14.01 23.1 21.91 35.07 20.83-1.68 7.18-.48 14.84 3.71 21.55a24.5 24.5 0 0 0 4.19 5.03c1.31.95 3.47.23 3.47-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__kN)",
    stroke: "url(#fish_svg__kO)",
    d: "M1552.97 1974.9c-.12-9.34 4.55-18.56 12.93-23.95 7.89-5.14 17.47-5.74 25.61-2.51 2.27.96 4.43-1.32 3.47-3.59-.84-1.92-1.92-3.83-3.23-5.63-6.94-9.45-19.15-13.41-30.16-10.41 1.19-9.34-1.2-20.35-7.66-30.41 6.34-2.27 11.97-3.95 17.35-.12 1.56 1.2 3.83-.24 3.47-2.15-.24-1.44-.6-2.88-1.19-4.31-4.67-12.93-18.68-19.64-31.24-14.97-2.52.96-4.79 2.28-6.83 3.95-2.87-1.31-5.86-2.27-8.97-2.51-6.23-1.32-12.33-.48-17.36 2.75-2.03 1.32-3.83 2.99-5.38 4.91-7.66 10.18-7.07 27.53 2.39 42.62l.36.48c8.98 14 23.1 21.9 35.07 20.83-1.68 7.18-.48 14.84 3.71 21.55a24.5 24.5 0 0 0 4.19 5.02c1.31.96 3.47.12 3.47-1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__kP)",
    stroke: "url(#fish_svg__kQ)",
    d: "M1710.48 2017.51c-.12-9.33 4.55-18.55 12.92-23.94 7.9-5.15 17.48-5.74 25.62-2.51 2.27.96 4.43-1.32 3.47-3.59-.84-1.92-1.92-3.83-3.23-5.63-6.94-9.46-19.15-13.41-30.16-10.41 1.19-9.34-1.2-20.36-7.66-30.41 6.34-2.28 11.96-3.95 17.35-.12 1.56 1.2 3.83-.24 3.47-2.16-.24-1.43-.6-2.87-1.19-4.31-4.67-12.93-18.68-19.63-31.24-14.96a24.2 24.2 0 0 0-6.83 3.95c-2.87-1.32-5.86-2.27-8.97-2.51-6.23-1.32-12.33-.48-17.36 2.75-2.03 1.32-3.83 2.99-5.38 4.91-7.66 10.17-7.07 27.53 2.39 42.62l.36.47c8.98 14.01 23.1 21.91 35.07 20.83-1.68 7.19-.48 14.85 3.71 21.55 1.2 1.92 2.63 3.59 4.19 5.03 1.31.96 3.47.12 3.47-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__kR)",
    stroke: "url(#fish_svg__kS)",
    d: "M1867.99 2060.13c-.12-9.34 4.55-18.55 12.93-23.94 7.9-5.15 17.47-5.75 25.61-2.51 2.27.95 4.43-1.32 3.47-3.6-.84-1.91-1.91-3.83-3.23-5.62-6.94-9.46-19.15-13.41-30.16-10.42 1.19-9.33-1.2-20.35-7.66-30.4 6.34-2.28 11.97-3.95 17.35-.12 1.56 1.19 3.83-.24 3.47-2.16-.24-1.44-.59-2.87-1.19-4.31-4.67-12.93-18.67-19.63-31.24-14.96-2.52.96-4.79 2.27-6.82 3.95-2.88-1.32-5.87-2.28-8.98-2.52-6.22-1.31-12.33-.47-17.36 2.76-2.03 1.31-3.83 2.99-5.38 4.91-7.66 10.17-7.06 27.53 2.39 42.61l.36.48c8.98 14.01 23.1 21.91 35.07 20.83-1.68 7.18-.48 14.85 3.71 21.55 1.2 1.92 2.63 3.59 4.19 5.03 1.32.96 3.47.12 3.47-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__kT)",
    stroke: "url(#fish_svg__kU)",
    d: "M2025.5 2102.63c-.12-9.34 4.55-18.56 12.93-23.94 7.9-5.15 17.47-5.75 25.61-2.52 2.28.96 4.43-1.31 3.47-3.59-.83-1.91-1.91-3.83-3.23-5.62-6.94-9.46-19.15-13.41-30.16-10.42 1.2-9.34-1.2-20.35-7.66-30.41 6.34-2.27 11.97-3.95 17.35-.12 1.56 1.2 3.83-.24 3.48-2.15-.24-1.44-.6-2.87-1.2-4.31-4.67-12.93-18.67-19.63-31.24-14.96a23.9 23.9 0 0 0-6.82 3.95c-2.88-1.32-5.87-2.28-8.98-2.52-6.22-1.31-12.33-.48-17.35 2.76-2.04 1.31-3.83 2.99-5.39 4.9-7.66 10.18-7.06 27.54 2.39 42.62l.36.48c8.98 14.01 23.1 21.91 35.07 20.83-1.67 7.18-.48 14.84 3.71 21.55 1.2 1.91 2.64 3.59 4.19 5.03 1.32 1.07 3.47.24 3.47-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__kV)",
    stroke: "url(#fish_svg__kW)",
    d: "M2183.01 2145.25c-.12-9.34 4.55-18.56 12.93-23.94 7.9-5.15 17.47-5.75 25.61-2.52 2.28.96 4.43-1.32 3.47-3.59-.84-1.92-1.91-3.83-3.23-5.63-6.94-9.45-19.15-13.4-30.16-10.41 1.2-9.34-1.2-20.35-7.66-30.41 6.34-2.27 11.97-3.95 17.35-.12 1.56 1.2 3.83-.24 3.48-2.15-.24-1.44-.6-2.88-1.2-4.31-4.67-12.93-18.67-19.64-31.24-14.97-2.51.96-4.79 2.28-6.82 3.95-2.88-1.31-5.87-2.27-8.98-2.51-6.22-1.32-12.33-.48-17.35 2.75-2.04 1.32-3.83 3-5.39 4.91-7.66 10.18-7.06 27.54 2.39 42.62l.36.48c8.98 14 23.1 21.91 35.07 20.83-1.67 7.18-.48 14.84 3.71 21.55a24.5 24.5 0 0 0 4.19 5.02c1.32 1.08 3.47.24 3.47-1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__kX)",
    stroke: "url(#fish_svg__kY)",
    d: "M2340.52 2187.87c-.12-9.34 4.55-18.56 12.93-23.95 7.9-5.14 17.47-5.74 25.61-2.51 2.28.96 4.43-1.32 3.47-3.59-.83-1.92-1.91-3.83-3.23-5.63-6.94-9.46-19.15-13.41-30.16-10.41 1.2-9.34-1.2-20.36-7.66-30.41 6.34-2.28 11.97-3.95 17.36-.12 1.55 1.2 3.83-.24 3.47-2.16-.24-1.43-.6-2.87-1.2-4.31-4.67-12.92-18.67-19.63-31.24-14.96-2.51.96-4.79 2.28-6.82 3.95-2.87-1.32-5.87-2.27-8.98-2.51-6.22-1.32-12.33-.48-17.35 2.75-2.04 1.32-3.83 2.99-5.39 4.91-7.66 10.17-7.06 27.53 2.39 42.62l.36.48c8.98 14 23.1 21.9 35.07 20.83-1.67 7.18-.48 14.84 3.71 21.54 1.2 1.92 2.64 3.59 4.19 5.03 1.32 1.08 3.47.24 3.47-1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__kZ)",
    stroke: "url(#fish_svg__la)",
    d: "M2498.04 2230.48c-.12-9.33 4.54-18.55 12.92-23.94 7.9-5.15 17.48-5.75 25.62-2.51 2.27.95 4.42-1.32 3.47-3.59-.84-1.92-1.92-3.84-3.24-5.63-6.94-9.46-19.15-13.41-30.16-10.42 1.2-9.33-1.19-20.35-7.66-30.4 6.35-2.28 11.97-3.95 17.36-.12 1.55 1.19 3.83-.24 3.47-2.16-.24-1.43-.6-2.87-1.2-4.31-4.67-12.93-18.67-19.63-31.24-14.96-2.51.96-4.78 2.27-6.82 3.95-2.87-1.32-5.86-2.28-8.98-2.52-6.22-1.31-12.32-.47-17.35 2.76-2.04 1.32-3.83 2.99-5.39 4.91-7.66 10.17-7.06 27.53 2.4 42.61l.36.48c8.97 14.01 23.1 21.91 35.06 20.83-1.67 7.19-.47 14.85 3.71 21.55 1.2 1.92 2.64 3.59 4.19 5.03 1.32.96 3.48.24 3.48-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__lb)",
    stroke: "url(#fish_svg__lc)",
    d: "M1298.75 2014.28c-.12-9.34 4.55-18.55 12.92-23.94 7.9-5.15 17.48-5.75 25.62-2.51 2.27.95 4.43-1.32 3.47-3.6-.84-1.91-1.92-3.83-3.23-5.62-6.94-9.46-19.15-13.41-30.16-10.42 1.19-9.33-1.2-20.35-7.66-30.4 6.34-2.28 11.96-3.95 17.35-.12 1.56 1.19 3.83-.24 3.47-2.16-.24-1.44-.6-2.87-1.2-4.31-4.66-12.93-18.67-19.63-31.23-14.96a24.2 24.2 0 0 0-6.83 3.95c-2.87-1.32-5.86-2.28-8.97-2.52-6.23-1.31-12.33-.47-17.36 2.76-2.03 1.31-3.83 2.99-5.38 4.91-7.66 10.17-7.07 27.53 2.39 42.61l.36.48c8.98 14.01 23.1 21.91 35.07 20.83-1.68 7.19-.48 14.85 3.71 21.55 1.19 1.92 2.63 3.59 4.19 5.03 1.43.96 3.47.12 3.47-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__ld)",
    stroke: "url(#fish_svg__le)",
    d: "M1456.26 2056.9c-.12-9.34 4.55-18.56 12.93-23.94 7.89-5.15 17.47-5.75 25.61-2.52 2.27.96 4.43-1.31 3.47-3.59-.84-1.91-1.92-3.83-3.23-5.62-6.94-9.46-19.15-13.41-30.16-10.42 1.19-9.34-1.2-20.35-7.66-30.41 6.34-2.27 11.97-3.95 17.35-.12 1.56 1.2 3.83-.24 3.47-2.15-.24-1.44-.6-2.87-1.19-4.31-4.67-12.93-18.68-19.63-31.24-14.96-2.52.95-4.79 2.27-6.83 3.95-2.87-1.32-5.86-2.28-8.97-2.52-6.23-1.32-12.33-.48-17.36 2.76-2.03 1.31-3.83 2.99-5.38 4.9-7.66 10.18-7.07 27.54 2.39 42.62l.36.48c8.98 14.01 23.1 21.91 35.07 20.83-1.68 7.18-.48 14.84 3.71 21.55 1.2 1.91 2.63 3.59 4.19 5.03 1.43.95 3.47.12 3.47-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__lf)",
    stroke: "url(#fish_svg__lg)",
    d: "M1613.77 2099.4c-.12-9.34 4.55-18.56 12.93-23.94 7.9-5.15 17.47-5.75 25.61-2.52 2.27.96 4.43-1.32 3.47-3.59-.84-1.92-1.91-3.83-3.23-5.63-6.94-9.45-19.15-13.4-30.16-10.41 1.19-9.34-1.2-20.35-7.66-30.41 6.34-2.27 11.97-3.95 17.35-.12 1.56 1.2 3.83-.24 3.47-2.15-.24-1.44-.6-2.88-1.19-4.31-4.67-12.93-18.68-19.64-31.24-14.97-2.52.96-4.79 2.28-6.83 3.95-2.87-1.31-5.86-2.27-8.97-2.51-6.23-1.32-12.33-.48-17.36 2.75-2.03 1.32-3.83 3-5.38 4.91-7.66 10.18-7.06 27.54 2.39 42.62l.36.48c8.98 14 23.1 21.91 35.07 20.83-1.68 7.18-.48 14.84 3.71 21.55a24.5 24.5 0 0 0 4.19 5.02c1.32 1.08 3.47.24 3.47-1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__lh)",
    stroke: "url(#fish_svg__li)",
    d: "M1771.28 2142.02c-.12-9.34 4.55-18.56 12.93-23.95 7.9-5.14 17.47-5.74 25.61-2.51 2.28.96 4.43-1.32 3.47-3.59-.84-1.92-1.91-3.83-3.23-5.63-6.94-9.46-19.15-13.41-30.16-10.41 1.2-9.34-1.2-20.35-7.66-30.41 6.34-2.28 11.97-3.95 17.35-.12 1.56 1.2 3.83-.24 3.47-2.16-.23-1.43-.59-2.87-1.19-4.31-4.67-12.92-18.67-19.63-31.24-14.96-2.51.96-4.79 2.28-6.82 3.95-2.88-1.32-5.87-2.27-8.98-2.51-6.22-1.32-12.33-.48-17.36 2.75-2.03 1.32-3.83 2.99-5.38 4.91-7.66 10.17-7.06 27.53 2.39 42.62l.36.48c8.98 14 23.1 21.9 35.07 20.83-1.67 7.18-.48 14.84 3.71 21.54 1.2 1.92 2.63 3.6 4.19 5.03 1.32 1.08 3.47.24 3.47-1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__lj)",
    stroke: "url(#fish_svg__lk)",
    d: "M1928.79 2184.63c-.12-9.33 4.55-18.55 12.93-23.94 7.9-5.15 17.47-5.75 25.61-2.51 2.28.95 4.43-1.32 3.47-3.59-.83-1.92-1.91-3.84-3.23-5.63-6.94-9.46-19.15-13.41-30.16-10.42 1.2-9.33-1.2-20.35-7.66-30.4 6.34-2.28 11.97-3.95 17.36-.12 1.55 1.19 3.83-.24 3.47-2.16-.24-1.43-.6-2.87-1.2-4.31-4.67-12.93-18.67-19.63-31.24-14.96-2.51.96-4.79 2.27-6.82 3.95-2.87-1.32-5.87-2.28-8.98-2.51-6.22-1.32-12.33-.48-17.35 2.75-2.04 1.32-3.83 2.99-5.39 4.91-7.66 10.17-7.06 27.53 2.39 42.61l.36.48c8.98 14.01 23.1 21.91 35.07 20.83-1.67 7.19-.48 14.85 3.71 21.55 1.2 1.92 2.64 3.59 4.19 5.03 1.32 1.08 3.47.24 3.47-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__ll)",
    stroke: "url(#fish_svg__lm)",
    d: "M2086.3 2227.25c-.12-9.34 4.55-18.55 12.93-23.94 7.9-5.15 17.47-5.75 25.61-2.52 2.28.96 4.43-1.31 3.47-3.59-.83-1.91-1.91-3.83-3.23-5.62-6.94-9.46-19.15-13.41-30.16-10.42 1.2-9.34-1.2-20.35-7.66-30.41 6.34-2.27 11.97-3.95 17.36-.12 1.55 1.2 3.83-.23 3.47-2.15-.24-1.44-.6-2.87-1.2-4.31-4.67-12.93-18.67-19.63-31.24-14.96a23.9 23.9 0 0 0-6.82 3.95c-2.87-1.32-5.87-2.28-8.98-2.52-6.22-1.31-12.33-.48-17.35 2.76-2.04 1.31-3.83 2.99-5.39 4.9-7.66 10.18-7.06 27.54 2.39 42.62l.36.48c8.98 14.01 23.1 21.91 35.07 20.83-1.67 7.18-.48 14.85 3.71 21.55 1.2 1.91 2.64 3.59 4.19 5.03 1.32.95 3.47.24 3.47-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__ln)",
    stroke: "url(#fish_svg__lo)",
    d: "M2243.81 2269.87c-.12-9.34 4.55-18.56 12.93-23.94 7.9-5.15 17.48-5.75 25.61-2.52 2.28.96 4.43-1.31 3.48-3.59-.84-1.91-1.92-3.83-3.24-5.63-6.94-9.45-19.15-13.4-30.16-10.41 1.2-9.34-1.19-20.35-7.66-30.41 6.35-2.27 11.97-3.95 17.36-.12 1.55 1.2 3.83-.24 3.47-2.15-.24-1.44-.6-2.88-1.2-4.31-4.67-12.93-18.67-19.63-31.24-14.97-2.51.96-4.79 2.28-6.82 3.95-2.87-1.31-5.87-2.27-8.98-2.51-6.22-1.32-12.32-.48-17.35 2.75-2.04 1.32-3.83 3-5.39 4.91-7.66 10.18-7.06 27.54 2.4 42.62l.36.48c8.97 14 23.09 21.91 35.06 20.83-1.67 7.18-.47 14.84 3.71 21.55 1.2 1.91 2.64 3.59 4.19 5.02 1.32.96 3.47.12 3.47-1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fish_svg__lp)",
    stroke: "url(#fish_svg__lq)",
    d: "M2401.33 2312.49c-.12-9.34 4.54-18.56 12.92-23.95 7.9-5.14 17.48-5.74 25.62-2.51 2.27.96 4.42-1.32 3.47-3.59-.84-1.92-1.92-3.83-3.23-5.63-6.95-9.46-19.15-13.41-30.17-10.41 1.2-9.34-1.19-20.35-7.66-30.41 6.35-2.27 11.97-3.95 17.36-.12 1.55 1.2 3.83-.24 3.47-2.15-.24-1.44-.6-2.88-1.2-4.31-4.67-12.93-18.67-19.64-31.24-14.97a24.5 24.5 0 0 0-6.82 3.95c-2.87-1.31-5.86-2.27-8.98-2.51-6.22-1.32-12.32-.48-17.35 2.75-2.03 1.32-3.83 2.99-5.39 4.91-7.66 10.18-7.06 27.53 2.4 42.62l.36.48c8.97 14 23.1 21.9 35.07 20.83-1.68 7.18-.48 14.84 3.71 21.54 1.19 1.92 2.63 3.6 4.19 5.03 1.31.96 3.47.12 3.47-1.55Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__a",
    x1: 3262.21,
    x2: 2036.69,
    y1: 2046.47,
    y2: 281.608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__c",
    x1: 1823.79,
    x2: 1921.61,
    y1: 51.385,
    y2: 51.385,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__d",
    x1: 3348.56,
    x2: 2123.04,
    y1: 1986.56,
    y2: 221.704,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__e",
    x1: 1981.3,
    x2: 2079.12,
    y1: 93.988,
    y2: 93.988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__f",
    x1: 3434.89,
    x2: 2209.37,
    y1: 1926.62,
    y2: 161.759,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__g",
    x1: 2138.81,
    x2: 2236.63,
    y1: 136.591,
    y2: 136.591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__h",
    x1: 3521.22,
    x2: 2295.69,
    y1: 1866.67,
    y2: 101.814,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__i",
    x1: 2296.32,
    x2: 2394.14,
    y1: 179.194,
    y2: 179.194,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__j",
    x1: 3607.54,
    x2: 2382.02,
    y1: 1806.73,
    y2: 41.868,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__k",
    x1: 2453.83,
    x2: 2551.65,
    y1: 221.797,
    y2: 221.797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__l",
    x1: 3693.87,
    x2: 2468.35,
    y1: 1746.78,
    y2: -18.078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__m",
    x1: 2611.34,
    x2: 2709.16,
    y1: 264.4,
    y2: 264.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__n",
    x1: 3780.2,
    x2: 2554.68,
    y1: 1686.84,
    y2: -78.024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__o",
    x1: 2768.85,
    x2: 2866.67,
    y1: 307.004,
    y2: 307.004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__p",
    x1: 3866.53,
    x2: 2641,
    y1: 1626.89,
    y2: -137.969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__q",
    x1: 2926.36,
    x2: 3024.18,
    y1: 349.607,
    y2: 349.607,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__r",
    x1: 3158.61,
    x2: 1933.09,
    y1: 2118.46,
    y2: 353.606,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__s",
    x1: 1727.12,
    x2: 1824.94,
    y1: 133.349,
    y2: 133.349,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__t",
    x1: 3244.94,
    x2: 2019.42,
    y1: 2058.52,
    y2: 293.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__u",
    x1: 1884.63,
    x2: 1982.45,
    y1: 175.952,
    y2: 175.952,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__v",
    x1: 3331.27,
    x2: 2105.75,
    y1: 1998.57,
    y2: 233.714,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__w",
    x1: 2042.14,
    x2: 2139.96,
    y1: 218.555,
    y2: 218.555,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__x",
    x1: 3417.6,
    x2: 2192.08,
    y1: 1938.63,
    y2: 173.766,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__y",
    x1: 2199.65,
    x2: 2297.47,
    y1: 261.159,
    y2: 261.159,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__z",
    x1: 3503.92,
    x2: 2278.4,
    y1: 1878.68,
    y2: 113.822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__A",
    x1: 2357.16,
    x2: 2454.98,
    y1: 303.762,
    y2: 303.762,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__B",
    x1: 3590.25,
    x2: 2364.73,
    y1: 1818.74,
    y2: 53.876,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__C",
    x1: 2514.67,
    x2: 2612.49,
    y1: 346.365,
    y2: 346.365,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__D",
    x1: 3676.58,
    x2: 2451.06,
    y1: 1758.79,
    y2: -6.072,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__E",
    x1: 2672.18,
    x2: 2770,
    y1: 388.968,
    y2: 388.968,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__F",
    x1: 3762.91,
    x2: 2537.38,
    y1: 1698.84,
    y2: -66.015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__G",
    x1: 2829.69,
    x2: 2927.51,
    y1: 431.571,
    y2: 431.571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__H",
    x1: 3054.99,
    x2: 1829.47,
    y1: 2190.42,
    y2: 425.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__I",
    x1: 1630.45,
    x2: 1728.27,
    y1: 215.314,
    y2: 215.314,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__J",
    x1: 3141.32,
    x2: 1915.8,
    y1: 2130.47,
    y2: 365.613,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__K",
    x1: 1787.96,
    x2: 1885.78,
    y1: 257.917,
    y2: 257.917,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__L",
    x1: 3227.65,
    x2: 2002.13,
    y1: 2070.53,
    y2: 305.667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__M",
    x1: 1945.47,
    x2: 2043.28,
    y1: 300.52,
    y2: 300.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__N",
    x1: 3313.97,
    x2: 2088.45,
    y1: 2010.58,
    y2: 245.723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__O",
    x1: 2102.98,
    x2: 2200.8,
    y1: 343.123,
    y2: 343.123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__P",
    x1: 3400.3,
    x2: 2174.78,
    y1: 1950.64,
    y2: 185.777,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__Q",
    x1: 2260.49,
    x2: 2358.31,
    y1: 385.726,
    y2: 385.726,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__R",
    x1: 3486.63,
    x2: 2261.11,
    y1: 1890.69,
    y2: 125.831,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__S",
    x1: 2417.99,
    x2: 2515.81,
    y1: 428.329,
    y2: 428.329,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__T",
    x1: 3572.96,
    x2: 2347.43,
    y1: 1830.74,
    y2: 65.886,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__U",
    x1: 2575.51,
    x2: 2673.32,
    y1: 470.933,
    y2: 470.933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__V",
    x1: 3659.28,
    x2: 2433.76,
    y1: 1770.8,
    y2: 5.939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__W",
    x1: 2733.02,
    x2: 2830.83,
    y1: 513.536,
    y2: 513.536,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__X",
    x1: 2951.37,
    x2: 1725.85,
    y1: 2262.37,
    y2: 497.515,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__Y",
    x1: 1533.78,
    x2: 1631.59,
    y1: 297.278,
    y2: 297.278,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__Z",
    x1: 3037.7,
    x2: 1812.18,
    y1: 2202.43,
    y2: 437.569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__aa",
    x1: 1691.29,
    x2: 1789.1,
    y1: 339.881,
    y2: 339.881,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__ab",
    x1: 3124.03,
    x2: 1898.5,
    y1: 2142.48,
    y2: 377.623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__ac",
    x1: 1848.79,
    x2: 1946.61,
    y1: 382.485,
    y2: 382.485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__ad",
    x1: 3210.36,
    x2: 1984.84,
    y1: 2082.54,
    y2: 317.676,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__ae",
    x1: 2006.3,
    x2: 2104.12,
    y1: 425.088,
    y2: 425.088,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__af",
    x1: 3296.69,
    x2: 2071.16,
    y1: 2022.59,
    y2: 257.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__ag",
    x1: 2163.82,
    x2: 2261.63,
    y1: 467.691,
    y2: 467.691,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__ah",
    x1: 3383.01,
    x2: 2157.49,
    y1: 1962.64,
    y2: 197.786,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__ai",
    x1: 2321.32,
    x2: 2419.14,
    y1: 510.294,
    y2: 510.294,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__aj",
    x1: 3469.34,
    x2: 2243.82,
    y1: 1902.7,
    y2: 137.837,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__ak",
    x1: 2478.83,
    x2: 2576.65,
    y1: 552.897,
    y2: 552.897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__al",
    x1: 3555.66,
    x2: 2330.14,
    y1: 1842.75,
    y2: 77.894,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__am",
    x1: 2636.34,
    x2: 2734.16,
    y1: 595.5,
    y2: 595.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__an",
    x1: 2847.75,
    x2: 1622.23,
    y1: 2334.33,
    y2: 569.469,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__ao",
    x1: 1437.1,
    x2: 1534.92,
    y1: 379.243,
    y2: 379.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__ap",
    x1: 2934.08,
    x2: 1708.56,
    y1: 2274.38,
    y2: 509.522,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__aq",
    x1: 1594.61,
    x2: 1692.43,
    y1: 421.846,
    y2: 421.846,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__ar",
    x1: 3020.41,
    x2: 1794.89,
    y1: 2214.44,
    y2: 449.576,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__as",
    x1: 1752.12,
    x2: 1849.94,
    y1: 464.449,
    y2: 464.449,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__at",
    x1: 3106.73,
    x2: 1881.21,
    y1: 2154.49,
    y2: 389.632,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__au",
    x1: 1909.63,
    x2: 2007.45,
    y1: 507.052,
    y2: 507.052,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__av",
    x1: 3193.06,
    x2: 1967.54,
    y1: 2094.54,
    y2: 329.686,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__aw",
    x1: 2067.14,
    x2: 2164.96,
    y1: 549.655,
    y2: 549.655,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__ax",
    x1: 3279.39,
    x2: 2053.87,
    y1: 2034.6,
    y2: 269.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__ay",
    x1: 2224.65,
    x2: 2322.47,
    y1: 592.259,
    y2: 592.259,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__az",
    x1: 3365.72,
    x2: 2140.2,
    y1: 1974.65,
    y2: 209.793,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__aA",
    x1: 2382.16,
    x2: 2479.98,
    y1: 634.862,
    y2: 634.862,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__aB",
    x1: 3452.04,
    x2: 2226.52,
    y1: 1914.71,
    y2: 149.849,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__aC",
    x1: 2539.67,
    x2: 2637.49,
    y1: 677.465,
    y2: 677.465,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__aD",
    x1: 2744.13,
    x2: 1518.61,
    y1: 2406.28,
    y2: 641.422,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__aE",
    x1: 1340.43,
    x2: 1438.25,
    y1: 461.207,
    y2: 461.207,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__aF",
    x1: 2830.46,
    x2: 1604.94,
    y1: 2346.34,
    y2: 581.478,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__aG",
    x1: 1497.94,
    x2: 1595.76,
    y1: 503.811,
    y2: 503.811,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__aH",
    x1: 2916.79,
    x2: 1691.26,
    y1: 2286.39,
    y2: 521.533,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__aI",
    x1: 1655.45,
    x2: 1753.27,
    y1: 546.414,
    y2: 546.414,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__aJ",
    x1: 3003.11,
    x2: 1777.59,
    y1: 2226.45,
    y2: 461.586,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__aK",
    x1: 1812.96,
    x2: 1910.78,
    y1: 589.017,
    y2: 589.017,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__aL",
    x1: 3089.44,
    x2: 1863.92,
    y1: 2166.5,
    y2: 401.639,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__aM",
    x1: 1970.47,
    x2: 2068.29,
    y1: 631.62,
    y2: 631.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__aN",
    x1: 3175.77,
    x2: 1950.25,
    y1: 2106.55,
    y2: 341.693,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__aO",
    x1: 2127.98,
    x2: 2225.8,
    y1: 674.223,
    y2: 674.223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__aP",
    x1: 3262.1,
    x2: 2036.57,
    y1: 2046.61,
    y2: 281.749,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__aQ",
    x1: 2285.49,
    x2: 2383.31,
    y1: 716.826,
    y2: 716.826,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__aR",
    x1: 3348.42,
    x2: 2122.9,
    y1: 1986.66,
    y2: 221.802,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__aS",
    x1: 2443,
    x2: 2540.82,
    y1: 759.429,
    y2: 759.429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__aT",
    x1: 2640.51,
    x2: 1414.99,
    y1: 2478.24,
    y2: 713.378,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__aU",
    x1: 1243.76,
    x2: 1341.58,
    y1: 543.172,
    y2: 543.172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__aV",
    x1: 2726.84,
    x2: 1501.32,
    y1: 2418.29,
    y2: 653.431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__aW",
    x1: 1401.27,
    x2: 1499.09,
    y1: 585.775,
    y2: 585.775,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__aX",
    x1: 2813.17,
    x2: 1587.64,
    y1: 2358.35,
    y2: 593.485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__aY",
    x1: 1558.78,
    x2: 1656.59,
    y1: 628.378,
    y2: 628.378,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__aZ",
    x1: 2899.49,
    x2: 1673.97,
    y1: 2298.4,
    y2: 533.541,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__ba",
    x1: 1716.29,
    x2: 1814.11,
    y1: 670.981,
    y2: 670.981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__bb",
    x1: 2985.82,
    x2: 1760.3,
    y1: 2238.45,
    y2: 473.596,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__bc",
    x1: 1873.8,
    x2: 1971.62,
    y1: 713.584,
    y2: 713.584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__bd",
    x1: 3072.15,
    x2: 1846.62,
    y1: 2178.51,
    y2: 413.649,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__be",
    x1: 2031.31,
    x2: 2129.12,
    y1: 756.188,
    y2: 756.188,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__bf",
    x1: 3158.48,
    x2: 1932.95,
    y1: 2118.56,
    y2: 353.702,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__bg",
    x1: 2188.82,
    x2: 2286.63,
    y1: 798.791,
    y2: 798.791,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__bh",
    x1: 3244.8,
    x2: 2019.28,
    y1: 2058.62,
    y2: 293.756,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__bi",
    x1: 2346.33,
    x2: 2444.15,
    y1: 841.394,
    y2: 841.394,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__bj",
    x1: 2536.89,
    x2: 1311.37,
    y1: 2550.19,
    y2: 785.332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__bk",
    x1: 1147.08,
    x2: 1244.9,
    y1: 625.136,
    y2: 625.136,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__bl",
    x1: 2623.22,
    x2: 1397.69,
    y1: 2490.25,
    y2: 725.387,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__bm",
    x1: 1304.59,
    x2: 1402.41,
    y1: 667.74,
    y2: 667.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__bn",
    x1: 2709.54,
    x2: 1484.02,
    y1: 2430.3,
    y2: 665.442,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__bo",
    x1: 1462.1,
    x2: 1559.92,
    y1: 710.343,
    y2: 710.343,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__bp",
    x1: 2795.87,
    x2: 1570.35,
    y1: 2370.35,
    y2: 605.495,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__bq",
    x1: 1619.61,
    x2: 1717.43,
    y1: 752.946,
    y2: 752.946,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__br",
    x1: 2882.2,
    x2: 1656.68,
    y1: 2310.41,
    y2: 545.548,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__bs",
    x1: 1777.12,
    x2: 1874.94,
    y1: 795.549,
    y2: 795.549,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__bt",
    x1: 2968.53,
    x2: 1743,
    y1: 2250.46,
    y2: 485.602,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__bu",
    x1: 1934.63,
    x2: 2032.45,
    y1: 838.152,
    y2: 838.152,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__bv",
    x1: 3054.85,
    x2: 1829.33,
    y1: 2190.52,
    y2: 425.658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__bw",
    x1: 2092.14,
    x2: 2189.96,
    y1: 880.755,
    y2: 880.755,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__bx",
    x1: 3141.18,
    x2: 1915.66,
    y1: 2130.57,
    y2: 365.712,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__by",
    x1: 2249.65,
    x2: 2347.47,
    y1: 923.358,
    y2: 923.358,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__bz",
    x1: 2433.27,
    x2: 1207.75,
    y1: 2622.15,
    y2: 857.288,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__bA",
    x1: 1050.41,
    x2: 1148.23,
    y1: 707.101,
    y2: 707.101,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__bB",
    x1: 2519.6,
    x2: 1294.07,
    y1: 2562.2,
    y2: 797.342,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__bC",
    x1: 1207.92,
    x2: 1305.74,
    y1: 749.704,
    y2: 749.704,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__bD",
    x1: 2605.93,
    x2: 1380.4,
    y1: 2502.26,
    y2: 737.394,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__bE",
    x1: 1365.43,
    x2: 1463.25,
    y1: 792.307,
    y2: 792.307,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__bF",
    x1: 2692.25,
    x2: 1466.73,
    y1: 2442.31,
    y2: 677.448,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__bG",
    x1: 1522.94,
    x2: 1620.76,
    y1: 834.91,
    y2: 834.91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__bH",
    x1: 2778.58,
    x2: 1553.06,
    y1: 2382.36,
    y2: 617.504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__bI",
    x1: 1680.45,
    x2: 1778.27,
    y1: 877.514,
    y2: 877.514,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__bJ",
    x1: 2864.9,
    x2: 1639.38,
    y1: 2322.42,
    y2: 557.559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__bK",
    x1: 1837.96,
    x2: 1935.78,
    y1: 920.117,
    y2: 920.117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__bL",
    x1: 2951.23,
    x2: 1725.71,
    y1: 2262.47,
    y2: 497.613,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__bM",
    x1: 1995.47,
    x2: 2093.29,
    y1: 962.72,
    y2: 962.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__bN",
    x1: 3037.56,
    x2: 1812.04,
    y1: 2202.53,
    y2: 437.665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__bO",
    x1: 2152.98,
    x2: 2250.8,
    y1: 1005.32,
    y2: 1005.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__bP",
    x1: 2329.65,
    x2: 1104.13,
    y1: 2694.1,
    y2: 929.242,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__bQ",
    x1: 953.739,
    x2: 1051.56,
    y1: 789.066,
    y2: 789.066,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__bR",
    x1: 2415.98,
    x2: 1190.45,
    y1: 2634.16,
    y2: 869.296,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__bS",
    x1: 1111.25,
    x2: 1209.07,
    y1: 831.669,
    y2: 831.669,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__bT",
    x1: 2502.3,
    x2: 1276.78,
    y1: 2574.21,
    y2: 809.351,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__bU",
    x1: 1268.76,
    x2: 1366.58,
    y1: 874.272,
    y2: 874.272,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__bV",
    x1: 2588.63,
    x2: 1363.11,
    y1: 2514.26,
    y2: 749.405,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__bW",
    x1: 1426.27,
    x2: 1524.09,
    y1: 916.875,
    y2: 916.875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__bX",
    x1: 2674.96,
    x2: 1449.44,
    y1: 2454.32,
    y2: 689.457,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__bY",
    x1: 1583.78,
    x2: 1681.6,
    y1: 959.478,
    y2: 959.478,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__bZ",
    x1: 2761.29,
    x2: 1535.76,
    y1: 2394.37,
    y2: 629.512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__ca",
    x1: 1741.29,
    x2: 1839.11,
    y1: 1002.08,
    y2: 1002.08,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__cb",
    x1: 2847.61,
    x2: 1622.09,
    y1: 2334.43,
    y2: 569.567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__cc",
    x1: 1898.8,
    x2: 1996.62,
    y1: 1044.68,
    y2: 1044.68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__cd",
    x1: 2933.94,
    x2: 1708.42,
    y1: 2274.48,
    y2: 509.621,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__ce",
    x1: 2056.31,
    x2: 2154.13,
    y1: 1087.29,
    y2: 1087.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__cf",
    x1: 3941.39,
    x2: 2715.87,
    y1: 1574.9,
    y2: -189.954,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__cg",
    x1: 3067.6,
    x2: 3165.42,
    y1: 393.246,
    y2: 393.246,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__ch",
    x1: 4027.72,
    x2: 2802.2,
    y1: 1514.96,
    y2: -249.903,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__ci",
    x1: 3225.11,
    x2: 3322.93,
    y1: 435.85,
    y2: 435.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__cj",
    x1: 4114.04,
    x2: 2888.52,
    y1: 1455.01,
    y2: -309.846,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__ck",
    x1: 3382.62,
    x2: 3480.44,
    y1: 478.453,
    y2: 478.453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__cl",
    x1: 4200.37,
    x2: 2974.85,
    y1: 1395.07,
    y2: -369.792,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__cm",
    x1: 3540.13,
    x2: 3637.95,
    y1: 521.056,
    y2: 521.056,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__cn",
    x1: 4286.7,
    x2: 3061.18,
    y1: 1335.12,
    y2: -429.738,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__co",
    x1: 3697.64,
    x2: 3795.46,
    y1: 563.659,
    y2: 563.659,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__cp",
    x1: 4373.03,
    x2: 3147.5,
    y1: 1275.18,
    y2: -489.684,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__cq",
    x1: 3855.15,
    x2: 3952.97,
    y1: 606.262,
    y2: 606.262,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__cr",
    x1: 4459.35,
    x2: 3233.83,
    y1: 1215.23,
    y2: -549.633,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__cs",
    x1: 4012.66,
    x2: 4110.48,
    y1: 648.865,
    y2: 648.865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__ct",
    x1: 4545.68,
    x2: 3320.16,
    y1: 1155.28,
    y2: -609.575,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__cu",
    x1: 4170.17,
    x2: 4267.99,
    y1: 691.468,
    y2: 691.468,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__cv",
    x1: 3837.77,
    x2: 2612.25,
    y1: 1646.86,
    y2: -118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__cw",
    x1: 2970.93,
    x2: 3068.75,
    y1: 475.211,
    y2: 475.211,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__cx",
    x1: 3924.1,
    x2: 2698.57,
    y1: 1586.91,
    y2: -177.945,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__cy",
    x1: 3128.44,
    x2: 3226.26,
    y1: 517.814,
    y2: 517.814,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__cz",
    x1: 4010.42,
    x2: 2784.9,
    y1: 1526.97,
    y2: -237.892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__cA",
    x1: 3285.95,
    x2: 3383.77,
    y1: 560.417,
    y2: 560.417,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__cB",
    x1: 4096.75,
    x2: 2871.23,
    y1: 1467.02,
    y2: -297.838,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__cC",
    x1: 3443.46,
    x2: 3541.28,
    y1: 603.02,
    y2: 603.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__cD",
    x1: 4183.08,
    x2: 2957.56,
    y1: 1407.08,
    y2: -357.786,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__cE",
    x1: 3600.97,
    x2: 3698.79,
    y1: 645.624,
    y2: 645.624,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__cF",
    x1: 4269.4,
    x2: 3043.88,
    y1: 1347.13,
    y2: -417.729,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__cG",
    x1: 3758.48,
    x2: 3856.3,
    y1: 688.227,
    y2: 688.227,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__cH",
    x1: 4355.73,
    x2: 3130.21,
    y1: 1287.18,
    y2: -477.675,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__cI",
    x1: 3915.99,
    x2: 4013.81,
    y1: 730.83,
    y2: 730.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__cJ",
    x1: 4442.06,
    x2: 3216.54,
    y1: 1227.24,
    y2: -537.621,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__cK",
    x1: 4073.5,
    x2: 4171.32,
    y1: 773.433,
    y2: 773.433,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__cL",
    x1: 3734.15,
    x2: 2508.63,
    y1: 1718.81,
    y2: -46.045,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__cM",
    x1: 2874.26,
    x2: 2972.08,
    y1: 557.176,
    y2: 557.176,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__cN",
    x1: 3820.48,
    x2: 2594.95,
    y1: 1658.87,
    y2: -105.991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__cO",
    x1: 3031.77,
    x2: 3129.59,
    y1: 599.779,
    y2: 599.779,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__cP",
    x1: 3906.8,
    x2: 2681.28,
    y1: 1598.92,
    y2: -165.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__cQ",
    x1: 3189.27,
    x2: 3287.09,
    y1: 642.382,
    y2: 642.382,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__cR",
    x1: 3993.13,
    x2: 2767.61,
    y1: 1538.98,
    y2: -225.883,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__cS",
    x1: 3346.79,
    x2: 3444.6,
    y1: 684.985,
    y2: 684.985,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__cT",
    x1: 4079.46,
    x2: 2853.93,
    y1: 1479.03,
    y2: -285.829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__cU",
    x1: 3504.3,
    x2: 3602.11,
    y1: 727.588,
    y2: 727.588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__cV",
    x1: 4165.78,
    x2: 2940.26,
    y1: 1419.08,
    y2: -345.774,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__cW",
    x1: 3661.8,
    x2: 3759.62,
    y1: 770.191,
    y2: 770.191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__cX",
    x1: 4252.11,
    x2: 3026.59,
    y1: 1359.14,
    y2: -405.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__cY",
    x1: 3819.32,
    x2: 3917.13,
    y1: 812.794,
    y2: 812.794,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__cZ",
    x1: 4338.44,
    x2: 3112.92,
    y1: 1299.19,
    y2: -465.669,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__da",
    x1: 3976.83,
    x2: 4074.64,
    y1: 855.397,
    y2: 855.397,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__db",
    x1: 3630.53,
    x2: 2405,
    y1: 1790.77,
    y2: 25.909,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__dc",
    x1: 2777.58,
    x2: 2875.4,
    y1: 639.14,
    y2: 639.14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__dd",
    x1: 3716.85,
    x2: 2491.33,
    y1: 1730.82,
    y2: -34.037,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__de",
    x1: 2935.09,
    x2: 3032.91,
    y1: 681.743,
    y2: 681.743,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__df",
    x1: 3803.18,
    x2: 2577.66,
    y1: 1670.88,
    y2: -93.983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__dg",
    x1: 3092.6,
    x2: 3190.42,
    y1: 724.346,
    y2: 724.346,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__dh",
    x1: 3889.51,
    x2: 2663.99,
    y1: 1610.93,
    y2: -153.928,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__di",
    x1: 3250.11,
    x2: 3347.93,
    y1: 766.949,
    y2: 766.949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__dj",
    x1: 3975.84,
    x2: 2750.32,
    y1: 1550.99,
    y2: -213.877,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__dk",
    x1: 3407.62,
    x2: 3505.44,
    y1: 809.553,
    y2: 809.553,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__dl",
    x1: 4062.16,
    x2: 2836.64,
    y1: 1491.04,
    y2: -273.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__dm",
    x1: 3565.13,
    x2: 3662.95,
    y1: 852.156,
    y2: 852.156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__dn",
    x1: 4148.49,
    x2: 2922.97,
    y1: 1431.09,
    y2: -333.766,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__do",
    x1: 3722.64,
    x2: 3820.46,
    y1: 894.759,
    y2: 894.759,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__dp",
    x1: 4234.82,
    x2: 3009.3,
    y1: 1371.15,
    y2: -393.712,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__dq",
    x1: 3880.15,
    x2: 3977.97,
    y1: 937.362,
    y2: 937.362,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__dr",
    x1: 3526.91,
    x2: 2301.38,
    y1: 1862.72,
    y2: 97.864,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__ds",
    x1: 2680.91,
    x2: 2778.73,
    y1: 721.105,
    y2: 721.105,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__dt",
    x1: 3613.23,
    x2: 2387.71,
    y1: 1802.78,
    y2: 37.918,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__du",
    x1: 2838.42,
    x2: 2936.24,
    y1: 763.708,
    y2: 763.708,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__dv",
    x1: 3699.56,
    x2: 2474.04,
    y1: 1742.83,
    y2: -22.031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__dw",
    x1: 2995.93,
    x2: 3093.75,
    y1: 806.311,
    y2: 806.311,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__dx",
    x1: 3785.89,
    x2: 2560.36,
    y1: 1682.89,
    y2: -81.974,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__dy",
    x1: 3153.44,
    x2: 3251.26,
    y1: 848.914,
    y2: 848.914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__dz",
    x1: 3872.22,
    x2: 2646.69,
    y1: 1622.94,
    y2: -141.919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__dA",
    x1: 3310.95,
    x2: 3408.77,
    y1: 891.517,
    y2: 891.517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__dB",
    x1: 3958.54,
    x2: 2733.02,
    y1: 1562.99,
    y2: -201.865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__dC",
    x1: 3468.46,
    x2: 3566.28,
    y1: 934.12,
    y2: 934.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__dD",
    x1: 4044.87,
    x2: 2819.35,
    y1: 1503.05,
    y2: -261.811,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__dE",
    x1: 3625.97,
    x2: 3723.79,
    y1: 976.723,
    y2: 976.723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__dF",
    x1: 4131.2,
    x2: 2905.68,
    y1: 1443.1,
    y2: -321.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__dG",
    x1: 3783.48,
    x2: 3881.3,
    y1: 1019.33,
    y2: 1019.33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__dH",
    x1: 3423.29,
    x2: 2197.77,
    y1: 1934.68,
    y2: 169.815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__dI",
    x1: 2584.24,
    x2: 2682.06,
    y1: 803.069,
    y2: 803.069,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__dJ",
    x1: 3509.61,
    x2: 2284.09,
    y1: 1874.73,
    y2: 109.872,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__dK",
    x1: 2741.75,
    x2: 2839.57,
    y1: 845.672,
    y2: 845.672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__dL",
    x1: 3595.94,
    x2: 2370.42,
    y1: 1814.79,
    y2: 49.927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__dM",
    x1: 2899.26,
    x2: 2997.08,
    y1: 888.275,
    y2: 888.275,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__dN",
    x1: 3682.27,
    x2: 2456.74,
    y1: 1754.84,
    y2: -10.019,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__dO",
    x1: 3056.77,
    x2: 3154.59,
    y1: 930.878,
    y2: 930.878,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__dP",
    x1: 3768.59,
    x2: 2543.07,
    y1: 1694.89,
    y2: -69.965,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__dQ",
    x1: 3214.28,
    x2: 3312.1,
    y1: 973.482,
    y2: 973.482,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__dR",
    x1: 3854.92,
    x2: 2629.4,
    y1: 1634.95,
    y2: -129.914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__dS",
    x1: 3371.79,
    x2: 3469.61,
    y1: 1016.08,
    y2: 1016.08,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__dT",
    x1: 3941.25,
    x2: 2715.73,
    y1: 1575,
    y2: -189.857,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__dU",
    x1: 3529.3,
    x2: 3627.12,
    y1: 1058.69,
    y2: 1058.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__dV",
    x1: 4027.58,
    x2: 2802.05,
    y1: 1515.06,
    y2: -249.802,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__dW",
    x1: 3686.81,
    x2: 3784.63,
    y1: 1101.29,
    y2: 1101.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__dX",
    x1: 3319.67,
    x2: 2094.14,
    y1: 2006.63,
    y2: 241.773,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__dY",
    x1: 2487.57,
    x2: 2585.39,
    y1: 885.034,
    y2: 885.034,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__dZ",
    x1: 3405.99,
    x2: 2180.47,
    y1: 1946.69,
    y2: 181.827,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__ea",
    x1: 2645.08,
    x2: 2742.9,
    y1: 927.637,
    y2: 927.637,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__eb",
    x1: 3492.32,
    x2: 2266.8,
    y1: 1886.74,
    y2: 121.878,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__ec",
    x1: 2802.59,
    x2: 2900.4,
    y1: 970.24,
    y2: 970.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__ed",
    x1: 3578.65,
    x2: 2353.12,
    y1: 1826.79,
    y2: 61.935,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__ee",
    x1: 2960.1,
    x2: 3057.91,
    y1: 1012.84,
    y2: 1012.84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__ef",
    x1: 3664.97,
    x2: 2439.45,
    y1: 1766.85,
    y2: 1.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__eg",
    x1: 3117.61,
    x2: 3215.43,
    y1: 1055.45,
    y2: 1055.45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__eh",
    x1: 3751.3,
    x2: 2525.78,
    y1: 1706.9,
    y2: -57.956,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__ei",
    x1: 3275.11,
    x2: 3372.93,
    y1: 1098.05,
    y2: 1098.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__ej",
    x1: 3837.63,
    x2: 2612.11,
    y1: 1646.96,
    y2: -117.902,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__ek",
    x1: 3432.63,
    x2: 3530.44,
    y1: 1140.65,
    y2: 1140.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__el",
    x1: 3923.96,
    x2: 2698.44,
    y1: 1587.01,
    y2: -177.851,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__em",
    x1: 3590.14,
    x2: 3687.95,
    y1: 1183.26,
    y2: 1183.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__en",
    x1: 3216.05,
    x2: 1990.52,
    y1: 2078.59,
    y2: 313.726,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__eo",
    x1: 2390.89,
    x2: 2488.71,
    y1: 966.998,
    y2: 966.998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__ep",
    x1: 3302.37,
    x2: 2076.85,
    y1: 2018.64,
    y2: 253.782,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__eq",
    x1: 2548.4,
    x2: 2646.22,
    y1: 1009.6,
    y2: 1009.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__er",
    x1: 3388.7,
    x2: 2163.18,
    y1: 1958.69,
    y2: 193.836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__es",
    x1: 2705.91,
    x2: 2803.73,
    y1: 1052.2,
    y2: 1052.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__et",
    x1: 3475.03,
    x2: 2249.5,
    y1: 1898.75,
    y2: 133.89,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__eu",
    x1: 2863.42,
    x2: 2961.24,
    y1: 1094.81,
    y2: 1094.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__ev",
    x1: 3561.35,
    x2: 2335.83,
    y1: 1838.8,
    y2: 73.944,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__ew",
    x1: 3020.93,
    x2: 3118.75,
    y1: 1137.41,
    y2: 1137.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__ex",
    x1: 3647.68,
    x2: 2422.16,
    y1: 1778.86,
    y2: 13.995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__ey",
    x1: 3178.44,
    x2: 3276.26,
    y1: 1180.01,
    y2: 1180.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__ez",
    x1: 3734.01,
    x2: 2508.49,
    y1: 1718.91,
    y2: -45.948,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__eA",
    x1: 3335.95,
    x2: 3433.77,
    y1: 1222.62,
    y2: 1222.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__eB",
    x1: 3820.34,
    x2: 2594.81,
    y1: 1658.97,
    y2: -105.893,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__eC",
    x1: 3493.46,
    x2: 3591.28,
    y1: 1265.22,
    y2: 1265.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__eD",
    x1: 3112.43,
    x2: 1886.9,
    y1: 2150.54,
    y2: 385.68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__eE",
    x1: 2294.22,
    x2: 2392.04,
    y1: 1048.96,
    y2: 1048.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__eF",
    x1: 3198.75,
    x2: 1973.23,
    y1: 2090.6,
    y2: 325.736,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__eG",
    x1: 2451.73,
    x2: 2549.55,
    y1: 1091.57,
    y2: 1091.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__eH",
    x1: 3285.08,
    x2: 2059.55,
    y1: 2030.65,
    y2: 265.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__eI",
    x1: 2609.24,
    x2: 2707.06,
    y1: 1134.17,
    y2: 1134.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__eJ",
    x1: 3371.41,
    x2: 2145.89,
    y1: 1970.7,
    y2: 205.841,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__eK",
    x1: 2766.75,
    x2: 2864.57,
    y1: 1176.77,
    y2: 1176.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__eL",
    x1: 3457.73,
    x2: 2232.21,
    y1: 1910.76,
    y2: 145.898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__eM",
    x1: 2924.26,
    x2: 3022.08,
    y1: 1219.38,
    y2: 1219.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__eN",
    x1: 3544.06,
    x2: 2318.54,
    y1: 1850.81,
    y2: 85.953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__eO",
    x1: 3081.77,
    x2: 3179.59,
    y1: 1261.98,
    y2: 1261.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__eP",
    x1: 3630.39,
    x2: 2404.86,
    y1: 1790.87,
    y2: 26.007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__eQ",
    x1: 3239.28,
    x2: 3337.1,
    y1: 1304.58,
    y2: 1304.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__eR",
    x1: 3716.72,
    x2: 2491.19,
    y1: 1730.92,
    y2: -33.939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__eS",
    x1: 3396.79,
    x2: 3494.61,
    y1: 1347.18,
    y2: 1347.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__eT",
    x1: 3008.8,
    x2: 1783.28,
    y1: 2222.5,
    y2: 457.637,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__eU",
    x1: 2197.55,
    x2: 2295.37,
    y1: 1130.93,
    y2: 1130.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__eV",
    x1: 3095.13,
    x2: 1869.61,
    y1: 2162.55,
    y2: 397.691,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__eW",
    x1: 2355.06,
    x2: 2452.88,
    y1: 1173.53,
    y2: 1173.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__eX",
    x1: 3181.46,
    x2: 1955.93,
    y1: 2102.6,
    y2: 337.745,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__eY",
    x1: 2512.57,
    x2: 2610.39,
    y1: 1216.13,
    y2: 1216.13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__eZ",
    x1: 3267.78,
    x2: 2042.26,
    y1: 2042.66,
    y2: 277.799,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__fa",
    x1: 2670.08,
    x2: 2767.9,
    y1: 1258.74,
    y2: 1258.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__fb",
    x1: 3354.11,
    x2: 2128.59,
    y1: 1982.71,
    y2: 217.853,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__fc",
    x1: 2827.59,
    x2: 2925.41,
    y1: 1301.34,
    y2: 1301.34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__fd",
    x1: 3440.44,
    x2: 2214.91,
    y1: 1922.77,
    y2: 157.907,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__fe",
    x1: 2985.1,
    x2: 3082.92,
    y1: 1343.94,
    y2: 1343.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__ff",
    x1: 3526.77,
    x2: 2301.24,
    y1: 1862.82,
    y2: 97.958,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__fg",
    x1: 3142.61,
    x2: 3240.43,
    y1: 1386.55,
    y2: 1386.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__fh",
    x1: 3613.09,
    x2: 2387.57,
    y1: 1802.88,
    y2: 38.015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__fi",
    x1: 3300.12,
    x2: 3397.93,
    y1: 1429.15,
    y2: 1429.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__fj",
    x1: 2227.86,
    x2: 1002.34,
    y1: 2764.79,
    y2: 999.926,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__fk",
    x1: 870.054,
    x2: 967.873,
    y1: 885.836,
    y2: 885.836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__fl",
    x1: 2314.18,
    x2: 1088.66,
    y1: 2704.84,
    y2: 939.981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__fm",
    x1: 1027.56,
    x2: 1125.38,
    y1: 928.439,
    y2: 928.439,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__fn",
    x1: 2400.51,
    x2: 1174.99,
    y1: 2644.9,
    y2: 880.036,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__fo",
    x1: 1185.07,
    x2: 1282.89,
    y1: 971.043,
    y2: 971.043,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__fp",
    x1: 2486.84,
    x2: 1261.31,
    y1: 2584.95,
    y2: 820.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__fq",
    x1: 1342.58,
    x2: 1440.4,
    y1: 1013.65,
    y2: 1013.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__fr",
    x1: 2573.17,
    x2: 1347.64,
    y1: 2525,
    y2: 760.142,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__fs",
    x1: 1500.09,
    x2: 1597.91,
    y1: 1056.25,
    y2: 1056.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__ft",
    x1: 2659.49,
    x2: 1433.97,
    y1: 2465.06,
    y2: 700.196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__fu",
    x1: 1657.6,
    x2: 1755.42,
    y1: 1098.85,
    y2: 1098.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__fv",
    x1: 2745.82,
    x2: 1520.3,
    y1: 2405.11,
    y2: 640.252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__fw",
    x1: 1815.11,
    x2: 1912.93,
    y1: 1141.46,
    y2: 1141.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__fx",
    x1: 2832.15,
    x2: 1606.62,
    y1: 2345.17,
    y2: 580.306,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__fy",
    x1: 1972.62,
    x2: 2070.44,
    y1: 1184.06,
    y2: 1184.06,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__fz",
    x1: 2124.24,
    x2: 898.714,
    y1: 2836.74,
    y2: 1071.88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__fA",
    x1: 773.38,
    x2: 871.2,
    y1: 967.801,
    y2: 967.801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__fB",
    x1: 2210.56,
    x2: 985.041,
    y1: 2776.79,
    y2: 1011.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__fC",
    x1: 930.89,
    x2: 1028.71,
    y1: 1010.4,
    y2: 1010.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__fD",
    x1: 2296.89,
    x2: 1071.37,
    y1: 2716.85,
    y2: 951.989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__fE",
    x1: 1088.4,
    x2: 1186.22,
    y1: 1053.01,
    y2: 1053.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__fF",
    x1: 2383.22,
    x2: 1157.69,
    y1: 2656.9,
    y2: 892.044,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__fG",
    x1: 1245.91,
    x2: 1343.73,
    y1: 1095.61,
    y2: 1095.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__fH",
    x1: 2469.54,
    x2: 1244.02,
    y1: 2596.96,
    y2: 832.098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__fI",
    x1: 1403.42,
    x2: 1501.24,
    y1: 1138.21,
    y2: 1138.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__fJ",
    x1: 2555.87,
    x2: 1330.35,
    y1: 2537.01,
    y2: 772.153,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__fK",
    x1: 1560.93,
    x2: 1658.75,
    y1: 1180.82,
    y2: 1180.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__fL",
    x1: 2642.2,
    x2: 1416.68,
    y1: 2477.07,
    y2: 712.205,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__fM",
    x1: 1718.44,
    x2: 1816.26,
    y1: 1223.42,
    y2: 1223.42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__fN",
    x1: 2728.53,
    x2: 1503.01,
    y1: 2417.12,
    y2: 652.259,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__fO",
    x1: 1875.95,
    x2: 1973.77,
    y1: 1266.02,
    y2: 1266.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__fP",
    x1: 2020.62,
    x2: 795.093,
    y1: 2908.7,
    y2: 1143.84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__fQ",
    x1: 676.709,
    x2: 774.528,
    y1: 1049.77,
    y2: 1049.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__fR",
    x1: 2106.94,
    x2: 881.42,
    y1: 2848.75,
    y2: 1083.89,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__fS",
    x1: 834.218,
    x2: 932.037,
    y1: 1092.37,
    y2: 1092.37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__fT",
    x1: 2193.27,
    x2: 967.746,
    y1: 2788.8,
    y2: 1023.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__fU",
    x1: 991.729,
    x2: 1089.55,
    y1: 1134.97,
    y2: 1134.97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__fV",
    x1: 2279.6,
    x2: 1054.07,
    y1: 2728.86,
    y2: 963.999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__fW",
    x1: 1149.24,
    x2: 1247.06,
    y1: 1177.57,
    y2: 1177.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__fX",
    x1: 2365.92,
    x2: 1140.4,
    y1: 2668.91,
    y2: 904.051,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__fY",
    x1: 1306.75,
    x2: 1404.57,
    y1: 1220.18,
    y2: 1220.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__fZ",
    x1: 2452.25,
    x2: 1226.73,
    y1: 2608.97,
    y2: 844.105,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__ga",
    x1: 1464.26,
    x2: 1562.08,
    y1: 1262.78,
    y2: 1262.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__gb",
    x1: 2538.58,
    x2: 1313.06,
    y1: 2549.02,
    y2: 784.161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__gc",
    x1: 1621.77,
    x2: 1719.59,
    y1: 1305.38,
    y2: 1305.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__gd",
    x1: 2624.9,
    x2: 1399.38,
    y1: 2489.07,
    y2: 724.215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__ge",
    x1: 1779.28,
    x2: 1877.1,
    y1: 1347.99,
    y2: 1347.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__gf",
    x1: 1916.99,
    x2: 691.471,
    y1: 2980.65,
    y2: 1215.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__gg",
    x1: 580.036,
    x2: 677.855,
    y1: 1131.73,
    y2: 1131.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__gh",
    x1: 2003.32,
    x2: 777.8,
    y1: 2920.7,
    y2: 1155.84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__gi",
    x1: 737.546,
    x2: 835.365,
    y1: 1174.33,
    y2: 1174.33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__gj",
    x1: 2089.65,
    x2: 864.127,
    y1: 2860.76,
    y2: 1095.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__gk",
    x1: 895.056,
    x2: 992.875,
    y1: 1216.94,
    y2: 1216.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__gl",
    x1: 2175.98,
    x2: 950.452,
    y1: 2800.81,
    y2: 1035.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__gm",
    x1: 1052.57,
    x2: 1150.38,
    y1: 1259.54,
    y2: 1259.54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__gn",
    x1: 2262.3,
    x2: 1036.78,
    y1: 2740.87,
    y2: 976.007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__go",
    x1: 1210.08,
    x2: 1307.89,
    y1: 1302.14,
    y2: 1302.14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__gp",
    x1: 2348.63,
    x2: 1123.11,
    y1: 2680.92,
    y2: 916.062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__gq",
    x1: 1367.59,
    x2: 1465.4,
    y1: 1344.75,
    y2: 1344.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__gr",
    x1: 2434.96,
    x2: 1209.44,
    y1: 2620.97,
    y2: 856.116,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__gs",
    x1: 1525.1,
    x2: 1622.91,
    y1: 1387.35,
    y2: 1387.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__gt",
    x1: 2521.28,
    x2: 1295.76,
    y1: 2561.03,
    y2: 796.168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__gu",
    x1: 1682.6,
    x2: 1780.42,
    y1: 1429.95,
    y2: 1429.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__gv",
    x1: 1813.37,
    x2: 587.85,
    y1: 3052.6,
    y2: 1287.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__gw",
    x1: 483.363,
    x2: 581.182,
    y1: 1213.69,
    y2: 1213.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__gx",
    x1: 1899.7,
    x2: 674.177,
    y1: 2992.66,
    y2: 1227.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__gy",
    x1: 640.872,
    x2: 738.691,
    y1: 1256.3,
    y2: 1256.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__gz",
    x1: 1986.03,
    x2: 760.505,
    y1: 2932.71,
    y2: 1167.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__gA",
    x1: 798.383,
    x2: 896.202,
    y1: 1298.9,
    y2: 1298.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__gB",
    x1: 2072.35,
    x2: 846.833,
    y1: 2872.77,
    y2: 1107.91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__gC",
    x1: 955.892,
    x2: 1053.71,
    y1: 1341.5,
    y2: 1341.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__gD",
    x1: 2158.68,
    x2: 933.158,
    y1: 2812.82,
    y2: 1047.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__gE",
    x1: 1113.4,
    x2: 1211.22,
    y1: 1384.11,
    y2: 1384.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__gF",
    x1: 2245.01,
    x2: 1019.49,
    y1: 2752.88,
    y2: 988.015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__gG",
    x1: 1270.91,
    x2: 1368.73,
    y1: 1426.71,
    y2: 1426.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__gH",
    x1: 2331.34,
    x2: 1105.81,
    y1: 2692.93,
    y2: 928.07,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__gI",
    x1: 1428.42,
    x2: 1526.24,
    y1: 1469.31,
    y2: 1469.31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__gJ",
    x1: 2417.66,
    x2: 1192.14,
    y1: 2632.98,
    y2: 868.125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__gK",
    x1: 1585.93,
    x2: 1683.75,
    y1: 1511.92,
    y2: 1511.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__gL",
    x1: 1709.75,
    x2: 484.228,
    y1: 3124.56,
    y2: 1359.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__gM",
    x1: 386.69,
    x2: 484.509,
    y1: 1295.66,
    y2: 1295.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__gN",
    x1: 1796.08,
    x2: 570.557,
    y1: 3064.61,
    y2: 1299.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__gO",
    x1: 544.2,
    x2: 642.019,
    y1: 1338.26,
    y2: 1338.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__gP",
    x1: 1882.41,
    x2: 656.885,
    y1: 3004.67,
    y2: 1239.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__gQ",
    x1: 701.71,
    x2: 799.529,
    y1: 1380.87,
    y2: 1380.87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__gR",
    x1: 1968.73,
    x2: 743.212,
    y1: 2944.72,
    y2: 1179.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__gS",
    x1: 859.22,
    x2: 957.039,
    y1: 1423.47,
    y2: 1423.47,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__gT",
    x1: 2055.06,
    x2: 829.537,
    y1: 2884.78,
    y2: 1119.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__gU",
    x1: 1016.73,
    x2: 1114.55,
    y1: 1466.07,
    y2: 1466.07,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__gV",
    x1: 2141.39,
    x2: 915.863,
    y1: 2824.83,
    y2: 1059.97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__gW",
    x1: 1174.24,
    x2: 1272.06,
    y1: 1508.67,
    y2: 1508.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__gX",
    x1: 2227.71,
    x2: 1002.19,
    y1: 2764.88,
    y2: 1000.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__gY",
    x1: 1331.75,
    x2: 1429.57,
    y1: 1551.28,
    y2: 1551.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__gZ",
    x1: 2314.04,
    x2: 1088.52,
    y1: 2704.94,
    y2: 940.077,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__ha",
    x1: 1489.26,
    x2: 1587.08,
    y1: 1593.88,
    y2: 1593.88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__hb",
    x1: 1606.13,
    x2: 380.607,
    y1: 3196.52,
    y2: 1431.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__hc",
    x1: 290.018,
    x2: 387.837,
    y1: 1377.62,
    y2: 1377.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__hd",
    x1: 1692.46,
    x2: 466.936,
    y1: 3136.57,
    y2: 1371.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__he",
    x1: 447.527,
    x2: 545.346,
    y1: 1420.23,
    y2: 1420.23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__hf",
    x1: 1778.79,
    x2: 553.264,
    y1: 3076.62,
    y2: 1311.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__hg",
    x1: 605.038,
    x2: 702.857,
    y1: 1462.83,
    y2: 1462.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__hh",
    x1: 1865.11,
    x2: 639.59,
    y1: 3016.68,
    y2: 1251.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__hi",
    x1: 762.547,
    x2: 860.366,
    y1: 1505.43,
    y2: 1505.43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__hj",
    x1: 1951.44,
    x2: 725.918,
    y1: 2956.73,
    y2: 1191.87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__hk",
    x1: 920.057,
    x2: 1017.88,
    y1: 1548.04,
    y2: 1548.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__hl",
    x1: 2037.77,
    x2: 812.244,
    y1: 2896.79,
    y2: 1131.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__hm",
    x1: 1077.57,
    x2: 1175.39,
    y1: 1590.64,
    y2: 1590.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__hn",
    x1: 2124.09,
    x2: 898.571,
    y1: 2836.84,
    y2: 1071.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__ho",
    x1: 1235.08,
    x2: 1332.9,
    y1: 1633.24,
    y2: 1633.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__hp",
    x1: 2210.42,
    x2: 984.9,
    y1: 2776.89,
    y2: 1012.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__hq",
    x1: 1392.59,
    x2: 1490.41,
    y1: 1675.85,
    y2: 1675.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__hr",
    x1: 1502.51,
    x2: 276.987,
    y1: 3268.47,
    y2: 1503.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__hs",
    x1: 193.345,
    x2: 291.164,
    y1: 1459.59,
    y2: 1459.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__ht",
    x1: 1588.84,
    x2: 363.314,
    y1: 3208.52,
    y2: 1443.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__hu",
    x1: 350.855,
    x2: 448.675,
    y1: 1502.19,
    y2: 1502.19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__hv",
    x1: 1675.16,
    x2: 449.643,
    y1: 3148.58,
    y2: 1383.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__hw",
    x1: 508.365,
    x2: 606.184,
    y1: 1544.79,
    y2: 1544.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__hx",
    x1: 1761.49,
    x2: 535.971,
    y1: 3088.63,
    y2: 1323.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__hy",
    x1: 665.875,
    x2: 763.694,
    y1: 1587.4,
    y2: 1587.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__hz",
    x1: 1847.82,
    x2: 622.298,
    y1: 3028.68,
    y2: 1263.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__hA",
    x1: 823.385,
    x2: 921.204,
    y1: 1630,
    y2: 1630,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__hB",
    x1: 1934.15,
    x2: 708.623,
    y1: 2968.74,
    y2: 1203.88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__hC",
    x1: 980.894,
    x2: 1078.71,
    y1: 1672.6,
    y2: 1672.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__hD",
    x1: 2020.47,
    x2: 794.949,
    y1: 2908.79,
    y2: 1143.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__hE",
    x1: 1138.4,
    x2: 1236.22,
    y1: 1715.21,
    y2: 1715.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__hF",
    x1: 2106.8,
    x2: 881.279,
    y1: 2848.85,
    y2: 1083.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__hG",
    x1: 1295.91,
    x2: 1393.73,
    y1: 1757.81,
    y2: 1757.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__hH",
    x1: 1398.89,
    x2: 173.366,
    y1: 3340.42,
    y2: 1575.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__hI",
    x1: 96.673,
    x2: 194.492,
    y1: 1541.55,
    y2: 1541.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__hJ",
    x1: 1485.22,
    x2: 259.692,
    y1: 3280.48,
    y2: 1515.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__hK",
    x1: 254.182,
    x2: 352.001,
    y1: 1584.16,
    y2: 1584.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__hL",
    x1: 1571.54,
    x2: 346.023,
    y1: 3220.53,
    y2: 1455.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__hM",
    x1: 411.693,
    x2: 509.512,
    y1: 1626.76,
    y2: 1626.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__hN",
    x1: 1657.87,
    x2: 432.349,
    y1: 3160.59,
    y2: 1395.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__hO",
    x1: 569.202,
    x2: 667.021,
    y1: 1669.36,
    y2: 1669.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__hP",
    x1: 1744.2,
    x2: 518.676,
    y1: 3100.64,
    y2: 1335.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__hQ",
    x1: 726.712,
    x2: 824.531,
    y1: 1711.96,
    y2: 1711.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__hR",
    x1: 1830.53,
    x2: 605.002,
    y1: 3040.69,
    y2: 1275.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__hS",
    x1: 884.222,
    x2: 982.041,
    y1: 1754.57,
    y2: 1754.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__hT",
    x1: 1916.85,
    x2: 691.329,
    y1: 2980.75,
    y2: 1215.89,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__hU",
    x1: 1041.73,
    x2: 1139.55,
    y1: 1797.17,
    y2: 1797.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__hV",
    x1: 2003.18,
    x2: 777.657,
    y1: 2920.8,
    y2: 1155.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__hW",
    x1: 1199.24,
    x2: 1297.06,
    y1: 1839.77,
    y2: 1839.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__hX",
    x1: 1295.27,
    x2: 69.744,
    y1: 3412.38,
    y2: 1647.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__hY",
    x1: 0,
    x2: 97.819,
    y1: 1623.52,
    y2: 1623.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__hZ",
    x1: 1381.6,
    x2: 156.072,
    y1: 3352.43,
    y2: 1587.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__ia",
    x1: 157.51,
    x2: 255.329,
    y1: 1666.12,
    y2: 1666.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__ib",
    x1: 1467.92,
    x2: 242.402,
    y1: 3292.48,
    y2: 1527.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__ic",
    x1: 315.02,
    x2: 412.839,
    y1: 1708.72,
    y2: 1708.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__id",
    x1: 1554.25,
    x2: 328.728,
    y1: 3232.54,
    y2: 1467.68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__ie",
    x1: 472.529,
    x2: 570.349,
    y1: 1751.33,
    y2: 1751.33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__if",
    x1: 1640.58,
    x2: 415.055,
    y1: 3172.59,
    y2: 1407.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__ig",
    x1: 630.039,
    x2: 727.858,
    y1: 1793.93,
    y2: 1793.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__ih",
    x1: 1726.9,
    x2: 501.383,
    y1: 3112.65,
    y2: 1347.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__ii",
    x1: 787.55,
    x2: 885.369,
    y1: 1836.53,
    y2: 1836.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__ij",
    x1: 1813.23,
    x2: 587.707,
    y1: 3052.7,
    y2: 1287.84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__ik",
    x1: 945.059,
    x2: 1042.88,
    y1: 1879.14,
    y2: 1879.14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__il",
    x1: 1899.56,
    x2: 674.036,
    y1: 2992.76,
    y2: 1227.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__im",
    x1: 1102.57,
    x2: 1200.39,
    y1: 1921.74,
    y2: 1921.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__in",
    x1: 2907.01,
    x2: 1681.49,
    y1: 2293.18,
    y2: 528.321,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__io",
    x1: 2113.86,
    x2: 2211.68,
    y1: 1227.7,
    y2: 1227.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__ip",
    x1: 2993.34,
    x2: 1767.81,
    y1: 2233.23,
    y2: 468.376,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__iq",
    x1: 2271.37,
    x2: 2369.19,
    y1: 1270.3,
    y2: 1270.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__ir",
    x1: 3079.66,
    x2: 1854.14,
    y1: 2173.29,
    y2: 408.429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__is",
    x1: 2428.88,
    x2: 2526.7,
    y1: 1312.9,
    y2: 1312.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__it",
    x1: 3165.99,
    x2: 1940.47,
    y1: 2113.34,
    y2: 348.484,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__iu",
    x1: 2586.39,
    x2: 2684.21,
    y1: 1355.51,
    y2: 1355.51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__iv",
    x1: 3252.32,
    x2: 2026.8,
    y1: 2053.4,
    y2: 288.538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__iw",
    x1: 2743.9,
    x2: 2841.72,
    y1: 1398.11,
    y2: 1398.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__ix",
    x1: 3338.65,
    x2: 2113.12,
    y1: 1993.45,
    y2: 228.589,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__iy",
    x1: 2901.41,
    x2: 2999.23,
    y1: 1440.71,
    y2: 1440.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__iz",
    x1: 3424.97,
    x2: 2199.45,
    y1: 1933.51,
    y2: 168.647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__iA",
    x1: 3058.92,
    x2: 3156.74,
    y1: 1483.32,
    y2: 1483.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__iB",
    x1: 3511.3,
    x2: 2285.78,
    y1: 1873.56,
    y2: 108.701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__iC",
    x1: 3216.43,
    x2: 3314.25,
    y1: 1525.92,
    y2: 1525.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__iD",
    x1: 2803.39,
    x2: 1577.87,
    y1: 2365.13,
    y2: 600.274,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__iE",
    x1: 2017.19,
    x2: 2115.01,
    y1: 1309.66,
    y2: 1309.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__iF",
    x1: 2889.72,
    x2: 1664.19,
    y1: 2305.19,
    y2: 540.33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__iG",
    x1: 2174.7,
    x2: 2272.52,
    y1: 1352.27,
    y2: 1352.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__iH",
    x1: 2976.04,
    x2: 1750.52,
    y1: 2245.24,
    y2: 480.385,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__iI",
    x1: 2332.21,
    x2: 2430.03,
    y1: 1394.87,
    y2: 1394.87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__iJ",
    x1: 3062.37,
    x2: 1836.85,
    y1: 2185.3,
    y2: 420.439,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__iK",
    x1: 2489.72,
    x2: 2587.54,
    y1: 1437.47,
    y2: 1437.47,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__iL",
    x1: 3148.7,
    x2: 1923.18,
    y1: 2125.35,
    y2: 360.493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__iM",
    x1: 2647.23,
    x2: 2745.05,
    y1: 1480.07,
    y2: 1480.07,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__iN",
    x1: 3235.02,
    x2: 2009.5,
    y1: 2065.41,
    y2: 300.547,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__iO",
    x1: 2804.74,
    x2: 2902.56,
    y1: 1522.68,
    y2: 1522.68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__iP",
    x1: 3321.35,
    x2: 2095.83,
    y1: 2005.46,
    y2: 240.601,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__iQ",
    x1: 2962.25,
    x2: 3060.07,
    y1: 1565.28,
    y2: 1565.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__iR",
    x1: 3407.68,
    x2: 2182.16,
    y1: 1945.51,
    y2: 180.652,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__iS",
    x1: 3119.76,
    x2: 3217.58,
    y1: 1607.88,
    y2: 1607.88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__iT",
    x1: 2699.77,
    x2: 1474.24,
    y1: 2437.09,
    y2: 672.231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__iU",
    x1: 1920.52,
    x2: 2018.33,
    y1: 1391.63,
    y2: 1391.63,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__iV",
    x1: 2786.09,
    x2: 1560.57,
    y1: 2377.14,
    y2: 612.285,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__iW",
    x1: 2078.03,
    x2: 2175.84,
    y1: 1434.23,
    y2: 1434.23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__iX",
    x1: 2872.42,
    x2: 1646.9,
    y1: 2317.2,
    y2: 552.338,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__iY",
    x1: 2235.53,
    x2: 2333.35,
    y1: 1476.83,
    y2: 1476.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__iZ",
    x1: 2958.75,
    x2: 1733.22,
    y1: 2257.25,
    y2: 492.393,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__ja",
    x1: 2393.04,
    x2: 2490.86,
    y1: 1519.44,
    y2: 1519.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__jb",
    x1: 3045.08,
    x2: 1819.55,
    y1: 2197.31,
    y2: 432.447,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__jc",
    x1: 2550.56,
    x2: 2648.37,
    y1: 1562.04,
    y2: 1562.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__jd",
    x1: 3131.4,
    x2: 1905.88,
    y1: 2137.36,
    y2: 372.498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__je",
    x1: 2708.06,
    x2: 2805.88,
    y1: 1604.64,
    y2: 1604.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__jf",
    x1: 3217.73,
    x2: 1992.21,
    y1: 2077.41,
    y2: 312.556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__jg",
    x1: 2865.57,
    x2: 2963.39,
    y1: 1647.25,
    y2: 1647.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__jh",
    x1: 3304.06,
    x2: 2078.54,
    y1: 2017.47,
    y2: 252.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__ji",
    x1: 3023.08,
    x2: 3120.9,
    y1: 1689.85,
    y2: 1689.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__jj",
    x1: 2596.15,
    x2: 1370.63,
    y1: 2509.04,
    y2: 744.183,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__jk",
    x1: 1823.84,
    x2: 1921.66,
    y1: 1473.59,
    y2: 1473.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__jl",
    x1: 2682.47,
    x2: 1456.95,
    y1: 2449.1,
    y2: 684.238,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__jm",
    x1: 1981.35,
    x2: 2079.17,
    y1: 1516.19,
    y2: 1516.19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__jn",
    x1: 2768.8,
    x2: 1543.28,
    y1: 2389.15,
    y2: 624.294,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__jo",
    x1: 2138.86,
    x2: 2236.68,
    y1: 1558.8,
    y2: 1558.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__jp",
    x1: 2855.13,
    x2: 1629.6,
    y1: 2329.21,
    y2: 564.348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__jq",
    x1: 2296.37,
    x2: 2394.19,
    y1: 1601.4,
    y2: 1601.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__jr",
    x1: 2941.46,
    x2: 1715.93,
    y1: 2269.26,
    y2: 504.402,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__js",
    x1: 2453.88,
    x2: 2551.7,
    y1: 1644,
    y2: 1644,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__jt",
    x1: 3027.78,
    x2: 1802.26,
    y1: 2209.32,
    y2: 444.456,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__ju",
    x1: 2611.39,
    x2: 2709.21,
    y1: 1686.61,
    y2: 1686.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__jv",
    x1: 3114.11,
    x2: 1888.59,
    y1: 2149.37,
    y2: 384.51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__jw",
    x1: 2768.9,
    x2: 2866.72,
    y1: 1729.21,
    y2: 1729.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__jx",
    x1: 3200.44,
    x2: 1974.92,
    y1: 2089.42,
    y2: 324.565,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__jy",
    x1: 2926.41,
    x2: 3024.23,
    y1: 1771.81,
    y2: 1771.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__jz",
    x1: 2492.53,
    x2: 1267,
    y1: 2581,
    y2: 816.14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__jA",
    x1: 1727.17,
    x2: 1824.99,
    y1: 1555.56,
    y2: 1555.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__jB",
    x1: 2578.85,
    x2: 1353.33,
    y1: 2521.05,
    y2: 756.194,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__jC",
    x1: 1884.68,
    x2: 1982.5,
    y1: 1598.16,
    y2: 1598.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__jD",
    x1: 2665.18,
    x2: 1439.66,
    y1: 2461.11,
    y2: 696.246,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__jE",
    x1: 2042.19,
    x2: 2140.01,
    y1: 1640.76,
    y2: 1640.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__jF",
    x1: 2751.51,
    x2: 1525.99,
    y1: 2401.16,
    y2: 636.301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__jG",
    x1: 2199.7,
    x2: 2297.52,
    y1: 1683.37,
    y2: 1683.37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__jH",
    x1: 2837.84,
    x2: 1612.31,
    y1: 2341.22,
    y2: 576.356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__jI",
    x1: 2357.21,
    x2: 2455.03,
    y1: 1725.97,
    y2: 1725.97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__jJ",
    x1: 2924.16,
    x2: 1698.64,
    y1: 2281.27,
    y2: 516.408,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__jK",
    x1: 2514.72,
    x2: 2612.54,
    y1: 1768.57,
    y2: 1768.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__jL",
    x1: 3010.49,
    x2: 1784.97,
    y1: 2221.32,
    y2: 456.465,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__jM",
    x1: 2672.23,
    x2: 2770.05,
    y1: 1811.17,
    y2: 1811.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__jN",
    x1: 3096.82,
    x2: 1871.29,
    y1: 2161.38,
    y2: 396.519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__jO",
    x1: 2829.74,
    x2: 2927.56,
    y1: 1853.78,
    y2: 1853.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__jP",
    x1: 2388.91,
    x2: 1163.39,
    y1: 2652.95,
    y2: 888.092,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__jQ",
    x1: 1630.5,
    x2: 1728.32,
    y1: 1637.52,
    y2: 1637.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__jR",
    x1: 2475.23,
    x2: 1249.71,
    y1: 2593.01,
    y2: 828.147,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__jS",
    x1: 1788.01,
    x2: 1885.83,
    y1: 1680.12,
    y2: 1680.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__jT",
    x1: 2561.56,
    x2: 1336.04,
    y1: 2533.06,
    y2: 768.203,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__jU",
    x1: 1945.52,
    x2: 2043.34,
    y1: 1722.73,
    y2: 1722.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__jV",
    x1: 2647.89,
    x2: 1422.36,
    y1: 2473.12,
    y2: 708.257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__jW",
    x1: 2103.03,
    x2: 2200.85,
    y1: 1765.33,
    y2: 1765.33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__jX",
    x1: 2734.21,
    x2: 1508.69,
    y1: 2413.17,
    y2: 648.311,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__jY",
    x1: 2260.54,
    x2: 2358.36,
    y1: 1807.93,
    y2: 1807.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__jZ",
    x1: 2820.54,
    x2: 1595.02,
    y1: 2353.22,
    y2: 588.364,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__ka",
    x1: 2418.05,
    x2: 2515.87,
    y1: 1850.54,
    y2: 1850.54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__kb",
    x1: 2906.87,
    x2: 1681.35,
    y1: 2293.28,
    y2: 528.42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__kc",
    x1: 2575.56,
    x2: 2673.38,
    y1: 1893.14,
    y2: 1893.14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__kd",
    x1: 2993.2,
    x2: 1767.67,
    y1: 2233.33,
    y2: 468.474,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__ke",
    x1: 2733.07,
    x2: 2830.89,
    y1: 1935.74,
    y2: 1935.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__kf",
    x1: 2285.28,
    x2: 1059.76,
    y1: 2724.91,
    y2: 960.049,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__kg",
    x1: 1533.83,
    x2: 1631.65,
    y1: 1719.49,
    y2: 1719.49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__kh",
    x1: 2371.61,
    x2: 1146.09,
    y1: 2664.96,
    y2: 900.103,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__ki",
    x1: 1691.34,
    x2: 1789.16,
    y1: 1762.09,
    y2: 1762.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__kj",
    x1: 2457.94,
    x2: 1232.42,
    y1: 2605.02,
    y2: 840.157,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__kk",
    x1: 1848.84,
    x2: 1946.66,
    y1: 1804.69,
    y2: 1804.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__kl",
    x1: 2544.27,
    x2: 1318.75,
    y1: 2545.07,
    y2: 780.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__km",
    x1: 2006.36,
    x2: 2104.17,
    y1: 1847.29,
    y2: 1847.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__kn",
    x1: 2630.59,
    x2: 1405.07,
    y1: 2485.13,
    y2: 720.264,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__ko",
    x1: 2163.87,
    x2: 2261.69,
    y1: 1889.9,
    y2: 1889.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__kp",
    x1: 2716.92,
    x2: 1491.4,
    y1: 2425.18,
    y2: 660.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__kq",
    x1: 2321.37,
    x2: 2419.19,
    y1: 1932.5,
    y2: 1932.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__kr",
    x1: 2803.25,
    x2: 1577.73,
    y1: 2365.23,
    y2: 600.371,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__ks",
    x1: 2478.88,
    x2: 2576.7,
    y1: 1975.1,
    y2: 1975.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__kt",
    x1: 2889.58,
    x2: 1664.05,
    y1: 2305.29,
    y2: 540.428,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__ku",
    x1: 2636.4,
    x2: 2734.21,
    y1: 2017.71,
    y2: 2017.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__kv",
    x1: 2181.66,
    x2: 956.139,
    y1: 2796.86,
    y2: 1032,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__kw",
    x1: 1437.15,
    x2: 1534.97,
    y1: 1801.45,
    y2: 1801.45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__kx",
    x1: 2267.99,
    x2: 1042.47,
    y1: 2736.92,
    y2: 972.056,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__ky",
    x1: 1594.66,
    x2: 1692.48,
    y1: 1844.05,
    y2: 1844.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__kz",
    x1: 2354.32,
    x2: 1128.8,
    y1: 2676.97,
    y2: 912.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__kA",
    x1: 1752.17,
    x2: 1849.99,
    y1: 1886.66,
    y2: 1886.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__kB",
    x1: 2440.64,
    x2: 1215.12,
    y1: 2617.03,
    y2: 852.166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__kC",
    x1: 1909.68,
    x2: 2007.5,
    y1: 1929.26,
    y2: 1929.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__kD",
    x1: 2526.97,
    x2: 1301.45,
    y1: 2557.08,
    y2: 792.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__kE",
    x1: 2067.19,
    x2: 2165.01,
    y1: 1971.86,
    y2: 1971.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__kF",
    x1: 2613.3,
    x2: 1387.77,
    y1: 2497.13,
    y2: 732.274,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__kG",
    x1: 2224.7,
    x2: 2322.52,
    y1: 2014.47,
    y2: 2014.47,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__kH",
    x1: 2699.63,
    x2: 1474.11,
    y1: 2437.19,
    y2: 672.327,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__kI",
    x1: 2382.21,
    x2: 2480.03,
    y1: 2057.07,
    y2: 2057.07,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__kJ",
    x1: 2785.95,
    x2: 1560.43,
    y1: 2377.24,
    y2: 612.383,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__kK",
    x1: 2539.72,
    x2: 2637.54,
    y1: 2099.67,
    y2: 2099.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__kL",
    x1: 2078.04,
    x2: 852.518,
    y1: 2868.82,
    y2: 1103.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__kM",
    x1: 1340.48,
    x2: 1438.3,
    y1: 1883.41,
    y2: 1883.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__kN",
    x1: 2164.37,
    x2: 938.848,
    y1: 2808.87,
    y2: 1044.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__kO",
    x1: 1497.99,
    x2: 1595.81,
    y1: 1926.02,
    y2: 1926.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__kP",
    x1: 2250.7,
    x2: 1025.17,
    y1: 2748.93,
    y2: 984.066,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__kQ",
    x1: 1655.5,
    x2: 1753.32,
    y1: 1968.62,
    y2: 1968.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__kR",
    x1: 2337.02,
    x2: 1111.5,
    y1: 2688.98,
    y2: 924.119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__kS",
    x1: 1813.01,
    x2: 1910.83,
    y1: 2011.22,
    y2: 2011.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__kT",
    x1: 2423.35,
    x2: 1197.83,
    y1: 2629.03,
    y2: 864.173,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__kU",
    x1: 1970.52,
    x2: 2068.34,
    y1: 2053.83,
    y2: 2053.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__kV",
    x1: 2509.68,
    x2: 1284.15,
    y1: 2569.09,
    y2: 804.229,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__kW",
    x1: 2128.03,
    x2: 2225.85,
    y1: 2096.43,
    y2: 2096.43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__kX",
    x1: 2596.01,
    x2: 1370.48,
    y1: 2509.14,
    y2: 744.283,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__kY",
    x1: 2285.54,
    x2: 2383.36,
    y1: 2139.03,
    y2: 2139.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__kZ",
    x1: 2682.33,
    x2: 1456.81,
    y1: 2449.2,
    y2: 684.337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__la",
    x1: 2443.05,
    x2: 2540.87,
    y1: 2181.64,
    y2: 2181.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__lb",
    x1: 1974.42,
    x2: 748.897,
    y1: 2940.77,
    y2: 1175.91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__lc",
    x1: 1243.81,
    x2: 1341.63,
    y1: 1965.38,
    y2: 1965.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__ld",
    x1: 2060.75,
    x2: 835.228,
    y1: 2880.83,
    y2: 1115.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__le",
    x1: 1401.32,
    x2: 1499.14,
    y1: 2007.98,
    y2: 2007.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__lf",
    x1: 2147.08,
    x2: 921.555,
    y1: 2820.88,
    y2: 1056.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__lg",
    x1: 1558.83,
    x2: 1656.65,
    y1: 2050.58,
    y2: 2050.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__lh",
    x1: 2233.4,
    x2: 1007.88,
    y1: 2760.93,
    y2: 996.075,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__li",
    x1: 1716.34,
    x2: 1814.16,
    y1: 2093.19,
    y2: 2093.19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__lj",
    x1: 2319.73,
    x2: 1094.21,
    y1: 2700.99,
    y2: 936.129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__lk",
    x1: 1873.85,
    x2: 1971.67,
    y1: 2135.79,
    y2: 2135.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__ll",
    x1: 2406.06,
    x2: 1180.53,
    y1: 2641.04,
    y2: 876.183,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__lm",
    x1: 2031.36,
    x2: 2129.17,
    y1: 2178.39,
    y2: 2178.39,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__ln",
    x1: 2492.38,
    x2: 1266.86,
    y1: 2581.1,
    y2: 816.236,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__lo",
    x1: 2188.87,
    x2: 2286.69,
    y1: 2221,
    y2: 2221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__lp",
    x1: 2578.71,
    x2: 1353.19,
    y1: 2521.15,
    y2: 756.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FBFBFB",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#EEE",
    stopOpacity: 0.754
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#DADADA",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#BDBDBD",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#989898",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6A6A6A",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#353535",
    stopOpacity: 0.112
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fish_svg__lq",
    x1: 2346.38,
    x2: 2444.2,
    y1: 2263.6,
    y2: 2263.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })))));
};
export default SvgFish;